var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e10) { throw _e10; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e11) { didErr = true; err = _e11; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function e(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var r,
        o,
        i,
        a,
        s = [],
        l = !0,
        c = !1;
      try {
        if (i = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          l = !1;
        } else for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0);
      } catch (e) {
        c = !0, o = e;
      } finally {
        try {
          if (!l && null != n["return"] && (a = n["return"](), Object(a) !== a)) return;
        } finally {
          if (c) throw o;
        }
      }
      return s;
    }
  }(e, n) || t(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function t(e, t) {
  if (e) {
    if ("string" == typeof e) return n(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
  }
}
function n(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function r(e) {
  return r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, r(e);
}
function o() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  o = function o() {
    return t;
  };
  var e,
    t = {},
    n = Object.prototype,
    i = n.hasOwnProperty,
    a = Object.defineProperty || function (e, t, n) {
      e[t] = n.value;
    },
    s = "function" == typeof Symbol ? Symbol : {},
    l = s.iterator || "@@iterator",
    c = s.asyncIterator || "@@asyncIterator",
    u = s.toStringTag || "@@toStringTag";
  function d(e, t, n) {
    return Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    d({}, "");
  } catch (e) {
    d = function d(e, t, n) {
      return e[t] = n;
    };
  }
  function f(e, t, n, r) {
    var o = t && t.prototype instanceof A ? t : A,
      i = Object.create(o.prototype),
      s = new B(r || []);
    return a(i, "_invoke", {
      value: O(e, n, s)
    }), i;
  }
  function p(e, t, n) {
    try {
      return {
        type: "normal",
        arg: e.call(t, n)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  t.wrap = f;
  var h = "suspendedStart",
    m = "suspendedYield",
    g = "executing",
    v = "completed",
    y = {};
  function A() {}
  function b() {}
  function _() {}
  var w = {};
  d(w, l, function () {
    return this;
  });
  var k = Object.getPrototypeOf,
    E = k && k(k(R([])));
  E && E !== n && i.call(E, l) && (w = E);
  var S = _.prototype = A.prototype = Object.create(w);
  function C(e) {
    ["next", "throw", "return"].forEach(function (t) {
      d(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function x(e, t) {
    function n(o, a, s, l) {
      var c = p(e[o], e, a);
      if ("throw" !== c.type) {
        var u = c.arg,
          d = u.value;
        return d && "object" == r(d) && i.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
          n("next", e, s, l);
        }, function (e) {
          n("throw", e, s, l);
        }) : t.resolve(d).then(function (e) {
          u.value = e, s(u);
        }, function (e) {
          return n("throw", e, s, l);
        });
      }
      l(c.arg);
    }
    var o;
    a(this, "_invoke", {
      value: function value(e, r) {
        function i() {
          return new t(function (t, o) {
            n(e, r, t, o);
          });
        }
        return o = o ? o.then(i, i) : i();
      }
    });
  }
  function O(t, n, r) {
    var o = h;
    return function (i, a) {
      if (o === g) throw new Error("Generator is already running");
      if (o === v) {
        if ("throw" === i) throw a;
        return {
          value: e,
          done: !0
        };
      }
      for (r.method = i, r.arg = a;;) {
        var s = r.delegate;
        if (s) {
          var l = P(s, r);
          if (l) {
            if (l === y) continue;
            return l;
          }
        }
        if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
          if (o === h) throw o = v, r.arg;
          r.dispatchException(r.arg);
        } else "return" === r.method && r.abrupt("return", r.arg);
        o = g;
        var c = p(t, n, r);
        if ("normal" === c.type) {
          if (o = r.done ? v : m, c.arg === y) continue;
          return {
            value: c.arg,
            done: r.done
          };
        }
        "throw" === c.type && (o = v, r.method = "throw", r.arg = c.arg);
      }
    };
  }
  function P(t, n) {
    var r = n.method,
      o = t.iterator[r];
    if (o === e) return n.delegate = null, "throw" === r && t.iterator["return"] && (n.method = "return", n.arg = e, P(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), y;
    var i = p(o, t.iterator, n.arg);
    if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (n[t.resultName] = a.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, y) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
  }
  function T(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function I(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function B(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(T, this), this.reset(!0);
  }
  function R(t) {
    if (t || "" === t) {
      var n = t[l];
      if (n) return n.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var o = -1,
          a = function n() {
            for (; ++o < t.length;) if (i.call(t, o)) return n.value = t[o], n.done = !1, n;
            return n.value = e, n.done = !0, n;
          };
        return a.next = a;
      }
    }
    throw new TypeError(r(t) + " is not iterable");
  }
  return b.prototype = _, a(S, "constructor", {
    value: _,
    configurable: !0
  }), a(_, "constructor", {
    value: b,
    configurable: !0
  }), b.displayName = d(_, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
  }, t.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, _) : (e.__proto__ = _, d(e, u, "GeneratorFunction")), e.prototype = Object.create(S), e;
  }, t.awrap = function (e) {
    return {
      __await: e
    };
  }, C(x.prototype), d(x.prototype, c, function () {
    return this;
  }), t.AsyncIterator = x, t.async = function (e, n, r, o, i) {
    void 0 === i && (i = Promise);
    var a = new x(f(e, n, r, o), i);
    return t.isGeneratorFunction(n) ? a : a.next().then(function (e) {
      return e.done ? e.value : a.next();
    });
  }, C(S), d(S, u, "Generator"), d(S, l, function () {
    return this;
  }), d(S, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (e) {
    var t = Object(e),
      n = [];
    for (var r in t) n.push(r);
    return n.reverse(), function e() {
      for (; n.length;) {
        var r = n.pop();
        if (r in t) return e.value = r, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, t.values = R, B.prototype = {
    constructor: B,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(I), !t) for (var n in this) "t" === n.charAt(0) && i.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var n = this;
      function r(r, o) {
        return s.type = "throw", s.arg = t, n.next = r, o && (n.method = "next", n.arg = e), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var a = this.tryEntries[o],
          s = a.completion;
        if ("root" === a.tryLoc) return r("end");
        if (a.tryLoc <= this.prev) {
          var l = i.call(a, "catchLoc"),
            c = i.call(a, "finallyLoc");
          if (l && c) {
            if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
            if (this.prev < a.finallyLoc) return r(a.finallyLoc);
          } else if (l) {
            if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
          } else {
            if (!c) throw new Error("try statement without catch or finally");
            if (this.prev < a.finallyLoc) return r(a.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var r = this.tryEntries[n];
        if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
          var o = r;
          break;
        }
      }
      o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
      var a = o ? o.completion : {};
      return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), y;
      }
    },
    "catch": function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.tryLoc === e) {
          var r = n.completion;
          if ("throw" === r.type) {
            var o = r.arg;
            I(n);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, n, r) {
      return this.delegate = {
        iterator: R(t),
        resultName: n,
        nextLoc: r
      }, "next" === this.method && (this.arg = e), y;
    }
  }, t;
}
function i(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (i = o.key, a = void 0, a = function (e, t) {
      if ("object" !== r(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var o = n.call(e, t || "default");
        if ("object" !== r(o)) return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(i, "string"), "symbol" === r(a) ? a : String(a)), o);
  }
  var i, a;
}
function a(e, t, n) {
  return t && i(e.prototype, t), n && i(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function s(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function l(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && h(e, t);
}
function c(e) {
  var t = p();
  return function () {
    var n,
      o = m(e);
    if (t) {
      var i = m(this).constructor;
      n = Reflect.construct(o, arguments, i);
    } else n = o.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === r(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return u(e);
    }(this, n);
  };
}
function u(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function d(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return d = function d(e) {
    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
    var n;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }
    function r() {
      return f(e, arguments, m(this).constructor);
    }
    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), h(r, e);
  }, d(e);
}
function f(e, t, n) {
  return f = p() ? Reflect.construct.bind() : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var o = new (Function.bind.apply(e, r))();
    return n && h(o, n.prototype), o;
  }, f.apply(null, arguments);
}
function p() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function h(e, t) {
  return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, h(e, t);
}
function m(e) {
  return m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, m(e);
}
var g, v, y, A, b, _;
function w(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        l(r.next(e));
      } catch (e) {
        i(e);
      }
    }
    function s(e) {
      try {
        l(r["throw"](e));
      } catch (e) {
        i(e);
      }
    }
    function l(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(a, s);
    }
    l((r = r.apply(e, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError, function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.oauth = "oauth", e.otp = "otp", e.crypto = "crypto", e.passwords = "passwords", e.passkeys = "passkeys";
}(g || (g = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft", e.Apple = "apple", e.Github = "github", e.GitLab = "gitlab", e.Facebook = "facebook", e.Discord = "discord", e.Salesforce = "salesforce", e.Slack = "slack", e.Amazon = "amazon", e.Bitbucket = "bitbucket", e.LinkedIn = "linkedin", e.Coinbase = "coinbase", e.Twitch = "twitch", e.Twitter = "twitter", e.TikTok = "tiktok", e.Snapchat = "snapchat", e.Figma = "figma", e.Yahoo = "yahoo";
}(v || (v = {})), function (e) {
  e.Vessel = "Vessel", e.Phantom = "Phantom", e.Metamask = "Metamask", e.Coinbase = "Coinbase", e.Binance = "Binance", e.GenericEthereumWallet = "Other Ethereum Wallet", e.GenericSolanaWallet = "Other Solana Wallet";
}(y || (y = {})), function (e) {
  e.embedded = "embedded", e.floating = "floating";
}(A || (A = {})), function (e) {
  e.SMS = "sms", e.WhatsApp = "whatsapp", e.Email = "email";
}(b || (b = {})), function (e) {
  e.MagicLinkLoginOrCreateEvent = "MAGIC_LINK_LOGIN_OR_CREATE", e.OTPsLoginOrCreateEvent = "OTP_LOGIN_OR_CREATE", e.OTPsAuthenticate = "OTP_AUTHENTICATE", e.CryptoWalletAuthenticateStart = "CRYPTO_WALLET_AUTHENTICATE_START", e.CryptoWalletAuthenticate = "CRYPTO_WALLET_AUTHENTICATE", e.PasswordCreate = "PASSWORD_CREATE", e.PasswordAuthenticate = "PASSWORD_AUTHENTICATE", e.PasswordResetByEmailStart = "PASSWORD_RESET_BY_EMAIL_START", e.PasswordResetByEmail = "PASSWORD_RESET_BY_EMAIL", e.PasskeyRegister = "PASSKEY_REGISTER", e.PasskeyAuthenticate = "PASSKEY_AUTHENTICATE", e.PasskeySkip = "PASSKEY_SKIP", e.PasskeyDone = "PASSKEY_DONE", e.B2BMagicLinkEmailLoginOrSignup = "B2B_MAGIC_LINK_EMAIL_LOGIN_OR_SIGNUP", e.B2BMagicLinkAuthenticate = "B2B_MAGIC_LINK_AUTHENTICATE", e.B2BMagicLinkEmailDiscoverySend = "B2B_MAGIC_LINK_EMAIL_DISCOVERY_SEND", e.B2BMagicLinkDiscoveryAuthenticate = "B2B_MAGIC_LINK_DISCOVERY_AUTHENTICATE", e.B2BSSOStart = "B2B_SSO_START", e.B2BSSOAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthDiscoveryAuthenticate = "B2B_OAUTH_DISCOVERY_AUTHENTICATE", e.B2BDiscoveryOrganizationsCreate = "B2B_DISCOVERY_ORGANIZATIONS_CREATE", e.B2BDiscoveryIntermediateSessionExchange = "B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE", e.B2BPasswordAuthenticate = "B2B_PASSWORD_AUTHENTICATE", e.B2BPasswordResetByEmailStart = "B2B_PASSWORD_RESET_BY_EMAIL_START", e.B2BPasswordResetByEmail = "B2B_PASSWORD_RESET_BY_EMAIL", e.B2BPasswordResetBySession = "B2B_PASSWORD_RESET_BY_SESSION";
}(_ || (_ = {}));
var k,
  E,
  S,
  C,
  x,
  O = function (e) {
    l(n, d(Error));
    var t = c(n);
    function n(e, r) {
      var o;
      return s(this, n), (o = t.call(this, e + "\n" + r)).message = e + "\n" + r, o.name = "SDKAPIUnreachableError", o.details = r, Object.setPrototypeOf(u(o), n.prototype), o;
    }
    return a(n);
  }(),
  P = function (e) {
    l(n, d(Error));
    var t = c(n);
    function n(e, r) {
      var o;
      return s(this, n), (o = t.call(this)).name = "StytchSDKUsageError", o.message = "Invalid call to ".concat(e, "\n") + r, o;
    }
    return a(n);
  }(),
  T = function (e) {
    l(n, d(Error));
    var t = c(n);
    function n(e) {
      var r, o;
      s(this, n), (r = t.call(this)).name = "StytchSDKSchemaError";
      var i = null === (o = e.body) || void 0 === o ? void 0 : o.map(function (e) {
        return "".concat(e.dataPath, ": ").concat(e.message);
      }).join("\n");
      return r.message = "[400] Request does not match expected schema\n".concat(i), r;
    }
    return a(n);
  }(),
  I = function (e) {
    l(n, d(Error));
    var t = c(n);
    function n(e) {
      var r;
      s(this, n), (r = t.call(this)).name = "StytchSDKAPIError";
      var o = e.status_code,
        i = e.error_type,
        a = e.error_message,
        l = e.error_url,
        c = e.request_id;
      return r.error_type = i, r.error_message = a, r.error_url = l, r.request_id = c, r.status_code = o, r.message = "[".concat(o, "] ").concat(i, "\n") + "".concat(a, "\n") + "See ".concat(l, " for more information.\n") + (c ? "request_id: ".concat(c, "\n") : ""), r;
    }
    return a(n);
  }(),
  B = ["unauthorized_credentials", "user_unauthenticated", "invalid_secret_authentication", "session_not_found"];
!function (e) {
  e.BiometricsSensorError = "biometrics_sensor_error", e.DeviceCredentialsNotAllowed = "device_credentials_not_allowed", e.DeviceHardwareError = "device_hardware_error", e.InternalError = "internal_error", e.KeyInvalidated = "key_invalidated", e.KeystoreUnavailable = "keystore_unavailable", e.NoBiometricsEnrolled = "no_biometrics_enrolled", e.NoBiometricsRegistration = "no_biometrics_registration", e.SessionExpired = "session_expired", e.UserCancellation = "user_cancellation", e.UserLockedOut = "user_locked_out", e.BiometricsNotAvailable = "biometrics_not_available";
}(k || (k = {})), function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.sso = "sso", e.passwords = "passwords", e.oauth = "oauth";
}(E || (E = {})), function (e) {
  e.Discovery = "Discovery", e.Organization = "Organization", e.PasswordReset = "PasswordReset";
}(S || (S = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft";
}(C || (C = {})), (x || (x = {})).RequiredCatcha = "Catcha Required";
var R,
  L = function (e) {
    l(n, d(Error));
    var t = c(n);
    function n(e) {
      var r;
      return s(this, n), (r = t.call(this, e)).type = e, r;
    }
    return a(n);
  }();
function M(e) {
  var t = e.method,
    n = e.errorMessage,
    r = e.finalURL,
    i = e.basicAuthHeader,
    a = e.xSDKClientHeader,
    s = e.xSDKParentHostHeader,
    l = e.body;
  return w(this, void 0, void 0, o().mark(function e() {
    var c, u, d, f, p, h;
    return o().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return c = {
            Authorization: i,
            "Content-Type": "application/json",
            "X-SDK-Client": a
          }, s && (c["X-SDK-Parent-Host"] = s), u = {
            method: t,
            headers: c,
            body: l && JSON.stringify(l)
          }, e.prev = 3, e.next = 6, fetch(r, u);
        case 6:
          d = e.sent, e.next = 14;
          break;
        case 9:
          if (e.prev = 9, e.t0 = e["catch"](3), "Failed to fetch" !== e.t0.message) {
            e.next = 13;
            break;
          }
          throw new O(n, "Unable to contact the Stytch servers. Are you online?");
        case 13:
          throw e.t0;
        case 14:
          if (403 !== d.status) {
            e.next = 27;
            break;
          }
          return e.prev = 15, e.next = 18, d.text();
        case 18:
          f = e.sent, e.next = 24;
          break;
        case 21:
          throw e.prev = 21, e.t1 = e["catch"](15), new O(n, "Invalid response from the Stytch servers.");
        case 24:
          if (!f.includes("Captcha required")) {
            e.next = 26;
            break;
          }
          throw new L(x.RequiredCatcha);
        case 26:
          throw new O(n, "Invalid response from the Stytch servers.");
        case 27:
          if (200 === d.status) {
            e.next = 40;
            break;
          }
          return e.prev = 28, e.next = 31, d.json();
        case 31:
          p = e.sent, e.next = 37;
          break;
        case 34:
          throw e.prev = 34, e.t2 = e["catch"](28), new O(n, "Invalid or no response from server");
        case 37:
          if (!("body" in p || "params" in p || "query" in p)) {
            e.next = 39;
            break;
          }
          throw new T(p);
        case 39:
          throw new I(p);
        case 40:
          return e.prev = 40, e.next = 43, d.json();
        case 43:
          return h = e.sent, e.abrupt("return", h.data);
        case 47:
          throw e.prev = 47, e.t3 = e["catch"](40), new O(n, "Invalid response from the Stytch servers.");
        case 50:
        case "end":
          return e.stop();
      }
    }, e, null, [[3, 9], [15, 21], [28, 34], [40, 47]]);
  }));
}
var D = new Uint8Array(16);
function N() {
  if (!R && !(R = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return R(D);
}
var z = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
for (var j = [], F = 0; F < 256; ++F) j.push((F + 256).toString(16).substr(1));
function U(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    n = (j[e[t + 0]] + j[e[t + 1]] + j[e[t + 2]] + j[e[t + 3]] + "-" + j[e[t + 4]] + j[e[t + 5]] + "-" + j[e[t + 6]] + j[e[t + 7]] + "-" + j[e[t + 8]] + j[e[t + 9]] + "-" + j[e[t + 10]] + j[e[t + 11]] + j[e[t + 12]] + j[e[t + 13]] + j[e[t + 14]] + j[e[t + 15]]).toLowerCase();
  if (!function (e) {
    return "string" == typeof e && z.test(e);
  }(n)) throw TypeError("Stringified UUID is invalid");
  return n;
}
function Q(e, t, n) {
  var r = (e = e || {}).random || (e.rng || N)();
  if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
    n = n || 0;
    for (var o = 0; o < 16; ++o) t[n + o] = r[o];
    return t;
  }
  return U(r);
}
var $ = {};
function H(e, t) {
  return w(this, void 0, void 0, o().mark(function n() {
    return o().wrap(function (n) {
      for (;;) switch (n.prev = n.next) {
        case 0:
          if (void 0 === $[e]) {
            n.next = 2;
            break;
          }
          return n.abrupt("return", $[e]);
        case 2:
          return $[e] = V(e, t), n.abrupt("return", $[e]);
        case 4:
        case "end":
          return n.stop();
      }
    }, n);
  }));
}
function V(e, t) {
  return new Promise(function (n, r) {
    var o = function (e) {
      var t = W(e);
      if (t[0]) return t[0];
    }(e);
    if (o && "true" === o.dataset.loaded) try {
      n(t());
    } catch (t) {
      return r(new Error("".concat(e, " already loaded, but module was not found in global scope: ").concat(t)));
    }
    var i = function (e) {
      var t = document.createElement("script");
      return t.setAttribute("src", e), t.setAttribute("async", "true"), t.setAttribute("defer", "true"), document.head.appendChild(t), t;
    }(e);
    i.addEventListener("load", function () {
      i.dataset.loaded = "true";
      try {
        n(t());
      } catch (t) {
        r(new Error("".concat(e, " was loaded, but module was not found in global scope: ").concat(t)));
      }
    }), i.addEventListener("error", function (t) {
      r(new Error("".concat(e, " could not be loaded: ").concat(t)));
    });
  });
}
var W = function W(e) {
  return document.querySelectorAll('script[src="'.concat(e, '"]'));
};
var K,
  q = ["[Stytch]"],
  G = function G() {
    for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
    return (e = console).warn.apply(e, q.concat(n));
  },
  Y = function Y() {
    for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
    return (e = console).error.apply(e, q.concat(n));
  },
  J = "\nYou can find your public token at https://stytch.com/dashboard/api-keys.",
  Z = function Z(e) {
    return e.includes("public-token-test");
  },
  X = function X(e) {
    var n = {
      isObject: function isObject(t, o) {
        var i = "object" === r(o) && !Array.isArray(o) && null !== o;
        if (!i) throw new P(e, t + " must be an object.");
        return n;
      },
      isOptionalObject: function isOptionalObject(e, t) {
        return void 0 === t ? n : n.isObject(e, t);
      },
      isString: function isString(t, r) {
        if ("string" != typeof r) throw new P(e, t + " must be a string.");
        return n;
      },
      isOptionalString: function isOptionalString(e, t) {
        return void 0 === t ? n : n.isString(e, t);
      },
      isStringArray: function isStringArray(r, o) {
        if (!Array.isArray(o)) throw new P(e, r + " must be an array of strings.");
        var i,
          a = function (e, n) {
            var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (!r) {
              if (Array.isArray(e) || (r = t(e)) || n && e && "number" == typeof e.length) {
                r && (e = r);
                var o = 0,
                  i = function i() {};
                return {
                  s: i,
                  n: function n() {
                    return o >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[o++]
                    };
                  },
                  e: function e(_e2) {
                    throw _e2;
                  },
                  f: i
                };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var a,
              s = !0,
              l = !1;
            return {
              s: function s() {
                r = r.call(e);
              },
              n: function n() {
                var e = r.next();
                return s = e.done, e;
              },
              e: function e(_e3) {
                l = !0, a = _e3;
              },
              f: function f() {
                try {
                  s || null == r["return"] || r["return"]();
                } finally {
                  if (l) throw a;
                }
              }
            };
          }(o);
        try {
          for (a.s(); !(i = a.n()).done;) {
            if ("string" != typeof i.value) throw new P(e, r + " must be an array of strings.");
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return n;
      },
      isOptionalStringArray: function isOptionalStringArray(e, t) {
        return void 0 === t ? n : n.isStringArray(e, t);
      },
      isNumber: function isNumber(t, r) {
        if ("number" != typeof r) throw new P(e, t + " must be a number.");
        return n;
      },
      isOptionalNumber: function isOptionalNumber(e, t) {
        return void 0 === t ? n : n.isNumber(e, t);
      },
      isBoolean: function isBoolean(t, r) {
        if ("boolean" != typeof r) throw new P(e, t + " must be a boolean.");
        return n;
      },
      isOptionalBoolean: function isOptionalBoolean(e, t) {
        return void 0 === t ? n : n.isBoolean(e, t);
      }
    };
    return n;
  },
  ee = a(function e(t, n, r) {
    var i = this,
      a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function () {
        return Promise.resolve(void 0);
      };
    s(this, e), this.bootstrapPromise = r, this.isEnabled = function () {
      return w(i, void 0, void 0, o().mark(function e() {
        return o().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.state.then(function (e) {
                return e.enabled;
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getTelemetryID = function () {
      return w(i, void 0, void 0, o().mark(function e() {
        var t, n, r, i;
        return o().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.state;
            case 2:
              if (t = e.sent, n = t.publicToken, r = t.enabled, i = t.dfpBackendURL, r) {
                e.next = 8;
                break;
              }
              return e.abrupt("return", void 0);
            case 8:
              return e.next = 10, window.GetTelemetryID(n, "".concat(i, "/submit"));
            case 10:
              return e.abrupt("return", e.sent);
            case 11:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getDFPTelemetryIDAndCaptcha = function () {
      return w(i, void 0, void 0, o().mark(function e() {
        var t, n, r, i, a, s;
        return o().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.state;
            case 2:
              if (t = e.sent, n = t.enabled, r = t.executeRecaptcha, i = t.mode, a = void 0, s = void 0, n) {
                e.next = 12;
                break;
              }
              return e.next = 11, r();
            case 11:
              s = e.sent;
            case 12:
              if ("DECISIONING" !== i) {
                e.next = 18;
                break;
              }
              return e.next = 15, this.getTelemetryID();
            case 15:
              a = e.sent, e.next = 25;
              break;
            case 18:
              if ("OBSERVATION" !== i) {
                e.next = 25;
                break;
              }
              return e.next = 21, this.getTelemetryID();
            case 21:
              return a = e.sent, e.next = 24, r();
            case 24:
              s = e.sent;
            case 25:
              return e.abrupt("return", {
                dfp_telemetry_id: a,
                captcha_token: s
              });
            case 26:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.retryWithCaptchaAndDFP = function (e, t) {
      return w(i, void 0, void 0, o().mark(function n() {
        var r, i, a;
        return o().wrap(function (n) {
          for (;;) switch (n.prev = n.next) {
            case 0:
              return n.next = 2, this.state;
            case 2:
              if (r = n.sent, i = r.enabled, a = r.executeRecaptcha, e.type !== x.RequiredCatcha || !i) {
                n.next = 14;
                break;
              }
              if (!t.body) {
                n.next = 13;
                break;
              }
              return n.next = 9, this.getTelemetryID();
            case 9:
              return t.body.dfp_telemetry_id = n.sent, n.next = 12, a();
            case 12:
              t.body.captcha_token = n.sent;
            case 13:
              return n.abrupt("return", t);
            case 14:
              throw new Error("Unable to query captcha and/or dfp telemetry ID");
            case 15:
            case "end":
              return n.stop();
          }
        }, n, this);
      }));
    }, this.state = r.then(function (e) {
      return w(i, void 0, void 0, o().mark(function r() {
        return o().wrap(function (r) {
          for (;;) switch (r.prev = r.next) {
            case 0:
              if (e.runDFPProtectedAuth) {
                r.next = 2;
                break;
              }
              return r.abrupt("return", {
                publicToken: t,
                dfpBackendURL: n,
                enabled: !1,
                loaded: !1,
                executeRecaptcha: a
              });
            case 2:
              return r.next = 4, void H("".concat("https://elements.stytch.com", "/telemetry.js"), function () {
                return window;
              });
            case 4:
              return r.abrupt("return", {
                publicToken: t,
                dfpBackendURL: n,
                enabled: !0,
                mode: e.dfpProtectedAuthMode || "OBSERVATION",
                loaded: !0,
                executeRecaptcha: a
              });
            case 5:
            case "end":
              return r.stop();
          }
        }, r);
      }));
    });
  }),
  te = function te() {
    return {
      isEnabled: function isEnabled() {
        return w(void 0, void 0, void 0, o().mark(function e() {
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !1);
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      getTelemetryID: function getTelemetryID() {
        return w(void 0, void 0, void 0, o().mark(function e() {
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", void 0);
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      getDFPTelemetryIDAndCaptcha: function getDFPTelemetryIDAndCaptcha() {
        return w(void 0, void 0, void 0, o().mark(function e() {
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", {
                  dfp_telemetry_id: void 0,
                  captcha_token: void 0
                });
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      retryWithCaptchaAndDFP: function retryWithCaptchaAndDFP() {
        return w(void 0, void 0, void 0, o().mark(function e() {
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                throw new Error("DFP protected auth is disabled");
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      }
    };
  },
  ne = function () {
    function e(t) {
      s(this, e), this.maxBatchSize = t.maxBatchSize, this.logEventURL = t.logEventURL, setInterval(this.flush.bind(this), t.intervalDurationMs), this.batch = [];
    }
    return a(e, [{
      key: "logEvent",
      value: function value(e, t) {
        this.batch.push({
          telemetry: e,
          event: t
        }), this.batch.length >= this.maxBatchSize && this.flush();
      }
    }, {
      key: "flush",
      value: function value() {
        return w(this, void 0, void 0, o().mark(function e() {
          var t;
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (this.batch.length) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return t = this.batch, this.batch = [], e.prev = 4, e.next = 7, fetch(this.logEventURL, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(t)
                });
              case 7:
                e.next = 11;
                break;
              case 9:
                e.prev = 9, e.t0 = e["catch"](4);
              case 11:
              case "end":
                return e.stop();
            }
          }, e, this, [[4, 9]]);
        }));
      }
    }]), e;
  }();
!function (e) {
  e.LoginOrCreateEML = "login_or_create_eml", e.LoginOrCreateOTP = "login_or_create_otp", e.ResetPassword = "reset_password";
}(K || (K = {})), Promise.resolve({
  pkceRequiredForEmailMagicLinks: !1
}), Promise.resolve({
  pkceRequiredForPasswordResets: !1
});
var re = Promise.resolve({
    pkceRequiredForEmailMagicLinks: !1
  }),
  oe = function () {
    function e(t, n, r, i) {
      var a = this,
        l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : re,
        c = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : te();
      s(this, e), this._networkClient = t, this._subscriptionService = n, this._pkceManager = r, this._passwordResetPKCEManager = i, this._config = l, this.dfpProtectedAuth = c, this.email = {
        loginOrSignup: function loginOrSignup(e) {
          return w(a, void 0, void 0, o().mark(function t() {
            var n, r;
            return o().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return X("stytch.magicLinks.email.loginOrSignup").isString("email", e.email_address).isString("organization_id", e.organization_id).isOptionalString("login_redirect_url", e.login_redirect_url).isOptionalString("login_template_id", e.login_template_id).isOptionalString("signup_redirect_url", e.signup_redirect_url).isOptionalString("signup_template_id", e.signup_template_id).isOptionalString("locale", e.locale), t.next = 3, this.getCodeChallenge();
                case 3:
                  return n = t.sent, r = Object.assign(Object.assign({}, e), {
                    pkce_code_challenge: n
                  }), t.abrupt("return", this._networkClient.fetchSDK({
                    url: "/b2b/magic_links/email/login_or_signup",
                    body: r,
                    errorMessage: "Failed to send magic link",
                    method: "POST"
                  }));
                case 6:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        },
        discovery: {
          send: function send(e) {
            return w(a, void 0, void 0, o().mark(function t() {
              var n, r;
              return o().wrap(function (t) {
                for (;;) switch (t.prev = t.next) {
                  case 0:
                    return X("stytch.magicLinks.email.discovery.send").isString("email_address", e.email_address).isOptionalString("discovery_redirect_url", e.discovery_redirect_url).isOptionalString("login_template_id", e.login_template_id).isOptionalString("locale", e.locale), t.next = 3, this.getCodeChallenge();
                  case 3:
                    return n = t.sent, r = Object.assign(Object.assign({}, e), {
                      pkce_code_challenge: n
                    }), t.abrupt("return", this._networkClient.fetchSDK({
                      url: "/b2b/magic_links/email/discovery/send",
                      body: r,
                      errorMessage: "Failed to send discovery magic link",
                      method: "POST"
                    }));
                  case 6:
                  case "end":
                    return t.stop();
                }
              }, t, this);
            }));
          }
        }
      }, this.authenticate = function (e) {
        return w(a, void 0, void 0, o().mark(function t() {
          var n, r;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return X("stytch.magicLinks.authenticate").isString("magic_links_token", e.magic_links_token).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.next = 3, this._passwordResetPKCEManager.getPKPair();
              case 3:
                if (n = t.sent, r = null, !(null == n ? void 0 : n.code_verifier)) {
                  t.next = 19;
                  break;
                }
                return t.prev = 6, t.next = 9, this.handlePKCEForAuthenticate(this._passwordResetPKCEManager, e);
              case 9:
                r = t.sent, t.next = 19;
                break;
              case 12:
                if (t.prev = 12, t.t0 = t["catch"](6), !t.t0.message.includes("pkce")) {
                  t.next = 18;
                  break;
                }
                console.log("Authenticate with passwords pkce namespace failed. Falling back to authenticate with magic_links namespace."), t.next = 19;
                break;
              case 18:
                throw t.t0;
              case 19:
                if (r) {
                  t.next = 23;
                  break;
                }
                return t.next = 22, this.handlePKCEForAuthenticate(this._pkceManager, e);
              case 22:
                r = t.sent;
              case 23:
                return r.member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: r.member_session,
                    member: r.member
                  },
                  session_token: r.session_token,
                  session_jwt: r.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: r.intermediate_session_token
                }), t.abrupt("return", r);
              case 25:
              case "end":
                return t.stop();
            }
          }, t, this, [[6, 12]]);
        }));
      }, this.discovery = {
        authenticate: function authenticate(e) {
          return w(a, void 0, void 0, o().mark(function t() {
            var n, r, i, a, s, l;
            return o().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return X("stytch.magicLinks.discovery.authenticate").isString("discovery_magic_links_token", e.discovery_magic_links_token), t.next = 3, this._pkceManager.getPKPair();
                case 3:
                  return n = t.sent, t.next = 6, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
                case 6:
                  return r = t.sent, i = r.dfp_telemetry_id, a = r.captcha_token, s = Object.assign({
                    pkce_code_verifier: null == n ? void 0 : n.code_verifier,
                    dfp_telemetry_id: i,
                    captcha_token: a
                  }, e), t.next = 12, this._networkClient.retriableFetchSDK({
                    url: "/b2b/magic_links/discovery/authenticate",
                    body: s,
                    errorMessage: "Failed to authenticate intermediate magic link token",
                    method: "POST",
                    retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                  });
                case 12:
                  return l = t.sent, this._pkceManager.clearPKPair(), this._subscriptionService.updateStateAndTokens({
                    state: null,
                    session_token: null,
                    session_jwt: null,
                    intermediate_session_token: l.intermediate_session_token
                  }), t.abrupt("return", l);
                case 16:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        }
      };
    }
    return a(e, [{
      key: "getCodeChallenge",
      value: function value() {
        return w(this, void 0, void 0, o().mark(function e() {
          var t, n;
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._config;
              case 2:
                if (t = e.sent, t.pkceRequiredForEmailMagicLinks) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", void 0);
              case 6:
                return e.next = 8, this._pkceManager.getPKPair();
              case 8:
                if (!(n = e.sent)) {
                  e.next = 11;
                  break;
                }
                return e.abrupt("return", n.code_challenge);
              case 11:
                return e.next = 13, this._pkceManager.startPKCETransaction();
              case 13:
                return n = e.sent, e.abrupt("return", n.code_challenge);
              case 15:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "handlePKCEForAuthenticate",
      value: function value(e, t) {
        return w(this, void 0, void 0, o().mark(function n() {
          var r, i, a, s, l, c;
          return o().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, e.getPKPair();
              case 2:
                return r = n.sent, n.next = 5, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 5:
                return i = n.sent, a = i.dfp_telemetry_id, s = i.captcha_token, l = Object.assign({
                  pkce_code_verifier: null == r ? void 0 : r.code_verifier,
                  dfp_telemetry_id: a,
                  captcha_token: s
                }, t), n.next = 11, this._networkClient.retriableFetchSDK({
                  url: "/b2b/magic_links/authenticate",
                  body: l,
                  errorMessage: "Failed to authenticate token",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 11:
                return c = n.sent, e.clearPKPair(), n.abrupt("return", c);
              case 14:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }]), e;
  }(),
  ie = a(function e(t, n) {
    var r = this;
    s(this, e), this._networkClient = t, this._subscriptionService = n, this.get = function () {
      return w(r, void 0, void 0, o().mark(function e() {
        var t;
        return o().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/members/me",
                errorMessage: "Failed to retrieve member info.",
                method: "GET"
              });
            case 2:
              return t = e.sent, this._subscriptionService.updateMember(t.member), e.abrupt("return", t.member);
            case 5:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getSync = function () {
      return r._subscriptionService.getMember();
    }, this.onChange = function (e) {
      return r._subscriptionService.subscribeToState(function (t) {
        var n;
        return e(null !== (n = null == t ? void 0 : t.member) && void 0 !== n ? n : null);
      });
    }, this.update = function (e) {
      return w(r, void 0, void 0, o().mark(function t() {
        var n;
        return o().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return X("stytch.member.update").isOptionalString("name", e.name).isOptionalObject("untrusted_metadata", e.untrusted_metadata).isOptionalBoolean("mfa_enrolled", e.mfa_enrolled).isOptionalString("mfa_phone_number", e.mfa_phone_number), t.next = 3, this._networkClient.fetchSDK({
                url: "/b2b/organizations/members/update",
                body: e,
                errorMessage: "Failed to update member.",
                method: "PUT"
              });
            case 3:
              return n = t.sent, this._subscriptionService.updateMember(n.member), t.abrupt("return", n);
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteMFAPhoneNumber = function () {
      return w(r, void 0, void 0, o().mark(function e() {
        var t;
        return o().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/members/deletePhoneNumber",
                errorMessage: "Failed to delete member phone number.",
                method: "DELETE"
              });
            case 2:
              return t = e.sent, this._subscriptionService.updateMember(t.member), e.abrupt("return", t);
            case 5:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    };
  }),
  ae = function () {
    function e(t, n, r, o, i) {
      var a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : te();
      s(this, e), this._networkClient = t, this._subscriptionService = n, this._pkceManager = r, this._dynamicConfig = o, this._config = i, this.dfpProtectedAuth = a;
    }
    return a(e, [{
      key: "authenticate",
      value: function value(e) {
        return w(this, void 0, void 0, o().mark(function t() {
          var n, r, i, a, s;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return X("stytch.sso.authenticate").isString("sso_token", e.sso_token).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.next = 3, this._pkceManager.getPKPair();
              case 3:
                return (n = t.sent) || G("No code verifier found in local storage for SSO flow.\nConsider using stytch.sso.start() to add PKCE to your SSO flows for added security.\nSee https://stytch.com/docs/oauth#guides_pkce for more information."), t.next = 7, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 7:
                return r = t.sent, i = r.dfp_telemetry_id, a = r.captcha_token, t.next = 12, this._networkClient.retriableFetchSDK({
                  url: "/b2b/sso/authenticate",
                  method: "POST",
                  body: Object.assign(Object.assign({
                    pkce_code_verifier: null == n ? void 0 : n.code_verifier
                  }, e), {
                    dfp_telemetry_id: i,
                    captcha_token: a
                  }),
                  errorMessage: "Failed to authenticate token",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 12:
                return s = t.sent, this._pkceManager.clearPKPair(), s.member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.member_session,
                    member: s.member
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: s.intermediate_session_token
                }), t.abrupt("return", s);
              case 16:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "getBaseApiUrl",
      value: function value() {
        return w(this, void 0, void 0, o().mark(function e() {
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (!Z(this._config.publicToken)) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return", this._config.testAPIURL);
              case 2:
                return e.abrupt("return", this._config.liveAPIURL);
              case 3:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "start",
      value: function value(e) {
        var t = e.connection_id,
          n = e.login_redirect_url,
          r = e.signup_redirect_url;
        return w(this, void 0, void 0, o().mark(function e() {
          var i, a, s, l, c;
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._dynamicConfig;
              case 2:
                return i = e.sent, a = i.pkceRequiredForSso, e.next = 6, this.getBaseApiUrl();
              case 6:
                if (s = e.sent, (l = new URL("".concat(s, "/v1/public/sso/start"))).searchParams.set("public_token", this._config.publicToken), l.searchParams.set("connection_id", t), !a) {
                  e.next = 17;
                  break;
                }
                return e.next = 13, this._pkceManager.startPKCETransaction();
              case 13:
                c = e.sent, l.searchParams.set("pkce_code_challenge", c.code_challenge), e.next = 18;
                break;
              case 17:
                this._pkceManager.clearPKPair();
              case 18:
                n && l.searchParams.set("login_redirect_url", n), r && l.searchParams.set("signup_redirect_url", r), window.location.href = l.toString();
              case 21:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }]), e;
  }(),
  se = a(function e(t) {
    var n = this;
    s(this, e), this._networkClient = t, this.get = function () {
      return w(n, void 0, void 0, o().mark(function e() {
        var t;
        return o().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/b2b/organizations/me",
                errorMessage: "Failed to retrieve organization info.",
                method: "GET"
              });
            case 2:
              return t = e.sent, e.abrupt("return", t.organization);
            case 4:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    };
  }),
  le = function () {
    function e(t, n, r, i, a) {
      var l = this,
        c = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : te();
      s(this, e), this._networkClient = t, this._subscriptionService = n, this._pkceManager = r, this._dynamicConfig = i, this._config = a, this.dfpProtectedAuth = c, this.discovery = {
        authenticate: function authenticate(e) {
          return w(l, void 0, void 0, o().mark(function t() {
            var n, r, i, a, s, l;
            return o().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return X("stytch.oauth.discovery.authenticate").isString("discovery_oauth_token", e.discovery_oauth_token), t.next = 3, this._pkceManager.getPKPair();
                case 3:
                  return n = t.sent, t.next = 6, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
                case 6:
                  return r = t.sent, i = r.dfp_telemetry_id, a = r.captcha_token, s = Object.assign({
                    pkce_code_verifier: null == n ? void 0 : n.code_verifier,
                    dfp_telemetry_id: i,
                    captcha_token: a
                  }, e), t.next = 12, this._networkClient.retriableFetchSDK({
                    url: "/b2b/oauth/discovery/authenticate",
                    body: s,
                    errorMessage: "Failed to authenticate discovery oauth token",
                    method: "POST",
                    retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                  });
                case 12:
                  return l = t.sent, this._pkceManager.clearPKPair(), this._subscriptionService.updateStateAndTokens({
                    state: null,
                    session_token: null,
                    session_jwt: null,
                    intermediate_session_token: l.intermediate_session_token
                  }), t.abrupt("return", l);
                case 16:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        }
      }, this.google = {
        start: this.startOAuthFlow(C.Google),
        discovery: {
          start: this.startDiscoveryOAuthFlow(C.Google)
        }
      }, this.microsoft = {
        start: this.startOAuthFlow(C.Microsoft),
        discovery: {
          start: this.startDiscoveryOAuthFlow(C.Microsoft)
        }
      };
    }
    return a(e, [{
      key: "authenticate",
      value: function value(e) {
        return w(this, void 0, void 0, o().mark(function t() {
          var n, r, i, a, s;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return X("stytch.oauth.authenticate").isString("oauth_token", e.oauth_token).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.next = 3, this._pkceManager.getPKPair();
              case 3:
                return (n = t.sent) || G("No code verifier found in local storage for OAuth flow.\nConsider using stytch.oauth.$provider.start() to add PKCE to your OAuth flows for added security.\nSee https://stytch.com/docs/oauth#guides_pkce for more information."), t.next = 7, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 7:
                return r = t.sent, i = r.dfp_telemetry_id, a = r.captcha_token, t.next = 12, this._networkClient.retriableFetchSDK({
                  url: "/b2b/oauth/authenticate",
                  method: "POST",
                  body: Object.assign({
                    pkce_code_verifier: null == n ? void 0 : n.code_verifier,
                    dfp_telemetry_id: i,
                    captcha_token: a
                  }, e),
                  errorMessage: "Failed to authenticate token",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 12:
                return s = t.sent, this._pkceManager.clearPKPair(), s.member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.member_session,
                    member: s.member
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: s.intermediate_session_token
                }), t.abrupt("return", s);
              case 16:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "getBaseApiUrl",
      value: function value() {
        return w(this, void 0, void 0, o().mark(function e() {
          var t, n;
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._dynamicConfig;
              case 2:
                if (t = e.sent, !(n = t.cnameDomain)) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", "https://".concat(n));
              case 6:
                if (!Z(this._config.publicToken)) {
                  e.next = 8;
                  break;
                }
                return e.abrupt("return", this._config.testAPIURL);
              case 8:
                return e.abrupt("return", this._config.liveAPIURL);
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "startOAuthFlow",
      value: function value(e) {
        var t = this;
        return function (n) {
          var r = n.organization_id,
            i = n.organization_slug,
            a = n.login_redirect_url,
            s = n.signup_redirect_url,
            l = n.custom_scopes,
            c = n.provider_params;
          return w(t, void 0, void 0, o().mark(function t() {
            var n, u, d, f, p, h;
            return o().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._dynamicConfig;
                case 2:
                  return n = t.sent, u = n.pkceRequiredForOAuth, t.next = 6, this.getBaseApiUrl();
                case 6:
                  if (d = t.sent, (f = new URL("".concat(d, "/v1/b2b/public/oauth/").concat(e, "/start"))).searchParams.set("public_token", this._config.publicToken), r && "" != r && f.searchParams.set("organization_id", r), i && "" != i && f.searchParams.set("slug", i), l && (X("startOAuthFlow").isStringArray("custom_scopes", l), f.searchParams.set("custom_scopes", l.join(" "))), c) for (p in X("startOAuthFlow").isOptionalObject("provider_params", c), c) f.searchParams.set("provider_" + p, c[p]);
                  if (!u) {
                    t.next = 20;
                    break;
                  }
                  return t.next = 16, this._pkceManager.startPKCETransaction();
                case 16:
                  h = t.sent, f.searchParams.set("pkce_code_challenge", h.code_challenge), t.next = 21;
                  break;
                case 20:
                  this._pkceManager.clearPKPair();
                case 21:
                  a && f.searchParams.set("login_redirect_url", a), s && f.searchParams.set("signup_redirect_url", s), window.location.href = f.toString();
                case 24:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        };
      }
    }, {
      key: "startDiscoveryOAuthFlow",
      value: function value(e) {
        var t = this;
        return function (n) {
          var r = n.discovery_redirect_url,
            i = n.custom_scopes,
            a = n.provider_params;
          return w(t, void 0, void 0, o().mark(function t() {
            var n, s, l, c, u, d;
            return o().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._dynamicConfig;
                case 2:
                  return n = t.sent, s = n.pkceRequiredForOAuth, t.next = 6, this.getBaseApiUrl();
                case 6:
                  if (l = t.sent, (c = new URL("".concat(l, "/v1/b2b/public/oauth/").concat(e, "/discovery/start"))).searchParams.set("public_token", this._config.publicToken), i && (X("startOAuthFlow").isStringArray("custom_scopes", i), c.searchParams.set("custom_scopes", i.join(" "))), a) for (u in X("startOAuthFlow").isOptionalObject("provider_params", a), a) c.searchParams.set("provider_" + u, a[u]);
                  if (!s) {
                    t.next = 18;
                    break;
                  }
                  return t.next = 14, this._pkceManager.startPKCETransaction();
                case 14:
                  d = t.sent, c.searchParams.set("pkce_code_challenge", d.code_challenge), t.next = 19;
                  break;
                case 18:
                  this._pkceManager.clearPKPair();
                case 19:
                  r && c.searchParams.set("discovery_redirect_url", r), window.location.href = c.toString();
                case 21:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        };
      }
    }]), e;
  }(),
  ce = function () {
    function e(t, n) {
      var r = this;
      s(this, e), this._networkClient = t, this._subscriptionService = n, this.getSync = function () {
        return r._subscriptionService.getSession();
      }, this.onChange = function (e) {
        return r._subscriptionService.subscribeToState(function (t) {
          var n;
          return e(null !== (n = null == t ? void 0 : t.session) && void 0 !== n ? n : null);
        });
      }, this.revoke = function (e) {
        return w(r, void 0, void 0, o().mark(function t() {
          var n;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, this._networkClient.fetchSDK({
                  url: "/b2b/sessions/revoke",
                  errorMessage: "Error revoking session",
                  method: "POST"
                });
              case 3:
                return n = t.sent, this._subscriptionService.destroyState(), t.abrupt("return", n);
              case 8:
                throw t.prev = 8, t.t0 = t["catch"](0), ((null == e ? void 0 : e.forceClear) || B.includes(t.t0.error_type)) && this._subscriptionService.destroyState(), t.t0;
              case 12:
              case "end":
                return t.stop();
            }
          }, t, this, [[0, 8]]);
        }));
      }, this.authenticate = function (e) {
        return w(r, void 0, void 0, o().mark(function t() {
          var n, r;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, n = {
                  session_duration_minutes: null == e ? void 0 : e.session_duration_minutes
                }, t.next = 4, this._networkClient.fetchSDK({
                  url: "/b2b/sessions/authenticate",
                  body: n,
                  errorMessage: "Error authenticating session",
                  method: "POST"
                });
              case 4:
                return r = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: r.member_session,
                    member: r.member
                  },
                  session_token: r.session_token,
                  session_jwt: r.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", r);
              case 9:
                throw t.prev = 9, t.t0 = t["catch"](0), B.includes(t.t0.error_type) && this._subscriptionService.destroyState(), t.t0;
              case 13:
              case "end":
                return t.stop();
            }
          }, t, this, [[0, 9]]);
        }));
      }, this.exchange = function (e) {
        return w(r, void 0, void 0, o().mark(function t() {
          var n;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return X("stytch.sessions.exchange").isString("organization_id", e.organization_id).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.prev = 1, t.next = 4, this._networkClient.fetchSDK({
                  url: "/b2b/sessions/exchange",
                  body: e,
                  errorMessage: "Failed to exchange session",
                  method: "POST"
                });
              case 4:
                return (n = t.sent).member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: n.member_session,
                    member: n.member
                  },
                  session_token: n.session_token,
                  session_jwt: n.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: n.intermediate_session_token
                }), t.abrupt("return", n);
              case 9:
                throw t.prev = 9, t.t0 = t["catch"](1), t.t0;
              case 12:
              case "end":
                return t.stop();
            }
          }, t, this, [[1, 9]]);
        }));
      };
    }
    return a(e, [{
      key: "getTokens",
      value: function value() {
        return this._subscriptionService.getTokens();
      }
    }]), e;
  }(),
  ue = a(function e(t, n) {
    var r = this;
    s(this, e), this._networkClient = t, this._subscriptionService = n, this.organizations = {
      list: function list() {
        return w(r, void 0, void 0, o().mark(function e() {
          return o().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.t0 = this._networkClient, e.next = 3, this._subscriptionService.getIntermediateSessionToken();
              case 3:
                if (e.t1 = e.sent, e.t1) {
                  e.next = 6;
                  break;
                }
                e.t1 = void 0;
              case 6:
                return e.t2 = e.t1, e.t3 = {
                  intermediate_session_token: e.t2
                }, e.t4 = {
                  url: "/b2b/discovery/organizations",
                  body: e.t3,
                  errorMessage: "Failed to retrieve discovered organizations",
                  method: "POST"
                }, e.abrupt("return", e.t0.fetchSDK.call(e.t0, e.t4));
              case 10:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      },
      create: function create(e) {
        return w(r, void 0, void 0, o().mark(function t() {
          var n, r;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return X("stytch.discovery.organizations.create").isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("organization_name", e.organization_name).isOptionalString("organization_slug", e.organization_slug).isOptionalString("organization_logo_url", e.organization_logo_url).isOptionalString("sso_jit_provisioning", e.sso_jit_provisioning).isOptionalStringArray("email_allowed_domains", e.email_allowed_domains).isOptionalString("email_invites", e.email_invites).isOptionalString("auth_methods", e.auth_methods).isOptionalStringArray("allowed_auth_methods", e.allowed_auth_methods).isOptionalString("mfa_policy", e.mfa_policy), t.t0 = Object, t.t1 = Object.assign({}, e), t.next = 5, this._subscriptionService.getIntermediateSessionToken();
              case 5:
                if (t.t2 = t.sent, t.t2) {
                  t.next = 8;
                  break;
                }
                t.t2 = void 0;
              case 8:
                return t.t3 = t.t2, t.t4 = {
                  intermediate_session_token: t.t3
                }, n = t.t0.assign.call(t.t0, t.t1, t.t4), t.next = 13, this._networkClient.fetchSDK({
                  url: "/b2b/discovery/organizations/create",
                  body: n,
                  errorMessage: "Failed to create organization and member",
                  method: "POST"
                });
              case 13:
                return (r = t.sent).member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: r.member_session,
                    member: r.member
                  },
                  session_token: r.session_token,
                  session_jwt: r.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: r.intermediate_session_token
                }), t.abrupt("return", r);
              case 16:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, this.intermediateSessions = {
      exchange: function exchange(e) {
        return w(r, void 0, void 0, o().mark(function t() {
          var n, r;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return X("stytch.discovery.intermediateSessions.exchange").isString("organization_id", e.organization_id).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale), t.t0 = Object, t.t1 = Object.assign({}, e), t.next = 5, this._subscriptionService.getIntermediateSessionToken();
              case 5:
                if (t.t2 = t.sent, t.t2) {
                  t.next = 8;
                  break;
                }
                t.t2 = void 0;
              case 8:
                return t.t3 = t.t2, t.t4 = {
                  intermediate_session_token: t.t3
                }, n = t.t0.assign.call(t.t0, t.t1, t.t4), t.next = 13, this._networkClient.fetchSDK({
                  url: "/b2b/discovery/intermediate_sessions/exchange",
                  body: n,
                  errorMessage: "Failed to exchange intermediate session",
                  method: "POST"
                });
              case 13:
                return (r = t.sent).member_session ? this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: r.member_session,
                    member: r.member
                  },
                  session_token: r.session_token,
                  session_jwt: r.session_jwt,
                  intermediate_session_token: null
                }) : this._subscriptionService.updateStateAndTokens({
                  state: null,
                  session_token: null,
                  session_jwt: null,
                  intermediate_session_token: r.intermediate_session_token
                }), t.abrupt("return", r);
              case 16:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    };
  });
Promise.resolve({
  pkceRequiredForPasswordResets: !1
});
var de,
  fe,
  pe,
  he,
  me,
  ge,
  ve,
  ye,
  Ae,
  be,
  _e,
  we = a(function e(t, n) {
    var r = this,
      i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : te();
    s(this, e), this._networkClient = t, this._subscriptionService = n, this.dfpProtectedAuth = i, this.sms = {
      send: function send(e) {
        return w(r, void 0, void 0, o().mark(function t() {
          var n, r, i;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return X("stytch.otps.sms.send").isString("organization_id", e.organization_id).isString("member_id", e.member_id).isOptionalString("mfa_phone_number", e.mfa_phone_number).isOptionalString("locale", e.locale), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, i = n.captcha_token, t.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/b2b/otps/sms/send",
                  body: Object.assign(Object.assign({}, e), {
                    dfp_telemetry_id: r,
                    captcha_token: i
                  }),
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 7:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      },
      authenticate: function authenticate(e) {
        return w(r, void 0, void 0, o().mark(function t() {
          var n, r, i, a, s;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return X("stytch.otps.sms.authenticate").isString("organization_id", e.organization_id).isString("member_id", e.member_id).isString("code", e.code).isOptionalString("set_mfa_enrollment", e.set_mfa_enrollment), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, i = n.captcha_token, t.t0 = Object, t.t1 = Object.assign({}, e), t.t2 = r, t.t3 = i, t.next = 12, this._subscriptionService.getIntermediateSessionToken();
              case 12:
                if (t.t4 = t.sent, t.t4) {
                  t.next = 15;
                  break;
                }
                t.t4 = void 0;
              case 15:
                return t.t5 = t.t4, t.t6 = {
                  dfp_telemetry_id: t.t2,
                  captcha_token: t.t3,
                  intermediate_session_token: t.t5
                }, a = t.t0.assign.call(t.t0, t.t1, t.t6), t.next = 20, this._networkClient.retriableFetchSDK({
                  url: "/b2b/otps/sms/authenticate",
                  body: a,
                  errorMessage: "Failed to authenticate one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 20:
                return s = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.member_session,
                    member: s.member
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", s);
              case 23:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    };
  }),
  ke = function () {
    function e(t, n) {
      var r = this;
      s(this, e), this._subscriptionService = t, this._headlessSessionClient = n, this._onDataChange = function (e) {
        (null == e ? void 0 : e.session) ? r.scheduleBackgroundRefresh() : r.cancelBackgroundRefresh();
      }, this._reauthenticateWithBackoff = function () {
        return w(r, void 0, void 0, o().mark(function t() {
          var n;
          return o().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                n = 0;
              case 1:
                return t.prev = 2, t.next = 5, this._headlessSessionClient.authenticate();
              case 5:
                return t.abrupt("return", t.sent);
              case 8:
                if (t.prev = 8, t.t0 = t["catch"](2), !e.isUnrecoverableError(t.t0)) {
                  t.next = 12;
                  break;
                }
                return t.abrupt("return", Promise.reject(t.t0));
              case 12:
                return n++, t.next = 15, new Promise(function (t) {
                  return setTimeout(t, e.timeoutForAttempt(n));
                });
              case 15:
                t.next = 1;
                break;
              case 17:
              case "end":
                return t.stop();
            }
          }, t, this, [[2, 8]]);
        }));
      }, this.timeout = null, this._subscriptionService.subscribeToState(this._onDataChange);
    }
    return a(e, [{
      key: "performBackgroundRefresh",
      value: function value() {
        var e = this;
        this._reauthenticateWithBackoff().then(function () {
          e.scheduleBackgroundRefresh();
        })["catch"](function (t) {
          G("Session background refresh failed. Signalling to app that user is logged out.", {
            error: t
          }), e._subscriptionService.destroyState();
        });
      }
    }, {
      key: "scheduleBackgroundRefresh",
      value: function value() {
        var t = this;
        this.cancelBackgroundRefresh(), this.timeout = setTimeout(function () {
          t.performBackgroundRefresh();
        }, e.REFRESH_INTERVAL_MS);
      }
    }, {
      key: "cancelBackgroundRefresh",
      value: function value() {
        null !== this.timeout && (clearTimeout(this.timeout), this.timeout = null);
      }
    }], [{
      key: "timeoutForAttempt",
      value: function value(e) {
        return e = Math.min(e, 7), Math.floor(350 * Math.random()) - 175 + 2e3 * Math.pow(2, e);
      }
    }, {
      key: "isUnrecoverableError",
      value: function value(e) {
        return B.includes(e.error_type);
      }
    }]), e;
  }();
function Ee(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        l(r.next(e));
      } catch (e) {
        i(e);
      }
    }
    function s(e) {
      try {
        l(r["throw"](e));
      } catch (e) {
        i(e);
      }
    }
    function l(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(a, s);
    }
    l((r = r.apply(e, t || [])).next());
  });
}
ke.REFRESH_INTERVAL_MS = 18e4, "function" == typeof SuppressedError && SuppressedError, function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.oauth = "oauth", e.otp = "otp", e.crypto = "crypto", e.passwords = "passwords", e.passkeys = "passkeys";
}(de || (de = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft", e.Apple = "apple", e.Github = "github", e.GitLab = "gitlab", e.Facebook = "facebook", e.Discord = "discord", e.Salesforce = "salesforce", e.Slack = "slack", e.Amazon = "amazon", e.Bitbucket = "bitbucket", e.LinkedIn = "linkedin", e.Coinbase = "coinbase", e.Twitch = "twitch", e.Twitter = "twitter", e.TikTok = "tiktok", e.Snapchat = "snapchat", e.Figma = "figma", e.Yahoo = "yahoo";
}(fe || (fe = {})), function (e) {
  e.Vessel = "Vessel", e.Phantom = "Phantom", e.Metamask = "Metamask", e.Coinbase = "Coinbase", e.Binance = "Binance", e.GenericEthereumWallet = "Other Ethereum Wallet", e.GenericSolanaWallet = "Other Solana Wallet";
}(pe || (pe = {})), function (e) {
  e.embedded = "embedded", e.floating = "floating";
}(he || (he = {})), function (e) {
  e.SMS = "sms", e.WhatsApp = "whatsapp", e.Email = "email";
}(me || (me = {})), function (e) {
  e.MagicLinkLoginOrCreateEvent = "MAGIC_LINK_LOGIN_OR_CREATE", e.OTPsLoginOrCreateEvent = "OTP_LOGIN_OR_CREATE", e.OTPsAuthenticate = "OTP_AUTHENTICATE", e.CryptoWalletAuthenticateStart = "CRYPTO_WALLET_AUTHENTICATE_START", e.CryptoWalletAuthenticate = "CRYPTO_WALLET_AUTHENTICATE", e.PasswordCreate = "PASSWORD_CREATE", e.PasswordAuthenticate = "PASSWORD_AUTHENTICATE", e.PasswordResetByEmailStart = "PASSWORD_RESET_BY_EMAIL_START", e.PasswordResetByEmail = "PASSWORD_RESET_BY_EMAIL", e.PasskeyRegister = "PASSKEY_REGISTER", e.PasskeyAuthenticate = "PASSKEY_AUTHENTICATE", e.PasskeySkip = "PASSKEY_SKIP", e.PasskeyDone = "PASSKEY_DONE", e.B2BMagicLinkEmailLoginOrSignup = "B2B_MAGIC_LINK_EMAIL_LOGIN_OR_SIGNUP", e.B2BMagicLinkAuthenticate = "B2B_MAGIC_LINK_AUTHENTICATE", e.B2BMagicLinkEmailDiscoverySend = "B2B_MAGIC_LINK_EMAIL_DISCOVERY_SEND", e.B2BMagicLinkDiscoveryAuthenticate = "B2B_MAGIC_LINK_DISCOVERY_AUTHENTICATE", e.B2BSSOStart = "B2B_SSO_START", e.B2BSSOAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthDiscoveryAuthenticate = "B2B_OAUTH_DISCOVERY_AUTHENTICATE", e.B2BDiscoveryOrganizationsCreate = "B2B_DISCOVERY_ORGANIZATIONS_CREATE", e.B2BDiscoveryIntermediateSessionExchange = "B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE", e.B2BPasswordAuthenticate = "B2B_PASSWORD_AUTHENTICATE", e.B2BPasswordResetByEmailStart = "B2B_PASSWORD_RESET_BY_EMAIL_START", e.B2BPasswordResetByEmail = "B2B_PASSWORD_RESET_BY_EMAIL", e.B2BPasswordResetBySession = "B2B_PASSWORD_RESET_BY_SESSION";
}(ge || (ge = {}));
var Se = /*#__PURE__*/function (_Error) {
  _inherits(Se, _Error);
  var _super = _createSuper(Se);
  function Se(e, t) {
    var _this;
    _classCallCheck(this, Se);
    _this = _super.call(this), _this.name = "StytchSDKUsageError", _this.message = "Invalid call to ".concat(e, "\n") + t;
    return _this;
  }
  return _createClass(Se);
}( /*#__PURE__*/_wrapNativeSuper(Error));
!function (e) {
  e.BiometricsSensorError = "biometrics_sensor_error", e.DeviceCredentialsNotAllowed = "device_credentials_not_allowed", e.DeviceHardwareError = "device_hardware_error", e.InternalError = "internal_error", e.KeyInvalidated = "key_invalidated", e.KeystoreUnavailable = "keystore_unavailable", e.NoBiometricsEnrolled = "no_biometrics_enrolled", e.NoBiometricsRegistration = "no_biometrics_registration", e.SessionExpired = "session_expired", e.UserCancellation = "user_cancellation", e.UserLockedOut = "user_locked_out", e.BiometricsNotAvailable = "biometrics_not_available";
}(ve || (ve = {})), function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.sso = "sso", e.passwords = "passwords", e.oauth = "oauth";
}(ye || (ye = {})), function (e) {
  e.Discovery = "Discovery", e.Organization = "Organization", e.PasswordReset = "PasswordReset";
}(Ae || (Ae = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft";
}(be || (be = {})), function (e) {
  e.RequiredCatcha = "Catcha Required";
}(_e || (_e = {}));
var Ce = function Ce(e) {
  var t = {
    isObject: function isObject(n, r) {
      if (!("object" == _typeof(r) && !Array.isArray(r) && null !== r)) throw new Se(e, n + " must be an object.");
      return t;
    },
    isOptionalObject: function isOptionalObject(e, n) {
      return void 0 === n ? t : t.isObject(e, n);
    },
    isString: function isString(n, r) {
      if ("string" != typeof r) throw new Se(e, n + " must be a string.");
      return t;
    },
    isOptionalString: function isOptionalString(e, n) {
      return void 0 === n ? t : t.isString(e, n);
    },
    isStringArray: function isStringArray(n, r) {
      if (!Array.isArray(r)) throw new Se(e, n + " must be an array of strings.");
      var _iterator = _createForOfIteratorHelper(r),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t2 = _step.value;
          if ("string" != typeof _t2) throw new Se(e, n + " must be an array of strings.");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return t;
    },
    isOptionalStringArray: function isOptionalStringArray(e, n) {
      return void 0 === n ? t : t.isStringArray(e, n);
    },
    isNumber: function isNumber(n, r) {
      if ("number" != typeof r) throw new Se(e, n + " must be a number.");
      return t;
    },
    isOptionalNumber: function isOptionalNumber(e, n) {
      return void 0 === n ? t : t.isNumber(e, n);
    },
    isBoolean: function isBoolean(n, r) {
      if ("boolean" != typeof r) throw new Se(e, n + " must be a boolean.");
      return t;
    },
    isOptionalBoolean: function isOptionalBoolean(e, n) {
      return void 0 === n ? t : t.isBoolean(e, n);
    }
  };
  return t;
};
var xe;
!function (e) {
  e.LoginOrCreateEML = "login_or_create_eml", e.LoginOrCreateOTP = "login_or_create_otp", e.ResetPassword = "reset_password";
}(xe || (xe = {})), Promise.resolve({
  pkceRequiredForEmailMagicLinks: !1
}), Promise.resolve({
  pkceRequiredForPasswordResets: !1
}), Promise.resolve({
  pkceRequiredForEmailMagicLinks: !1
});
var Oe = Promise.resolve({
  pkceRequiredForPasswordResets: !1
});
var Pe = /*#__PURE__*/function () {
  function Pe(e, t, n) {
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Oe;
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
      return {
        isEnabled: function isEnabled() {
          return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", !1);
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
        },
        getTelemetryID: function getTelemetryID() {
          return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
        },
        getDFPTelemetryIDAndCaptcha: function getDFPTelemetryIDAndCaptcha() {
          return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", {
                    dfp_telemetry_id: void 0,
                    captcha_token: void 0
                  });
                case 1:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
        },
        retryWithCaptchaAndDFP: function retryWithCaptchaAndDFP() {
          return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  throw new Error("DFP protected auth is disabled");
                case 1:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
        }
      };
    }();
    _classCallCheck(this, Pe);
    this._networkClient = e, this._subscriptionService = t, this._pkceManager = n, this._config = r, this.dfpProtectedAuth = o;
  }
  _createClass(Pe, [{
    key: "getCodeChallenge",
    value: function getCodeChallenge() {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _yield$this$_config, e, t;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this._config;
            case 2:
              _yield$this$_config = _context5.sent;
              e = _yield$this$_config.pkceRequiredForPasswordResets;
              if (e) {
                _context5.next = 6;
                break;
              }
              return _context5.abrupt("return");
            case 6:
              _context5.next = 8;
              return this._pkceManager.getPKPair();
            case 8:
              t = _context5.sent;
              _context5.t0 = t;
              if (_context5.t0) {
                _context5.next = 14;
                break;
              }
              _context5.next = 13;
              return this._pkceManager.startPKCETransaction();
            case 13:
              t = _context5.sent;
            case 14:
              return _context5.abrupt("return", t.code_challenge);
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "authenticate",
    value: function authenticate(e) {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var t, n, _yield$this$dfpProtec, r, o, i;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              Ce("stytch.passwords.authenticate").isString("org_id", e.organization_id).isString("password", e.password).isString("email_address", e.email_address).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale);
              _context6.next = 3;
              return this._pkceManager.getPKPair();
            case 3:
              t = _context6.sent;
              n = null == t ? void 0 : t.code_verifier;
              _context6.next = 7;
              return this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
            case 7:
              _yield$this$dfpProtec = _context6.sent;
              r = _yield$this$dfpProtec.dfp_telemetry_id;
              o = _yield$this$dfpProtec.captcha_token;
              _context6.next = 12;
              return this._networkClient.retriableFetchSDK({
                url: "/b2b/passwords/authenticate",
                method: "POST",
                errorMessage: "Failed to authenticate password.",
                body: {
                  organization_id: e.organization_id,
                  email_address: e.email_address,
                  password: e.password,
                  session_duration_minutes: e.session_duration_minutes,
                  locale: e.locale,
                  captcha_token: o,
                  dfp_telemetry_id: r,
                  code_verifier: n
                },
                retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
              });
            case 12:
              i = _context6.sent;
              return _context6.abrupt("return", (i.member_session ? this._subscriptionService.updateStateAndTokens({
                state: {
                  session: i.member_session,
                  member: i.member
                },
                session_token: i.session_token,
                session_jwt: i.session_jwt,
                intermediate_session_token: null
              }) : this._subscriptionService.updateStateAndTokens({
                state: null,
                session_token: null,
                session_jwt: null,
                intermediate_session_token: i.intermediate_session_token
              }), i));
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "resetByEmailStart",
    value: function resetByEmailStart(e) {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var t, _yield$this$dfpProtec2, n, r;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              Ce("stytch.passwords.resetByEmailStart").isString("email", e.email_address).isOptionalString("login_redirect_url", e.login_redirect_url).isOptionalString("reset_password_redirect_url", e.reset_password_redirect_url).isOptionalString("reset_password_template_id", e.reset_password_template_id).isOptionalNumber("reset_password_expiration_minutes", e.reset_password_expiration_minutes);
              _context7.next = 3;
              return this.getCodeChallenge();
            case 3:
              t = _context7.sent;
              _context7.next = 6;
              return this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
            case 6:
              _yield$this$dfpProtec2 = _context7.sent;
              n = _yield$this$dfpProtec2.dfp_telemetry_id;
              r = _yield$this$dfpProtec2.captcha_token;
              return _context7.abrupt("return", this._networkClient.retriableFetchSDK({
                url: "/b2b/passwords/email/reset/start",
                method: "POST",
                errorMessage: "Failed to start password reset flow.",
                body: {
                  organization_id: e.organization_id,
                  email_address: e.email_address,
                  login_redirect_url: e.login_redirect_url,
                  reset_password_redirect_url: e.reset_password_redirect_url,
                  reset_password_expiration_minutes: e.reset_password_expiration_minutes,
                  reset_password_template_id: e.reset_password_template_id,
                  code_challenge: t,
                  captcha_token: r,
                  dfp_telemetry_id: n
                },
                retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
              }));
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "resetByEmail",
    value: function resetByEmail(e) {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _yield$this$dfpProtec3, t, n, r, o, i;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              Ce("stytch.passwords.resetByEmail").isString("password_reset_token", e.password_reset_token).isString("password", e.password).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalString("locale", e.locale);
              _context8.next = 3;
              return this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
            case 3:
              _yield$this$dfpProtec3 = _context8.sent;
              t = _yield$this$dfpProtec3.dfp_telemetry_id;
              n = _yield$this$dfpProtec3.captcha_token;
              _context8.next = 8;
              return this._pkceManager.getPKPair();
            case 8:
              r = _context8.sent;
              o = null == r ? void 0 : r.code_verifier;
              _context8.next = 12;
              return this._networkClient.retriableFetchSDK({
                url: "/b2b/passwords/email/reset",
                method: "POST",
                errorMessage: "Failed to reset password.",
                body: {
                  password_reset_token: e.password_reset_token,
                  password: e.password,
                  session_duration_minutes: e.session_duration_minutes,
                  locale: e.locale,
                  captcha_token: n,
                  dfp_telemetry_id: t,
                  code_verifier: o
                },
                retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
              });
            case 12:
              i = _context8.sent;
              return _context8.abrupt("return", (this._pkceManager.clearPKPair(), i.member_session ? this._subscriptionService.updateStateAndTokens({
                state: {
                  session: i.member_session,
                  member: i.member
                },
                session_token: i.session_token,
                session_jwt: i.session_jwt,
                intermediate_session_token: null
              }) : this._subscriptionService.updateStateAndTokens({
                state: null,
                session_token: null,
                session_jwt: null,
                intermediate_session_token: i.intermediate_session_token
              }), i));
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "resetByExistingPassword",
    value: function resetByExistingPassword(e) {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _yield$this$dfpProtec4, t, n, r;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              Ce("stytch.passwords.resetByExistingPassword").isString("email", e.email_address).isString("existing_password", e.existing_password).isString("new_password", e.new_password).isOptionalString("locale", e.locale);
              _context9.next = 3;
              return this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
            case 3:
              _yield$this$dfpProtec4 = _context9.sent;
              t = _yield$this$dfpProtec4.dfp_telemetry_id;
              n = _yield$this$dfpProtec4.captcha_token;
              _context9.next = 8;
              return this._networkClient.retriableFetchSDK({
                url: "/b2b/passwords/existing_password/reset",
                method: "POST",
                errorMessage: "Failed to reset password.",
                body: {
                  organization_id: e.organization_id,
                  email_address: e.email_address,
                  existing_password: e.existing_password,
                  new_password: e.new_password,
                  locale: e.locale,
                  captcha_token: n,
                  dfp_telemetry_id: t
                },
                retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
              });
            case 8:
              r = _context9.sent;
              return _context9.abrupt("return", (r.member_session ? this._subscriptionService.updateStateAndTokens({
                state: {
                  session: r.member_session,
                  member: r.member
                },
                session_token: r.session_token,
                session_jwt: r.session_jwt,
                intermediate_session_token: null
              }) : this._subscriptionService.updateStateAndTokens({
                state: null,
                session_token: null,
                session_jwt: null,
                intermediate_session_token: r.intermediate_session_token
              }), r));
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "resetBySession",
    value: function resetBySession(e) {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _yield$this$dfpProtec5, t, n, r;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              Ce("stytch.passwords.resetBySession").isString("password", e.password);
              _context10.next = 3;
              return this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
            case 3:
              _yield$this$dfpProtec5 = _context10.sent;
              t = _yield$this$dfpProtec5.dfp_telemetry_id;
              n = _yield$this$dfpProtec5.captcha_token;
              _context10.next = 8;
              return this._networkClient.retriableFetchSDK({
                url: "/b2b/passwords/session/reset",
                method: "POST",
                errorMessage: "Failed to reset by session.",
                body: {
                  password: e.password,
                  captcha_token: n,
                  dfp_telemetry_id: t
                },
                retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
              });
            case 8:
              r = _context10.sent;
              return _context10.abrupt("return", (this._subscriptionService.updateStateAndTokens({
                state: {
                  session: r.member_session,
                  member: r.member
                },
                session_token: r.session_token,
                session_jwt: r.session_jwt,
                intermediate_session_token: null
              }), r));
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "strengthCheck",
    value: function strengthCheck(e) {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", (Ce("stytch.passwords.strengthCheck").isOptionalString("email", e.email_address).isString("password", e.password), this._networkClient.fetchSDK({
                url: "/b2b/passwords/strength_check",
                method: "POST",
                errorMessage: "Failed to check password strength.",
                body: {
                  email_address: e.email_address,
                  password: e.password
                }
              })));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }]);
  return Pe;
}();
var Te = "bootstrap";
var Ie = /*#__PURE__*/function () {
  function Ie(e, t, n) {
    var _this2 = this;
    _classCallCheck(this, Ie);
    this._publicToken = e, this._networkClient = t, this._dataLayer = n, this._bootstrapDataPromise = this._networkClient.fetchSDK({
      url: "/projects/bootstrap/".concat(this._publicToken),
      method: "GET",
      errorMessage: "Error fetching bootstrap data for SDK for ".concat(this._publicToken)
    }).then(Ie.mapBootstrapData).then(function (e) {
      return _this2._dataLayer.setItem(Te, JSON.stringify(e)), e;
    })["catch"](function (e) {
      return Y(e), {
        displayWatermark: !1,
        cnameDomain: null,
        emailDomains: ["stytch.com"],
        captchaSettings: {
          enabled: !1
        },
        pkceRequiredForEmailMagicLinks: !1,
        pkceRequiredForPasswordResets: !1,
        pkceRequiredForOAuth: !1,
        pkceRequiredForSso: !1,
        slugPattern: null,
        createOrganizationEnabled: !1,
        passwordConfig: null,
        runDFPProtectedAuth: !1
      };
    });
  }
  _createClass(Ie, [{
    key: "getSync",
    value: function getSync() {
      var e = this._dataLayer.getItem(Te);
      if (null === e) return {
        displayWatermark: !1,
        cnameDomain: null,
        emailDomains: ["stytch.com"],
        captchaSettings: {
          enabled: !1
        },
        pkceRequiredForEmailMagicLinks: !1,
        pkceRequiredForPasswordResets: !1,
        pkceRequiredForOAuth: !1,
        pkceRequiredForSso: !1,
        slugPattern: null,
        createOrganizationEnabled: !1,
        passwordConfig: null,
        runDFPProtectedAuth: !1
      };
      try {
        return JSON.parse(e);
      } catch (e) {
        return {
          displayWatermark: !1,
          cnameDomain: null,
          emailDomains: ["stytch.com"],
          captchaSettings: {
            enabled: !1
          },
          pkceRequiredForEmailMagicLinks: !1,
          pkceRequiredForPasswordResets: !1,
          pkceRequiredForOAuth: !1,
          pkceRequiredForSso: !1,
          slugPattern: null,
          createOrganizationEnabled: !1,
          passwordConfig: null,
          runDFPProtectedAuth: !1
        };
      }
    }
  }, {
    key: "getAsync",
    value: function getAsync() {
      return this._bootstrapDataPromise;
    }
  }], [{
    key: "mapBootstrapData",
    value: function mapBootstrapData(e) {
      var t;
      var n = null !== e.password_config ? {
        ludsComplexity: e.password_config.luds_complexity,
        ludsMinimumCount: e.password_config.luds_minimum_count
      } : null;
      return {
        displayWatermark: !e.disable_sdk_watermark,
        captchaSettings: e.captcha_settings,
        cnameDomain: e.cname_domain,
        emailDomains: e.email_domains,
        pkceRequiredForEmailMagicLinks: e.pkce_required_for_email_magic_links,
        pkceRequiredForPasswordResets: e.pkce_required_for_password_resets,
        pkceRequiredForOAuth: e.pkce_required_for_oauth,
        pkceRequiredForSso: e.pkce_required_for_sso,
        slugPattern: e.slug_pattern,
        createOrganizationEnabled: e.create_organization_enabled,
        passwordConfig: n,
        runDFPProtectedAuth: null !== (t = e.dfp_protected_auth_enabled) && void 0 !== t && t,
        dfpProtectedAuthMode: e.dfp_protected_auth_mode
      };
    }
  }]);
  return Ie;
}();
var Be = /*#__PURE__*/_createClass(function Be(e) {
  var _this3 = this;
  _classCallCheck(this, Be);
  this.bootstrapPromise = e, this.executeRecaptcha = function () {
    return Ee(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var _yield$this$state, e, t, n;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return this.state;
          case 2:
            _yield$this$state = _context12.sent;
            e = _yield$this$state.captchaClient;
            t = _yield$this$state.configured;
            n = _yield$this$state.siteKey;
            if (!t) {
              _context12.next = 10;
              break;
            }
            _context12.next = 9;
            return new Promise(function (t) {
              return e.ready(t);
            });
          case 9:
            return _context12.abrupt("return", e.execute(n, {
              action: "LOGIN"
            }));
          case 10:
          case "end":
            return _context12.stop();
        }
      }, _callee12, this);
    }));
  }, this.state = e.then(function (e) {
    return Ee(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      var t;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            if (!e.captchaSettings.enabled) {
              _context13.next = 9;
              break;
            }
            _context13.t1 = !0;
            _context13.next = 4;
            return t = e.captchaSettings.siteKey, H("https://www.google.com/recaptcha/enterprise.js?render=".concat(t), function () {
              return window.grecaptcha.enterprise;
            });
          case 4:
            _context13.t2 = _context13.sent;
            _context13.t3 = e.captchaSettings.siteKey;
            _context13.t0 = {
              configured: _context13.t1,
              captchaClient: _context13.t2,
              siteKey: _context13.t3
            };
            _context13.next = 10;
            break;
          case 9:
            _context13.t0 = {
              configured: !1
            };
          case 10:
            return _context13.abrupt("return", _context13.t0);
          case 11:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
  });
});
var Re = /*#__PURE__*/function () {
  function Re(e, t, n, r) {
    _classCallCheck(this, Re);
    this._publicToken = e, this._subscriptionDataLayer = t, this.baseURL = n, this.additionalTelemetryDataFn = r, this.updateSessionToken = function () {
      return null;
    }, this.eventLogger = new ne({
      maxBatchSize: 15,
      intervalDurationMs: 800,
      logEventURL: this.buildSDKUrl("/events")
    });
  }
  _createClass(Re, [{
    key: "logEvent",
    value: function logEvent(_ref) {
      var e = _ref.name,
        t = _ref.details,
        _ref$error = _ref.error,
        n = _ref$error === void 0 ? {} : _ref$error;
      this.eventLogger.logEvent(this.createTelemetryBlob(), {
        public_token: this._publicToken,
        event_name: e,
        details: t,
        error_code: n.error_code,
        error_description: n.error_description,
        http_status_code: n.http_status_code
      });
    }
  }, {
    key: "createTelemetryBlob",
    value: function createTelemetryBlob() {
      return Object.assign(Object.assign({
        event_id: "event-id-".concat(Q()),
        app_session_id: "app-session-id-".concat(Q()),
        persistent_id: "persistent-id-".concat(Q()),
        client_sent_at: new Date().toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }, this.additionalTelemetryDataFn()), {
        app: {
          identifier: window.location.hostname
        },
        sdk: {
          identifier: "Stytch.js Javascript SDK",
          version: "3.1.1"
        }
      });
    }
  }, {
    key: "fetchSDK",
    value: function fetchSDK(_ref2) {
      var e = _ref2.url,
        t = _ref2.body,
        n = _ref2.errorMessage,
        r = _ref2.method;
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var o, i, a, s;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              o = this._subscriptionDataLayer.readSessionCookie().session_token, i = "Basic " + window.btoa(this._publicToken + ":" + (o || this._publicToken)), a = window.btoa(JSON.stringify(this.createTelemetryBlob())), s = window.location.origin;
              return _context14.abrupt("return", M({
                basicAuthHeader: i,
                body: t,
                errorMessage: n,
                finalURL: this.buildSDKUrl(e),
                method: r,
                xSDKClientHeader: a,
                xSDKParentHostHeader: s
              }));
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "retriableFetchSDK",
    value: function retriableFetchSDK(_ref3) {
      var e = _ref3.url,
        t = _ref3.body,
        n = _ref3.errorMessage,
        r = _ref3.method,
        i = _ref3.retryCallback;
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var a, s, l, c;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              a = this._subscriptionDataLayer.readSessionCookie().session_token, s = "Basic " + window.btoa(this._publicToken + ":" + (a || this._publicToken)), l = window.btoa(JSON.stringify(this.createTelemetryBlob())), c = window.location.origin;
              return _context15.abrupt("return", function (e) {
                var t = e.method,
                  n = e.errorMessage,
                  r = e.finalURL,
                  i = e.basicAuthHeader,
                  a = e.xSDKClientHeader,
                  s = e.xSDKParentHostHeader,
                  l = e.body,
                  c = e.retryCallback;
                return w(this, void 0, void 0, o().mark(function e() {
                  var u;
                  return o().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return u = {
                          method: t,
                          errorMessage: n,
                          finalURL: r,
                          basicAuthHeader: i,
                          xSDKClientHeader: a,
                          xSDKParentHostHeader: s,
                          body: l
                        }, e.prev = 1, e.next = 4, M(u);
                      case 4:
                      case 15:
                        return e.abrupt("return", e.sent);
                      case 7:
                        if (e.prev = 7, e.t0 = e["catch"](1), !(e.t0 instanceof L)) {
                          e.next = 16;
                          break;
                        }
                        return e.next = 12, c(e.t0, u);
                      case 12:
                        return u = e.sent, e.next = 15, M(u);
                      case 16:
                        throw e.t0;
                      case 17:
                      case "end":
                        return e.stop();
                    }
                  }, e, null, [[1, 7]]);
                }));
              }({
                basicAuthHeader: s,
                body: t,
                errorMessage: n,
                finalURL: this.buildSDKUrl(e),
                method: r,
                xSDKClientHeader: l,
                xSDKParentHostHeader: c,
                retryCallback: i
              }));
            case 2:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "buildSDKUrl",
    value: function buildSDKUrl(e) {
      return "".concat(this.baseURL, "/sdk/v1").concat(e);
    }
  }]);
  return Re;
}();
function Le(e) {
  var t = e.toString(16);
  return 1 === t.length && (t = "0" + t), t;
}
var Me = /*#__PURE__*/function () {
  function Me(e, t) {
    _classCallCheck(this, Me);
    this._dataLayer = e, this.namespace = t;
  }
  _createClass(Me, [{
    key: "key",
    value: function key() {
      return "PKCE_VERIFIER:" + this.namespace;
    }
  }, {
    key: "startPKCETransaction",
    value: function startPKCETransaction() {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var e;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return Me.createProofkeyPair();
            case 2:
              e = _context16.sent;
              return _context16.abrupt("return", (this._dataLayer.setItem(this.key(), JSON.stringify(e)), e));
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "getPKPair",
    value: function getPKPair() {
      var e = this._dataLayer.getItem(this.key());
      if (null !== e) try {
        return JSON.parse(e);
      } catch (e) {
        return void G("Found malformed Proof Key pair in localstorage.");
      }
    }
  }, {
    key: "clearPKPair",
    value: function clearPKPair() {
      return this._dataLayer.removeItem(this.key());
    }
  }], [{
    key: "createProofkeyPair",
    value: function createProofkeyPair() {
      return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _String$fromCharCode;
        var e, t, n, r;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              e = new Uint32Array(16);
              window.crypto.getRandomValues(e);
              t = Array.from(e).map(Le).join("");
              _context17.next = 5;
              return window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(t));
            case 5:
              n = _context17.sent;
              return _context17.abrupt("return", {
                code_challenge: (r = n, btoa((_String$fromCharCode = String.fromCharCode).call.apply(_String$fromCharCode, [null].concat(_toConsumableArray(new Uint8Array(r))))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")),
                code_verifier: t
              });
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
    }
  }]);
  return Me;
}();
var De = /*#__PURE__*/function () {
  function De(e) {
    _classCallCheck(this, De);
    this._networkClient = e;
  }
  _createClass(De, [{
    key: "searchUser",
    value: function searchUser(e) {
      return this._networkClient.fetchSDK({
        url: "/users/search",
        method: "POST",
        body: {
          email: e
        },
        errorMessage: "Error searching for user ".concat(e)
      });
    }
  }, {
    key: "searchOrganization",
    value: function searchOrganization(e) {
      return this._networkClient.fetchSDK({
        url: "/b2b/organizations/search",
        method: "POST",
        body: {
          organization_slug: e
        },
        errorMessage: "Error searching slug"
      });
    }
  }, {
    key: "searchMember",
    value: function searchMember(e, t) {
      return this._networkClient.fetchSDK({
        url: "/b2b/organizations/members/search",
        method: "POST",
        body: {
          email_address: e,
          organization_id: t
        },
        errorMessage: "Error searching for member ".concat(e)
      });
    }
  }]);
  return De;
}();
var Ne = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
  ze = function ze(e) {
    return (document.cookie ? document.cookie.split("; ") : []).filter(function (t) {
      var _t$split = t.split("="),
        _t$split2 = _slicedToArray(_t$split, 1),
        n = _t$split2[0];
      return e === n;
    }).length > 1;
  };
/*! js-cookie v3.0.1 | MIT */
function je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n) e[r] = n[r];
  }
  return e;
}
var Fe = function e(t, n) {
  function r(e, r, o) {
    if ("undefined" != typeof document) {
      "number" == typeof (o = je({}, n, o)).expires && (o.expires = new Date(Date.now() + 864e5 * o.expires)), o.expires && (o.expires = o.expires.toUTCString()), e = encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var a in o) o[a] && (i += "; " + a, !0 !== o[a] && (i += "=" + o[a].split(";")[0]));
      return document.cookie = e + "=" + t.write(r, e) + i;
    }
  }
  return Object.create({
    set: r,
    get: function get(e) {
      if ("undefined" != typeof document && (!arguments.length || e)) {
        for (var n = document.cookie ? document.cookie.split("; ") : [], r = {}, o = 0; o < n.length; o++) {
          var i = n[o].split("="),
            a = i.slice(1).join("=");
          try {
            var s = decodeURIComponent(i[0]);
            if (r[s] = t.read(a, s), e === s) break;
          } catch (e) {}
        }
        return e ? r[e] : r;
      }
    },
    remove: function remove(e, t) {
      r(e, "", je({}, t, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(t) {
      return e(this.converter, je({}, this.attributes, t));
    },
    withConverter: function withConverter(t) {
      return e(je({}, this.converter, t), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(n)
    },
    converter: {
      value: Object.freeze(t)
    }
  });
}({
  read: function read(e) {
    return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
}, {
  path: "/"
});
var Ue = function Ue(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return "stytch_sdk_state_".concat(e).concat(t ? "::".concat(t) : "");
};
var Qe = /*#__PURE__*/function () {
  function Qe(e, t) {
    var _this4 = this;
    _classCallCheck(this, Qe);
    this.browserSessionStorage = {
      getItem: function getItem(e) {
        return sessionStorage.getItem(Ue(_this4.publicToken, e));
      },
      setItem: function setItem(e, t) {
        return sessionStorage.setItem(Ue(_this4.publicToken, e), t);
      },
      removeItem: function removeItem(e) {
        return sessionStorage.removeItem(Ue(_this4.publicToken, e));
      }
    }, this.publicToken = e, this.state = null, this.subscriptions = {}, (null == t ? void 0 : t.cookieOptions) ? (X("SubscriptionDataLayer").isOptionalString("cookieOptions.opaqueTokenCookieName", t.cookieOptions.opaqueTokenCookieName).isOptionalString("cookieOptions.jwtCookieName", t.cookieOptions.jwtCookieName).isOptionalString("cookieOptions.istCookieName", t.cookieOptions.istCookieName).isOptionalString("cookieOptions.path", t.cookieOptions.path).isOptionalString("cookieOptions.domain", t.cookieOptions.domain), this._jwtCookieName = t.cookieOptions.jwtCookieName || null, this._opaqueTokenCookieName = t.cookieOptions.opaqueTokenCookieName || null, this._cookiePath = t.cookieOptions.path || null, this._domain = t.cookieOptions.domain || null, this._cookieAvailableToSubdomains = t.cookieOptions.availableToSubdomains || !1, this._istCookieName = t.cookieOptions.istCookieName || null) : (this._opaqueTokenCookieName = null, this._jwtCookieName = null, this._cookiePath = null, this._domain = null, this._cookieAvailableToSubdomains = !1, this._istCookieName = null);
    var n = localStorage.getItem(Ue(this.publicToken));
    if (!n) return;
    var r;
    try {
      r = JSON.parse(n);
    } catch (e) {
      return void this.syncToLocalStorage();
    }
    this.state = r;
  }
  _createClass(Qe, [{
    key: "opaqueTokenCookieName",
    get: function get() {
      var e;
      return null !== (e = this._opaqueTokenCookieName) && void 0 !== e ? e : "stytch_session";
    }
  }, {
    key: "jwtCookieName",
    get: function get() {
      var e;
      return null !== (e = this._jwtCookieName) && void 0 !== e ? e : "stytch_session_jwt";
    }
  }, {
    key: "istCookieName",
    get: function get() {
      var e;
      return null !== (e = this._istCookieName) && void 0 !== e ? e : "stytch_intermediate_session_token";
    }
  }, {
    key: "readSessionCookie",
    value: function readSessionCookie() {
      return {
        session_token: Fe.get(this.opaqueTokenCookieName),
        session_jwt: Fe.get(this.jwtCookieName)
      };
    }
  }, {
    key: "readIntermediateSessionTokenCookie",
    value: function readIntermediateSessionTokenCookie() {
      return Fe.get(this.istCookieName);
    }
  }, {
    key: "writeSessionCookie",
    value: function writeSessionCookie(e) {
      var t, n, r, o;
      var i = e.state,
        a = e.session_token,
        s = e.session_jwt,
        l = Qe.generateCookieOpts({
          expiresAt: null !== (n = null === (t = null == i ? void 0 : i.session) || void 0 === t ? void 0 : t.expires_at) && void 0 !== n ? n : "",
          availableToSubdomains: this._cookieAvailableToSubdomains,
          path: this._cookiePath,
          domain: this._domain
        });
      Fe.set(this.opaqueTokenCookieName, a, l), Fe.set(this.jwtCookieName, s, l);
      var c = Qe.generateCookieOpts({
        expiresAt: null !== (o = null === (r = null == i ? void 0 : i.session) || void 0 === r ? void 0 : r.expires_at) && void 0 !== o ? o : "",
        availableToSubdomains: !this._cookieAvailableToSubdomains,
        path: this._cookiePath,
        domain: this._domain
      });
      ze(this.jwtCookieName) && Fe.remove(this.jwtCookieName, c), ze(this.opaqueTokenCookieName) && Fe.remove(this.opaqueTokenCookieName, c), ze(this.jwtCookieName) && G("Could not remove extraneous JWT cookie. This might happen if the cookie has been set using multiple `path` settings, and may produce unwanted behavior."), ze(this.opaqueTokenCookieName) && G("Could not remove extraneous opaque token cookie.");
    }
  }, {
    key: "writeIntermediateSessionTokenCookie",
    value: function writeIntermediateSessionTokenCookie(e) {
      var t = new Date(Date.now() + 6e5),
        n = Qe.generateCookieOpts({
          expiresAt: t.toString(),
          availableToSubdomains: this._cookieAvailableToSubdomains,
          path: this._cookiePath,
          domain: this._domain
        });
      Fe.set(this.istCookieName, e, n);
    }
  }, {
    key: "removeSessionCookie",
    value: function removeSessionCookie() {
      this.removeCookies([this.opaqueTokenCookieName, this.jwtCookieName]);
    }
  }, {
    key: "removeISTCookie",
    value: function removeISTCookie() {
      this.removeCookies([this.istCookieName]);
    }
  }, {
    key: "removeCookies",
    value: function removeCookies(e) {
      var _this5 = this;
      [!0, !1].forEach(function (t) {
        [_this5._cookiePath, null].forEach(function (n) {
          [_this5._domain, null].forEach(function (r) {
            var o = Qe.generateCookieOpts({
              expiresAt: new Date(0).toString(),
              availableToSubdomains: t,
              path: n,
              domain: r
            });
            e.forEach(function (e) {
              Fe.remove(e, o);
            });
          });
        });
      });
    }
  }, {
    key: "syncToLocalStorage",
    value: function syncToLocalStorage() {
      localStorage.setItem(Ue(this.publicToken), JSON.stringify(this.state));
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      return localStorage.getItem(Ue(this.publicToken, e));
    }
  }, {
    key: "setItem",
    value: function setItem(e, t) {
      return localStorage.setItem(Ue(this.publicToken, e), t);
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      return localStorage.removeItem(Ue(this.publicToken, e));
    }
  }], [{
    key: "generateCookieOpts",
    value: function generateCookieOpts(_ref4) {
      var e = _ref4.path,
        t = _ref4.domain,
        n = _ref4.availableToSubdomains,
        r = _ref4.expiresAt;
      var o = {
        expires: new Date(r),
        sameSite: "lax"
      };
      return e && (o.path = e), Boolean("localhost" === window.location.hostname || "[::1]" === window.location.hostname || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) ? o.secure = !1 : (n && (o.domain = t || window.location.host), o.secure = !0), o;
    }
  }]);
  return Qe;
}();
var $e = /*#__PURE__*/function (_Qe) {
  _inherits($e, _Qe);
  var _super2 = _createSuper($e);
  function $e() {
    _classCallCheck(this, $e);
    return _super2.apply(this, arguments);
  }
  return _createClass($e);
}(Qe);
var He = Symbol["for"]("__stytch_b2b_DataLayer"),
  Ve = function Ve(e, t) {
    var n = function () {
      var e = window;
      return e[He] || (e[He] = {}), e[He];
    }();
    return n[e] || (n[e] = new $e(e, t)), n[e];
  },
  We = function We(e, t) {
    Object.values(e).forEach(function (e) {
      return e(t);
    });
  },
  Ke = function () {
    var t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).KEYS_TO_EXCLUDE,
      n = void 0 === t ? [] : t;
    return function t(o, i) {
      return r(o) === r(i) && (null === o || null === i ? o === i : "object" === r(o) ? Object.keys(o).length === Object.keys(i).length && !Object.keys(o).some(function (e) {
        return !(e in i);
      }) && Object.entries(o).filter(function (t) {
        var r = e(t, 1)[0];
        return !n.includes(r);
      }).every(function (n) {
        var r = e(n, 2),
          o = r[0],
          a = r[1];
        return t(a, i[o]);
      }) : o === i);
    };
  }({
    KEYS_TO_EXCLUDE: ["last_accessed_at"]
  });
var qe = /*#__PURE__*/function () {
  function qe(e, t) {
    var _this6 = this;
    _classCallCheck(this, qe);
    this._publicToken = e, this._datalayer = t, this._listen = function (e) {
      if (e.key !== Ue(_this6._publicToken)) return;
      if (null === e.newValue || "null" === e.newValue) return void _this6.destroyState();
      var t = JSON.parse(e.newValue);
      _this6.updateState(t);
    }, window.addEventListener("storage", this._listen);
    var _this$_datalayer$read = this._datalayer.readSessionCookie(),
      n = _this$_datalayer$read.session_token;
    n || this.destroyState();
  }
  _createClass(qe, [{
    key: "getTokens",
    value: function getTokens() {
      var _this$_datalayer$read2 = this._datalayer.readSessionCookie(),
        e = _this$_datalayer$read2.session_token,
        t = _this$_datalayer$read2.session_jwt;
      return "string" != typeof e || "string" != typeof t ? null : {
        session_token: e,
        session_jwt: t
      };
    }
  }, {
    key: "getIntermediateSessionToken",
    value: function getIntermediateSessionToken() {
      return this._datalayer.readIntermediateSessionTokenCookie() || null;
    }
  }, {
    key: "destroyState",
    value: function destroyState() {
      this.updateStateAndTokens({
        state: null,
        session_token: null,
        session_jwt: null,
        intermediate_session_token: null
      });
    }
  }, {
    key: "_updateStateAndTokensInternal",
    value: function _updateStateAndTokensInternal(e) {
      var t = this._datalayer.state,
        n = null === e.state ? null : Object.assign(Object.assign({}, this._datalayer.state), e.state);
      this._datalayer.state = n, Ke(t, n) || We(this._datalayer.subscriptions, n);
    }
  }, {
    key: "updateStateAndTokens",
    value: function updateStateAndTokens(e) {
      e.state ? (this._datalayer.writeSessionCookie(e), this._datalayer.removeISTCookie()) : e.intermediate_session_token ? (this._datalayer.writeIntermediateSessionTokenCookie(e.intermediate_session_token), this._datalayer.removeSessionCookie()) : (this._datalayer.removeSessionCookie(), this._datalayer.removeISTCookie()), this._updateStateAndTokensInternal(e), this._datalayer.syncToLocalStorage();
    }
  }, {
    key: "updateState",
    value: function updateState(e) {
      var t = this._datalayer.state,
        n = null === e ? null : Object.assign(Object.assign({}, this._datalayer.state), e);
      this._datalayer.state = n, Ke(t, n) || (We(this._datalayer.subscriptions, n), this._datalayer.syncToLocalStorage());
    }
  }, {
    key: "updateTokens",
    value: function updateTokens(e) {
      var t = e.session_token,
        n = e.session_jwt,
        r = this._datalayer.readSessionCookie(),
        o = Object.assign(Object.assign({}, r), {
          session_token: t,
          session_jwt: n
        });
      t || n ? (this._datalayer.writeSessionCookie(o), this._datalayer.removeISTCookie()) : this._datalayer.removeSessionCookie();
    }
  }, {
    key: "subscribeToState",
    value: function subscribeToState(e) {
      return function (e, t) {
        var n = Math.random().toString(36).slice(-10);
        return e[n] = t, function () {
          return delete e[n];
        };
      }(this._datalayer.subscriptions, e);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this._datalayer.state;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("storage", this._listen);
    }
  }, {
    key: "syncFromDeviceStorage",
    value: function syncFromDeviceStorage() {
      return null;
    }
  }]);
  return qe;
}();
var Ge = /*#__PURE__*/function (_qe) {
  _inherits(Ge, _qe);
  var _super3 = _createSuper(Ge);
  function Ge() {
    var _this7;
    _classCallCheck(this, Ge);
    _this7 = _super3.apply(this, arguments), _this7.updateMember = function (e) {
      return _this7.updateState({
        member: e
      });
    }, _this7.getMember = function () {
      var e, t;
      return null !== (t = null === (e = _this7.getState()) || void 0 === e ? void 0 : e.member) && void 0 !== t ? t : null;
    }, _this7.getSession = function () {
      var e, t;
      return null !== (t = null === (e = _this7.getState()) || void 0 === e ? void 0 : e.session) && void 0 !== t ? t : null;
    };
    return _this7;
  }
  return _createClass(Ge);
}(qe);
var Ye = Symbol["for"]("stytch__internal_b2b"),
  Je = function Je(e) {
    var t = e;
    if (!t[Ye]) throw Error("Internals not found!");
    return t[Ye];
  };
var Ze = /*#__PURE__*/_createClass(function Ze(e, t) {
  var _this8 = this;
  _classCallCheck(this, Ze);
  var n;
  !function (e) {
    if ("undefined" == typeof window) throw new Error("The ".concat(e, " is not compatible with server-side environments.\nIf using nextjs, use the create").concat(e, " method instead.\n```\n").concat("import { createStytchB2BHeadlessClient } from '@stytch/nextjs/b2b';\n    \n  const stytch = createStytchB2BHeadlessClient('public-token-...');\n  ", "\n```\n"));
  }("StytchB2BHeadlessClient"), "string" != typeof (n = e) ? G("Public token is malformed. Expected a string, got ".concat(r(n), ".").concat(J)) : "" === n ? G('Public token is malformed. Expected "public-token-...", got an empty string.'.concat(J)) : n.startsWith("public-token-") || G('Public token is malformed. Expected "public-token-...", got '.concat(n, ".").concat(J));
  var o = t,
    i = function (e) {
      var t, n, r, o, i, a, s, l, c, u;
      return {
        cookieOptions: null == e ? void 0 : e.cookieOptions,
        endpoints: {
          sdkBackendURL: null !== (n = null === (t = null == e ? void 0 : e.endpoints) || void 0 === t ? void 0 : t.sdkBackendURL) && void 0 !== n ? n : "https://web.stytch.com",
          testAPIURL: null !== (o = null === (r = null == e ? void 0 : e.endpoints) || void 0 === r ? void 0 : r.testAPIURL) && void 0 !== o ? o : "https://test.stytch.com",
          liveAPIURL: null !== (a = null === (i = null == e ? void 0 : e.endpoints) || void 0 === i ? void 0 : i.liveAPIURL) && void 0 !== a ? a : "https://api.stytch.com",
          dfpBackendURL: null !== (l = null === (s = null == e ? void 0 : e.endpoints) || void 0 === s ? void 0 : s.dfpBackendURL) && void 0 !== l ? l : "https://telemetry.stytch.com",
          clientsideServicesIframeURL: null !== (u = null === (c = null == e ? void 0 : e.endpoints) || void 0 === c ? void 0 : c.clientsideServicesIframeURL) && void 0 !== u ? u : "https://js.stytch.com/clientside-services/index.html"
        }
      };
    }(o);
  this._dataLayer = Ve(e, o), this._subscriptionService = new Ge(e, this._dataLayer);
  var a = new Me(this._dataLayer, "passwords");
  this._networkClient = new Re(e, this._dataLayer, i.endpoints.sdkBackendURL, function () {
    var e, t, n, r;
    return {
      stytch_member_id: null === (t = null === (e = _this8._dataLayer.state) || void 0 === e ? void 0 : e.member) || void 0 === t ? void 0 : t.member_id,
      stytch_member_session_id: null === (r = null === (n = _this8._dataLayer.state) || void 0 === n ? void 0 : n.session) || void 0 === r ? void 0 : r.member_session_id
    };
  });
  var s = new Ie(e, this._networkClient, this._dataLayer),
    l = new Be(s.getAsync()),
    c = new ee(e, i.endpoints.dfpBackendURL, s.getAsync(), l.executeRecaptcha);
  this.organization = new se(this._networkClient), this.member = new ie(this._networkClient, this._subscriptionService), this.session = new ce(this._networkClient, this._subscriptionService), this.magicLinks = new oe(this._networkClient, this._subscriptionService, new Me(this._dataLayer, "magic_links"), a, s.getAsync(), c), this.oauth = new le(this._networkClient, this._subscriptionService, new Me(this._dataLayer, "oauth"), s.getAsync(), {
    publicToken: e,
    testAPIURL: i.endpoints.testAPIURL,
    liveAPIURL: i.endpoints.liveAPIURL
  }, c), this.sso = new ae(this._networkClient, this._subscriptionService, new Me(this._dataLayer, "sso"), s.getAsync(), {
    publicToken: e,
    testAPIURL: i.endpoints.testAPIURL,
    liveAPIURL: i.endpoints.liveAPIURL
  }), this.discovery = new ue(this._networkClient, this._subscriptionService), this.passwords = new Pe(this._networkClient, this._subscriptionService, a, s.getAsync(), c), this.otps = new we(this._networkClient, this._subscriptionService, c), this._sessionManager = new ke(this._subscriptionService, this.session);
  var u = new De(this._networkClient);
  this._dataLayer.readSessionCookie().session_token && this._sessionManager.performBackgroundRefresh(), this._networkClient.logEvent({
    name: "b2b_sdk_instance_instantiated",
    details: {
      event_callback_registered: !1,
      error_callback_registered: !1,
      success_callback_registered: !1
    }
  });
  (function (e, t) {
    Object.assign(e, _defineProperty({}, Ye, t));
  })(this, {
    bootstrap: s,
    publicToken: e,
    searchManager: u,
    dataLayer: this._dataLayer,
    networkClient: this._networkClient
  });
});
var Xe = {
    exports: {}
  },
  et = {},
  tt = Object.getOwnPropertySymbols,
  nt = Object.prototype.hasOwnProperty,
  rt = Object.prototype.propertyIsEnumerable;
var ot = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
      var r = Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      });
      if ("0123456789" !== r.join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        o[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, r, o = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(e), i = 1; i < arguments.length; i++) {
      for (var a in n = Object(arguments[i])) nt.call(n, a) && (o[a] = n[a]);
      if (tt) {
        r = tt(n);
        for (var s = 0; s < r.length; s++) rt.call(n, r[s]) && (o[r[s]] = n[r[s]]);
      }
    }
    return o;
  },
  it = ot,
  at = 60103,
  st = 60106;
et.Fragment = 60107, et.StrictMode = 60108, et.Profiler = 60114;
var lt = 60109,
  ct = 60110,
  ut = 60112;
et.Suspense = 60113;
var dt = 60115,
  ft = 60116;
if ("function" == typeof Symbol && Symbol["for"]) {
  var pt = Symbol["for"];
  at = pt("react.element"), st = pt("react.portal"), et.Fragment = pt("react.fragment"), et.StrictMode = pt("react.strict_mode"), et.Profiler = pt("react.profiler"), lt = pt("react.provider"), ct = pt("react.context"), ut = pt("react.forward_ref"), et.Suspense = pt("react.suspense"), dt = pt("react.memo"), ft = pt("react.lazy");
}
var ht = "function" == typeof Symbol && Symbol.iterator;
function mt(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var gt = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
  vt = {};
function yt(e, t, n) {
  this.props = e, this.context = t, this.refs = vt, this.updater = n || gt;
}
function At() {}
function bt(e, t, n) {
  this.props = e, this.context = t, this.refs = vt, this.updater = n || gt;
}
yt.prototype.isReactComponent = {}, yt.prototype.setState = function (e, t) {
  if ("object" != _typeof(e) && "function" != typeof e && null != e) throw Error(mt(85));
  this.updater.enqueueSetState(this, e, t, "setState");
}, yt.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
}, At.prototype = yt.prototype;
var _t = bt.prototype = new At();
_t.constructor = bt, it(_t, yt.prototype), _t.isPureReactComponent = !0;
var wt = {
    current: null
  },
  kt = Object.prototype.hasOwnProperty,
  Et = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function St(e, t, n) {
  var r,
    o = {},
    i = null,
    a = null;
  if (null != t) for (r in void 0 !== t.ref && (a = t.ref), void 0 !== t.key && (i = "" + t.key), t) kt.call(t, r) && !Et.hasOwnProperty(r) && (o[r] = t[r]);
  var s = arguments.length - 2;
  if (1 === s) o.children = n;else if (1 < s) {
    for (var l = Array(s), c = 0; c < s; c++) l[c] = arguments[c + 2];
    o.children = l;
  }
  if (e && e.defaultProps) for (r in s = e.defaultProps) void 0 === o[r] && (o[r] = s[r]);
  return {
    $$typeof: at,
    type: e,
    key: i,
    ref: a,
    props: o,
    _owner: wt.current
  };
}
function Ct(e) {
  return "object" == _typeof(e) && null !== e && e.$$typeof === at;
}
var xt = /\/+/g;
function Ot(e, t) {
  return "object" == _typeof(e) && null !== e && null != e.key ? function (e) {
    var t = {
      "=": "=0",
      ":": "=2"
    };
    return "$" + e.replace(/[=:]/g, function (e) {
      return t[e];
    });
  }("" + e.key) : t.toString(36);
}
function Pt(e, t, n, r, o) {
  var i = _typeof(e);
  "undefined" !== i && "boolean" !== i || (e = null);
  var a = !1;
  if (null === e) a = !0;else switch (i) {
    case "string":
    case "number":
      a = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case at:
        case st:
          a = !0;
      }
  }
  if (a) return o = o(a = e), e = "" === r ? "." + Ot(a, 0) : r, Array.isArray(o) ? (n = "", null != e && (n = e.replace(xt, "$&/") + "/"), Pt(o, t, n, "", function (e) {
    return e;
  })) : null != o && (Ct(o) && (o = function (e, t) {
    return {
      $$typeof: at,
      type: e.type,
      key: t,
      ref: e.ref,
      props: e.props,
      _owner: e._owner
    };
  }(o, n + (!o.key || a && a.key === o.key ? "" : ("" + o.key).replace(xt, "$&/") + "/") + e)), t.push(o)), 1;
  if (a = 0, r = "" === r ? "." : r + ":", Array.isArray(e)) for (var s = 0; s < e.length; s++) {
    var l = r + Ot(i = e[s], s);
    a += Pt(i, t, n, l, o);
  } else if (l = function (e) {
    return null === e || "object" != _typeof(e) ? null : "function" == typeof (e = ht && e[ht] || e["@@iterator"]) ? e : null;
  }(e), "function" == typeof l) for (e = l.call(e), s = 0; !(i = e.next()).done;) a += Pt(i = i.value, t, n, l = r + Ot(i, s++), o);else if ("object" === i) throw t = "" + e, Error(mt(31, "[object Object]" === t ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
  return a;
}
function Tt(e, t, n) {
  if (null == e) return e;
  var r = [],
    o = 0;
  return Pt(e, r, "", "", function (e) {
    return t.call(n, e, o++);
  }), r;
}
function It(e) {
  if (-1 === e._status) {
    var t = e._result;
    t = t(), e._status = 0, e._result = t, t.then(function (t) {
      0 === e._status && (t = t["default"], e._status = 1, e._result = t);
    }, function (t) {
      0 === e._status && (e._status = 2, e._result = t);
    });
  }
  if (1 === e._status) return e._result;
  throw e._result;
}
var Bt = {
  current: null
};
function Rt() {
  var e = Bt.current;
  if (null === e) throw Error(mt(321));
  return e;
}
var Lt = {
  ReactCurrentDispatcher: Bt,
  ReactCurrentBatchConfig: {
    transition: 0
  },
  ReactCurrentOwner: wt,
  IsSomeRendererActing: {
    current: !1
  },
  assign: it
};
et.Children = {
  map: Tt,
  forEach: function forEach(e, t, n) {
    Tt(e, function () {
      t.apply(this, arguments);
    }, n);
  },
  count: function count(e) {
    var t = 0;
    return Tt(e, function () {
      t++;
    }), t;
  },
  toArray: function toArray(e) {
    return Tt(e, function (e) {
      return e;
    }) || [];
  },
  only: function only(e) {
    if (!Ct(e)) throw Error(mt(143));
    return e;
  }
}, et.Component = yt, et.PureComponent = bt, et.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Lt, et.cloneElement = function (e, t, n) {
  if (null == e) throw Error(mt(267, e));
  var r = it({}, e.props),
    o = e.key,
    i = e.ref,
    a = e._owner;
  if (null != t) {
    if (void 0 !== t.ref && (i = t.ref, a = wt.current), void 0 !== t.key && (o = "" + t.key), e.type && e.type.defaultProps) var s = e.type.defaultProps;
    for (l in t) kt.call(t, l) && !Et.hasOwnProperty(l) && (r[l] = void 0 === t[l] && void 0 !== s ? s[l] : t[l]);
  }
  var l = arguments.length - 2;
  if (1 === l) r.children = n;else if (1 < l) {
    s = Array(l);
    for (var c = 0; c < l; c++) s[c] = arguments[c + 2];
    r.children = s;
  }
  return {
    $$typeof: at,
    type: e.type,
    key: o,
    ref: i,
    props: r,
    _owner: a
  };
}, et.createContext = function (e, t) {
  return void 0 === t && (t = null), (e = {
    $$typeof: ct,
    _calculateChangedBits: t,
    _currentValue: e,
    _currentValue2: e,
    _threadCount: 0,
    Provider: null,
    Consumer: null
  }).Provider = {
    $$typeof: lt,
    _context: e
  }, e.Consumer = e;
}, et.createElement = St, et.createFactory = function (e) {
  var t = St.bind(null, e);
  return t.type = e, t;
}, et.createRef = function () {
  return {
    current: null
  };
}, et.forwardRef = function (e) {
  return {
    $$typeof: ut,
    render: e
  };
}, et.isValidElement = Ct, et.lazy = function (e) {
  return {
    $$typeof: ft,
    _payload: {
      _status: -1,
      _result: e
    },
    _init: It
  };
}, et.memo = function (e, t) {
  return {
    $$typeof: dt,
    type: e,
    compare: void 0 === t ? null : t
  };
}, et.useCallback = function (e, t) {
  return Rt().useCallback(e, t);
}, et.useContext = function (e, t) {
  return Rt().useContext(e, t);
}, et.useDebugValue = function () {}, et.useEffect = function (e, t) {
  return Rt().useEffect(e, t);
}, et.useImperativeHandle = function (e, t, n) {
  return Rt().useImperativeHandle(e, t, n);
}, et.useLayoutEffect = function (e, t) {
  return Rt().useLayoutEffect(e, t);
}, et.useMemo = function (e, t) {
  return Rt().useMemo(e, t);
}, et.useReducer = function (e, t, n) {
  return Rt().useReducer(e, t, n);
}, et.useRef = function (e) {
  return Rt().useRef(e);
}, et.useState = function (e) {
  return Rt().useState(e);
}, et.version = "17.0.2", Xe.exports = et;
var Mt = Xe.exports,
  Dt = {
    exports: {}
  },
  Nt = {},
  zt = 60103,
  jt = 60106,
  Ft = 60107,
  Ut = 60108,
  Qt = 60114,
  $t = 60109,
  Ht = 60110,
  Vt = 60112,
  Wt = 60113,
  Kt = 60120,
  qt = 60115,
  Gt = 60116,
  Yt = 60121,
  Jt = 60122,
  Zt = 60117,
  Xt = 60129,
  en = 60131;
if ("function" == typeof Symbol && Symbol["for"]) {
  var tn = Symbol["for"];
  zt = tn("react.element"), jt = tn("react.portal"), Ft = tn("react.fragment"), Ut = tn("react.strict_mode"), Qt = tn("react.profiler"), $t = tn("react.provider"), Ht = tn("react.context"), Vt = tn("react.forward_ref"), Wt = tn("react.suspense"), Kt = tn("react.suspense_list"), qt = tn("react.memo"), Gt = tn("react.lazy"), Yt = tn("react.block"), Jt = tn("react.server.block"), Zt = tn("react.fundamental"), Xt = tn("react.debug_trace_mode"), en = tn("react.legacy_hidden");
}
function nn(e) {
  if ("object" == _typeof(e) && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case zt:
        switch (e = e.type) {
          case Ft:
          case Qt:
          case Ut:
          case Wt:
          case Kt:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case Ht:
              case Vt:
              case Gt:
              case qt:
              case $t:
                return e;
              default:
                return t;
            }
        }
      case jt:
        return t;
    }
  }
}
var rn = $t,
  on = zt,
  an = Vt,
  sn = Ft,
  ln = Gt,
  cn = qt,
  un = jt,
  dn = Qt,
  fn = Ut,
  pn = Wt;
Nt.ContextConsumer = Ht, Nt.ContextProvider = rn, Nt.Element = on, Nt.ForwardRef = an, Nt.Fragment = sn, Nt.Lazy = ln, Nt.Memo = cn, Nt.Portal = un, Nt.Profiler = dn, Nt.StrictMode = fn, Nt.Suspense = pn, Nt.isAsyncMode = function () {
  return !1;
}, Nt.isConcurrentMode = function () {
  return !1;
}, Nt.isContextConsumer = function (e) {
  return nn(e) === Ht;
}, Nt.isContextProvider = function (e) {
  return nn(e) === $t;
}, Nt.isElement = function (e) {
  return "object" == _typeof(e) && null !== e && e.$$typeof === zt;
}, Nt.isForwardRef = function (e) {
  return nn(e) === Vt;
}, Nt.isFragment = function (e) {
  return nn(e) === Ft;
}, Nt.isLazy = function (e) {
  return nn(e) === Gt;
}, Nt.isMemo = function (e) {
  return nn(e) === qt;
}, Nt.isPortal = function (e) {
  return nn(e) === jt;
}, Nt.isProfiler = function (e) {
  return nn(e) === Qt;
}, Nt.isStrictMode = function (e) {
  return nn(e) === Ut;
}, Nt.isSuspense = function (e) {
  return nn(e) === Wt;
}, Nt.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === Ft || e === Qt || e === Xt || e === Ut || e === Wt || e === Kt || e === en || "object" == _typeof(e) && null !== e && (e.$$typeof === Gt || e.$$typeof === qt || e.$$typeof === $t || e.$$typeof === Ht || e.$$typeof === Vt || e.$$typeof === Zt || e.$$typeof === Yt || e[0] === Jt);
}, Nt.typeOf = nn, Dt.exports = Nt;
var hn = function hn(e, t, n, r) {
  var o = n ? n.call(r, e, t) : void 0;
  if (void 0 !== o) return !!o;
  if (e === t) return !0;
  if ("object" != _typeof(e) || !e || "object" != _typeof(t) || !t) return !1;
  var i = Object.keys(e),
    a = Object.keys(t);
  if (i.length !== a.length) return !1;
  for (var s = Object.prototype.hasOwnProperty.bind(t), l = 0; l < i.length; l++) {
    var c = i[l];
    if (!s(c)) return !1;
    var u = e[c],
      d = t[c];
    if (!1 === (o = n ? n.call(r, u, d, c) : void 0) || void 0 === o && u !== d) return !1;
  }
  return !0;
};
function mn(e) {
  function t(e, r, l, c, f) {
    for (var p, h, m, g, b, w = 0, k = 0, E = 0, S = 0, C = 0, B = 0, L = m = p = 0, D = 0, N = 0, z = 0, j = 0, F = l.length, U = F - 1, Q = "", $ = "", H = "", V = ""; D < F;) {
      if (h = l.charCodeAt(D), D === U && 0 !== k + S + E + w && (0 !== k && (h = 47 === k ? 10 : 47), S = E = w = 0, F++, U++), 0 === k + S + E + w) {
        if (D === U && (0 < N && (Q = Q.replace(d, "")), 0 < Q.trim().length)) {
          switch (h) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              Q += l.charAt(D);
          }
          h = 59;
        }
        switch (h) {
          case 123:
            for (p = (Q = Q.trim()).charCodeAt(0), m = 1, j = ++D; D < F;) {
              switch (h = l.charCodeAt(D)) {
                case 123:
                  m++;
                  break;
                case 125:
                  m--;
                  break;
                case 47:
                  switch (h = l.charCodeAt(D + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (L = D + 1; L < U; ++L) switch (l.charCodeAt(L)) {
                          case 47:
                            if (42 === h && 42 === l.charCodeAt(L - 1) && D + 2 !== L) {
                              D = L + 1;
                              break e;
                            }
                            break;
                          case 10:
                            if (47 === h) {
                              D = L + 1;
                              break e;
                            }
                        }
                        D = L;
                      }
                  }
                  break;
                case 91:
                  h++;
                case 40:
                  h++;
                case 34:
                case 39:
                  for (; D++ < U && l.charCodeAt(D) !== h;);
              }
              if (0 === m) break;
              D++;
            }
            if (m = l.substring(j, D), 0 === p && (p = (Q = Q.replace(u, "").trim()).charCodeAt(0)), 64 === p) {
              switch (0 < N && (Q = Q.replace(d, "")), h = Q.charCodeAt(1)) {
                case 100:
                case 109:
                case 115:
                case 45:
                  N = r;
                  break;
                default:
                  N = I;
              }
              if (j = (m = t(r, N, m, h, f + 1)).length, 0 < R && (b = s(3, m, N = n(I, Q, z), r, O, x, j, h, f, c), Q = N.join(""), void 0 !== b && 0 === (j = (m = b.trim()).length) && (h = 0, m = "")), 0 < j) switch (h) {
                case 115:
                  Q = Q.replace(_, a);
                case 100:
                case 109:
                case 45:
                  m = Q + "{" + m + "}";
                  break;
                case 107:
                  m = (Q = Q.replace(v, "$1 $2")) + "{" + m + "}", m = 1 === T || 2 === T && i("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                  break;
                default:
                  m = Q + m, 112 === c && ($ += m, m = "");
              } else m = "";
            } else m = t(r, n(r, Q, z), m, c, f + 1);
            H += m, m = z = N = L = p = 0, Q = "", h = l.charCodeAt(++D);
            break;
          case 125:
          case 59:
            if (1 < (j = (Q = (0 < N ? Q.replace(d, "") : Q).trim()).length)) switch (0 === L && (p = Q.charCodeAt(0), 45 === p || 96 < p && 123 > p) && (j = (Q = Q.replace(" ", ":")).length), 0 < R && void 0 !== (b = s(1, Q, r, e, O, x, $.length, c, f, c)) && 0 === (j = (Q = b.trim()).length) && (Q = "\0\0"), p = Q.charCodeAt(0), h = Q.charCodeAt(1), p) {
              case 0:
                break;
              case 64:
                if (105 === h || 99 === h) {
                  V += Q + l.charAt(D);
                  break;
                }
              default:
                58 !== Q.charCodeAt(j - 1) && ($ += o(Q, p, h, Q.charCodeAt(2)));
            }
            z = N = L = p = 0, Q = "", h = l.charCodeAt(++D);
        }
      }
      switch (h) {
        case 13:
        case 10:
          47 === k ? k = 0 : 0 === 1 + p && 107 !== c && 0 < Q.length && (N = 1, Q += "\0"), 0 < R * M && s(0, Q, r, e, O, x, $.length, c, f, c), x = 1, O++;
          break;
        case 59:
        case 125:
          if (0 === k + S + E + w) {
            x++;
            break;
          }
        default:
          switch (x++, g = l.charAt(D), h) {
            case 9:
            case 32:
              if (0 === S + w + k) switch (C) {
                case 44:
                case 58:
                case 9:
                case 32:
                  g = "";
                  break;
                default:
                  32 !== h && (g = " ");
              }
              break;
            case 0:
              g = "\\0";
              break;
            case 12:
              g = "\\f";
              break;
            case 11:
              g = "\\v";
              break;
            case 38:
              0 === S + k + w && (N = z = 1, g = "\f" + g);
              break;
            case 108:
              if (0 === S + k + w + P && 0 < L) switch (D - L) {
                case 2:
                  112 === C && 58 === l.charCodeAt(D - 3) && (P = C);
                case 8:
                  111 === B && (P = B);
              }
              break;
            case 58:
              0 === S + k + w && (L = D);
              break;
            case 44:
              0 === k + E + S + w && (N = 1, g += "\r");
              break;
            case 34:
            case 39:
              0 === k && (S = S === h ? 0 : 0 === S ? h : S);
              break;
            case 91:
              0 === S + k + E && w++;
              break;
            case 93:
              0 === S + k + E && w--;
              break;
            case 41:
              0 === S + k + w && E--;
              break;
            case 40:
              if (0 === S + k + w) {
                if (0 === p) if (2 * C + 3 * B == 533) ;else p = 1;
                E++;
              }
              break;
            case 64:
              0 === k + E + S + w + L + m && (m = 1);
              break;
            case 42:
            case 47:
              if (!(0 < S + w + E)) switch (k) {
                case 0:
                  switch (2 * h + 3 * l.charCodeAt(D + 1)) {
                    case 235:
                      k = 47;
                      break;
                    case 220:
                      j = D, k = 42;
                  }
                  break;
                case 42:
                  47 === h && 42 === C && j + 2 !== D && (33 === l.charCodeAt(j + 2) && ($ += l.substring(j, D + 1)), g = "", k = 0);
              }
          }
          0 === k && (Q += g);
      }
      B = C, C = h, D++;
    }
    if (0 < (j = $.length)) {
      if (N = r, 0 < R && void 0 !== (b = s(2, $, N, e, O, x, j, c, f, c)) && 0 === ($ = b).length) return V + $ + H;
      if ($ = N.join(",") + "{" + $ + "}", 0 != T * P) {
        switch (2 !== T || i($, 2) || (P = 0), P) {
          case 111:
            $ = $.replace(A, ":-moz-$1") + $;
            break;
          case 112:
            $ = $.replace(y, "::-webkit-input-$1") + $.replace(y, "::-moz-$1") + $.replace(y, ":-ms-input-$1") + $;
        }
        P = 0;
      }
    }
    return V + $ + H;
  }
  function n(e, t, n) {
    var o = t.trim().split(m);
    t = o;
    var i = o.length,
      a = e.length;
    switch (a) {
      case 0:
      case 1:
        var s = 0;
        for (e = 0 === a ? "" : e[0] + " "; s < i; ++s) t[s] = r(e, t[s], n).trim();
        break;
      default:
        var l = s = 0;
        for (t = []; s < i; ++s) for (var c = 0; c < a; ++c) t[l++] = r(e[c] + " ", o[s], n).trim();
    }
    return t;
  }
  function r(e, t, n) {
    var r = t.charCodeAt(0);
    switch (33 > r && (r = (t = t.trim()).charCodeAt(0)), r) {
      case 38:
        return t.replace(g, "$1" + e.trim());
      case 58:
        return e.trim() + t.replace(g, "$1" + e.trim());
      default:
        if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(g, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }
    return e + t;
  }
  function o(e, t, n, r) {
    var a = e + ";",
      s = 2 * t + 3 * n + 4 * r;
    if (944 === s) {
      e = a.indexOf(":", 9) + 1;
      var l = a.substring(e, a.length - 1).trim();
      return l = a.substring(0, e).trim() + l + ";", 1 === T || 2 === T && i(l, 1) ? "-webkit-" + l + l : l;
    }
    if (0 === T || 2 === T && !i(a, 1)) return a;
    switch (s) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11)) return a.replace(C, "$1-webkit-$2") + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
          case 115:
            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
          case 98:
            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
        }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        return "-webkit-box-pack" + (l = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + a + "-ms-flex-pack" + l + a;
      case 1005:
        return p.test(a) ? a.replace(f, ":-webkit-") + a.replace(f, ":-moz-") + a : a;
      case 1e3:
        switch (t = (l = a.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(t)) {
          case 226:
            l = a.replace(b, "tb");
            break;
          case 232:
            l = a.replace(b, "tb-rl");
            break;
          case 220:
            l = a.replace(b, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + l + a;
      case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;
      case 975:
        switch (t = (a = e).length - 10, s = (l = (33 === a.charCodeAt(t) ? a.substring(0, t) : a).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))) {
          case 203:
            if (111 > l.charCodeAt(8)) break;
          case 115:
            a = a.replace(l, "-webkit-" + l) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(l, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + a.replace(l, "-webkit-" + l) + ";" + a.replace(l, "-ms-" + l + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return l = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + l + "-ms-flex-" + l + a;
          case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(k, "") + a;
          default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(k, "") + a;
        }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === S.test(e)) return 115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? o(e.replace("stretch", "fill-available"), t, n, r).replace(":fill-available", ":stretch") : a.replace(l, "-webkit-" + l) + a.replace(l, "-moz-" + l.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === n + r && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(h, "$1-webkit-$2") + a;
    }
    return a;
  }
  function i(e, t) {
    var n = e.indexOf(1 === t ? ":" : "{"),
      r = e.substring(0, 3 !== t ? n : 10);
    return n = e.substring(n + 1, e.length - 1), L(2 !== t ? r : r.replace(E, "$1"), n, t);
  }
  function a(e, t) {
    var n = o(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
    return n !== t + ";" ? n.replace(w, " or ($1)").substring(4) : "(" + t + ")";
  }
  function s(e, t, n, r, o, i, a, s, l, u) {
    for (var d, f = 0, p = t; f < R; ++f) switch (d = B[f].call(c, e, p, n, r, o, i, a, s, l, u)) {
      case void 0:
      case !1:
      case !0:
      case null:
        break;
      default:
        p = d;
    }
    if (p !== t) return p;
  }
  function l(e) {
    return void 0 !== (e = e.prefix) && (L = null, e ? "function" != typeof e ? T = 1 : (T = 2, L = e) : T = 0), l;
  }
  function c(e, n) {
    var r = e;
    if (33 > r.charCodeAt(0) && (r = r.trim()), r = [r], 0 < R) {
      var o = s(-1, n, r, r, O, x, 0, 0, 0, 0);
      void 0 !== o && "string" == typeof o && (n = o);
    }
    var i = t(I, r, n, 0, 0);
    return 0 < R && void 0 !== (o = s(-2, i, r, r, O, x, i.length, 0, 0, 0)) && (i = o), "", P = 0, x = O = 1, i;
  }
  var u = /^\0+/g,
    d = /[\0\r\f]/g,
    f = /: */g,
    p = /zoo|gra/,
    h = /([,: ])(transform)/g,
    m = /,\r+?/g,
    g = /([\t\r\n ])*\f?&/g,
    v = /@(k\w+)\s*(\S*)\s*/,
    y = /::(place)/g,
    A = /:(read-only)/g,
    b = /[svh]\w+-[tblr]{2}/,
    _ = /\(\s*(.*)\s*\)/g,
    w = /([\s\S]*?);/g,
    k = /-self|flex-/g,
    E = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    S = /stretch|:\s*\w+\-(?:conte|avail)/,
    C = /([^-])(image-set\()/,
    x = 1,
    O = 1,
    P = 0,
    T = 1,
    I = [],
    B = [],
    R = 0,
    L = null,
    M = 0;
  return c.use = function e(t) {
    switch (t) {
      case void 0:
      case null:
        R = B.length = 0;
        break;
      default:
        if ("function" == typeof t) B[R++] = t;else if ("object" == _typeof(t)) for (var n = 0, r = t.length; n < r; ++n) e(t[n]);else M = 0 | !!t;
    }
    return e;
  }, c.set = l, void 0 !== e && l(e), c;
}
var gn = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function vn(e) {
  var t = Object.create(null);
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}
var yn = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  An = vn(function (e) {
    return yn.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
  }),
  bn = {
    exports: {}
  },
  _n = {},
  wn = "function" == typeof Symbol && Symbol["for"],
  kn = wn ? Symbol["for"]("react.element") : 60103,
  En = wn ? Symbol["for"]("react.portal") : 60106,
  Sn = wn ? Symbol["for"]("react.fragment") : 60107,
  Cn = wn ? Symbol["for"]("react.strict_mode") : 60108,
  xn = wn ? Symbol["for"]("react.profiler") : 60114,
  On = wn ? Symbol["for"]("react.provider") : 60109,
  Pn = wn ? Symbol["for"]("react.context") : 60110,
  Tn = wn ? Symbol["for"]("react.async_mode") : 60111,
  In = wn ? Symbol["for"]("react.concurrent_mode") : 60111,
  Bn = wn ? Symbol["for"]("react.forward_ref") : 60112,
  Rn = wn ? Symbol["for"]("react.suspense") : 60113,
  Ln = wn ? Symbol["for"]("react.suspense_list") : 60120,
  Mn = wn ? Symbol["for"]("react.memo") : 60115,
  Dn = wn ? Symbol["for"]("react.lazy") : 60116,
  Nn = wn ? Symbol["for"]("react.block") : 60121,
  zn = wn ? Symbol["for"]("react.fundamental") : 60117,
  jn = wn ? Symbol["for"]("react.responder") : 60118,
  Fn = wn ? Symbol["for"]("react.scope") : 60119;
function Un(e) {
  if ("object" == _typeof(e) && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case kn:
        switch (e = e.type) {
          case Tn:
          case In:
          case Sn:
          case xn:
          case Cn:
          case Rn:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case Pn:
              case Bn:
              case Dn:
              case Mn:
              case On:
                return e;
              default:
                return t;
            }
        }
      case En:
        return t;
    }
  }
}
function Qn(e) {
  return Un(e) === In;
}
_n.AsyncMode = Tn, _n.ConcurrentMode = In, _n.ContextConsumer = Pn, _n.ContextProvider = On, _n.Element = kn, _n.ForwardRef = Bn, _n.Fragment = Sn, _n.Lazy = Dn, _n.Memo = Mn, _n.Portal = En, _n.Profiler = xn, _n.StrictMode = Cn, _n.Suspense = Rn, _n.isAsyncMode = function (e) {
  return Qn(e) || Un(e) === Tn;
}, _n.isConcurrentMode = Qn, _n.isContextConsumer = function (e) {
  return Un(e) === Pn;
}, _n.isContextProvider = function (e) {
  return Un(e) === On;
}, _n.isElement = function (e) {
  return "object" == _typeof(e) && null !== e && e.$$typeof === kn;
}, _n.isForwardRef = function (e) {
  return Un(e) === Bn;
}, _n.isFragment = function (e) {
  return Un(e) === Sn;
}, _n.isLazy = function (e) {
  return Un(e) === Dn;
}, _n.isMemo = function (e) {
  return Un(e) === Mn;
}, _n.isPortal = function (e) {
  return Un(e) === En;
}, _n.isProfiler = function (e) {
  return Un(e) === xn;
}, _n.isStrictMode = function (e) {
  return Un(e) === Cn;
}, _n.isSuspense = function (e) {
  return Un(e) === Rn;
}, _n.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === Sn || e === In || e === xn || e === Cn || e === Rn || e === Ln || "object" == _typeof(e) && null !== e && (e.$$typeof === Dn || e.$$typeof === Mn || e.$$typeof === On || e.$$typeof === Pn || e.$$typeof === Bn || e.$$typeof === zn || e.$$typeof === jn || e.$$typeof === Fn || e.$$typeof === Nn);
}, _n.typeOf = Un, bn.exports = _n;
var $n = bn.exports,
  Hn = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
  Vn = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
  Wn = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
  Kn = {};
function qn(e) {
  return $n.isMemo(e) ? Wn : Kn[e.$$typeof] || Hn;
}
Kn[$n.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Kn[$n.Memo] = Wn;
var Gn = Object.defineProperty,
  Yn = Object.getOwnPropertyNames,
  Jn = Object.getOwnPropertySymbols,
  Zn = Object.getOwnPropertyDescriptor,
  Xn = Object.getPrototypeOf,
  er = Object.prototype;
var tr = function e(t, n, r) {
  if ("string" != typeof n) {
    if (er) {
      var o = Xn(n);
      o && o !== er && e(t, o, r);
    }
    var i = Yn(n);
    Jn && (i = i.concat(Jn(n)));
    for (var a = qn(t), s = qn(n), l = 0; l < i.length; ++l) {
      var c = i[l];
      if (!(Vn[c] || r && r[c] || s && s[c] || a && a[c])) {
        var u = Zn(n, c);
        try {
          Gn(t, c, u);
        } catch (e) {}
      }
    }
  }
  return t;
};
function nr() {
  return (nr = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var rr = function rr(e, t) {
    for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1) n.push(t[r], e[r + 1]);
    return n;
  },
  or = function or(e) {
    return null !== e && "object" == _typeof(e) && "[object Object]" === (e.toString ? e.toString() : Object.prototype.toString.call(e)) && !Dt.exports.typeOf(e);
  },
  ir = Object.freeze([]),
  ar = Object.freeze({});
function sr(e) {
  return "function" == typeof e;
}
function lr(e) {
  return e.displayName || e.name || "Component";
}
function cr(e) {
  return e && "string" == typeof e.styledComponentId;
}
var ur = "undefined" != typeof process && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
  dr = "undefined" != typeof window && "HTMLElement" in window,
  fr = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY && "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY);
function pr(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var hr = function () {
    function e(e) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function (e) {
      for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
      return t;
    }, t.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, r = n.length, o = r; e >= o;) (o <<= 1) < 0 && pr(16, "" + e);
        this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
        for (var i = r; i < o; i++) this.groupSizes[i] = 0;
      }
      for (var a = this.indexOfGroup(e + 1), s = 0, l = t.length; s < l; s++) this.tag.insertRule(a, t[s]) && (this.groupSizes[e]++, a++);
    }, t.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          r = n + t;
        this.groupSizes[e] = 0;
        for (var o = n; o < r; o++) this.tag.deleteRule(n);
      }
    }, t.getGroup = function (e) {
      var t = "";
      if (e >= this.length || 0 === this.groupSizes[e]) return t;
      for (var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, i = r; i < o; i++) t += this.tag.getRule(i) + "/*!sc*/\n";
      return t;
    }, e;
  }(),
  mr = new Map(),
  gr = new Map(),
  vr = 1,
  yr = function yr(e) {
    if (mr.has(e)) return mr.get(e);
    for (; gr.has(vr);) vr++;
    var t = vr++;
    return mr.set(e, t), gr.set(t, e), t;
  },
  Ar = function Ar(e) {
    return gr.get(e);
  },
  br = function br(e, t) {
    t >= vr && (vr = t + 1), mr.set(e, t), gr.set(t, e);
  },
  _r = "style[" + ur + '][data-styled-version="5.3.5"]',
  wr = new RegExp("^" + ur + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
  kr = function kr(e, t, n) {
    for (var r, o = n.split(","), i = 0, a = o.length; i < a; i++) (r = o[i]) && e.registerName(t, r);
  },
  Er = function Er(e, t) {
    for (var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, i = n.length; o < i; o++) {
      var a = n[o].trim();
      if (a) {
        var s = a.match(wr);
        if (s) {
          var l = 0 | parseInt(s[1], 10),
            c = s[2];
          0 !== l && (br(c, l), kr(e, c, s[3]), e.getTag().insertRules(l, r)), r.length = 0;
        } else r.push(a);
      }
    }
  },
  Sr = function Sr(e) {
    var t = document.head,
      n = e || t,
      r = document.createElement("style"),
      o = function (e) {
        for (var t = e.childNodes, n = t.length; n >= 0; n--) {
          var r = t[n];
          if (r && 1 === r.nodeType && r.hasAttribute(ur)) return r;
        }
      }(n),
      i = void 0 !== o ? o.nextSibling : null;
    r.setAttribute(ur, "active"), r.setAttribute("data-styled-version", "5.3.5");
    var a = "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
    return a && r.setAttribute("nonce", a), n.insertBefore(r, i), r;
  },
  Cr = function () {
    function e(e) {
      var t = this.element = Sr(e);
      t.appendChild(document.createTextNode("")), this.sheet = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          if (o.ownerNode === e) return o;
        }
        pr(17);
      }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      try {
        return this.sheet.insertRule(t, e), this.length++, !0;
      } catch (e) {
        return !1;
      }
    }, t.deleteRule = function (e) {
      this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function (e) {
      var t = this.sheet.cssRules[e];
      return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
  }(),
  xr = function () {
    function e(e) {
      var t = this.element = Sr(e);
      this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      if (e <= this.length && e >= 0) {
        var n = document.createTextNode(t),
          r = this.nodes[e];
        return this.element.insertBefore(n, r || null), this.length++, !0;
      }
      return !1;
    }, t.deleteRule = function (e) {
      this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.nodes[e].textContent : "";
    }, e;
  }(),
  Or = function () {
    function e(e) {
      this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function (e) {
      this.rules.splice(e, 1), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.rules[e] : "";
    }, e;
  }(),
  Pr = dr,
  Tr = {
    isServer: !dr,
    useCSSOMInjection: !fr
  },
  Ir = function () {
    function e(e, t, n) {
      void 0 === e && (e = ar), void 0 === t && (t = {}), this.options = nr({}, Tr, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && dr && Pr && (Pr = !1, function (e) {
        for (var t = document.querySelectorAll(_r), n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          o && "active" !== o.getAttribute(ur) && (Er(e, o), o.parentNode && o.parentNode.removeChild(o));
        }
      }(this));
    }
    e.registerId = function (e) {
      return yr(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function (t, n) {
      return void 0 === n && (n = !0), new e(nr({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function (e) {
      return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function () {
      return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new Or(o) : r ? new Cr(o) : new xr(o), new hr(e)));
      var e, t, n, r, o;
    }, t.hasNameForId = function (e, t) {
      return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function (e, t) {
      if (yr(e), this.names.has(e)) this.names.get(e).add(t);else {
        var n = new Set();
        n.add(t), this.names.set(e, n);
      }
    }, t.insertRules = function (e, t, n) {
      this.registerName(e, t), this.getTag().insertRules(yr(e), n);
    }, t.clearNames = function (e) {
      this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function (e) {
      this.getTag().clearGroup(yr(e)), this.clearNames(e);
    }, t.clearTag = function () {
      this.tag = void 0;
    }, t.toString = function () {
      return function (e) {
        for (var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++) {
          var i = Ar(o);
          if (void 0 !== i) {
            var a = e.names.get(i),
              s = t.getGroup(o);
            if (a && s && a.size) {
              var l = ur + ".g" + o + '[id="' + i + '"]',
                c = "";
              void 0 !== a && a.forEach(function (e) {
                e.length > 0 && (c += e + ",");
              }), r += "" + s + l + '{content:"' + c + '"}/*!sc*/\n';
            }
          }
        }
        return r;
      }(this);
    }, e;
  }(),
  Br = /(a)(d)/gi,
  Rr = function Rr(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function Lr(e) {
  var t,
    n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = Rr(t % 52) + n;
  return (Rr(t % 52) + n).replace(Br, "$1-$2");
}
var Mr = function Mr(e, t) {
    for (var n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
    return e;
  },
  Dr = function Dr(e) {
    return Mr(5381, e);
  };
var Nr = Dr("5.3.5"),
  zr = function () {
    function e(e, t, n) {
      this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && function (e) {
        for (var t = 0; t < e.length; t += 1) {
          var n = e[t];
          if (sr(n) && !cr(n)) return !1;
        }
        return !0;
      }(e), this.componentId = t, this.baseHash = Mr(Nr, t), this.baseStyle = n, Ir.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function (e, t, n) {
      var r = this.componentId,
        o = [];
      if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
        if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);else {
          var i = to(this.rules, e, t, n).join(""),
            a = Lr(Mr(this.baseHash, i) >>> 0);
          if (!t.hasNameForId(r, a)) {
            var s = n(i, "." + a, void 0, r);
            t.insertRules(r, a, s);
          }
          o.push(a), this.staticRulesId = a;
        }
      } else {
        for (var l = this.rules.length, c = Mr(this.baseHash, n.hash), u = "", d = 0; d < l; d++) {
          var f = this.rules[d];
          if ("string" == typeof f) u += f;else if (f) {
            var p = to(f, e, t, n),
              h = Array.isArray(p) ? p.join("") : p;
            c = Mr(c, h + d), u += h;
          }
        }
        if (u) {
          var m = Lr(c >>> 0);
          if (!t.hasNameForId(r, m)) {
            var g = n(u, "." + m, void 0, r);
            t.insertRules(r, m, g);
          }
          o.push(m);
        }
      }
      return o.join(" ");
    }, e;
  }(),
  jr = /^\s*\/\/.*$/gm,
  Fr = [":", "[", ".", "#"];
function Ur(e) {
  var t,
    n,
    r,
    o,
    i = void 0 === e ? ar : e,
    a = i.options,
    s = void 0 === a ? ar : a,
    l = i.plugins,
    c = void 0 === l ? ir : l,
    u = new mn(s),
    d = [],
    f = function (e) {
      function t(t) {
        if (t) try {
          e(t + "}");
        } catch (e) {}
      }
      return function (n, r, o, i, a, s, l, c, u, d) {
        switch (n) {
          case 1:
            if (0 === u && 64 === r.charCodeAt(0)) return e(r + ";"), "";
            break;
          case 2:
            if (0 === c) return r + "/*|*/";
            break;
          case 3:
            switch (c) {
              case 102:
              case 112:
                return e(o[0] + r), "";
              default:
                return r + (0 === d ? "/*|*/" : "");
            }
          case -2:
            r.split("/*|*/}").forEach(t);
        }
      };
    }(function (e) {
      d.push(e);
    }),
    p = function p(e, r, i) {
      return 0 === r && -1 !== Fr.indexOf(i[n.length]) || i.match(o) ? e : "." + t;
    };
  function h(e, i, a, s) {
    void 0 === s && (s = "&");
    var l = e.replace(jr, ""),
      c = i && a ? a + " " + i + " { " + l + " }" : l;
    return t = s, n = i, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), u(a || !i ? "" : i, c);
  }
  return u.use([].concat(c, [function (e, t, o) {
    2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, p));
  }, f, function (e) {
    if (-2 === e) {
      var t = d;
      return d = [], t;
    }
  }])), h.hash = c.length ? c.reduce(function (e, t) {
    return t.name || pr(15), Mr(e, t.name);
  }, 5381).toString() : "", h;
}
var Qr = Mt.createContext();
Qr.Consumer;
var $r = Mt.createContext(),
  Hr = ($r.Consumer, new Ir()),
  Vr = Ur();
function Wr() {
  return Xe.exports.useContext(Qr) || Hr;
}
function Kr(e) {
  var t = Xe.exports.useState(e.stylisPlugins),
    n = t[0],
    r = t[1],
    o = Wr(),
    i = Xe.exports.useMemo(function () {
      var t = o;
      return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
        target: e.target
      }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
        useCSSOMInjection: !1
      })), t;
    }, [e.disableCSSOMInjection, e.sheet, e.target]),
    a = Xe.exports.useMemo(function () {
      return Ur({
        options: {
          prefix: !e.disableVendorPrefixes
        },
        plugins: n
      });
    }, [e.disableVendorPrefixes, n]);
  return Xe.exports.useEffect(function () {
    hn(n, e.stylisPlugins) || r(e.stylisPlugins);
  }, [e.stylisPlugins]), Mt.createElement(Qr.Provider, {
    value: i
  }, Mt.createElement($r.Provider, {
    value: a
  }, e.children));
}
var qr = function () {
    function e(e, t) {
      var n = this;
      this.inject = function (e, t) {
        void 0 === t && (t = Vr);
        var r = n.name + t.hash;
        e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
      }, this.toString = function () {
        return pr(12, String(n.name));
      }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function (e) {
      return void 0 === e && (e = Vr), this.name + e.hash;
    }, e;
  }(),
  Gr = /([A-Z])/,
  Yr = /([A-Z])/g,
  Jr = /^ms-/,
  Zr = function Zr(e) {
    return "-" + e.toLowerCase();
  };
function Xr(e) {
  return Gr.test(e) ? e.replace(Yr, Zr).replace(Jr, "-ms-") : e;
}
var eo = function eo(e) {
  return null == e || !1 === e || "" === e;
};
function to(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var o, i = [], a = 0, s = e.length; a < s; a += 1) "" !== (o = to(e[a], t, n, r)) && (Array.isArray(o) ? i.push.apply(i, o) : i.push(o));
    return i;
  }
  return eo(e) ? "" : cr(e) ? "." + e.styledComponentId : sr(e) ? "function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !t ? e : to(e(t), t, n, r) : e instanceof qr ? n ? (e.inject(n, r), e.getName(r)) : e : or(e) ? function e(t, n) {
    var r,
      o,
      i = [];
    for (var a in t) t.hasOwnProperty(a) && !eo(t[a]) && (Array.isArray(t[a]) && t[a].isCss || sr(t[a]) ? i.push(Xr(a) + ":", t[a], ";") : or(t[a]) ? i.push.apply(i, e(t[a], a)) : i.push(Xr(a) + ": " + (r = a, (null == (o = t[a]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in gn ? String(o).trim() : o + "px") + ";")));
    return n ? [n + " {"].concat(i, ["}"]) : i;
  }(e) : e.toString();
  var l;
}
var no = function no(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function ro(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return sr(e) || or(e) ? no(to(rr(ir, [e].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : no(to(rr(e, n)));
}
var oo = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  io = /(^-|-$)/g;
function ao(e) {
  return e.replace(oo, "-").replace(io, "");
}
var so = function so(e) {
  return Lr(Dr(e) >>> 0);
};
function lo(e) {
  return "string" == typeof e && !0;
}
var co = function co(e) {
    return "function" == typeof e || "object" == _typeof(e) && null !== e && !Array.isArray(e);
  },
  uo = function uo(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
  };
function fo(e, t, n) {
  var r = e[n];
  co(t) && co(r) ? po(r, t) : e[n] = t;
}
function po(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var o = 0, i = n; o < i.length; o++) {
    var a = i[o];
    if (co(a)) for (var s in a) uo(s) && fo(e, a[s], s);
  }
  return e;
}
var ho = Mt.createContext();
function mo(e) {
  var t = Xe.exports.useContext(ho),
    n = Xe.exports.useMemo(function () {
      return function (e, t) {
        return e ? sr(e) ? e(t) : Array.isArray(e) || "object" != _typeof(e) ? pr(8) : t ? nr({}, t, {}, e) : e : pr(14);
      }(e.theme, t);
    }, [e.theme, t]);
  return e.children ? Mt.createElement(ho.Provider, {
    value: n
  }, e.children) : null;
}
ho.Consumer;
var go = {};
function vo(e, t, n) {
  var r = cr(e),
    o = !lo(e),
    i = t.attrs,
    a = void 0 === i ? ir : i,
    s = t.componentId,
    l = void 0 === s ? function (e, t) {
      var n = "string" != typeof e ? "sc" : ao(e);
      go[n] = (go[n] || 0) + 1;
      var r = n + "-" + so("5.3.5" + n + go[n]);
      return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : s,
    c = t.displayName,
    u = void 0 === c ? function (e) {
      return lo(e) ? "styled." + e : "Styled(" + lr(e) + ")";
    }(e) : c,
    d = t.displayName && t.componentId ? ao(t.displayName) + "-" + t.componentId : t.componentId || l,
    f = r && e.attrs ? Array.prototype.concat(e.attrs, a).filter(Boolean) : a,
    p = t.shouldForwardProp;
  r && e.shouldForwardProp && (p = t.shouldForwardProp ? function (n, r, o) {
    return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
  } : e.shouldForwardProp);
  var h,
    m = new zr(n, d, r ? e.componentStyle : void 0),
    g = m.isStatic && 0 === a.length,
    v = function v(e, t) {
      return function (e, t, n, r) {
        var o = e.attrs,
          i = e.componentStyle,
          a = e.defaultProps,
          s = e.foldedComponentIds,
          l = e.shouldForwardProp,
          c = e.styledComponentId,
          u = e.target,
          d = function (e, t, n) {
            void 0 === e && (e = ar);
            var r = nr({}, t, {
                theme: e
              }),
              o = {};
            return n.forEach(function (e) {
              var t,
                n,
                i,
                a = e;
              for (t in sr(a) && (a = a(r)), a) r[t] = o[t] = "className" === t ? (n = o[t], i = a[t], n && i ? n + " " + i : n || i) : a[t];
            }), [r, o];
          }(function (e, t, n) {
            return void 0 === n && (n = ar), e.theme !== n.theme && e.theme || t || n.theme;
          }(t, Xe.exports.useContext(ho), a) || ar, t, o),
          f = d[0],
          p = d[1],
          h = function (e, t, n, r) {
            var o = Wr(),
              i = Xe.exports.useContext($r) || Vr;
            return t ? e.generateAndInjectStyles(ar, o, i) : e.generateAndInjectStyles(n, o, i);
          }(i, r, f),
          m = n,
          g = p.$as || t.$as || p.as || t.as || u,
          v = lo(g),
          y = p !== t ? nr({}, t, {}, p) : t,
          A = {};
        for (var b in y) "$" !== b[0] && "as" !== b && ("forwardedAs" === b ? A.as = y[b] : (l ? l(b, An, g) : !v || An(b)) && (A[b] = y[b]));
        return t.style && p.style !== t.style && (A.style = nr({}, t.style, {}, p.style)), A.className = Array.prototype.concat(s, c, h !== c ? h : null, t.className, p.className).filter(Boolean).join(" "), A.ref = m, Xe.exports.createElement(g, A);
      }(h, e, t, g);
    };
  return v.displayName = u, (h = Mt.forwardRef(v)).attrs = f, h.componentStyle = m, h.displayName = u, h.shouldForwardProp = p, h.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : ir, h.styledComponentId = d, h.target = r ? e.target : e, h.withComponent = function (e) {
    var r = t.componentId,
      o = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          o = {},
          i = Object.keys(e);
        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o;
      }(t, ["componentId"]),
      i = r && r + "-" + (lo(e) ? e : ao(lr(e)));
    return vo(e, nr({}, o, {
      attrs: f,
      componentId: i
    }), n);
  }, Object.defineProperty(h, "defaultProps", {
    get: function get() {
      return this._foldedDefaultProps;
    },
    set: function set(t) {
      this._foldedDefaultProps = r ? po({}, e.defaultProps, t) : t;
    }
  }), h.toString = function () {
    return "." + h.styledComponentId;
  }, o && tr(h, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), h;
}
var yo = function yo(e) {
  return function e(t, n, r) {
    if (void 0 === r && (r = ar), !Dt.exports.isValidElementType(n)) return pr(1, String(n));
    var o = function o() {
      return t(n, r, ro.apply(void 0, arguments));
    };
    return o.withConfig = function (o) {
      return e(t, n, nr({}, r, {}, o));
    }, o.attrs = function (o) {
      return e(t, n, nr({}, r, {
        attrs: Array.prototype.concat(r.attrs, o).filter(Boolean)
      }));
    }, o;
  }(vo, e);
};
function Ao(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  var o = ro.apply(void 0, [e].concat(n)).join(""),
    i = so(o);
  return new qr(i, o);
}
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function (e) {
  yo[e] = yo(e);
});
var bo = function bo() {
    return Xe.exports.useContext(ho);
  },
  _o = yo,
  wo = {
    exports: {}
  },
  ko = {},
  Eo = {
    exports: {}
  },
  So = {};
!function (e) {
  var _t3, n, r, o;
  if ("object" == (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && "function" == typeof performance.now) {
    var i = performance;
    e.unstable_now = function () {
      return i.now();
    };
  } else {
    var a = Date,
      s = a.now();
    e.unstable_now = function () {
      return a.now() - s;
    };
  }
  if ("undefined" == typeof window || "function" != typeof MessageChannel) {
    var l = null,
      c = null,
      u = function u() {
        if (null !== l) try {
          var t = e.unstable_now();
          l(!0, t), l = null;
        } catch (e) {
          throw setTimeout(u, 0), e;
        }
      };
    _t3 = function t(e) {
      null !== l ? setTimeout(_t3, 0, e) : (l = e, setTimeout(u, 0));
    }, n = function n(e, t) {
      c = setTimeout(e, t);
    }, r = function r() {
      clearTimeout(c);
    }, e.unstable_shouldYield = function () {
      return !1;
    }, o = e.unstable_forceFrameRate = function () {};
  } else {
    var d = window.setTimeout,
      f = window.clearTimeout;
    if ("undefined" != typeof console) {
      var p = window.cancelAnimationFrame;
      "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), "function" != typeof p && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var h = !1,
      m = null,
      g = -1,
      v = 5,
      y = 0;
    e.unstable_shouldYield = function () {
      return e.unstable_now() >= y;
    }, o = function o() {}, e.unstable_forceFrameRate = function (e) {
      0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : v = 0 < e ? Math.floor(1e3 / e) : 5;
    };
    var A = new MessageChannel(),
      b = A.port2;
    A.port1.onmessage = function () {
      if (null !== m) {
        var t = e.unstable_now();
        y = t + v;
        try {
          m(!0, t) ? b.postMessage(null) : (h = !1, m = null);
        } catch (e) {
          throw b.postMessage(null), e;
        }
      } else h = !1;
    }, _t3 = function _t3(e) {
      m = e, h || (h = !0, b.postMessage(null));
    }, n = function n(t, _n2) {
      g = d(function () {
        t(e.unstable_now());
      }, _n2);
    }, r = function r() {
      f(g), g = -1;
    };
  }
  function _(e, t) {
    var n = e.length;
    e.push(t);
    e: for (;;) {
      var r = n - 1 >>> 1,
        o = e[r];
      if (!(void 0 !== o && 0 < E(o, t))) break e;
      e[r] = t, e[n] = o, n = r;
    }
  }
  function w(e) {
    return void 0 === (e = e[0]) ? null : e;
  }
  function k(e) {
    var t = e[0];
    if (void 0 !== t) {
      var n = e.pop();
      if (n !== t) {
        e[0] = n;
        e: for (var r = 0, o = e.length; r < o;) {
          var i = 2 * (r + 1) - 1,
            a = e[i],
            s = i + 1,
            l = e[s];
          if (void 0 !== a && 0 > E(a, n)) void 0 !== l && 0 > E(l, a) ? (e[r] = l, e[s] = n, r = s) : (e[r] = a, e[i] = n, r = i);else {
            if (!(void 0 !== l && 0 > E(l, n))) break e;
            e[r] = l, e[s] = n, r = s;
          }
        }
      }
      return t;
    }
    return null;
  }
  function E(e, t) {
    var n = e.sortIndex - t.sortIndex;
    return 0 !== n ? n : e.id - t.id;
  }
  var S = [],
    C = [],
    x = 1,
    O = null,
    P = 3,
    T = !1,
    I = !1,
    B = !1;
  function R(e) {
    for (var t = w(C); null !== t;) {
      if (null === t.callback) k(C);else {
        if (!(t.startTime <= e)) break;
        k(C), t.sortIndex = t.expirationTime, _(S, t);
      }
      t = w(C);
    }
  }
  function L(e) {
    if (B = !1, R(e), !I) if (null !== w(S)) I = !0, _t3(M);else {
      var r = w(C);
      null !== r && n(L, r.startTime - e);
    }
  }
  function M(t, o) {
    I = !1, B && (B = !1, r()), T = !0;
    var i = P;
    try {
      for (R(o), O = w(S); null !== O && (!(O.expirationTime > o) || t && !e.unstable_shouldYield());) {
        var a = O.callback;
        if ("function" == typeof a) {
          O.callback = null, P = O.priorityLevel;
          var s = a(O.expirationTime <= o);
          o = e.unstable_now(), "function" == typeof s ? O.callback = s : O === w(S) && k(S), R(o);
        } else k(S);
        O = w(S);
      }
      if (null !== O) var l = !0;else {
        var c = w(C);
        null !== c && n(L, c.startTime - o), l = !1;
      }
      return l;
    } finally {
      O = null, P = i, T = !1;
    }
  }
  var D = o;
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function (e) {
    e.callback = null;
  }, e.unstable_continueExecution = function () {
    I || T || (I = !0, _t3(M));
  }, e.unstable_getCurrentPriorityLevel = function () {
    return P;
  }, e.unstable_getFirstCallbackNode = function () {
    return w(S);
  }, e.unstable_next = function (e) {
    switch (P) {
      case 1:
      case 2:
      case 3:
        var t = 3;
        break;
      default:
        t = P;
    }
    var n = P;
    P = t;
    try {
      return e();
    } finally {
      P = n;
    }
  }, e.unstable_pauseExecution = function () {}, e.unstable_requestPaint = D, e.unstable_runWithPriority = function (e, t) {
    switch (e) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        e = 3;
    }
    var n = P;
    P = e;
    try {
      return t();
    } finally {
      P = n;
    }
  }, e.unstable_scheduleCallback = function (o, i, a) {
    var s = e.unstable_now();
    switch ("object" == _typeof(a) && null !== a ? a = "number" == typeof (a = a.delay) && 0 < a ? s + a : s : a = s, o) {
      case 1:
        var l = -1;
        break;
      case 2:
        l = 250;
        break;
      case 5:
        l = 1073741823;
        break;
      case 4:
        l = 1e4;
        break;
      default:
        l = 5e3;
    }
    return o = {
      id: x++,
      callback: i,
      priorityLevel: o,
      startTime: a,
      expirationTime: l = a + l,
      sortIndex: -1
    }, a > s ? (o.sortIndex = a, _(C, o), null === w(S) && o === w(C) && (B ? r() : B = !0, n(L, a - s))) : (o.sortIndex = l, _(S, o), I || T || (I = !0, _t3(M))), o;
  }, e.unstable_wrapCallback = function (e) {
    var t = P;
    return function () {
      var n = P;
      P = t;
      try {
        return e.apply(this, arguments);
      } finally {
        P = n;
      }
    };
  };
}(So), Eo.exports = So;
var Co = Xe.exports,
  xo = ot,
  Oo = Eo.exports;
function Po(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!Co) throw Error(Po(227));
var To = new Set(),
  Io = {};
function Bo(e, t) {
  Ro(e, t), Ro(e + "Capture", t);
}
function Ro(e, t) {
  for (Io[e] = t, e = 0; e < t.length; e++) To.add(t[e]);
}
var Lo = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
  Mo = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  Do = Object.prototype.hasOwnProperty,
  No = {},
  zo = {};
function jo(e, t, n, r, o, i, a) {
  this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = r, this.attributeNamespace = o, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = i, this.removeEmptyString = a;
}
var Fo = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
  Fo[e] = new jo(e, 0, !1, e, null, !1, !1);
}), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
  var t = e[0];
  Fo[t] = new jo(t, 1, !1, e[1], null, !1, !1);
}), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
  Fo[e] = new jo(e, 2, !1, e.toLowerCase(), null, !1, !1);
}), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
  Fo[e] = new jo(e, 2, !1, e, null, !1, !1);
}), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
  Fo[e] = new jo(e, 3, !1, e.toLowerCase(), null, !1, !1);
}), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
  Fo[e] = new jo(e, 3, !0, e, null, !1, !1);
}), ["capture", "download"].forEach(function (e) {
  Fo[e] = new jo(e, 4, !1, e, null, !1, !1);
}), ["cols", "rows", "size", "span"].forEach(function (e) {
  Fo[e] = new jo(e, 6, !1, e, null, !1, !1);
}), ["rowSpan", "start"].forEach(function (e) {
  Fo[e] = new jo(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var Uo = /[\-:]([a-z])/g;
function Qo(e) {
  return e[1].toUpperCase();
}
function $o(e, t, n, r) {
  var o = Fo.hasOwnProperty(t) ? Fo[t] : null;
  (null !== o ? 0 === o.type : !r && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function (e, t, n, r) {
    if (null == t || function (e, t, n, r) {
      if (null !== n && 0 === n.type) return !1;
      switch (_typeof(t)) {
        case "function":
        case "symbol":
          return !0;
        case "boolean":
          return !r && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
        default:
          return !1;
      }
    }(e, t, n, r)) return !0;
    if (r) return !1;
    if (null !== n) switch (n.type) {
      case 3:
        return !t;
      case 4:
        return !1 === t;
      case 5:
        return isNaN(t);
      case 6:
        return isNaN(t) || 1 > t;
    }
    return !1;
  }(t, n, o, r) && (n = null), r || null === o ? function (e) {
    return !!Do.call(zo, e) || !Do.call(No, e) && (Mo.test(e) ? zo[e] = !0 : (No[e] = !0, !1));
  }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : o.mustUseProperty ? e[o.propertyName] = null === n ? 3 !== o.type && "" : n : (t = o.attributeName, r = o.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (o = o.type) || 4 === o && !0 === n ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
  var t = e.replace(Uo, Qo);
  Fo[t] = new jo(t, 1, !1, e, null, !1, !1);
}), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
  var t = e.replace(Uo, Qo);
  Fo[t] = new jo(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
}), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
  var t = e.replace(Uo, Qo);
  Fo[t] = new jo(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
}), ["tabIndex", "crossOrigin"].forEach(function (e) {
  Fo[e] = new jo(e, 1, !1, e.toLowerCase(), null, !1, !1);
}), Fo.xlinkHref = new jo("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (e) {
  Fo[e] = new jo(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
var Ho = Co.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  Vo = 60103,
  Wo = 60106,
  Ko = 60107,
  qo = 60108,
  Go = 60114,
  Yo = 60109,
  Jo = 60110,
  Zo = 60112,
  Xo = 60113,
  ei = 60120,
  ti = 60115,
  ni = 60116,
  ri = 60121,
  oi = 60128,
  ii = 60129,
  ai = 60130,
  si = 60131;
if ("function" == typeof Symbol && Symbol["for"]) {
  var li = Symbol["for"];
  Vo = li("react.element"), Wo = li("react.portal"), Ko = li("react.fragment"), qo = li("react.strict_mode"), Go = li("react.profiler"), Yo = li("react.provider"), Jo = li("react.context"), Zo = li("react.forward_ref"), Xo = li("react.suspense"), ei = li("react.suspense_list"), ti = li("react.memo"), ni = li("react.lazy"), ri = li("react.block"), li("react.scope"), oi = li("react.opaque.id"), ii = li("react.debug_trace_mode"), ai = li("react.offscreen"), si = li("react.legacy_hidden");
}
var ci,
  ui = "function" == typeof Symbol && Symbol.iterator;
function di(e) {
  return null === e || "object" != _typeof(e) ? null : "function" == typeof (e = ui && e[ui] || e["@@iterator"]) ? e : null;
}
function fi(e) {
  if (void 0 === ci) try {
    throw Error();
  } catch (e) {
    var t = e.stack.trim().match(/\n( *(at )?)/);
    ci = t && t[1] || "";
  }
  return "\n" + ci + e;
}
var pi = !1;
function hi(e, t) {
  if (!e || pi) return "";
  pi = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t) {
      if (t = function t() {
        throw Error();
      }, Object.defineProperty(t.prototype, "props", {
        set: function set() {
          throw Error();
        }
      }), "object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && Reflect.construct) {
        try {
          Reflect.construct(t, []);
        } catch (e) {
          var r = e;
        }
        Reflect.construct(e, [], t);
      } else {
        try {
          t.call();
        } catch (e) {
          r = e;
        }
        e.call(t.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (e) {
        r = e;
      }
      e();
    }
  } catch (e) {
    if (e && r && "string" == typeof e.stack) {
      for (var o = e.stack.split("\n"), i = r.stack.split("\n"), a = o.length - 1, s = i.length - 1; 1 <= a && 0 <= s && o[a] !== i[s];) s--;
      for (; 1 <= a && 0 <= s; a--, s--) if (o[a] !== i[s]) {
        if (1 !== a || 1 !== s) do {
          if (a--, 0 > --s || o[a] !== i[s]) return "\n" + o[a].replace(" at new ", " at ");
        } while (1 <= a && 0 <= s);
        break;
      }
    }
  } finally {
    pi = !1, Error.prepareStackTrace = n;
  }
  return (e = e ? e.displayName || e.name : "") ? fi(e) : "";
}
function mi(e) {
  switch (e.tag) {
    case 5:
      return fi(e.type);
    case 16:
      return fi("Lazy");
    case 13:
      return fi("Suspense");
    case 19:
      return fi("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = hi(e.type, !1);
    case 11:
      return e = hi(e.type.render, !1);
    case 22:
      return e = hi(e.type._render, !1);
    case 1:
      return e = hi(e.type, !0);
    default:
      return "";
  }
}
function gi(e) {
  if (null == e) return null;
  if ("function" == typeof e) return e.displayName || e.name || null;
  if ("string" == typeof e) return e;
  switch (e) {
    case Ko:
      return "Fragment";
    case Wo:
      return "Portal";
    case Go:
      return "Profiler";
    case qo:
      return "StrictMode";
    case Xo:
      return "Suspense";
    case ei:
      return "SuspenseList";
  }
  if ("object" == _typeof(e)) switch (e.$$typeof) {
    case Jo:
      return (e.displayName || "Context") + ".Consumer";
    case Yo:
      return (e._context.displayName || "Context") + ".Provider";
    case Zo:
      var t = e.render;
      return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
    case ti:
      return gi(e.type);
    case ri:
      return gi(e._render);
    case ni:
      t = e._payload, e = e._init;
      try {
        return gi(e(t));
      } catch (e) {}
  }
  return null;
}
function vi(e) {
  switch (_typeof(e)) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return e;
    default:
      return "";
  }
}
function yi(e) {
  var t = e.type;
  return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
}
function Ai(e) {
  e._valueTracker || (e._valueTracker = function (e) {
    var t = yi(e) ? "checked" : "value",
      n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
      r = "" + e[t];
    if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
      var o = n.get,
        i = n.set;
      return Object.defineProperty(e, t, {
        configurable: !0,
        get: function get() {
          return o.call(this);
        },
        set: function set(e) {
          r = "" + e, i.call(this, e);
        }
      }), Object.defineProperty(e, t, {
        enumerable: n.enumerable
      }), {
        getValue: function getValue() {
          return r;
        },
        setValue: function setValue(e) {
          r = "" + e;
        },
        stopTracking: function stopTracking() {
          e._valueTracker = null, delete e[t];
        }
      };
    }
  }(e));
}
function bi(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(),
    r = "";
  return e && (r = yi(e) ? e.checked ? "true" : "false" : e.value), (e = r) !== n && (t.setValue(e), !0);
}
function _i(e) {
  if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
  try {
    return e.activeElement || e.body;
  } catch (t) {
    return e.body;
  }
}
function wi(e, t) {
  var n = t.checked;
  return xo({}, t, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: null != n ? n : e._wrapperState.initialChecked
  });
}
function ki(e, t) {
  var n = null == t.defaultValue ? "" : t.defaultValue,
    r = null != t.checked ? t.checked : t.defaultChecked;
  n = vi(null != t.value ? t.value : n), e._wrapperState = {
    initialChecked: r,
    initialValue: n,
    controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
  };
}
function Ei(e, t) {
  null != (t = t.checked) && $o(e, "checked", t, !1);
}
function Si(e, t) {
  Ei(e, t);
  var n = vi(t.value),
    r = t.type;
  if (null != n) "number" === r ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);else if ("submit" === r || "reset" === r) return void e.removeAttribute("value");
  t.hasOwnProperty("value") ? xi(e, t.type, n) : t.hasOwnProperty("defaultValue") && xi(e, t.type, vi(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
}
function Ci(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (!("submit" !== r && "reset" !== r || void 0 !== t.value && null !== t.value)) return;
    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
  }
  "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
}
function xi(e, t, n) {
  "number" === t && _i(e.ownerDocument) === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
function Oi(e, t) {
  return e = xo({
    children: void 0
  }, t), (t = function (e) {
    var t = "";
    return Co.Children.forEach(e, function (e) {
      null != e && (t += e);
    }), t;
  }(t.children)) && (e.children = t), e;
}
function Pi(e, t, n, r) {
  if (e = e.options, t) {
    t = {};
    for (var o = 0; o < n.length; o++) t["$" + n[o]] = !0;
    for (n = 0; n < e.length; n++) o = t.hasOwnProperty("$" + e[n].value), e[n].selected !== o && (e[n].selected = o), o && r && (e[n].defaultSelected = !0);
  } else {
    for (n = "" + vi(n), t = null, o = 0; o < e.length; o++) {
      if (e[o].value === n) return e[o].selected = !0, void (r && (e[o].defaultSelected = !0));
      null !== t || e[o].disabled || (t = e[o]);
    }
    null !== t && (t.selected = !0);
  }
}
function Ti(e, t) {
  if (null != t.dangerouslySetInnerHTML) throw Error(Po(91));
  return xo({}, t, {
    value: void 0,
    defaultValue: void 0,
    children: "" + e._wrapperState.initialValue
  });
}
function Ii(e, t) {
  var n = t.value;
  if (null == n) {
    if (n = t.children, t = t.defaultValue, null != n) {
      if (null != t) throw Error(Po(92));
      if (Array.isArray(n)) {
        if (!(1 >= n.length)) throw Error(Po(93));
        n = n[0];
      }
      t = n;
    }
    null == t && (t = ""), n = t;
  }
  e._wrapperState = {
    initialValue: vi(n)
  };
}
function Bi(e, t) {
  var n = vi(t.value),
    r = vi(t.defaultValue);
  null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != r && (e.defaultValue = "" + r);
}
function Ri(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && "" !== t && null !== t && (e.value = t);
}
var Li = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg"
};
function Mi(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function Di(e, t) {
  return null == e || "http://www.w3.org/1999/xhtml" === e ? Mi(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
}
var Ni,
  zi = function (e) {
    return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (t, n, r, o) {
      MSApp.execUnsafeLocalFunction(function () {
        return e(t, n);
      });
    } : e;
  }(function (e, t) {
    if (e.namespaceURI !== Li.svg || "innerHTML" in e) e.innerHTML = t;else {
      for ((Ni = Ni || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = Ni.firstChild; e.firstChild;) e.removeChild(e.firstChild);
      for (; t.firstChild;) e.appendChild(t.firstChild);
    }
  });
function ji(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
  }
  e.textContent = t;
}
var Fi = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
  Ui = ["Webkit", "ms", "Moz", "O"];
function Qi(e, t, n) {
  return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || Fi.hasOwnProperty(e) && Fi[e] ? ("" + t).trim() : t + "px";
}
function $i(e, t) {
  for (var n in e = e.style, t) if (t.hasOwnProperty(n)) {
    var r = 0 === n.indexOf("--"),
      o = Qi(n, t[n], r);
    "float" === n && (n = "cssFloat"), r ? e.setProperty(n, o) : e[n] = o;
  }
}
Object.keys(Fi).forEach(function (e) {
  Ui.forEach(function (t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), Fi[t] = Fi[e];
  });
});
var Hi = xo({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});
function Vi(e, t) {
  if (t) {
    if (Hi[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(Po(137, e));
    if (null != t.dangerouslySetInnerHTML) {
      if (null != t.children) throw Error(Po(60));
      if ("object" != _typeof(t.dangerouslySetInnerHTML) || !("__html" in t.dangerouslySetInnerHTML)) throw Error(Po(61));
    }
    if (null != t.style && "object" != _typeof(t.style)) throw Error(Po(62));
  }
}
function Wi(e, t) {
  if (-1 === e.indexOf("-")) return "string" == typeof t.is;
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
function Ki(e) {
  return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
}
var qi = null,
  Gi = null,
  Yi = null;
function Ji(e) {
  if (e = kc(e)) {
    if ("function" != typeof qi) throw Error(Po(280));
    var t = e.stateNode;
    t && (t = Sc(t), qi(e.stateNode, e.type, t));
  }
}
function Zi(e) {
  Gi ? Yi ? Yi.push(e) : Yi = [e] : Gi = e;
}
function Xi() {
  if (Gi) {
    var e = Gi,
      t = Yi;
    if (Yi = Gi = null, Ji(e), t) for (e = 0; e < t.length; e++) Ji(t[e]);
  }
}
function ea(e, t) {
  return e(t);
}
function ta(e, t, n, r, o) {
  return e(t, n, r, o);
}
function na() {}
var ra = ea,
  oa = !1,
  ia = !1;
function aa() {
  null === Gi && null === Yi || (na(), Xi());
}
function sa(e, t) {
  var n = e.stateNode;
  if (null === n) return null;
  var r = Sc(n);
  if (null === r) return null;
  n = r[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) || (r = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !r;
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && "function" != typeof n) throw Error(Po(231, t, _typeof(n)));
  return n;
}
var la = !1;
if (Lo) try {
  var ca = {};
  Object.defineProperty(ca, "passive", {
    get: function get() {
      la = !0;
    }
  }), window.addEventListener("test", ca, ca), window.removeEventListener("test", ca, ca);
} catch (Rm) {
  la = !1;
}
function ua(e, t, n, r, o, i, a, s, l) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, c);
  } catch (e) {
    this.onError(e);
  }
}
var da = !1,
  fa = null,
  pa = !1,
  ha = null,
  ma = {
    onError: function onError(e) {
      da = !0, fa = e;
    }
  };
function ga(e, t, n, r, o, i, a, s, l) {
  da = !1, fa = null, ua.apply(ma, arguments);
}
function va(e) {
  var t = e,
    n = e;
  if (e.alternate) for (; t["return"];) t = t["return"];else {
    e = t;
    do {
      0 != (1026 & (t = e).flags) && (n = t["return"]), e = t["return"];
    } while (e);
  }
  return 3 === t.tag ? n : null;
}
function ya(e) {
  if (13 === e.tag) {
    var t = e.memoizedState;
    if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
  }
  return null;
}
function Aa(e) {
  if (va(e) !== e) throw Error(Po(188));
}
function ba(e) {
  if (e = function (e) {
    var t = e.alternate;
    if (!t) {
      if (null === (t = va(e))) throw Error(Po(188));
      return t !== e ? null : e;
    }
    for (var n = e, r = t;;) {
      var o = n["return"];
      if (null === o) break;
      var i = o.alternate;
      if (null === i) {
        if (null !== (r = o["return"])) {
          n = r;
          continue;
        }
        break;
      }
      if (o.child === i.child) {
        for (i = o.child; i;) {
          if (i === n) return Aa(o), e;
          if (i === r) return Aa(o), t;
          i = i.sibling;
        }
        throw Error(Po(188));
      }
      if (n["return"] !== r["return"]) n = o, r = i;else {
        for (var a = !1, s = o.child; s;) {
          if (s === n) {
            a = !0, n = o, r = i;
            break;
          }
          if (s === r) {
            a = !0, r = o, n = i;
            break;
          }
          s = s.sibling;
        }
        if (!a) {
          for (s = i.child; s;) {
            if (s === n) {
              a = !0, n = i, r = o;
              break;
            }
            if (s === r) {
              a = !0, r = i, n = o;
              break;
            }
            s = s.sibling;
          }
          if (!a) throw Error(Po(189));
        }
      }
      if (n.alternate !== r) throw Error(Po(190));
    }
    if (3 !== n.tag) throw Error(Po(188));
    return n.stateNode.current === n ? e : t;
  }(e), !e) return null;
  for (var t = e;;) {
    if (5 === t.tag || 6 === t.tag) return t;
    if (t.child) t.child["return"] = t, t = t.child;else {
      if (t === e) break;
      for (; !t.sibling;) {
        if (!t["return"] || t["return"] === e) return null;
        t = t["return"];
      }
      t.sibling["return"] = t["return"], t = t.sibling;
    }
  }
  return null;
}
function _a(e, t) {
  for (var n = e.alternate; null !== t;) {
    if (t === e || t === n) return !0;
    t = t["return"];
  }
  return !1;
}
var wa,
  ka,
  Ea,
  Sa,
  Ca = !1,
  xa = [],
  Oa = null,
  Pa = null,
  Ta = null,
  Ia = new Map(),
  Ba = new Map(),
  Ra = [],
  La = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Ma(e, t, n, r, o) {
  return {
    blockedOn: e,
    domEventName: t,
    eventSystemFlags: 16 | n,
    nativeEvent: o,
    targetContainers: [r]
  };
}
function Da(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      Oa = null;
      break;
    case "dragenter":
    case "dragleave":
      Pa = null;
      break;
    case "mouseover":
    case "mouseout":
      Ta = null;
      break;
    case "pointerover":
    case "pointerout":
      Ia["delete"](t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Ba["delete"](t.pointerId);
  }
}
function Na(e, t, n, r, o, i) {
  return null === e || e.nativeEvent !== i ? (e = Ma(t, n, r, o, i), null !== t && null !== (t = kc(t)) && ka(t), e) : (e.eventSystemFlags |= r, t = e.targetContainers, null !== o && -1 === t.indexOf(o) && t.push(o), e);
}
function za(e) {
  var t = wc(e.target);
  if (null !== t) {
    var n = va(t);
    if (null !== n) if (13 === (t = n.tag)) {
      if (null !== (t = ya(n))) return e.blockedOn = t, void Sa(e.lanePriority, function () {
        Oo.unstable_runWithPriority(e.priority, function () {
          Ea(n);
        });
      });
    } else if (3 === t && n.stateNode.hydrate) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
  }
  e.blockedOn = null;
}
function ja(e) {
  if (null !== e.blockedOn) return !1;
  for (var t = e.targetContainers; 0 < t.length;) {
    var n = bs(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (null !== n) return null !== (t = kc(n)) && ka(t), e.blockedOn = n, !1;
    t.shift();
  }
  return !0;
}
function Fa(e, t, n) {
  ja(e) && n["delete"](t);
}
function Ua() {
  for (Ca = !1; 0 < xa.length;) {
    var e = xa[0];
    if (null !== e.blockedOn) {
      null !== (e = kc(e.blockedOn)) && wa(e);
      break;
    }
    for (var t = e.targetContainers; 0 < t.length;) {
      var n = bs(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
      if (null !== n) {
        e.blockedOn = n;
        break;
      }
      t.shift();
    }
    null === e.blockedOn && xa.shift();
  }
  null !== Oa && ja(Oa) && (Oa = null), null !== Pa && ja(Pa) && (Pa = null), null !== Ta && ja(Ta) && (Ta = null), Ia.forEach(Fa), Ba.forEach(Fa);
}
function Qa(e, t) {
  e.blockedOn === t && (e.blockedOn = null, Ca || (Ca = !0, Oo.unstable_scheduleCallback(Oo.unstable_NormalPriority, Ua)));
}
function $a(e) {
  function t(t) {
    return Qa(t, e);
  }
  if (0 < xa.length) {
    Qa(xa[0], e);
    for (var n = 1; n < xa.length; n++) {
      var r = xa[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (null !== Oa && Qa(Oa, e), null !== Pa && Qa(Pa, e), null !== Ta && Qa(Ta, e), Ia.forEach(t), Ba.forEach(t), n = 0; n < Ra.length; n++) (r = Ra[n]).blockedOn === e && (r.blockedOn = null);
  for (; 0 < Ra.length && null === (n = Ra[0]).blockedOn;) za(n), null === n.blockedOn && Ra.shift();
}
function Ha(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var Va = {
    animationend: Ha("Animation", "AnimationEnd"),
    animationiteration: Ha("Animation", "AnimationIteration"),
    animationstart: Ha("Animation", "AnimationStart"),
    transitionend: Ha("Transition", "TransitionEnd")
  },
  Wa = {},
  Ka = {};
function qa(e) {
  if (Wa[e]) return Wa[e];
  if (!Va[e]) return e;
  var t,
    n = Va[e];
  for (t in n) if (n.hasOwnProperty(t) && t in Ka) return Wa[e] = n[t];
  return e;
}
Lo && (Ka = document.createElement("div").style, "AnimationEvent" in window || (delete Va.animationend.animation, delete Va.animationiteration.animation, delete Va.animationstart.animation), "TransitionEvent" in window || delete Va.transitionend.transition);
var Ga = qa("animationend"),
  Ya = qa("animationiteration"),
  Ja = qa("animationstart"),
  Za = qa("transitionend"),
  Xa = new Map(),
  es = new Map(),
  ts = ["abort", "abort", Ga, "animationEnd", Ya, "animationIteration", Ja, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", Za, "transitionEnd", "waiting", "waiting"];
function ns(e, t) {
  for (var n = 0; n < e.length; n += 2) {
    var r = e[n],
      o = e[n + 1];
    o = "on" + (o[0].toUpperCase() + o.slice(1)), es.set(r, t), Xa.set(r, o), Bo(o, [r]);
  }
}
(0, Oo.unstable_now)();
var rs = 8;
function os(e) {
  if (0 != (1 & e)) return rs = 15, 1;
  if (0 != (2 & e)) return rs = 14, 2;
  if (0 != (4 & e)) return rs = 13, 4;
  var t = 24 & e;
  return 0 !== t ? (rs = 12, t) : 0 != (32 & e) ? (rs = 11, 32) : 0 !== (t = 192 & e) ? (rs = 10, t) : 0 != (256 & e) ? (rs = 9, 256) : 0 !== (t = 3584 & e) ? (rs = 8, t) : 0 != (4096 & e) ? (rs = 7, 4096) : 0 !== (t = 4186112 & e) ? (rs = 6, t) : 0 !== (t = 62914560 & e) ? (rs = 5, t) : 67108864 & e ? (rs = 4, 67108864) : 0 != (134217728 & e) ? (rs = 3, 134217728) : 0 !== (t = 805306368 & e) ? (rs = 2, t) : 0 != (1073741824 & e) ? (rs = 1, 1073741824) : (rs = 8, e);
}
function is(e, t) {
  var n = e.pendingLanes;
  if (0 === n) return rs = 0;
  var r = 0,
    o = 0,
    i = e.expiredLanes,
    a = e.suspendedLanes,
    s = e.pingedLanes;
  if (0 !== i) r = i, o = rs = 15;else if (0 !== (i = 134217727 & n)) {
    var l = i & ~a;
    0 !== l ? (r = os(l), o = rs) : 0 !== (s &= i) && (r = os(s), o = rs);
  } else 0 !== (i = n & ~a) ? (r = os(i), o = rs) : 0 !== s && (r = os(s), o = rs);
  if (0 === r) return 0;
  if (r = n & ((0 > (r = 31 - ds(r)) ? 0 : 1 << r) << 1) - 1, 0 !== t && t !== r && 0 == (t & a)) {
    if (os(t), o <= rs) return t;
    rs = o;
  }
  if (0 !== (t = e.entangledLanes)) for (e = e.entanglements, t &= r; 0 < t;) o = 1 << (n = 31 - ds(t)), r |= e[n], t &= ~o;
  return r;
}
function as(e) {
  return 0 !== (e = -1073741825 & e.pendingLanes) ? e : 1073741824 & e ? 1073741824 : 0;
}
function ss(e, t) {
  switch (e) {
    case 15:
      return 1;
    case 14:
      return 2;
    case 12:
      return 0 === (e = ls(24 & ~t)) ? ss(10, t) : e;
    case 10:
      return 0 === (e = ls(192 & ~t)) ? ss(8, t) : e;
    case 8:
      return 0 === (e = ls(3584 & ~t)) && 0 === (e = ls(4186112 & ~t)) && (e = 512), e;
    case 2:
      return 0 === (t = ls(805306368 & ~t)) && (t = 268435456), t;
  }
  throw Error(Po(358, e));
}
function ls(e) {
  return e & -e;
}
function cs(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function us(e, t, n) {
  e.pendingLanes |= t;
  var r = t - 1;
  e.suspendedLanes &= r, e.pingedLanes &= r, (e = e.eventTimes)[t = 31 - ds(t)] = n;
}
var ds = Math.clz32 ? Math.clz32 : function (e) {
    return 0 === e ? 32 : 31 - (fs(e) / ps | 0) | 0;
  },
  fs = Math.log,
  ps = Math.LN2;
var hs = Oo.unstable_UserBlockingPriority,
  ms = Oo.unstable_runWithPriority,
  gs = !0;
function vs(e, t, n, r) {
  oa || na();
  var o = As,
    i = oa;
  oa = !0;
  try {
    ta(o, e, t, n, r);
  } finally {
    (oa = i) || aa();
  }
}
function ys(e, t, n, r) {
  ms(hs, As.bind(null, e, t, n, r));
}
function As(e, t, n, r) {
  var o;
  if (gs) if ((o = 0 == (4 & t)) && 0 < xa.length && -1 < La.indexOf(e)) e = Ma(null, e, t, n, r), xa.push(e);else {
    var i = bs(e, t, n, r);
    if (null === i) o && Da(e, r);else {
      if (o) {
        if (-1 < La.indexOf(e)) return e = Ma(i, e, t, n, r), void xa.push(e);
        if (function (e, t, n, r, o) {
          switch (t) {
            case "focusin":
              return Oa = Na(Oa, e, t, n, r, o), !0;
            case "dragenter":
              return Pa = Na(Pa, e, t, n, r, o), !0;
            case "mouseover":
              return Ta = Na(Ta, e, t, n, r, o), !0;
            case "pointerover":
              var i = o.pointerId;
              return Ia.set(i, Na(Ia.get(i) || null, e, t, n, r, o)), !0;
            case "gotpointercapture":
              return i = o.pointerId, Ba.set(i, Na(Ba.get(i) || null, e, t, n, r, o)), !0;
          }
          return !1;
        }(i, e, t, n, r)) return;
        Da(e, r);
      }
      tc(e, t, r, null, n);
    }
  }
}
function bs(e, t, n, r) {
  var o = Ki(r);
  if (null !== (o = wc(o))) {
    var i = va(o);
    if (null === i) o = null;else {
      var a = i.tag;
      if (13 === a) {
        if (null !== (o = ya(i))) return o;
        o = null;
      } else if (3 === a) {
        if (i.stateNode.hydrate) return 3 === i.tag ? i.stateNode.containerInfo : null;
        o = null;
      } else i !== o && (o = null);
    }
  }
  return tc(e, t, r, o, n), null;
}
var _s = null,
  ws = null,
  ks = null;
function Es() {
  if (ks) return ks;
  var e,
    t,
    n = ws,
    r = n.length,
    o = "value" in _s ? _s.value : _s.textContent,
    i = o.length;
  for (e = 0; e < r && n[e] === o[e]; e++);
  var a = r - e;
  for (t = 1; t <= a && n[r - t] === o[i - t]; t++);
  return ks = o.slice(e, 1 < t ? 1 - t : void 0);
}
function Ss(e) {
  var t = e.keyCode;
  return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
}
function Cs() {
  return !0;
}
function xs() {
  return !1;
}
function Os(e) {
  function t(t, n, r, o, i) {
    for (var a in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = o, this.target = i, this.currentTarget = null, e) e.hasOwnProperty(a) && (t = e[a], this[a] = t ? t(o) : o[a]);
    return this.isDefaultPrevented = (null != o.defaultPrevented ? o.defaultPrevented : !1 === o.returnValue) ? Cs : xs, this.isPropagationStopped = xs, this;
  }
  return xo(t.prototype, {
    preventDefault: function preventDefault() {
      this.defaultPrevented = !0;
      var e = this.nativeEvent;
      e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = Cs);
    },
    stopPropagation: function stopPropagation() {
      var e = this.nativeEvent;
      e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = Cs);
    },
    persist: function persist() {},
    isPersistent: Cs
  }), t;
}
var Ps,
  Ts,
  Is,
  Bs = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  },
  Rs = Os(Bs),
  Ls = xo({}, Bs, {
    view: 0,
    detail: 0
  }),
  Ms = Os(Ls),
  Ds = xo({}, Ls, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: qs,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(e) {
      return void 0 === e.relatedTarget ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function movementX(e) {
      return "movementX" in e ? e.movementX : (e !== Is && (Is && "mousemove" === e.type ? (Ps = e.screenX - Is.screenX, Ts = e.screenY - Is.screenY) : Ts = Ps = 0, Is = e), Ps);
    },
    movementY: function movementY(e) {
      return "movementY" in e ? e.movementY : Ts;
    }
  }),
  Ns = Os(Ds),
  zs = Os(xo({}, Ds, {
    dataTransfer: 0
  })),
  js = Os(xo({}, Ls, {
    relatedTarget: 0
  })),
  Fs = Os(xo({}, Bs, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  })),
  Us = xo({}, Bs, {
    clipboardData: function clipboardData(e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
  }),
  Qs = Os(Us),
  $s = Os(xo({}, Bs, {
    data: 0
  })),
  Hs = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
  Vs = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
  Ws = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
function Ks(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : !!(e = Ws[e]) && !!t[e];
}
function qs() {
  return Ks;
}
var Gs = xo({}, Ls, {
    key: function key(e) {
      if (e.key) {
        var t = Hs[e.key] || e.key;
        if ("Unidentified" !== t) return t;
      }
      return "keypress" === e.type ? 13 === (e = Ss(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? Vs[e.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: qs,
    charCode: function charCode(e) {
      return "keypress" === e.type ? Ss(e) : 0;
    },
    keyCode: function keyCode(e) {
      return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
    },
    which: function which(e) {
      return "keypress" === e.type ? Ss(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
    }
  }),
  Ys = Os(Gs),
  Js = Os(xo({}, Ds, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  })),
  Zs = Os(xo({}, Ls, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: qs
  })),
  Xs = Os(xo({}, Bs, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  })),
  el = xo({}, Ds, {
    deltaX: function deltaX(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function deltaY(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }),
  tl = Os(el),
  nl = [9, 13, 27, 32],
  rl = Lo && "CompositionEvent" in window,
  ol = null;
Lo && "documentMode" in document && (ol = document.documentMode);
var il = Lo && "TextEvent" in window && !ol,
  al = Lo && (!rl || ol && 8 < ol && 11 >= ol),
  sl = String.fromCharCode(32),
  ll = !1;
function cl(e, t) {
  switch (e) {
    case "keyup":
      return -1 !== nl.indexOf(t.keyCode);
    case "keydown":
      return 229 !== t.keyCode;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function ul(e) {
  return "object" == _typeof(e = e.detail) && "data" in e ? e.data : null;
}
var dl = !1;
var fl = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0
};
function pl(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return "input" === t ? !!fl[e.type] : "textarea" === t;
}
function hl(e, t, n, r) {
  Zi(r), 0 < (t = rc(t, "onChange")).length && (n = new Rs("onChange", "change", null, n, r), e.push({
    event: n,
    listeners: t
  }));
}
var ml = null,
  gl = null;
function vl(e) {
  Gl(e, 0);
}
function yl(e) {
  if (bi(Ec(e))) return e;
}
function Al(e, t) {
  if ("change" === e) return t;
}
var bl = !1;
if (Lo) {
  var _l;
  if (Lo) {
    var wl = ("oninput" in document);
    if (!wl) {
      var kl = document.createElement("div");
      kl.setAttribute("oninput", "return;"), wl = "function" == typeof kl.oninput;
    }
    _l = wl;
  } else _l = !1;
  bl = _l && (!document.documentMode || 9 < document.documentMode);
}
function El() {
  ml && (ml.detachEvent("onpropertychange", Sl), gl = ml = null);
}
function Sl(e) {
  if ("value" === e.propertyName && yl(gl)) {
    var t = [];
    if (hl(t, gl, e, Ki(e)), e = vl, oa) e(t);else {
      oa = !0;
      try {
        ea(e, t);
      } finally {
        oa = !1, aa();
      }
    }
  }
}
function Cl(e, t, n) {
  "focusin" === e ? (El(), gl = n, (ml = t).attachEvent("onpropertychange", Sl)) : "focusout" === e && El();
}
function xl(e) {
  if ("selectionchange" === e || "keyup" === e || "keydown" === e) return yl(gl);
}
function Ol(e, t) {
  if ("click" === e) return yl(t);
}
function Pl(e, t) {
  if ("input" === e || "change" === e) return yl(t);
}
var Tl = "function" == typeof Object.is ? Object.is : function (e, t) {
    return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
  },
  Il = Object.prototype.hasOwnProperty;
function Bl(e, t) {
  if (Tl(e, t)) return !0;
  if ("object" != _typeof(e) || null === e || "object" != _typeof(t) || null === t) return !1;
  var n = Object.keys(e),
    r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) if (!Il.call(t, n[r]) || !Tl(e[n[r]], t[n[r]])) return !1;
  return !0;
}
function Rl(e) {
  for (; e && e.firstChild;) e = e.firstChild;
  return e;
}
function Ll(e, t) {
  var n,
    r = Rl(e);
  for (e = 0; r;) {
    if (3 === r.nodeType) {
      if (n = e + r.textContent.length, e <= t && n >= t) return {
        node: r,
        offset: t - e
      };
      e = n;
    }
    e: {
      for (; r;) {
        if (r.nextSibling) {
          r = r.nextSibling;
          break e;
        }
        r = r.parentNode;
      }
      r = void 0;
    }
    r = Rl(r);
  }
}
function Ml(e, t) {
  return !(!e || !t) && (e === t || (!e || 3 !== e.nodeType) && (t && 3 === t.nodeType ? Ml(e, t.parentNode) : "contains" in e ? e.contains(t) : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(t))));
}
function Dl() {
  for (var e = window, t = _i(); t instanceof e.HTMLIFrameElement;) {
    try {
      var n = "string" == typeof t.contentWindow.location.href;
    } catch (e) {
      n = !1;
    }
    if (!n) break;
    t = _i((e = t.contentWindow).document);
  }
  return t;
}
function Nl(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
}
var zl = Lo && "documentMode" in document && 11 >= document.documentMode,
  jl = null,
  Fl = null,
  Ul = null,
  Ql = !1;
function $l(e, t, n) {
  var r = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
  Ql || null == jl || jl !== _i(r) || ("selectionStart" in (r = jl) && Nl(r) ? r = {
    start: r.selectionStart,
    end: r.selectionEnd
  } : r = {
    anchorNode: (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection()).anchorNode,
    anchorOffset: r.anchorOffset,
    focusNode: r.focusNode,
    focusOffset: r.focusOffset
  }, Ul && Bl(Ul, r) || (Ul = r, 0 < (r = rc(Fl, "onSelect")).length && (t = new Rs("onSelect", "select", null, t, n), e.push({
    event: t,
    listeners: r
  }), t.target = jl)));
}
ns("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), ns("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), ns(ts, 2);
for (var Hl = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Vl = 0; Vl < Hl.length; Vl++) es.set(Hl[Vl], 0);
Ro("onMouseEnter", ["mouseout", "mouseover"]), Ro("onMouseLeave", ["mouseout", "mouseover"]), Ro("onPointerEnter", ["pointerout", "pointerover"]), Ro("onPointerLeave", ["pointerout", "pointerover"]), Bo("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), Bo("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), Bo("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Bo("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), Bo("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), Bo("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Wl = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
  Kl = new Set("cancel close invalid load scroll toggle".split(" ").concat(Wl));
function ql(e, t, n) {
  var r = e.type || "unknown-event";
  e.currentTarget = n, function (e, t, n, r, o, i, a, s, l) {
    if (ga.apply(this, arguments), da) {
      if (!da) throw Error(Po(198));
      var c = fa;
      da = !1, fa = null, pa || (pa = !0, ha = c);
    }
  }(r, t, void 0, e), e.currentTarget = null;
}
function Gl(e, t) {
  t = 0 != (4 & t);
  for (var n = 0; n < e.length; n++) {
    var r = e[n],
      o = r.event;
    r = r.listeners;
    e: {
      var i = void 0;
      if (t) for (var a = r.length - 1; 0 <= a; a--) {
        var s = r[a],
          l = s.instance,
          c = s.currentTarget;
        if (s = s.listener, l !== i && o.isPropagationStopped()) break e;
        ql(o, s, c), i = l;
      } else for (a = 0; a < r.length; a++) {
        if (l = (s = r[a]).instance, c = s.currentTarget, s = s.listener, l !== i && o.isPropagationStopped()) break e;
        ql(o, s, c), i = l;
      }
    }
  }
  if (pa) throw e = ha, pa = !1, ha = null, e;
}
function Yl(e, t) {
  var n = Cc(t),
    r = e + "__bubble";
  n.has(r) || (ec(t, e, 2, !1), n.add(r));
}
var Jl = "_reactListening" + Math.random().toString(36).slice(2);
function Zl(e) {
  e[Jl] || (e[Jl] = !0, To.forEach(function (t) {
    Kl.has(t) || Xl(t, !1, e, null), Xl(t, !0, e, null);
  }));
}
function Xl(e, t, n, r) {
  var o = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0,
    i = n;
  if ("selectionchange" === e && 9 !== n.nodeType && (i = n.ownerDocument), null !== r && !t && Kl.has(e)) {
    if ("scroll" !== e) return;
    o |= 2, i = r;
  }
  var a = Cc(i),
    s = e + "__" + (t ? "capture" : "bubble");
  a.has(s) || (t && (o |= 4), ec(i, e, o, t), a.add(s));
}
function ec(e, t, n, r) {
  var o = es.get(t);
  switch (void 0 === o ? 2 : o) {
    case 0:
      o = vs;
      break;
    case 1:
      o = ys;
      break;
    default:
      o = As;
  }
  n = o.bind(null, t, n, e), o = void 0, !la || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (o = !0), r ? void 0 !== o ? e.addEventListener(t, n, {
    capture: !0,
    passive: o
  }) : e.addEventListener(t, n, !0) : void 0 !== o ? e.addEventListener(t, n, {
    passive: o
  }) : e.addEventListener(t, n, !1);
}
function tc(e, t, n, r, o) {
  var i = r;
  if (0 == (1 & t) && 0 == (2 & t) && null !== r) e: for (;;) {
    if (null === r) return;
    var a = r.tag;
    if (3 === a || 4 === a) {
      var s = r.stateNode.containerInfo;
      if (s === o || 8 === s.nodeType && s.parentNode === o) break;
      if (4 === a) for (a = r["return"]; null !== a;) {
        var l = a.tag;
        if ((3 === l || 4 === l) && ((l = a.stateNode.containerInfo) === o || 8 === l.nodeType && l.parentNode === o)) return;
        a = a["return"];
      }
      for (; null !== s;) {
        if (null === (a = wc(s))) return;
        if (5 === (l = a.tag) || 6 === l) {
          r = i = a;
          continue e;
        }
        s = s.parentNode;
      }
    }
    r = r["return"];
  }
  !function (e, t, n) {
    if (ia) return e(t, n);
    ia = !0;
    try {
      return ra(e, t, n);
    } finally {
      ia = !1, aa();
    }
  }(function () {
    var r = i,
      o = Ki(n),
      a = [];
    e: {
      var s = Xa.get(e);
      if (void 0 !== s) {
        var l = Rs,
          c = e;
        switch (e) {
          case "keypress":
            if (0 === Ss(n)) break e;
          case "keydown":
          case "keyup":
            l = Ys;
            break;
          case "focusin":
            c = "focus", l = js;
            break;
          case "focusout":
            c = "blur", l = js;
            break;
          case "beforeblur":
          case "afterblur":
            l = js;
            break;
          case "click":
            if (2 === n.button) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            l = Ns;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            l = zs;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            l = Zs;
            break;
          case Ga:
          case Ya:
          case Ja:
            l = Fs;
            break;
          case Za:
            l = Xs;
            break;
          case "scroll":
            l = Ms;
            break;
          case "wheel":
            l = tl;
            break;
          case "copy":
          case "cut":
          case "paste":
            l = Qs;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            l = Js;
        }
        var u = 0 != (4 & t),
          d = !u && "scroll" === e,
          f = u ? null !== s ? s + "Capture" : null : s;
        u = [];
        for (var p, h = r; null !== h;) {
          var m = (p = h).stateNode;
          if (5 === p.tag && null !== m && (p = m, null !== f && null != (m = sa(h, f)) && u.push(nc(h, m, p))), d) break;
          h = h["return"];
        }
        0 < u.length && (s = new l(s, c, null, n, o), a.push({
          event: s,
          listeners: u
        }));
      }
    }
    if (0 == (7 & t)) {
      if (l = "mouseout" === e || "pointerout" === e, (!(s = "mouseover" === e || "pointerover" === e) || 0 != (16 & t) || !(c = n.relatedTarget || n.fromElement) || !wc(c) && !c[bc]) && (l || s) && (s = o.window === o ? o : (s = o.ownerDocument) ? s.defaultView || s.parentWindow : window, l ? (l = r, null !== (c = (c = n.relatedTarget || n.toElement) ? wc(c) : null) && (c !== (d = va(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (l = null, c = r), l !== c)) {
        if (u = Ns, m = "onMouseLeave", f = "onMouseEnter", h = "mouse", "pointerout" !== e && "pointerover" !== e || (u = Js, m = "onPointerLeave", f = "onPointerEnter", h = "pointer"), d = null == l ? s : Ec(l), p = null == c ? s : Ec(c), (s = new u(m, h + "leave", l, n, o)).target = d, s.relatedTarget = p, m = null, wc(o) === r && ((u = new u(f, h + "enter", c, n, o)).target = p, u.relatedTarget = d, m = u), d = m, l && c) e: {
          for (f = c, h = 0, p = u = l; p; p = oc(p)) h++;
          for (p = 0, m = f; m; m = oc(m)) p++;
          for (; 0 < h - p;) u = oc(u), h--;
          for (; 0 < p - h;) f = oc(f), p--;
          for (; h--;) {
            if (u === f || null !== f && u === f.alternate) break e;
            u = oc(u), f = oc(f);
          }
          u = null;
        } else u = null;
        null !== l && ic(a, s, l, u, !1), null !== c && null !== d && ic(a, d, c, u, !0);
      }
      if ("select" === (l = (s = r ? Ec(r) : window).nodeName && s.nodeName.toLowerCase()) || "input" === l && "file" === s.type) var g = Al;else if (pl(s)) {
        if (bl) g = Pl;else {
          g = xl;
          var v = Cl;
        }
      } else (l = s.nodeName) && "input" === l.toLowerCase() && ("checkbox" === s.type || "radio" === s.type) && (g = Ol);
      switch (g && (g = g(e, r)) ? hl(a, g, n, o) : (v && v(e, s, r), "focusout" === e && (v = s._wrapperState) && v.controlled && "number" === s.type && xi(s, "number", s.value)), v = r ? Ec(r) : window, e) {
        case "focusin":
          (pl(v) || "true" === v.contentEditable) && (jl = v, Fl = r, Ul = null);
          break;
        case "focusout":
          Ul = Fl = jl = null;
          break;
        case "mousedown":
          Ql = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Ql = !1, $l(a, n, o);
          break;
        case "selectionchange":
          if (zl) break;
        case "keydown":
        case "keyup":
          $l(a, n, o);
      }
      var y;
      if (rl) e: {
        switch (e) {
          case "compositionstart":
            var A = "onCompositionStart";
            break e;
          case "compositionend":
            A = "onCompositionEnd";
            break e;
          case "compositionupdate":
            A = "onCompositionUpdate";
            break e;
        }
        A = void 0;
      } else dl ? cl(e, n) && (A = "onCompositionEnd") : "keydown" === e && 229 === n.keyCode && (A = "onCompositionStart");
      A && (al && "ko" !== n.locale && (dl || "onCompositionStart" !== A ? "onCompositionEnd" === A && dl && (y = Es()) : (ws = "value" in (_s = o) ? _s.value : _s.textContent, dl = !0)), 0 < (v = rc(r, A)).length && (A = new $s(A, e, null, n, o), a.push({
        event: A,
        listeners: v
      }), y ? A.data = y : null !== (y = ul(n)) && (A.data = y))), (y = il ? function (e, t) {
        switch (e) {
          case "compositionend":
            return ul(t);
          case "keypress":
            return 32 !== t.which ? null : (ll = !0, sl);
          case "textInput":
            return (e = t.data) === sl && ll ? null : e;
          default:
            return null;
        }
      }(e, n) : function (e, t) {
        if (dl) return "compositionend" === e || !rl && cl(e, t) ? (e = Es(), ks = ws = _s = null, dl = !1, e) : null;
        switch (e) {
          case "paste":
          default:
            return null;
          case "keypress":
            if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
              if (t["char"] && 1 < t["char"].length) return t["char"];
              if (t.which) return String.fromCharCode(t.which);
            }
            return null;
          case "compositionend":
            return al && "ko" !== t.locale ? null : t.data;
        }
      }(e, n)) && 0 < (r = rc(r, "onBeforeInput")).length && (o = new $s("onBeforeInput", "beforeinput", null, n, o), a.push({
        event: o,
        listeners: r
      }), o.data = y);
    }
    Gl(a, t);
  });
}
function nc(e, t, n) {
  return {
    instance: e,
    listener: t,
    currentTarget: n
  };
}
function rc(e, t) {
  for (var n = t + "Capture", r = []; null !== e;) {
    var o = e,
      i = o.stateNode;
    5 === o.tag && null !== i && (o = i, null != (i = sa(e, n)) && r.unshift(nc(e, i, o)), null != (i = sa(e, t)) && r.push(nc(e, i, o))), e = e["return"];
  }
  return r;
}
function oc(e) {
  if (null === e) return null;
  do {
    e = e["return"];
  } while (e && 5 !== e.tag);
  return e || null;
}
function ic(e, t, n, r, o) {
  for (var i = t._reactName, a = []; null !== n && n !== r;) {
    var s = n,
      l = s.alternate,
      c = s.stateNode;
    if (null !== l && l === r) break;
    5 === s.tag && null !== c && (s = c, o ? null != (l = sa(n, i)) && a.unshift(nc(n, l, s)) : o || null != (l = sa(n, i)) && a.push(nc(n, l, s))), n = n["return"];
  }
  0 !== a.length && e.push({
    event: t,
    listeners: a
  });
}
function ac() {}
var sc = null,
  lc = null;
function cc(e, t) {
  switch (e) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!t.autoFocus;
  }
  return !1;
}
function uc(e, t) {
  return "textarea" === e || "option" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == _typeof(t.dangerouslySetInnerHTML) && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
}
var dc = "function" == typeof setTimeout ? setTimeout : void 0,
  fc = "function" == typeof clearTimeout ? clearTimeout : void 0;
function pc(e) {
  1 === e.nodeType ? e.textContent = "" : 9 === e.nodeType && null != (e = e.body) && (e.textContent = "");
}
function hc(e) {
  for (; null != e; e = e.nextSibling) {
    var t = e.nodeType;
    if (1 === t || 3 === t) break;
  }
  return e;
}
function mc(e) {
  e = e.previousSibling;
  for (var t = 0; e;) {
    if (8 === e.nodeType) {
      var n = e.data;
      if ("$" === n || "$!" === n || "$?" === n) {
        if (0 === t) return e;
        t--;
      } else "/$" === n && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var gc = 0;
var vc = Math.random().toString(36).slice(2),
  yc = "__reactFiber$" + vc,
  Ac = "__reactProps$" + vc,
  bc = "__reactContainer$" + vc,
  _c = "__reactEvents$" + vc;
function wc(e) {
  var t = e[yc];
  if (t) return t;
  for (var n = e.parentNode; n;) {
    if (t = n[bc] || n[yc]) {
      if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for (e = mc(e); null !== e;) {
        if (n = e[yc]) return n;
        e = mc(e);
      }
      return t;
    }
    n = (e = n).parentNode;
  }
  return null;
}
function kc(e) {
  return !(e = e[yc] || e[bc]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
}
function Ec(e) {
  if (5 === e.tag || 6 === e.tag) return e.stateNode;
  throw Error(Po(33));
}
function Sc(e) {
  return e[Ac] || null;
}
function Cc(e) {
  var t = e[_c];
  return void 0 === t && (t = e[_c] = new Set()), t;
}
var xc = [],
  Oc = -1;
function Pc(e) {
  return {
    current: e
  };
}
function Tc(e) {
  0 > Oc || (e.current = xc[Oc], xc[Oc] = null, Oc--);
}
function Ic(e, t) {
  Oc++, xc[Oc] = e.current, e.current = t;
}
var Bc = {},
  Rc = Pc(Bc),
  Lc = Pc(!1),
  Mc = Bc;
function Dc(e, t) {
  var n = e.type.contextTypes;
  if (!n) return Bc;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
  var o,
    i = {};
  for (o in n) i[o] = t[o];
  return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = i), i;
}
function Nc(e) {
  return null != (e = e.childContextTypes);
}
function zc() {
  Tc(Lc), Tc(Rc);
}
function jc(e, t, n) {
  if (Rc.current !== Bc) throw Error(Po(168));
  Ic(Rc, t), Ic(Lc, n);
}
function Fc(e, t, n) {
  var r = e.stateNode;
  if (e = t.childContextTypes, "function" != typeof r.getChildContext) return n;
  for (var o in r = r.getChildContext()) if (!(o in e)) throw Error(Po(108, gi(t) || "Unknown", o));
  return xo({}, n, r);
}
function Uc(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Bc, Mc = Rc.current, Ic(Rc, e), Ic(Lc, Lc.current), !0;
}
function Qc(e, t, n) {
  var r = e.stateNode;
  if (!r) throw Error(Po(169));
  n ? (e = Fc(e, t, Mc), r.__reactInternalMemoizedMergedChildContext = e, Tc(Lc), Tc(Rc), Ic(Rc, e)) : Tc(Lc), Ic(Lc, n);
}
var $c = null,
  Hc = null,
  Vc = Oo.unstable_runWithPriority,
  Wc = Oo.unstable_scheduleCallback,
  Kc = Oo.unstable_cancelCallback,
  qc = Oo.unstable_shouldYield,
  Gc = Oo.unstable_requestPaint,
  Yc = Oo.unstable_now,
  Jc = Oo.unstable_getCurrentPriorityLevel,
  Zc = Oo.unstable_ImmediatePriority,
  Xc = Oo.unstable_UserBlockingPriority,
  eu = Oo.unstable_NormalPriority,
  tu = Oo.unstable_LowPriority,
  nu = Oo.unstable_IdlePriority,
  ru = {},
  ou = void 0 !== Gc ? Gc : function () {},
  iu = null,
  au = null,
  su = !1,
  lu = Yc(),
  cu = 1e4 > lu ? Yc : function () {
    return Yc() - lu;
  };
function uu() {
  switch (Jc()) {
    case Zc:
      return 99;
    case Xc:
      return 98;
    case eu:
      return 97;
    case tu:
      return 96;
    case nu:
      return 95;
    default:
      throw Error(Po(332));
  }
}
function du(e) {
  switch (e) {
    case 99:
      return Zc;
    case 98:
      return Xc;
    case 97:
      return eu;
    case 96:
      return tu;
    case 95:
      return nu;
    default:
      throw Error(Po(332));
  }
}
function fu(e, t) {
  return e = du(e), Vc(e, t);
}
function pu(e, t, n) {
  return e = du(e), Wc(e, t, n);
}
function hu() {
  if (null !== au) {
    var e = au;
    au = null, Kc(e);
  }
  mu();
}
function mu() {
  if (!su && null !== iu) {
    su = !0;
    var e = 0;
    try {
      var t = iu;
      fu(99, function () {
        for (; e < t.length; e++) {
          var n = t[e];
          do {
            n = n(!0);
          } while (null !== n);
        }
      }), iu = null;
    } catch (t) {
      throw null !== iu && (iu = iu.slice(e + 1)), Wc(Zc, hu), t;
    } finally {
      su = !1;
    }
  }
}
var gu = Ho.ReactCurrentBatchConfig;
function vu(e, t) {
  if (e && e.defaultProps) {
    for (var n in t = xo({}, t), e = e.defaultProps) void 0 === t[n] && (t[n] = e[n]);
    return t;
  }
  return t;
}
var yu = Pc(null),
  Au = null,
  bu = null,
  _u = null;
function wu() {
  _u = bu = Au = null;
}
function ku(e) {
  var t = yu.current;
  Tc(yu), e.type._context._currentValue = t;
}
function Eu(e, t) {
  for (; null !== e;) {
    var n = e.alternate;
    if ((e.childLanes & t) === t) {
      if (null === n || (n.childLanes & t) === t) break;
      n.childLanes |= t;
    } else e.childLanes |= t, null !== n && (n.childLanes |= t);
    e = e["return"];
  }
}
function Su(e, t) {
  Au = e, _u = bu = null, null !== (e = e.dependencies) && null !== e.firstContext && (0 != (e.lanes & t) && (nf = !0), e.firstContext = null);
}
function Cu(e, t) {
  if (_u !== e && !1 !== t && 0 !== t) if ("number" == typeof t && 1073741823 !== t || (_u = e, t = 1073741823), t = {
    context: e,
    observedBits: t,
    next: null
  }, null === bu) {
    if (null === Au) throw Error(Po(308));
    bu = t, Au.dependencies = {
      lanes: 0,
      firstContext: t,
      responders: null
    };
  } else bu = bu.next = t;
  return e._currentValue;
}
var xu = !1;
function Ou(e) {
  e.updateQueue = {
    baseState: e.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null
    },
    effects: null
  };
}
function Pu(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
    baseState: e.baseState,
    firstBaseUpdate: e.firstBaseUpdate,
    lastBaseUpdate: e.lastBaseUpdate,
    shared: e.shared,
    effects: e.effects
  });
}
function Tu(e, t) {
  return {
    eventTime: e,
    lane: t,
    tag: 0,
    payload: null,
    callback: null,
    next: null
  };
}
function Iu(e, t) {
  if (null !== (e = e.updateQueue)) {
    var n = (e = e.shared).pending;
    null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
  }
}
function Bu(e, t) {
  var n = e.updateQueue,
    r = e.alternate;
  if (null !== r && n === (r = r.updateQueue)) {
    var o = null,
      i = null;
    if (null !== (n = n.firstBaseUpdate)) {
      do {
        var a = {
          eventTime: n.eventTime,
          lane: n.lane,
          tag: n.tag,
          payload: n.payload,
          callback: n.callback,
          next: null
        };
        null === i ? o = i = a : i = i.next = a, n = n.next;
      } while (null !== n);
      null === i ? o = i = t : i = i.next = t;
    } else o = i = t;
    return n = {
      baseState: r.baseState,
      firstBaseUpdate: o,
      lastBaseUpdate: i,
      shared: r.shared,
      effects: r.effects
    }, void (e.updateQueue = n);
  }
  null === (e = n.lastBaseUpdate) ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function Ru(e, t, n, r) {
  var o = e.updateQueue;
  xu = !1;
  var i = o.firstBaseUpdate,
    a = o.lastBaseUpdate,
    s = o.shared.pending;
  if (null !== s) {
    o.shared.pending = null;
    var l = s,
      c = l.next;
    l.next = null, null === a ? i = c : a.next = c, a = l;
    var u = e.alternate;
    if (null !== u) {
      var d = (u = u.updateQueue).lastBaseUpdate;
      d !== a && (null === d ? u.firstBaseUpdate = c : d.next = c, u.lastBaseUpdate = l);
    }
  }
  if (null !== i) {
    for (d = o.baseState, a = 0, u = c = l = null;;) {
      s = i.lane;
      var f = i.eventTime;
      if ((r & s) === s) {
        null !== u && (u = u.next = {
          eventTime: f,
          lane: 0,
          tag: i.tag,
          payload: i.payload,
          callback: i.callback,
          next: null
        });
        e: {
          var p = e,
            h = i;
          switch (s = t, f = n, h.tag) {
            case 1:
              if ("function" == typeof (p = h.payload)) {
                d = p.call(f, d, s);
                break e;
              }
              d = p;
              break e;
            case 3:
              p.flags = -4097 & p.flags | 64;
            case 0:
              if (null == (s = "function" == typeof (p = h.payload) ? p.call(f, d, s) : p)) break e;
              d = xo({}, d, s);
              break e;
            case 2:
              xu = !0;
          }
        }
        null !== i.callback && (e.flags |= 32, null === (s = o.effects) ? o.effects = [i] : s.push(i));
      } else f = {
        eventTime: f,
        lane: s,
        tag: i.tag,
        payload: i.payload,
        callback: i.callback,
        next: null
      }, null === u ? (c = u = f, l = d) : u = u.next = f, a |= s;
      if (null === (i = i.next)) {
        if (null === (s = o.shared.pending)) break;
        i = s.next, s.next = null, o.lastBaseUpdate = s, o.shared.pending = null;
      }
    }
    null === u && (l = d), o.baseState = l, o.firstBaseUpdate = c, o.lastBaseUpdate = u, lp |= a, e.lanes = a, e.memoizedState = d;
  }
}
function Lu(e, t, n) {
  if (e = t.effects, t.effects = null, null !== e) for (t = 0; t < e.length; t++) {
    var r = e[t],
      o = r.callback;
    if (null !== o) {
      if (r.callback = null, r = n, "function" != typeof o) throw Error(Po(191, o));
      o.call(r);
    }
  }
}
var Mu = new Co.Component().refs;
function Du(e, t, n, r) {
  n = null == (n = n(r, t = e.memoizedState)) ? t : xo({}, t, n), e.memoizedState = n, 0 === e.lanes && (e.updateQueue.baseState = n);
}
var Nu = {
  isMounted: function isMounted(e) {
    return !!(e = e._reactInternals) && va(e) === e;
  },
  enqueueSetState: function enqueueSetState(e, t, n) {
    e = e._reactInternals;
    var r = Rp(),
      o = Lp(e),
      i = Tu(r, o);
    i.payload = t, null != n && (i.callback = n), Iu(e, i), Mp(e, o, r);
  },
  enqueueReplaceState: function enqueueReplaceState(e, t, n) {
    e = e._reactInternals;
    var r = Rp(),
      o = Lp(e),
      i = Tu(r, o);
    i.tag = 1, i.payload = t, null != n && (i.callback = n), Iu(e, i), Mp(e, o, r);
  },
  enqueueForceUpdate: function enqueueForceUpdate(e, t) {
    e = e._reactInternals;
    var n = Rp(),
      r = Lp(e),
      o = Tu(n, r);
    o.tag = 2, null != t && (o.callback = t), Iu(e, o), Mp(e, r, n);
  }
};
function zu(e, t, n, r, o, i, a) {
  return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, i, a) : !t.prototype || !t.prototype.isPureReactComponent || !Bl(n, r) || !Bl(o, i);
}
function ju(e, t, n) {
  var r = !1,
    o = Bc,
    i = t.contextType;
  return "object" == _typeof(i) && null !== i ? i = Cu(i) : (o = Nc(t) ? Mc : Rc.current, i = (r = null != (r = t.contextTypes)) ? Dc(e, o) : Bc), t = new t(n, i), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = Nu, e.stateNode = t, t._reactInternals = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = o, e.__reactInternalMemoizedMaskedChildContext = i), t;
}
function Fu(e, t, n, r) {
  e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Nu.enqueueReplaceState(t, t.state, null);
}
function Uu(e, t, n, r) {
  var o = e.stateNode;
  o.props = n, o.state = e.memoizedState, o.refs = Mu, Ou(e);
  var i = t.contextType;
  "object" == _typeof(i) && null !== i ? o.context = Cu(i) : (i = Nc(t) ? Mc : Rc.current, o.context = Dc(e, i)), Ru(e, n, o, r), o.state = e.memoizedState, "function" == typeof (i = t.getDerivedStateFromProps) && (Du(e, t, i, n), o.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof o.getSnapshotBeforeUpdate || "function" != typeof o.UNSAFE_componentWillMount && "function" != typeof o.componentWillMount || (t = o.state, "function" == typeof o.componentWillMount && o.componentWillMount(), "function" == typeof o.UNSAFE_componentWillMount && o.UNSAFE_componentWillMount(), t !== o.state && Nu.enqueueReplaceState(o, o.state, null), Ru(e, n, o, r), o.state = e.memoizedState), "function" == typeof o.componentDidMount && (e.flags |= 4);
}
var Qu = Array.isArray;
function $u(e, t, n) {
  if (null !== (e = n.ref) && "function" != typeof e && "object" != _typeof(e)) {
    if (n._owner) {
      if (n = n._owner) {
        if (1 !== n.tag) throw Error(Po(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(Po(147, e));
      var o = "" + e;
      return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === o ? t.ref : (t = function t(e) {
        var t = r.refs;
        t === Mu && (t = r.refs = {}), null === e ? delete t[o] : t[o] = e;
      }, t._stringRef = o, t);
    }
    if ("string" != typeof e) throw Error(Po(284));
    if (!n._owner) throw Error(Po(290, e));
  }
  return e;
}
function Hu(e, t) {
  if ("textarea" !== e.type) throw Error(Po(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t));
}
function Vu(e) {
  function t(t, n) {
    if (e) {
      var r = t.lastEffect;
      null !== r ? (r.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.flags = 8;
    }
  }
  function n(n, r) {
    if (!e) return null;
    for (; null !== r;) t(n, r), r = r.sibling;
    return null;
  }
  function r(e, t) {
    for (e = new Map(); null !== t;) null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
    return e;
  }
  function o(e, t) {
    return (e = ph(e, t)).index = 0, e.sibling = null, e;
  }
  function i(t, n, r) {
    return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.flags = 2, n) : r : (t.flags = 2, n) : n;
  }
  function a(t) {
    return e && null === t.alternate && (t.flags = 2), t;
  }
  function s(e, t, n, r) {
    return null === t || 6 !== t.tag ? ((t = vh(n, e.mode, r))["return"] = e, t) : ((t = o(t, n))["return"] = e, t);
  }
  function l(e, t, n, r) {
    return null !== t && t.elementType === n.type ? ((r = o(t, n.props)).ref = $u(e, t, n), r["return"] = e, r) : ((r = hh(n.type, n.key, n.props, null, e.mode, r)).ref = $u(e, t, n), r["return"] = e, r);
  }
  function c(e, t, n, r) {
    return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = yh(n, e.mode, r))["return"] = e, t) : ((t = o(t, n.children || []))["return"] = e, t);
  }
  function u(e, t, n, r, i) {
    return null === t || 7 !== t.tag ? ((t = mh(n, e.mode, r, i))["return"] = e, t) : ((t = o(t, n))["return"] = e, t);
  }
  function d(e, t, n) {
    if ("string" == typeof t || "number" == typeof t) return (t = vh("" + t, e.mode, n))["return"] = e, t;
    if ("object" == _typeof(t) && null !== t) {
      switch (t.$$typeof) {
        case Vo:
          return (n = hh(t.type, t.key, t.props, null, e.mode, n)).ref = $u(e, null, t), n["return"] = e, n;
        case Wo:
          return (t = yh(t, e.mode, n))["return"] = e, t;
      }
      if (Qu(t) || di(t)) return (t = mh(t, e.mode, n, null))["return"] = e, t;
      Hu(e, t);
    }
    return null;
  }
  function f(e, t, n, r) {
    var o = null !== t ? t.key : null;
    if ("string" == typeof n || "number" == typeof n) return null !== o ? null : s(e, t, "" + n, r);
    if ("object" == _typeof(n) && null !== n) {
      switch (n.$$typeof) {
        case Vo:
          return n.key === o ? n.type === Ko ? u(e, t, n.props.children, r, o) : l(e, t, n, r) : null;
        case Wo:
          return n.key === o ? c(e, t, n, r) : null;
      }
      if (Qu(n) || di(n)) return null !== o ? null : u(e, t, n, r, null);
      Hu(e, n);
    }
    return null;
  }
  function p(e, t, n, r, o) {
    if ("string" == typeof r || "number" == typeof r) return s(t, e = e.get(n) || null, "" + r, o);
    if ("object" == _typeof(r) && null !== r) {
      switch (r.$$typeof) {
        case Vo:
          return e = e.get(null === r.key ? n : r.key) || null, r.type === Ko ? u(t, e, r.props.children, o, r.key) : l(t, e, r, o);
        case Wo:
          return c(t, e = e.get(null === r.key ? n : r.key) || null, r, o);
      }
      if (Qu(r) || di(r)) return u(t, e = e.get(n) || null, r, o, null);
      Hu(t, r);
    }
    return null;
  }
  function h(o, a, s, l) {
    for (var c = null, u = null, h = a, m = a = 0, g = null; null !== h && m < s.length; m++) {
      h.index > m ? (g = h, h = null) : g = h.sibling;
      var v = f(o, h, s[m], l);
      if (null === v) {
        null === h && (h = g);
        break;
      }
      e && h && null === v.alternate && t(o, h), a = i(v, a, m), null === u ? c = v : u.sibling = v, u = v, h = g;
    }
    if (m === s.length) return n(o, h), c;
    if (null === h) {
      for (; m < s.length; m++) null !== (h = d(o, s[m], l)) && (a = i(h, a, m), null === u ? c = h : u.sibling = h, u = h);
      return c;
    }
    for (h = r(o, h); m < s.length; m++) null !== (g = p(h, o, m, s[m], l)) && (e && null !== g.alternate && h["delete"](null === g.key ? m : g.key), a = i(g, a, m), null === u ? c = g : u.sibling = g, u = g);
    return e && h.forEach(function (e) {
      return t(o, e);
    }), c;
  }
  function m(o, a, s, l) {
    var c = di(s);
    if ("function" != typeof c) throw Error(Po(150));
    if (null == (s = c.call(s))) throw Error(Po(151));
    for (var u = c = null, h = a, m = a = 0, g = null, v = s.next(); null !== h && !v.done; m++, v = s.next()) {
      h.index > m ? (g = h, h = null) : g = h.sibling;
      var y = f(o, h, v.value, l);
      if (null === y) {
        null === h && (h = g);
        break;
      }
      e && h && null === y.alternate && t(o, h), a = i(y, a, m), null === u ? c = y : u.sibling = y, u = y, h = g;
    }
    if (v.done) return n(o, h), c;
    if (null === h) {
      for (; !v.done; m++, v = s.next()) null !== (v = d(o, v.value, l)) && (a = i(v, a, m), null === u ? c = v : u.sibling = v, u = v);
      return c;
    }
    for (h = r(o, h); !v.done; m++, v = s.next()) null !== (v = p(h, o, m, v.value, l)) && (e && null !== v.alternate && h["delete"](null === v.key ? m : v.key), a = i(v, a, m), null === u ? c = v : u.sibling = v, u = v);
    return e && h.forEach(function (e) {
      return t(o, e);
    }), c;
  }
  return function (e, r, i, s) {
    var l = "object" == _typeof(i) && null !== i && i.type === Ko && null === i.key;
    l && (i = i.props.children);
    var c = "object" == _typeof(i) && null !== i;
    if (c) switch (i.$$typeof) {
      case Vo:
        e: {
          for (c = i.key, l = r; null !== l;) {
            if (l.key === c) {
              if (7 === l.tag) {
                if (i.type === Ko) {
                  n(e, l.sibling), (r = o(l, i.props.children))["return"] = e, e = r;
                  break e;
                }
              } else if (l.elementType === i.type) {
                n(e, l.sibling), (r = o(l, i.props)).ref = $u(e, l, i), r["return"] = e, e = r;
                break e;
              }
              n(e, l);
              break;
            }
            t(e, l), l = l.sibling;
          }
          i.type === Ko ? ((r = mh(i.props.children, e.mode, s, i.key))["return"] = e, e = r) : ((s = hh(i.type, i.key, i.props, null, e.mode, s)).ref = $u(e, r, i), s["return"] = e, e = s);
        }
        return a(e);
      case Wo:
        e: {
          for (l = i.key; null !== r;) {
            if (r.key === l) {
              if (4 === r.tag && r.stateNode.containerInfo === i.containerInfo && r.stateNode.implementation === i.implementation) {
                n(e, r.sibling), (r = o(r, i.children || []))["return"] = e, e = r;
                break e;
              }
              n(e, r);
              break;
            }
            t(e, r), r = r.sibling;
          }
          (r = yh(i, e.mode, s))["return"] = e, e = r;
        }
        return a(e);
    }
    if ("string" == typeof i || "number" == typeof i) return i = "" + i, null !== r && 6 === r.tag ? (n(e, r.sibling), (r = o(r, i))["return"] = e, e = r) : (n(e, r), (r = vh(i, e.mode, s))["return"] = e, e = r), a(e);
    if (Qu(i)) return h(e, r, i, s);
    if (di(i)) return m(e, r, i, s);
    if (c && Hu(e, i), void 0 === i && !l) switch (e.tag) {
      case 1:
      case 22:
      case 0:
      case 11:
      case 15:
        throw Error(Po(152, gi(e.type) || "Component"));
    }
    return n(e, r);
  };
}
var Wu = Vu(!0),
  Ku = Vu(!1),
  qu = {},
  Gu = Pc(qu),
  Yu = Pc(qu),
  Ju = Pc(qu);
function Zu(e) {
  if (e === qu) throw Error(Po(174));
  return e;
}
function Xu(e, t) {
  switch (Ic(Ju, t), Ic(Yu, e), Ic(Gu, qu), e = t.nodeType) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : Di(null, "");
      break;
    default:
      t = Di(t = (e = 8 === e ? t.parentNode : t).namespaceURI || null, e = e.tagName);
  }
  Tc(Gu), Ic(Gu, t);
}
function ed() {
  Tc(Gu), Tc(Yu), Tc(Ju);
}
function td(e) {
  Zu(Ju.current);
  var t = Zu(Gu.current),
    n = Di(t, e.type);
  t !== n && (Ic(Yu, e), Ic(Gu, n));
}
function nd(e) {
  Yu.current === e && (Tc(Gu), Tc(Yu));
}
var rd = Pc(0);
function od(e) {
  for (var t = e; null !== t;) {
    if (13 === t.tag) {
      var n = t.memoizedState;
      if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
    } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
      if (0 != (64 & t.flags)) return t;
    } else if (null !== t.child) {
      t.child["return"] = t, t = t.child;
      continue;
    }
    if (t === e) break;
    for (; null === t.sibling;) {
      if (null === t["return"] || t["return"] === e) return null;
      t = t["return"];
    }
    t.sibling["return"] = t["return"], t = t.sibling;
  }
  return null;
}
var id = null,
  ad = null,
  sd = !1;
function ld(e, t) {
  var n = dh(5, null, null, 0);
  n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n["return"] = e, n.flags = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
}
function cd(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, !0);
    case 6:
      return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, !0);
    default:
      return !1;
  }
}
function ud(e) {
  if (sd) {
    var t = ad;
    if (t) {
      var n = t;
      if (!cd(e, t)) {
        if (!(t = hc(n.nextSibling)) || !cd(e, t)) return e.flags = -1025 & e.flags | 2, sd = !1, void (id = e);
        ld(id, n);
      }
      id = e, ad = hc(t.firstChild);
    } else e.flags = -1025 & e.flags | 2, sd = !1, id = e;
  }
}
function dd(e) {
  for (e = e["return"]; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;) e = e["return"];
  id = e;
}
function fd(e) {
  if (e !== id) return !1;
  if (!sd) return dd(e), sd = !0, !1;
  var t = e.type;
  if (5 !== e.tag || "head" !== t && "body" !== t && !uc(t, e.memoizedProps)) for (t = ad; t;) ld(e, t), t = hc(t.nextSibling);
  if (dd(e), 13 === e.tag) {
    if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(Po(317));
    e: {
      for (e = e.nextSibling, t = 0; e;) {
        if (8 === e.nodeType) {
          var n = e.data;
          if ("/$" === n) {
            if (0 === t) {
              ad = hc(e.nextSibling);
              break e;
            }
            t--;
          } else "$" !== n && "$!" !== n && "$?" !== n || t++;
        }
        e = e.nextSibling;
      }
      ad = null;
    }
  } else ad = id ? hc(e.stateNode.nextSibling) : null;
  return !0;
}
function pd() {
  ad = id = null, sd = !1;
}
var hd = [];
function md() {
  for (var e = 0; e < hd.length; e++) hd[e]._workInProgressVersionPrimary = null;
  hd.length = 0;
}
var gd = Ho.ReactCurrentDispatcher,
  vd = Ho.ReactCurrentBatchConfig,
  yd = 0,
  Ad = null,
  bd = null,
  _d = null,
  wd = !1,
  kd = !1;
function Ed() {
  throw Error(Po(321));
}
function Sd(e, t) {
  if (null === t) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!Tl(e[n], t[n])) return !1;
  return !0;
}
function Cd(e, t, n, r, o, i) {
  if (yd = i, Ad = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, gd.current = null === e || null === e.memoizedState ? Zd : Xd, e = n(r, o), kd) {
    i = 0;
    do {
      if (kd = !1, !(25 > i)) throw Error(Po(301));
      i += 1, _d = bd = null, t.updateQueue = null, gd.current = ef, e = n(r, o);
    } while (kd);
  }
  if (gd.current = Jd, t = null !== bd && null !== bd.next, yd = 0, _d = bd = Ad = null, wd = !1, t) throw Error(Po(300));
  return e;
}
function xd() {
  var e = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  return null === _d ? Ad.memoizedState = _d = e : _d = _d.next = e, _d;
}
function Od() {
  if (null === bd) {
    var e = Ad.alternate;
    e = null !== e ? e.memoizedState : null;
  } else e = bd.next;
  var t = null === _d ? Ad.memoizedState : _d.next;
  if (null !== t) _d = t, bd = e;else {
    if (null === e) throw Error(Po(310));
    e = {
      memoizedState: (bd = e).memoizedState,
      baseState: bd.baseState,
      baseQueue: bd.baseQueue,
      queue: bd.queue,
      next: null
    }, null === _d ? Ad.memoizedState = _d = e : _d = _d.next = e;
  }
  return _d;
}
function Pd(e, t) {
  return "function" == typeof t ? t(e) : t;
}
function Td(e) {
  var t = Od(),
    n = t.queue;
  if (null === n) throw Error(Po(311));
  n.lastRenderedReducer = e;
  var r = bd,
    o = r.baseQueue,
    i = n.pending;
  if (null !== i) {
    if (null !== o) {
      var a = o.next;
      o.next = i.next, i.next = a;
    }
    r.baseQueue = o = i, n.pending = null;
  }
  if (null !== o) {
    o = o.next, r = r.baseState;
    var s = a = i = null,
      l = o;
    do {
      var c = l.lane;
      if ((yd & c) === c) null !== s && (s = s.next = {
        lane: 0,
        action: l.action,
        eagerReducer: l.eagerReducer,
        eagerState: l.eagerState,
        next: null
      }), r = l.eagerReducer === e ? l.eagerState : e(r, l.action);else {
        var u = {
          lane: c,
          action: l.action,
          eagerReducer: l.eagerReducer,
          eagerState: l.eagerState,
          next: null
        };
        null === s ? (a = s = u, i = r) : s = s.next = u, Ad.lanes |= c, lp |= c;
      }
      l = l.next;
    } while (null !== l && l !== o);
    null === s ? i = r : s.next = a, Tl(r, t.memoizedState) || (nf = !0), t.memoizedState = r, t.baseState = i, t.baseQueue = s, n.lastRenderedState = r;
  }
  return [t.memoizedState, n.dispatch];
}
function Id(e) {
  var t = Od(),
    n = t.queue;
  if (null === n) throw Error(Po(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch,
    o = n.pending,
    i = t.memoizedState;
  if (null !== o) {
    n.pending = null;
    var a = o = o.next;
    do {
      i = e(i, a.action), a = a.next;
    } while (a !== o);
    Tl(i, t.memoizedState) || (nf = !0), t.memoizedState = i, null === t.baseQueue && (t.baseState = i), n.lastRenderedState = i;
  }
  return [i, r];
}
function Bd(e, t, n) {
  var r = t._getVersion;
  r = r(t._source);
  var o = t._workInProgressVersionPrimary;
  if (null !== o ? e = o === r : (e = e.mutableReadLanes, (e = (yd & e) === e) && (t._workInProgressVersionPrimary = r, hd.push(t))), e) return n(t._source);
  throw hd.push(t), Error(Po(350));
}
function Rd(e, t, n, r) {
  var o = ep;
  if (null === o) throw Error(Po(349));
  var i = t._getVersion,
    a = i(t._source),
    s = gd.current,
    l = s.useState(function () {
      return Bd(o, t, n);
    }),
    c = l[1],
    u = l[0];
  l = _d;
  var d = e.memoizedState,
    f = d.refs,
    p = f.getSnapshot,
    h = d.source;
  d = d.subscribe;
  var m = Ad;
  return e.memoizedState = {
    refs: f,
    source: t,
    subscribe: r
  }, s.useEffect(function () {
    f.getSnapshot = n, f.setSnapshot = c;
    var e = i(t._source);
    if (!Tl(a, e)) {
      e = n(t._source), Tl(u, e) || (c(e), e = Lp(m), o.mutableReadLanes |= e & o.pendingLanes), e = o.mutableReadLanes, o.entangledLanes |= e;
      for (var r = o.entanglements, s = e; 0 < s;) {
        var l = 31 - ds(s),
          d = 1 << l;
        r[l] |= e, s &= ~d;
      }
    }
  }, [n, t, r]), s.useEffect(function () {
    return r(t._source, function () {
      var e = f.getSnapshot,
        n = f.setSnapshot;
      try {
        n(e(t._source));
        var r = Lp(m);
        o.mutableReadLanes |= r & o.pendingLanes;
      } catch (e) {
        n(function () {
          throw e;
        });
      }
    });
  }, [t, r]), Tl(p, n) && Tl(h, t) && Tl(d, r) || ((e = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: Pd,
    lastRenderedState: u
  }).dispatch = c = Yd.bind(null, Ad, e), l.queue = e, l.baseQueue = null, u = Bd(o, t, n), l.memoizedState = l.baseState = u), u;
}
function Ld(e, t, n) {
  return Rd(Od(), e, t, n);
}
function Md(e) {
  var t = xd();
  return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: Pd,
    lastRenderedState: e
  }).dispatch = Yd.bind(null, Ad, e), [t.memoizedState, e];
}
function Dd(e, t, n, r) {
  return e = {
    tag: e,
    create: t,
    destroy: n,
    deps: r,
    next: null
  }, null === (t = Ad.updateQueue) ? (t = {
    lastEffect: null
  }, Ad.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
}
function Nd(e) {
  return e = {
    current: e
  }, xd().memoizedState = e;
}
function zd() {
  return Od().memoizedState;
}
function jd(e, t, n, r) {
  var o = xd();
  Ad.flags |= e, o.memoizedState = Dd(1 | t, n, void 0, void 0 === r ? null : r);
}
function Fd(e, t, n, r) {
  var o = Od();
  r = void 0 === r ? null : r;
  var i = void 0;
  if (null !== bd) {
    var a = bd.memoizedState;
    if (i = a.destroy, null !== r && Sd(r, a.deps)) return void Dd(t, n, i, r);
  }
  Ad.flags |= e, o.memoizedState = Dd(1 | t, n, i, r);
}
function Ud(e, t) {
  return jd(516, 4, e, t);
}
function Qd(e, t) {
  return Fd(516, 4, e, t);
}
function $d(e, t) {
  return Fd(4, 2, e, t);
}
function Hd(e, t) {
  return "function" == typeof t ? (e = e(), t(e), function () {
    t(null);
  }) : null != t ? (e = e(), t.current = e, function () {
    t.current = null;
  }) : void 0;
}
function Vd(e, t, n) {
  return n = null != n ? n.concat([e]) : null, Fd(4, 2, Hd.bind(null, t, e), n);
}
function Wd() {}
function Kd(e, t) {
  var n = Od();
  t = void 0 === t ? null : t;
  var r = n.memoizedState;
  return null !== r && null !== t && Sd(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
}
function qd(e, t) {
  var n = Od();
  t = void 0 === t ? null : t;
  var r = n.memoizedState;
  return null !== r && null !== t && Sd(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
}
function Gd(e, t) {
  var n = uu();
  fu(98 > n ? 98 : n, function () {
    e(!0);
  }), fu(97 < n ? 97 : n, function () {
    var n = vd.transition;
    vd.transition = 1;
    try {
      e(!1), t();
    } finally {
      vd.transition = n;
    }
  });
}
function Yd(e, t, n) {
  var r = Rp(),
    o = Lp(e),
    i = {
      lane: o,
      action: n,
      eagerReducer: null,
      eagerState: null,
      next: null
    },
    a = t.pending;
  if (null === a ? i.next = i : (i.next = a.next, a.next = i), t.pending = i, a = e.alternate, e === Ad || null !== a && a === Ad) kd = wd = !0;else {
    if (0 === e.lanes && (null === a || 0 === a.lanes) && null !== (a = t.lastRenderedReducer)) try {
      var s = t.lastRenderedState,
        l = a(s, n);
      if (i.eagerReducer = a, i.eagerState = l, Tl(l, s)) return;
    } catch (e) {}
    Mp(e, o, r);
  }
}
var Jd = {
    readContext: Cu,
    useCallback: Ed,
    useContext: Ed,
    useEffect: Ed,
    useImperativeHandle: Ed,
    useLayoutEffect: Ed,
    useMemo: Ed,
    useReducer: Ed,
    useRef: Ed,
    useState: Ed,
    useDebugValue: Ed,
    useDeferredValue: Ed,
    useTransition: Ed,
    useMutableSource: Ed,
    useOpaqueIdentifier: Ed,
    unstable_isNewReconciler: !1
  },
  Zd = {
    readContext: Cu,
    useCallback: function useCallback(e, t) {
      return xd().memoizedState = [e, void 0 === t ? null : t], e;
    },
    useContext: Cu,
    useEffect: Ud,
    useImperativeHandle: function useImperativeHandle(e, t, n) {
      return n = null != n ? n.concat([e]) : null, jd(4, 2, Hd.bind(null, t, e), n);
    },
    useLayoutEffect: function useLayoutEffect(e, t) {
      return jd(4, 2, e, t);
    },
    useMemo: function useMemo(e, t) {
      var n = xd();
      return t = void 0 === t ? null : t, e = e(), n.memoizedState = [e, t], e;
    },
    useReducer: function useReducer(e, t, n) {
      var r = xd();
      return t = void 0 !== n ? n(t) : t, r.memoizedState = r.baseState = t, e = (e = r.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: t
      }).dispatch = Yd.bind(null, Ad, e), [r.memoizedState, e];
    },
    useRef: Nd,
    useState: Md,
    useDebugValue: Wd,
    useDeferredValue: function useDeferredValue(e) {
      var t = Md(e),
        n = t[0],
        r = t[1];
      return Ud(function () {
        var t = vd.transition;
        vd.transition = 1;
        try {
          r(e);
        } finally {
          vd.transition = t;
        }
      }, [e]), n;
    },
    useTransition: function useTransition() {
      var e = Md(!1),
        t = e[0];
      return Nd(e = Gd.bind(null, e[1])), [e, t];
    },
    useMutableSource: function useMutableSource(e, t, n) {
      var r = xd();
      return r.memoizedState = {
        refs: {
          getSnapshot: t,
          setSnapshot: null
        },
        source: e,
        subscribe: n
      }, Rd(r, e, t, n);
    },
    useOpaqueIdentifier: function useOpaqueIdentifier() {
      if (sd) {
        var e = !1,
          t = function (e) {
            return {
              $$typeof: oi,
              toString: e,
              valueOf: e
            };
          }(function () {
            throw e || (e = !0, n("r:" + (gc++).toString(36))), Error(Po(355));
          }),
          n = Md(t)[1];
        return 0 == (2 & Ad.mode) && (Ad.flags |= 516, Dd(5, function () {
          n("r:" + (gc++).toString(36));
        }, void 0, null)), t;
      }
      return Md(t = "r:" + (gc++).toString(36)), t;
    },
    unstable_isNewReconciler: !1
  },
  Xd = {
    readContext: Cu,
    useCallback: Kd,
    useContext: Cu,
    useEffect: Qd,
    useImperativeHandle: Vd,
    useLayoutEffect: $d,
    useMemo: qd,
    useReducer: Td,
    useRef: zd,
    useState: function useState() {
      return Td(Pd);
    },
    useDebugValue: Wd,
    useDeferredValue: function useDeferredValue(e) {
      var t = Td(Pd),
        n = t[0],
        r = t[1];
      return Qd(function () {
        var t = vd.transition;
        vd.transition = 1;
        try {
          r(e);
        } finally {
          vd.transition = t;
        }
      }, [e]), n;
    },
    useTransition: function useTransition() {
      var e = Td(Pd)[0];
      return [zd().current, e];
    },
    useMutableSource: Ld,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
      return Td(Pd)[0];
    },
    unstable_isNewReconciler: !1
  },
  ef = {
    readContext: Cu,
    useCallback: Kd,
    useContext: Cu,
    useEffect: Qd,
    useImperativeHandle: Vd,
    useLayoutEffect: $d,
    useMemo: qd,
    useReducer: Id,
    useRef: zd,
    useState: function useState() {
      return Id(Pd);
    },
    useDebugValue: Wd,
    useDeferredValue: function useDeferredValue(e) {
      var t = Id(Pd),
        n = t[0],
        r = t[1];
      return Qd(function () {
        var t = vd.transition;
        vd.transition = 1;
        try {
          r(e);
        } finally {
          vd.transition = t;
        }
      }, [e]), n;
    },
    useTransition: function useTransition() {
      var e = Id(Pd)[0];
      return [zd().current, e];
    },
    useMutableSource: Ld,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
      return Id(Pd)[0];
    },
    unstable_isNewReconciler: !1
  },
  tf = Ho.ReactCurrentOwner,
  nf = !1;
function rf(e, t, n, r) {
  t.child = null === e ? Ku(t, null, n, r) : Wu(t, e.child, n, r);
}
function of(e, t, n, r, o) {
  n = n.render;
  var i = t.ref;
  return Su(t, o), r = Cd(e, t, n, r, i, o), null === e || nf ? (t.flags |= 1, rf(e, t, r, o), t.child) : (t.updateQueue = e.updateQueue, t.flags &= -517, e.lanes &= ~o, Cf(e, t, o));
}
function af(e, t, n, r, o, i) {
  if (null === e) {
    var a = n.type;
    return "function" != typeof a || fh(a) || void 0 !== a.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = hh(n.type, null, r, t, t.mode, i)).ref = t.ref, e["return"] = t, t.child = e) : (t.tag = 15, t.type = a, sf(e, t, a, r, o, i));
  }
  return a = e.child, 0 == (o & i) && (o = a.memoizedProps, (n = null !== (n = n.compare) ? n : Bl)(o, r) && e.ref === t.ref) ? Cf(e, t, i) : (t.flags |= 1, (e = ph(a, r)).ref = t.ref, e["return"] = t, t.child = e);
}
function sf(e, t, n, r, o, i) {
  if (null !== e && Bl(e.memoizedProps, r) && e.ref === t.ref) {
    if (nf = !1, 0 == (i & o)) return t.lanes = e.lanes, Cf(e, t, i);
    0 != (16384 & e.flags) && (nf = !0);
  }
  return uf(e, t, n, r, i);
}
function lf(e, t, n) {
  var r = t.pendingProps,
    o = r.children,
    i = null !== e ? e.memoizedState : null;
  if ("hidden" === r.mode || "unstable-defer-without-hiding" === r.mode) {
    if (0 == (4 & t.mode)) t.memoizedState = {
      baseLanes: 0
    }, $p(t, n);else {
      if (0 == (1073741824 & n)) return e = null !== i ? i.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
        baseLanes: e
      }, $p(t, e), null;
      t.memoizedState = {
        baseLanes: 0
      }, $p(t, null !== i ? i.baseLanes : n);
    }
  } else null !== i ? (r = i.baseLanes | n, t.memoizedState = null) : r = n, $p(t, r);
  return rf(e, t, o, n), t.child;
}
function cf(e, t) {
  var n = t.ref;
  (null === e && null !== n || null !== e && e.ref !== n) && (t.flags |= 128);
}
function uf(e, t, n, r, o) {
  var i = Nc(n) ? Mc : Rc.current;
  return i = Dc(t, i), Su(t, o), n = Cd(e, t, n, r, i, o), null === e || nf ? (t.flags |= 1, rf(e, t, n, o), t.child) : (t.updateQueue = e.updateQueue, t.flags &= -517, e.lanes &= ~o, Cf(e, t, o));
}
function df(e, t, n, r, o) {
  if (Nc(n)) {
    var i = !0;
    Uc(t);
  } else i = !1;
  if (Su(t, o), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2), ju(t, n, r), Uu(t, n, r, o), r = !0;else if (null === e) {
    var a = t.stateNode,
      s = t.memoizedProps;
    a.props = s;
    var l = a.context,
      c = n.contextType;
    "object" == _typeof(c) && null !== c ? c = Cu(c) : c = Dc(t, c = Nc(n) ? Mc : Rc.current);
    var u = n.getDerivedStateFromProps,
      d = "function" == typeof u || "function" == typeof a.getSnapshotBeforeUpdate;
    d || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (s !== r || l !== c) && Fu(t, a, r, c), xu = !1;
    var f = t.memoizedState;
    a.state = f, Ru(t, r, a, o), l = t.memoizedState, s !== r || f !== l || Lc.current || xu ? ("function" == typeof u && (Du(t, n, u, r), l = t.memoizedState), (s = xu || zu(t, n, s, r, f, l, c)) ? (d || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.flags |= 4)) : ("function" == typeof a.componentDidMount && (t.flags |= 4), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = c, r = s) : ("function" == typeof a.componentDidMount && (t.flags |= 4), r = !1);
  } else {
    a = t.stateNode, Pu(e, t), s = t.memoizedProps, c = t.type === t.elementType ? s : vu(t.type, s), a.props = c, d = t.pendingProps, f = a.context, "object" == _typeof(l = n.contextType) && null !== l ? l = Cu(l) : l = Dc(t, l = Nc(n) ? Mc : Rc.current);
    var p = n.getDerivedStateFromProps;
    (u = "function" == typeof p || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (s !== d || f !== l) && Fu(t, a, r, l), xu = !1, f = t.memoizedState, a.state = f, Ru(t, r, a, o);
    var h = t.memoizedState;
    s !== d || f !== h || Lc.current || xu ? ("function" == typeof p && (Du(t, n, p, r), h = t.memoizedState), (c = xu || zu(t, n, c, r, f, h, l)) ? (u || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(r, h, l), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, h, l)), "function" == typeof a.componentDidUpdate && (t.flags |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.flags |= 256)) : ("function" != typeof a.componentDidUpdate || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 256), t.memoizedProps = r, t.memoizedState = h), a.props = r, a.state = h, a.context = l, r = c) : ("function" != typeof a.componentDidUpdate || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || s === e.memoizedProps && f === e.memoizedState || (t.flags |= 256), r = !1);
  }
  return ff(e, t, n, r, i, o);
}
function ff(e, t, n, r, o, i) {
  cf(e, t);
  var a = 0 != (64 & t.flags);
  if (!r && !a) return o && Qc(t, n, !1), Cf(e, t, i);
  r = t.stateNode, tf.current = t;
  var s = a && "function" != typeof n.getDerivedStateFromError ? null : r.render();
  return t.flags |= 1, null !== e && a ? (t.child = Wu(t, e.child, null, i), t.child = Wu(t, null, s, i)) : rf(e, t, s, i), t.memoizedState = r.state, o && Qc(t, n, !0), t.child;
}
function pf(e) {
  var t = e.stateNode;
  t.pendingContext ? jc(0, t.pendingContext, t.pendingContext !== t.context) : t.context && jc(0, t.context, !1), Xu(e, t.containerInfo);
}
var hf,
  mf,
  gf,
  vf,
  yf = {
    dehydrated: null,
    retryLane: 0
  };
function Af(e, t, n) {
  var r,
    o = t.pendingProps,
    i = rd.current,
    a = !1;
  return (r = 0 != (64 & t.flags)) || (r = (null === e || null !== e.memoizedState) && 0 != (2 & i)), r ? (a = !0, t.flags &= -65) : null !== e && null === e.memoizedState || void 0 === o.fallback || !0 === o.unstable_avoidThisFallback || (i |= 1), Ic(rd, 1 & i), null === e ? (void 0 !== o.fallback && ud(t), e = o.children, i = o.fallback, a ? (e = bf(t, e, i, n), t.child.memoizedState = {
    baseLanes: n
  }, t.memoizedState = yf, e) : "number" == typeof o.unstable_expectedLoadTime ? (e = bf(t, e, i, n), t.child.memoizedState = {
    baseLanes: n
  }, t.memoizedState = yf, t.lanes = 33554432, e) : ((n = gh({
    mode: "visible",
    children: e
  }, t.mode, n, null))["return"] = t, t.child = n)) : (e.memoizedState, a ? (o = wf(e, t, o.children, o.fallback, n), a = t.child, i = e.child.memoizedState, a.memoizedState = null === i ? {
    baseLanes: n
  } : {
    baseLanes: i.baseLanes | n
  }, a.childLanes = e.childLanes & ~n, t.memoizedState = yf, o) : (n = _f(e, t, o.children, n), t.memoizedState = null, n));
}
function bf(e, t, n, r) {
  var o = e.mode,
    i = e.child;
  return t = {
    mode: "hidden",
    children: t
  }, 0 == (2 & o) && null !== i ? (i.childLanes = 0, i.pendingProps = t) : i = gh(t, o, 0, null), n = mh(n, o, r, null), i["return"] = e, n["return"] = e, i.sibling = n, e.child = i, n;
}
function _f(e, t, n, r) {
  var o = e.child;
  return e = o.sibling, n = ph(o, {
    mode: "visible",
    children: n
  }), 0 == (2 & t.mode) && (n.lanes = r), n["return"] = t, n.sibling = null, null !== e && (e.nextEffect = null, e.flags = 8, t.firstEffect = t.lastEffect = e), t.child = n;
}
function wf(e, t, n, r, o) {
  var i = t.mode,
    a = e.child;
  e = a.sibling;
  var s = {
    mode: "hidden",
    children: n
  };
  return 0 == (2 & i) && t.child !== a ? ((n = t.child).childLanes = 0, n.pendingProps = s, null !== (a = n.lastEffect) ? (t.firstEffect = n.firstEffect, t.lastEffect = a, a.nextEffect = null) : t.firstEffect = t.lastEffect = null) : n = ph(a, s), null !== e ? r = ph(e, r) : (r = mh(r, i, o, null)).flags |= 2, r["return"] = t, n["return"] = t, n.sibling = r, t.child = n, r;
}
function kf(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  null !== n && (n.lanes |= t), Eu(e["return"], t);
}
function Ef(e, t, n, r, o, i) {
  var a = e.memoizedState;
  null === a ? e.memoizedState = {
    isBackwards: t,
    rendering: null,
    renderingStartTime: 0,
    last: r,
    tail: n,
    tailMode: o,
    lastEffect: i
  } : (a.isBackwards = t, a.rendering = null, a.renderingStartTime = 0, a.last = r, a.tail = n, a.tailMode = o, a.lastEffect = i);
}
function Sf(e, t, n) {
  var r = t.pendingProps,
    o = r.revealOrder,
    i = r.tail;
  if (rf(e, t, r.children, n), 0 != (2 & (r = rd.current))) r = 1 & r | 2, t.flags |= 64;else {
    if (null !== e && 0 != (64 & e.flags)) e: for (e = t.child; null !== e;) {
      if (13 === e.tag) null !== e.memoizedState && kf(e, n);else if (19 === e.tag) kf(e, n);else if (null !== e.child) {
        e.child["return"] = e, e = e.child;
        continue;
      }
      if (e === t) break e;
      for (; null === e.sibling;) {
        if (null === e["return"] || e["return"] === t) break e;
        e = e["return"];
      }
      e.sibling["return"] = e["return"], e = e.sibling;
    }
    r &= 1;
  }
  if (Ic(rd, r), 0 == (2 & t.mode)) t.memoizedState = null;else switch (o) {
    case "forwards":
      for (n = t.child, o = null; null !== n;) null !== (e = n.alternate) && null === od(e) && (o = n), n = n.sibling;
      null === (n = o) ? (o = t.child, t.child = null) : (o = n.sibling, n.sibling = null), Ef(t, !1, o, n, i, t.lastEffect);
      break;
    case "backwards":
      for (n = null, o = t.child, t.child = null; null !== o;) {
        if (null !== (e = o.alternate) && null === od(e)) {
          t.child = o;
          break;
        }
        e = o.sibling, o.sibling = n, n = o, o = e;
      }
      Ef(t, !0, n, null, i, t.lastEffect);
      break;
    case "together":
      Ef(t, !1, null, null, void 0, t.lastEffect);
      break;
    default:
      t.memoizedState = null;
  }
  return t.child;
}
function Cf(e, t, n) {
  if (null !== e && (t.dependencies = e.dependencies), lp |= t.lanes, 0 != (n & t.childLanes)) {
    if (null !== e && t.child !== e.child) throw Error(Po(153));
    if (null !== t.child) {
      for (n = ph(e = t.child, e.pendingProps), t.child = n, n["return"] = t; null !== e.sibling;) e = e.sibling, (n = n.sibling = ph(e, e.pendingProps))["return"] = t;
      n.sibling = null;
    }
    return t.child;
  }
  return null;
}
function xf(e, t) {
  if (!sd) switch (e.tailMode) {
    case "hidden":
      t = e.tail;
      for (var n = null; null !== t;) null !== t.alternate && (n = t), t = t.sibling;
      null === n ? e.tail = null : n.sibling = null;
      break;
    case "collapsed":
      n = e.tail;
      for (var r = null; null !== n;) null !== n.alternate && (r = n), n = n.sibling;
      null === r ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : r.sibling = null;
  }
}
function Of(e, t, n) {
  var r = t.pendingProps;
  switch (t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;
    case 1:
    case 17:
      return Nc(t.type) && zc(), null;
    case 3:
      return ed(), Tc(Lc), Tc(Rc), md(), (r = t.stateNode).pendingContext && (r.context = r.pendingContext, r.pendingContext = null), null !== e && null !== e.child || (fd(t) ? t.flags |= 4 : r.hydrate || (t.flags |= 256)), mf(t), null;
    case 5:
      nd(t);
      var o = Zu(Ju.current);
      if (n = t.type, null !== e && null != t.stateNode) gf(e, t, n, r, o), e.ref !== t.ref && (t.flags |= 128);else {
        if (!r) {
          if (null === t.stateNode) throw Error(Po(166));
          return null;
        }
        if (e = Zu(Gu.current), fd(t)) {
          r = t.stateNode, n = t.type;
          var i = t.memoizedProps;
          switch (r[yc] = t, r[Ac] = i, n) {
            case "dialog":
              Yl("cancel", r), Yl("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              Yl("load", r);
              break;
            case "video":
            case "audio":
              for (e = 0; e < Wl.length; e++) Yl(Wl[e], r);
              break;
            case "source":
              Yl("error", r);
              break;
            case "img":
            case "image":
            case "link":
              Yl("error", r), Yl("load", r);
              break;
            case "details":
              Yl("toggle", r);
              break;
            case "input":
              ki(r, i), Yl("invalid", r);
              break;
            case "select":
              r._wrapperState = {
                wasMultiple: !!i.multiple
              }, Yl("invalid", r);
              break;
            case "textarea":
              Ii(r, i), Yl("invalid", r);
          }
          for (var a in Vi(n, i), e = null, i) i.hasOwnProperty(a) && (o = i[a], "children" === a ? "string" == typeof o ? r.textContent !== o && (e = ["children", o]) : "number" == typeof o && r.textContent !== "" + o && (e = ["children", "" + o]) : Io.hasOwnProperty(a) && null != o && "onScroll" === a && Yl("scroll", r));
          switch (n) {
            case "input":
              Ai(r), Ci(r, i, !0);
              break;
            case "textarea":
              Ai(r), Ri(r);
              break;
            case "select":
            case "option":
              break;
            default:
              "function" == typeof i.onClick && (r.onclick = ac);
          }
          r = e, t.updateQueue = r, null !== r && (t.flags |= 4);
        } else {
          switch (a = 9 === o.nodeType ? o : o.ownerDocument, e === Li.html && (e = Mi(n)), e === Li.html ? "script" === n ? ((e = a.createElement("div")).innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : "string" == typeof r.is ? e = a.createElement(n, {
            is: r.is
          }) : (e = a.createElement(n), "select" === n && (a = e, r.multiple ? a.multiple = !0 : r.size && (a.size = r.size))) : e = a.createElementNS(e, n), e[yc] = t, e[Ac] = r, hf(e, t, !1, !1), t.stateNode = e, a = Wi(n, r), n) {
            case "dialog":
              Yl("cancel", e), Yl("close", e), o = r;
              break;
            case "iframe":
            case "object":
            case "embed":
              Yl("load", e), o = r;
              break;
            case "video":
            case "audio":
              for (o = 0; o < Wl.length; o++) Yl(Wl[o], e);
              o = r;
              break;
            case "source":
              Yl("error", e), o = r;
              break;
            case "img":
            case "image":
            case "link":
              Yl("error", e), Yl("load", e), o = r;
              break;
            case "details":
              Yl("toggle", e), o = r;
              break;
            case "input":
              ki(e, r), o = wi(e, r), Yl("invalid", e);
              break;
            case "option":
              o = Oi(e, r);
              break;
            case "select":
              e._wrapperState = {
                wasMultiple: !!r.multiple
              }, o = xo({}, r, {
                value: void 0
              }), Yl("invalid", e);
              break;
            case "textarea":
              Ii(e, r), o = Ti(e, r), Yl("invalid", e);
              break;
            default:
              o = r;
          }
          Vi(n, o);
          var s = o;
          for (i in s) if (s.hasOwnProperty(i)) {
            var l = s[i];
            "style" === i ? $i(e, l) : "dangerouslySetInnerHTML" === i ? null != (l = l ? l.__html : void 0) && zi(e, l) : "children" === i ? "string" == typeof l ? ("textarea" !== n || "" !== l) && ji(e, l) : "number" == typeof l && ji(e, "" + l) : "suppressContentEditableWarning" !== i && "suppressHydrationWarning" !== i && "autoFocus" !== i && (Io.hasOwnProperty(i) ? null != l && "onScroll" === i && Yl("scroll", e) : null != l && $o(e, i, l, a));
          }
          switch (n) {
            case "input":
              Ai(e), Ci(e, r, !1);
              break;
            case "textarea":
              Ai(e), Ri(e);
              break;
            case "option":
              null != r.value && e.setAttribute("value", "" + vi(r.value));
              break;
            case "select":
              e.multiple = !!r.multiple, null != (i = r.value) ? Pi(e, !!r.multiple, i, !1) : null != r.defaultValue && Pi(e, !!r.multiple, r.defaultValue, !0);
              break;
            default:
              "function" == typeof o.onClick && (e.onclick = ac);
          }
          cc(n, r) && (t.flags |= 4);
        }
        null !== t.ref && (t.flags |= 128);
      }
      return null;
    case 6:
      if (e && null != t.stateNode) vf(e, t, e.memoizedProps, r);else {
        if ("string" != typeof r && null === t.stateNode) throw Error(Po(166));
        n = Zu(Ju.current), Zu(Gu.current), fd(t) ? (r = t.stateNode, n = t.memoizedProps, r[yc] = t, r.nodeValue !== n && (t.flags |= 4)) : ((r = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(r))[yc] = t, t.stateNode = r);
      }
      return null;
    case 13:
      return Tc(rd), r = t.memoizedState, 0 != (64 & t.flags) ? (t.lanes = n, t) : (r = null !== r, n = !1, null === e ? void 0 !== t.memoizedProps.fallback && fd(t) : n = null !== e.memoizedState, r && !n && 0 != (2 & t.mode) && (null === e && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (1 & rd.current) ? 0 === ip && (ip = 3) : (0 !== ip && 3 !== ip || (ip = 4), null === ep || 0 == (134217727 & lp) && 0 == (134217727 & cp) || jp(ep, np))), (r || n) && (t.flags |= 4), null);
    case 4:
      return ed(), mf(t), null === e && Zl(t.stateNode.containerInfo), null;
    case 10:
      return ku(t), null;
    case 19:
      if (Tc(rd), null === (r = t.memoizedState)) return null;
      if (i = 0 != (64 & t.flags), null === (a = r.rendering)) {
        if (i) xf(r, !1);else {
          if (0 !== ip || null !== e && 0 != (64 & e.flags)) for (e = t.child; null !== e;) {
            if (null !== (a = od(e))) {
              for (t.flags |= 64, xf(r, !1), null !== (i = a.updateQueue) && (t.updateQueue = i, t.flags |= 4), null === r.lastEffect && (t.firstEffect = null), t.lastEffect = r.lastEffect, r = n, n = t.child; null !== n;) e = r, (i = n).flags &= 2, i.nextEffect = null, i.firstEffect = null, i.lastEffect = null, null === (a = i.alternate) ? (i.childLanes = 0, i.lanes = e, i.child = null, i.memoizedProps = null, i.memoizedState = null, i.updateQueue = null, i.dependencies = null, i.stateNode = null) : (i.childLanes = a.childLanes, i.lanes = a.lanes, i.child = a.child, i.memoizedProps = a.memoizedProps, i.memoizedState = a.memoizedState, i.updateQueue = a.updateQueue, i.type = a.type, e = a.dependencies, i.dependencies = null === e ? null : {
                lanes: e.lanes,
                firstContext: e.firstContext
              }), n = n.sibling;
              return Ic(rd, 1 & rd.current | 2), t.child;
            }
            e = e.sibling;
          }
          null !== r.tail && cu() > pp && (t.flags |= 64, i = !0, xf(r, !1), t.lanes = 33554432);
        }
      } else {
        if (!i) if (null !== (e = od(a))) {
          if (t.flags |= 64, i = !0, null !== (n = e.updateQueue) && (t.updateQueue = n, t.flags |= 4), xf(r, !0), null === r.tail && "hidden" === r.tailMode && !a.alternate && !sd) return null !== (t = t.lastEffect = r.lastEffect) && (t.nextEffect = null), null;
        } else 2 * cu() - r.renderingStartTime > pp && 1073741824 !== n && (t.flags |= 64, i = !0, xf(r, !1), t.lanes = 33554432);
        r.isBackwards ? (a.sibling = t.child, t.child = a) : (null !== (n = r.last) ? n.sibling = a : t.child = a, r.last = a);
      }
      return null !== r.tail ? (n = r.tail, r.rendering = n, r.tail = n.sibling, r.lastEffect = t.lastEffect, r.renderingStartTime = cu(), n.sibling = null, t = rd.current, Ic(rd, i ? 1 & t | 2 : 1 & t), n) : null;
    case 23:
    case 24:
      return Hp(), null !== e && null !== e.memoizedState != (null !== t.memoizedState) && "unstable-defer-without-hiding" !== r.mode && (t.flags |= 4), null;
  }
  throw Error(Po(156, t.tag));
}
function Pf(e) {
  switch (e.tag) {
    case 1:
      Nc(e.type) && zc();
      var t = e.flags;
      return 4096 & t ? (e.flags = -4097 & t | 64, e) : null;
    case 3:
      if (ed(), Tc(Lc), Tc(Rc), md(), 0 != (64 & (t = e.flags))) throw Error(Po(285));
      return e.flags = -4097 & t | 64, e;
    case 5:
      return nd(e), null;
    case 13:
      return Tc(rd), 4096 & (t = e.flags) ? (e.flags = -4097 & t | 64, e) : null;
    case 19:
      return Tc(rd), null;
    case 4:
      return ed(), null;
    case 10:
      return ku(e), null;
    case 23:
    case 24:
      return Hp(), null;
    default:
      return null;
  }
}
function Tf(e, t) {
  try {
    var n = "",
      r = t;
    do {
      n += mi(r), r = r["return"];
    } while (r);
    var o = n;
  } catch (e) {
    o = "\nError generating stack: " + e.message + "\n" + e.stack;
  }
  return {
    value: e,
    source: t,
    stack: o
  };
}
function If(e, t) {
  try {
    console.error(t.value);
  } catch (e) {
    setTimeout(function () {
      throw e;
    });
  }
}
hf = function hf(e, t) {
  for (var n = t.child; null !== n;) {
    if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);else if (4 !== n.tag && null !== n.child) {
      n.child["return"] = n, n = n.child;
      continue;
    }
    if (n === t) break;
    for (; null === n.sibling;) {
      if (null === n["return"] || n["return"] === t) return;
      n = n["return"];
    }
    n.sibling["return"] = n["return"], n = n.sibling;
  }
}, mf = function mf() {}, gf = function gf(e, t, n, r) {
  var o = e.memoizedProps;
  if (o !== r) {
    e = t.stateNode, Zu(Gu.current);
    var i,
      a = null;
    switch (n) {
      case "input":
        o = wi(e, o), r = wi(e, r), a = [];
        break;
      case "option":
        o = Oi(e, o), r = Oi(e, r), a = [];
        break;
      case "select":
        o = xo({}, o, {
          value: void 0
        }), r = xo({}, r, {
          value: void 0
        }), a = [];
        break;
      case "textarea":
        o = Ti(e, o), r = Ti(e, r), a = [];
        break;
      default:
        "function" != typeof o.onClick && "function" == typeof r.onClick && (e.onclick = ac);
    }
    for (c in Vi(n, r), n = null, o) if (!r.hasOwnProperty(c) && o.hasOwnProperty(c) && null != o[c]) if ("style" === c) {
      var s = o[c];
      for (i in s) s.hasOwnProperty(i) && (n || (n = {}), n[i] = "");
    } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && (Io.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
    for (c in r) {
      var l = r[c];
      if (s = null != o ? o[c] : void 0, r.hasOwnProperty(c) && l !== s && (null != l || null != s)) if ("style" === c) {
        if (s) {
          for (i in s) !s.hasOwnProperty(i) || l && l.hasOwnProperty(i) || (n || (n = {}), n[i] = "");
          for (i in l) l.hasOwnProperty(i) && s[i] !== l[i] && (n || (n = {}), n[i] = l[i]);
        } else n || (a || (a = []), a.push(c, n)), n = l;
      } else "dangerouslySetInnerHTML" === c ? (l = l ? l.__html : void 0, s = s ? s.__html : void 0, null != l && s !== l && (a = a || []).push(c, l)) : "children" === c ? "string" != typeof l && "number" != typeof l || (a = a || []).push(c, "" + l) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && (Io.hasOwnProperty(c) ? (null != l && "onScroll" === c && Yl("scroll", e), a || s === l || (a = [])) : "object" == _typeof(l) && null !== l && l.$$typeof === oi ? l.toString() : (a = a || []).push(c, l));
    }
    n && (a = a || []).push("style", n);
    var c = a;
    (t.updateQueue = c) && (t.flags |= 4);
  }
}, vf = function vf(e, t, n, r) {
  n !== r && (t.flags |= 4);
};
var Bf = "function" == typeof WeakMap ? WeakMap : Map;
function Rf(e, t, n) {
  (n = Tu(-1, n)).tag = 3, n.payload = {
    element: null
  };
  var r = t.value;
  return n.callback = function () {
    vp || (vp = !0, yp = r), If(0, t);
  }, n;
}
function Lf(e, t, n) {
  (n = Tu(-1, n)).tag = 3;
  var r = e.type.getDerivedStateFromError;
  if ("function" == typeof r) {
    var o = t.value;
    n.payload = function () {
      return If(0, t), r(o);
    };
  }
  var i = e.stateNode;
  return null !== i && "function" == typeof i.componentDidCatch && (n.callback = function () {
    "function" != typeof r && (null === Ap ? Ap = new Set([this]) : Ap.add(this), If(0, t));
    var e = t.stack;
    this.componentDidCatch(t.value, {
      componentStack: null !== e ? e : ""
    });
  }), n;
}
var Mf = "function" == typeof WeakSet ? WeakSet : Set;
function Df(e) {
  var t = e.ref;
  if (null !== t) if ("function" == typeof t) try {
    t(null);
  } catch (t) {
    sh(e, t);
  } else t.current = null;
}
function Nf(e, t) {
  switch (t.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
    case 5:
    case 6:
    case 4:
    case 17:
      return;
    case 1:
      if (256 & t.flags && null !== e) {
        var n = e.memoizedProps,
          r = e.memoizedState;
        t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : vu(t.type, n), r), e.__reactInternalSnapshotBeforeUpdate = t;
      }
      return;
    case 3:
      return void (256 & t.flags && pc(t.stateNode.containerInfo));
  }
  throw Error(Po(163));
}
function zf(e, t, n) {
  switch (n.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      if (null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)) {
        e = t = t.next;
        do {
          if (3 == (3 & e.tag)) {
            var r = e.create;
            e.destroy = r();
          }
          e = e.next;
        } while (e !== t);
      }
      if (null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)) {
        e = t = t.next;
        do {
          var o = e;
          r = o.next, 0 != (4 & (o = o.tag)) && 0 != (1 & o) && (oh(n, e), rh(n, e)), e = r;
        } while (e !== t);
      }
      return;
    case 1:
      return e = n.stateNode, 4 & n.flags && (null === t ? e.componentDidMount() : (r = n.elementType === n.type ? t.memoizedProps : vu(n.type, t.memoizedProps), e.componentDidUpdate(r, t.memoizedState, e.__reactInternalSnapshotBeforeUpdate))), void (null !== (t = n.updateQueue) && Lu(n, t, e));
    case 3:
      if (null !== (t = n.updateQueue)) {
        if (e = null, null !== n.child) switch (n.child.tag) {
          case 5:
          case 1:
            e = n.child.stateNode;
        }
        Lu(n, t, e);
      }
      return;
    case 5:
      return e = n.stateNode, void (null === t && 4 & n.flags && cc(n.type, n.memoizedProps) && e.focus());
    case 6:
    case 4:
    case 12:
    case 19:
    case 17:
    case 20:
    case 21:
    case 23:
    case 24:
      return;
    case 13:
      return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && $a(n)))));
  }
  throw Error(Po(163));
}
function jf(e, t) {
  for (var n = e;;) {
    if (5 === n.tag) {
      var r = n.stateNode;
      if (t) "function" == typeof (r = r.style).setProperty ? r.setProperty("display", "none", "important") : r.display = "none";else {
        r = n.stateNode;
        var o = n.memoizedProps.style;
        o = null != o && o.hasOwnProperty("display") ? o.display : null, r.style.display = Qi("display", o);
      }
    } else if (6 === n.tag) n.stateNode.nodeValue = t ? "" : n.memoizedProps;else if ((23 !== n.tag && 24 !== n.tag || null === n.memoizedState || n === e) && null !== n.child) {
      n.child["return"] = n, n = n.child;
      continue;
    }
    if (n === e) break;
    for (; null === n.sibling;) {
      if (null === n["return"] || n["return"] === e) return;
      n = n["return"];
    }
    n.sibling["return"] = n["return"], n = n.sibling;
  }
}
function Ff(e, t) {
  if (Hc && "function" == typeof Hc.onCommitFiberUnmount) try {
    Hc.onCommitFiberUnmount($c, t);
  } catch (e) {}
  switch (t.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
        var n = e = e.next;
        do {
          var r = n,
            o = r.destroy;
          if (r = r.tag, void 0 !== o) if (0 != (4 & r)) oh(t, n);else {
            r = t;
            try {
              o();
            } catch (e) {
              sh(r, e);
            }
          }
          n = n.next;
        } while (n !== e);
      }
      break;
    case 1:
      if (Df(t), "function" == typeof (e = t.stateNode).componentWillUnmount) try {
        e.props = t.memoizedProps, e.state = t.memoizedState, e.componentWillUnmount();
      } catch (e) {
        sh(t, e);
      }
      break;
    case 5:
      Df(t);
      break;
    case 4:
      Wf(e, t);
  }
}
function Uf(e) {
  e.alternate = null, e.child = null, e.dependencies = null, e.firstEffect = null, e.lastEffect = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e["return"] = null, e.updateQueue = null;
}
function Qf(e) {
  return 5 === e.tag || 3 === e.tag || 4 === e.tag;
}
function $f(e) {
  e: {
    for (var t = e["return"]; null !== t;) {
      if (Qf(t)) break e;
      t = t["return"];
    }
    throw Error(Po(160));
  }
  var n = t;
  switch (t = n.stateNode, n.tag) {
    case 5:
      var r = !1;
      break;
    case 3:
    case 4:
      t = t.containerInfo, r = !0;
      break;
    default:
      throw Error(Po(161));
  }
  16 & n.flags && (ji(t, ""), n.flags &= -17);
  e: t: for (n = e;;) {
    for (; null === n.sibling;) {
      if (null === n["return"] || Qf(n["return"])) {
        n = null;
        break e;
      }
      n = n["return"];
    }
    for (n.sibling["return"] = n["return"], n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;) {
      if (2 & n.flags) continue t;
      if (null === n.child || 4 === n.tag) continue t;
      n.child["return"] = n, n = n.child;
    }
    if (!(2 & n.flags)) {
      n = n.stateNode;
      break e;
    }
  }
  r ? Hf(e, n, t) : Vf(e, n, t);
}
function Hf(e, t, n) {
  var r = e.tag,
    o = 5 === r || 6 === r;
  if (o) e = o ? e.stateNode : e.stateNode.instance, t ? 8 === n.nodeType ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (8 === n.nodeType ? (t = n.parentNode).insertBefore(e, n) : (t = n).appendChild(e), null != (n = n._reactRootContainer) || null !== t.onclick || (t.onclick = ac));else if (4 !== r && null !== (e = e.child)) for (Hf(e, t, n), e = e.sibling; null !== e;) Hf(e, t, n), e = e.sibling;
}
function Vf(e, t, n) {
  var r = e.tag,
    o = 5 === r || 6 === r;
  if (o) e = o ? e.stateNode : e.stateNode.instance, t ? n.insertBefore(e, t) : n.appendChild(e);else if (4 !== r && null !== (e = e.child)) for (Vf(e, t, n), e = e.sibling; null !== e;) Vf(e, t, n), e = e.sibling;
}
function Wf(e, t) {
  for (var n, r, o = t, i = !1;;) {
    if (!i) {
      i = o["return"];
      e: for (;;) {
        if (null === i) throw Error(Po(160));
        switch (n = i.stateNode, i.tag) {
          case 5:
            r = !1;
            break e;
          case 3:
          case 4:
            n = n.containerInfo, r = !0;
            break e;
        }
        i = i["return"];
      }
      i = !0;
    }
    if (5 === o.tag || 6 === o.tag) {
      e: for (var a = e, s = o, l = s;;) if (Ff(a, l), null !== l.child && 4 !== l.tag) l.child["return"] = l, l = l.child;else {
        if (l === s) break e;
        for (; null === l.sibling;) {
          if (null === l["return"] || l["return"] === s) break e;
          l = l["return"];
        }
        l.sibling["return"] = l["return"], l = l.sibling;
      }
      r ? (a = n, s = o.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(s) : a.removeChild(s)) : n.removeChild(o.stateNode);
    } else if (4 === o.tag) {
      if (null !== o.child) {
        n = o.stateNode.containerInfo, r = !0, o.child["return"] = o, o = o.child;
        continue;
      }
    } else if (Ff(e, o), null !== o.child) {
      o.child["return"] = o, o = o.child;
      continue;
    }
    if (o === t) break;
    for (; null === o.sibling;) {
      if (null === o["return"] || o["return"] === t) return;
      4 === (o = o["return"]).tag && (i = !1);
    }
    o.sibling["return"] = o["return"], o = o.sibling;
  }
}
function Kf(e, t) {
  switch (t.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      var n = t.updateQueue;
      if (null !== (n = null !== n ? n.lastEffect : null)) {
        var r = n = n.next;
        do {
          3 == (3 & r.tag) && (e = r.destroy, r.destroy = void 0, void 0 !== e && e()), r = r.next;
        } while (r !== n);
      }
      return;
    case 1:
    case 12:
    case 17:
      return;
    case 5:
      if (null != (n = t.stateNode)) {
        r = t.memoizedProps;
        var o = null !== e ? e.memoizedProps : r;
        e = t.type;
        var i = t.updateQueue;
        if (t.updateQueue = null, null !== i) {
          for (n[Ac] = r, "input" === e && "radio" === r.type && null != r.name && Ei(n, r), Wi(e, o), t = Wi(e, r), o = 0; o < i.length; o += 2) {
            var a = i[o],
              s = i[o + 1];
            "style" === a ? $i(n, s) : "dangerouslySetInnerHTML" === a ? zi(n, s) : "children" === a ? ji(n, s) : $o(n, a, s, t);
          }
          switch (e) {
            case "input":
              Si(n, r);
              break;
            case "textarea":
              Bi(n, r);
              break;
            case "select":
              e = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!r.multiple, null != (i = r.value) ? Pi(n, !!r.multiple, i, !1) : e !== !!r.multiple && (null != r.defaultValue ? Pi(n, !!r.multiple, r.defaultValue, !0) : Pi(n, !!r.multiple, r.multiple ? [] : "", !1));
          }
        }
      }
      return;
    case 6:
      if (null === t.stateNode) throw Error(Po(162));
      return void (t.stateNode.nodeValue = t.memoizedProps);
    case 3:
      return void ((n = t.stateNode).hydrate && (n.hydrate = !1, $a(n.containerInfo)));
    case 13:
      return null !== t.memoizedState && (fp = cu(), jf(t.child, !0)), void qf(t);
    case 19:
      return void qf(t);
    case 23:
    case 24:
      return void jf(t, null !== t.memoizedState);
  }
  throw Error(Po(163));
}
function qf(e) {
  var t = e.updateQueue;
  if (null !== t) {
    e.updateQueue = null;
    var n = e.stateNode;
    null === n && (n = e.stateNode = new Mf()), t.forEach(function (t) {
      var r = ch.bind(null, e, t);
      n.has(t) || (n.add(t), t.then(r, r));
    });
  }
}
function Gf(e, t) {
  return null !== e && (null === (e = e.memoizedState) || null !== e.dehydrated) && null !== (t = t.memoizedState) && null === t.dehydrated;
}
var Yf = Math.ceil,
  Jf = Ho.ReactCurrentDispatcher,
  Zf = Ho.ReactCurrentOwner,
  Xf = 0,
  ep = null,
  tp = null,
  np = 0,
  rp = 0,
  op = Pc(0),
  ip = 0,
  ap = null,
  sp = 0,
  lp = 0,
  cp = 0,
  up = 0,
  dp = null,
  fp = 0,
  pp = 1 / 0;
function hp() {
  pp = cu() + 500;
}
var mp,
  gp = null,
  vp = !1,
  yp = null,
  Ap = null,
  bp = !1,
  _p = null,
  wp = 90,
  kp = [],
  Ep = [],
  Sp = null,
  Cp = 0,
  xp = null,
  Op = -1,
  Pp = 0,
  Tp = 0,
  Ip = null,
  Bp = !1;
function Rp() {
  return 0 != (48 & Xf) ? cu() : -1 !== Op ? Op : Op = cu();
}
function Lp(e) {
  if (0 == (2 & (e = e.mode))) return 1;
  if (0 == (4 & e)) return 99 === uu() ? 1 : 2;
  if (0 === Pp && (Pp = sp), 0 !== gu.transition) {
    0 !== Tp && (Tp = null !== dp ? dp.pendingLanes : 0), e = Pp;
    var t = 4186112 & ~Tp;
    return 0 === (t &= -t) && 0 === (t = (e = 4186112 & ~e) & -e) && (t = 8192), t;
  }
  return e = uu(), 0 != (4 & Xf) && 98 === e ? e = ss(12, Pp) : e = ss(e = function (e) {
    switch (e) {
      case 99:
        return 15;
      case 98:
        return 10;
      case 97:
      case 96:
        return 8;
      case 95:
        return 2;
      default:
        return 0;
    }
  }(e), Pp), e;
}
function Mp(e, t, n) {
  if (50 < Cp) throw Cp = 0, xp = null, Error(Po(185));
  if (null === (e = Dp(e, t))) return null;
  us(e, t, n), e === ep && (cp |= t, 4 === ip && jp(e, np));
  var r = uu();
  1 === t ? 0 != (8 & Xf) && 0 == (48 & Xf) ? Fp(e) : (Np(e, n), 0 === Xf && (hp(), hu())) : (0 == (4 & Xf) || 98 !== r && 99 !== r || (null === Sp ? Sp = new Set([e]) : Sp.add(e)), Np(e, n)), dp = e;
}
function Dp(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (null !== n && (n.lanes |= t), n = e, e = e["return"]; null !== e;) e.childLanes |= t, null !== (n = e.alternate) && (n.childLanes |= t), n = e, e = e["return"];
  return 3 === n.tag ? n.stateNode : null;
}
function Np(e, t) {
  for (var n = e.callbackNode, r = e.suspendedLanes, o = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes; 0 < a;) {
    var s = 31 - ds(a),
      l = 1 << s,
      c = i[s];
    if (-1 === c) {
      if (0 == (l & r) || 0 != (l & o)) {
        c = t, os(l);
        var u = rs;
        i[s] = 10 <= u ? c + 250 : 6 <= u ? c + 5e3 : -1;
      }
    } else c <= t && (e.expiredLanes |= l);
    a &= ~l;
  }
  if (r = is(e, e === ep ? np : 0), t = rs, 0 === r) null !== n && (n !== ru && Kc(n), e.callbackNode = null, e.callbackPriority = 0);else {
    if (null !== n) {
      if (e.callbackPriority === t) return;
      n !== ru && Kc(n);
    }
    15 === t ? (n = Fp.bind(null, e), null === iu ? (iu = [n], au = Wc(Zc, mu)) : iu.push(n), n = ru) : 14 === t ? n = pu(99, Fp.bind(null, e)) : (n = function (e) {
      switch (e) {
        case 15:
        case 14:
          return 99;
        case 13:
        case 12:
        case 11:
        case 10:
          return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
          return 97;
        case 3:
        case 2:
        case 1:
          return 95;
        case 0:
          return 90;
        default:
          throw Error(Po(358, e));
      }
    }(t), n = pu(n, zp.bind(null, e))), e.callbackPriority = t, e.callbackNode = n;
  }
}
function zp(e) {
  if (Op = -1, Tp = Pp = 0, 0 != (48 & Xf)) throw Error(Po(327));
  var t = e.callbackNode;
  if (nh() && e.callbackNode !== t) return null;
  var n = is(e, e === ep ? np : 0);
  if (0 === n) return null;
  var r = n,
    o = Xf;
  Xf |= 16;
  var i = Kp();
  for (ep === e && np === r || (hp(), Vp(e, r));;) try {
    Yp();
    break;
  } catch (t) {
    Wp(e, t);
  }
  if (wu(), Jf.current = i, Xf = o, null !== tp ? r = 0 : (ep = null, np = 0, r = ip), 0 != (sp & cp)) Vp(e, 0);else if (0 !== r) {
    if (2 === r && (Xf |= 64, e.hydrate && (e.hydrate = !1, pc(e.containerInfo)), 0 !== (n = as(e)) && (r = qp(e, n))), 1 === r) throw t = ap, Vp(e, 0), jp(e, n), Np(e, cu()), t;
    switch (e.finishedWork = e.current.alternate, e.finishedLanes = n, r) {
      case 0:
      case 1:
        throw Error(Po(345));
      case 2:
      case 5:
        Xp(e);
        break;
      case 3:
        if (jp(e, n), (62914560 & n) === n && 10 < (r = fp + 500 - cu())) {
          if (0 !== is(e, 0)) break;
          if (((o = e.suspendedLanes) & n) !== n) {
            Rp(), e.pingedLanes |= e.suspendedLanes & o;
            break;
          }
          e.timeoutHandle = dc(Xp.bind(null, e), r);
          break;
        }
        Xp(e);
        break;
      case 4:
        if (jp(e, n), (4186112 & n) === n) break;
        for (r = e.eventTimes, o = -1; 0 < n;) {
          var a = 31 - ds(n);
          i = 1 << a, (a = r[a]) > o && (o = a), n &= ~i;
        }
        if (n = o, 10 < (n = (120 > (n = cu() - n) ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * Yf(n / 1960)) - n)) {
          e.timeoutHandle = dc(Xp.bind(null, e), n);
          break;
        }
        Xp(e);
        break;
      default:
        throw Error(Po(329));
    }
  }
  return Np(e, cu()), e.callbackNode === t ? zp.bind(null, e) : null;
}
function jp(e, t) {
  for (t &= ~up, t &= ~cp, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t;) {
    var n = 31 - ds(t),
      r = 1 << n;
    e[n] = -1, t &= ~r;
  }
}
function Fp(e) {
  if (0 != (48 & Xf)) throw Error(Po(327));
  if (nh(), e === ep && 0 != (e.expiredLanes & np)) {
    var t = np,
      n = qp(e, t);
    0 != (sp & cp) && (n = qp(e, t = is(e, t)));
  } else n = qp(e, t = is(e, 0));
  if (0 !== e.tag && 2 === n && (Xf |= 64, e.hydrate && (e.hydrate = !1, pc(e.containerInfo)), 0 !== (t = as(e)) && (n = qp(e, t))), 1 === n) throw n = ap, Vp(e, 0), jp(e, t), Np(e, cu()), n;
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, Xp(e), Np(e, cu()), null;
}
function Up(e, t) {
  var n = Xf;
  Xf |= 1;
  try {
    return e(t);
  } finally {
    0 === (Xf = n) && (hp(), hu());
  }
}
function Qp(e, t) {
  var n = Xf;
  Xf &= -2, Xf |= 8;
  try {
    return e(t);
  } finally {
    0 === (Xf = n) && (hp(), hu());
  }
}
function $p(e, t) {
  Ic(op, rp), rp |= t, sp |= t;
}
function Hp() {
  rp = op.current, Tc(op);
}
function Vp(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var n = e.timeoutHandle;
  if (-1 !== n && (e.timeoutHandle = -1, fc(n)), null !== tp) for (n = tp["return"]; null !== n;) {
    var r = n;
    switch (r.tag) {
      case 1:
        null != (r = r.type.childContextTypes) && zc();
        break;
      case 3:
        ed(), Tc(Lc), Tc(Rc), md();
        break;
      case 5:
        nd(r);
        break;
      case 4:
        ed();
        break;
      case 13:
      case 19:
        Tc(rd);
        break;
      case 10:
        ku(r);
        break;
      case 23:
      case 24:
        Hp();
    }
    n = n["return"];
  }
  ep = e, tp = ph(e.current, null), np = rp = sp = t, ip = 0, ap = null, up = cp = lp = 0;
}
function Wp(e, t) {
  for (;;) {
    var n = tp;
    try {
      if (wu(), gd.current = Jd, wd) {
        for (var r = Ad.memoizedState; null !== r;) {
          var o = r.queue;
          null !== o && (o.pending = null), r = r.next;
        }
        wd = !1;
      }
      if (yd = 0, _d = bd = Ad = null, kd = !1, Zf.current = null, null === n || null === n["return"]) {
        ip = 1, ap = t, tp = null;
        break;
      }
      e: {
        var i = e,
          a = n["return"],
          s = n,
          l = t;
        if (t = np, s.flags |= 2048, s.firstEffect = s.lastEffect = null, null !== l && "object" == _typeof(l) && "function" == typeof l.then) {
          var c = l;
          if (0 == (2 & s.mode)) {
            var u = s.alternate;
            u ? (s.updateQueue = u.updateQueue, s.memoizedState = u.memoizedState, s.lanes = u.lanes) : (s.updateQueue = null, s.memoizedState = null);
          }
          var d = 0 != (1 & rd.current),
            f = a;
          do {
            var p;
            if (p = 13 === f.tag) {
              var h = f.memoizedState;
              if (null !== h) p = null !== h.dehydrated;else {
                var m = f.memoizedProps;
                p = void 0 !== m.fallback && (!0 !== m.unstable_avoidThisFallback || !d);
              }
            }
            if (p) {
              var g = f.updateQueue;
              if (null === g) {
                var v = new Set();
                v.add(c), f.updateQueue = v;
              } else g.add(c);
              if (0 == (2 & f.mode)) {
                if (f.flags |= 64, s.flags |= 16384, s.flags &= -2981, 1 === s.tag) if (null === s.alternate) s.tag = 17;else {
                  var y = Tu(-1, 1);
                  y.tag = 2, Iu(s, y);
                }
                s.lanes |= 1;
                break e;
              }
              l = void 0, s = t;
              var A = i.pingCache;
              if (null === A ? (A = i.pingCache = new Bf(), l = new Set(), A.set(c, l)) : void 0 === (l = A.get(c)) && (l = new Set(), A.set(c, l)), !l.has(s)) {
                l.add(s);
                var b = lh.bind(null, i, c, s);
                c.then(b, b);
              }
              f.flags |= 4096, f.lanes = t;
              break e;
            }
            f = f["return"];
          } while (null !== f);
          l = Error((gi(s.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
        }
        5 !== ip && (ip = 2), l = Tf(l, s), f = a;
        do {
          switch (f.tag) {
            case 3:
              i = l, f.flags |= 4096, t &= -t, f.lanes |= t, Bu(f, Rf(0, i, t));
              break e;
            case 1:
              i = l;
              var _ = f.type,
                w = f.stateNode;
              if (0 == (64 & f.flags) && ("function" == typeof _.getDerivedStateFromError || null !== w && "function" == typeof w.componentDidCatch && (null === Ap || !Ap.has(w)))) {
                f.flags |= 4096, t &= -t, f.lanes |= t, Bu(f, Lf(f, i, t));
                break e;
              }
          }
          f = f["return"];
        } while (null !== f);
      }
      Zp(n);
    } catch (e) {
      t = e, tp === n && null !== n && (tp = n = n["return"]);
      continue;
    }
    break;
  }
}
function Kp() {
  var e = Jf.current;
  return Jf.current = Jd, null === e ? Jd : e;
}
function qp(e, t) {
  var n = Xf;
  Xf |= 16;
  var r = Kp();
  for (ep === e && np === t || Vp(e, t);;) try {
    Gp();
    break;
  } catch (t) {
    Wp(e, t);
  }
  if (wu(), Xf = n, Jf.current = r, null !== tp) throw Error(Po(261));
  return ep = null, np = 0, ip;
}
function Gp() {
  for (; null !== tp;) Jp(tp);
}
function Yp() {
  for (; null !== tp && !qc();) Jp(tp);
}
function Jp(e) {
  var t = mp(e.alternate, e, rp);
  e.memoizedProps = e.pendingProps, null === t ? Zp(e) : tp = t, Zf.current = null;
}
function Zp(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (e = t["return"], 0 == (2048 & t.flags)) {
      if (null !== (n = Of(n, t, rp))) return void (tp = n);
      if (24 !== (n = t).tag && 23 !== n.tag || null === n.memoizedState || 0 != (1073741824 & rp) || 0 == (4 & n.mode)) {
        for (var r = 0, o = n.child; null !== o;) r |= o.lanes | o.childLanes, o = o.sibling;
        n.childLanes = r;
      }
      null !== e && 0 == (2048 & e.flags) && (null === e.firstEffect && (e.firstEffect = t.firstEffect), null !== t.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = t.firstEffect), e.lastEffect = t.lastEffect), 1 < t.flags && (null !== e.lastEffect ? e.lastEffect.nextEffect = t : e.firstEffect = t, e.lastEffect = t));
    } else {
      if (null !== (n = Pf(t))) return n.flags &= 2047, void (tp = n);
      null !== e && (e.firstEffect = e.lastEffect = null, e.flags |= 2048);
    }
    if (null !== (t = t.sibling)) return void (tp = t);
    tp = t = e;
  } while (null !== t);
  0 === ip && (ip = 5);
}
function Xp(e) {
  var t = uu();
  return fu(99, eh.bind(null, e, t)), null;
}
function eh(e, t) {
  do {
    nh();
  } while (null !== _p);
  if (0 != (48 & Xf)) throw Error(Po(327));
  var n = e.finishedWork;
  if (null === n) return null;
  if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(Po(177));
  e.callbackNode = null;
  var r = n.lanes | n.childLanes,
    o = r,
    i = e.pendingLanes & ~o;
  e.pendingLanes = o, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= o, e.mutableReadLanes &= o, e.entangledLanes &= o, o = e.entanglements;
  for (var a = e.eventTimes, s = e.expirationTimes; 0 < i;) {
    var l = 31 - ds(i),
      c = 1 << l;
    o[l] = 0, a[l] = -1, s[l] = -1, i &= ~c;
  }
  if (null !== Sp && 0 == (24 & r) && Sp.has(e) && Sp["delete"](e), e === ep && (tp = ep = null, np = 0), 1 < n.flags ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, r = n.firstEffect) : r = n : r = n.firstEffect, null !== r) {
    if (o = Xf, Xf |= 32, Zf.current = null, sc = gs, Nl(a = Dl())) {
      if ("selectionStart" in a) s = {
        start: a.selectionStart,
        end: a.selectionEnd
      };else e: if (s = (s = a.ownerDocument) && s.defaultView || window, (c = s.getSelection && s.getSelection()) && 0 !== c.rangeCount) {
        s = c.anchorNode, i = c.anchorOffset, l = c.focusNode, c = c.focusOffset;
        try {
          s.nodeType, l.nodeType;
        } catch (e) {
          s = null;
          break e;
        }
        var u = 0,
          d = -1,
          f = -1,
          p = 0,
          h = 0,
          m = a,
          g = null;
        t: for (;;) {
          for (var v; m !== s || 0 !== i && 3 !== m.nodeType || (d = u + i), m !== l || 0 !== c && 3 !== m.nodeType || (f = u + c), 3 === m.nodeType && (u += m.nodeValue.length), null !== (v = m.firstChild);) g = m, m = v;
          for (;;) {
            if (m === a) break t;
            if (g === s && ++p === i && (d = u), g === l && ++h === c && (f = u), null !== (v = m.nextSibling)) break;
            g = (m = g).parentNode;
          }
          m = v;
        }
        s = -1 === d || -1 === f ? null : {
          start: d,
          end: f
        };
      } else s = null;
      s = s || {
        start: 0,
        end: 0
      };
    } else s = null;
    lc = {
      focusedElem: a,
      selectionRange: s
    }, gs = !1, Ip = null, Bp = !1, gp = r;
    do {
      try {
        th();
      } catch (e) {
        if (null === gp) throw Error(Po(330));
        sh(gp, e), gp = gp.nextEffect;
      }
    } while (null !== gp);
    Ip = null, gp = r;
    do {
      try {
        for (a = e; null !== gp;) {
          var y = gp.flags;
          if (16 & y && ji(gp.stateNode, ""), 128 & y) {
            var A = gp.alternate;
            if (null !== A) {
              var b = A.ref;
              null !== b && ("function" == typeof b ? b(null) : b.current = null);
            }
          }
          switch (1038 & y) {
            case 2:
              $f(gp), gp.flags &= -3;
              break;
            case 6:
              $f(gp), gp.flags &= -3, Kf(gp.alternate, gp);
              break;
            case 1024:
              gp.flags &= -1025;
              break;
            case 1028:
              gp.flags &= -1025, Kf(gp.alternate, gp);
              break;
            case 4:
              Kf(gp.alternate, gp);
              break;
            case 8:
              Wf(a, s = gp);
              var _ = s.alternate;
              Uf(s), null !== _ && Uf(_);
          }
          gp = gp.nextEffect;
        }
      } catch (e) {
        if (null === gp) throw Error(Po(330));
        sh(gp, e), gp = gp.nextEffect;
      }
    } while (null !== gp);
    if (b = lc, A = Dl(), y = b.focusedElem, a = b.selectionRange, A !== y && y && y.ownerDocument && Ml(y.ownerDocument.documentElement, y)) {
      null !== a && Nl(y) && (A = a.start, void 0 === (b = a.end) && (b = A), "selectionStart" in y ? (y.selectionStart = A, y.selectionEnd = Math.min(b, y.value.length)) : (b = (A = y.ownerDocument || document) && A.defaultView || window).getSelection && (b = b.getSelection(), s = y.textContent.length, _ = Math.min(a.start, s), a = void 0 === a.end ? _ : Math.min(a.end, s), !b.extend && _ > a && (s = a, a = _, _ = s), s = Ll(y, _), i = Ll(y, a), s && i && (1 !== b.rangeCount || b.anchorNode !== s.node || b.anchorOffset !== s.offset || b.focusNode !== i.node || b.focusOffset !== i.offset) && ((A = A.createRange()).setStart(s.node, s.offset), b.removeAllRanges(), _ > a ? (b.addRange(A), b.extend(i.node, i.offset)) : (A.setEnd(i.node, i.offset), b.addRange(A))))), A = [];
      for (b = y; b = b.parentNode;) 1 === b.nodeType && A.push({
        element: b,
        left: b.scrollLeft,
        top: b.scrollTop
      });
      for ("function" == typeof y.focus && y.focus(), y = 0; y < A.length; y++) (b = A[y]).element.scrollLeft = b.left, b.element.scrollTop = b.top;
    }
    gs = !!sc, lc = sc = null, e.current = n, gp = r;
    do {
      try {
        for (y = e; null !== gp;) {
          var w = gp.flags;
          if (36 & w && zf(y, gp.alternate, gp), 128 & w) {
            A = void 0;
            var k = gp.ref;
            if (null !== k) {
              var E = gp.stateNode;
              gp.tag, A = E, "function" == typeof k ? k(A) : k.current = A;
            }
          }
          gp = gp.nextEffect;
        }
      } catch (e) {
        if (null === gp) throw Error(Po(330));
        sh(gp, e), gp = gp.nextEffect;
      }
    } while (null !== gp);
    gp = null, ou(), Xf = o;
  } else e.current = n;
  if (bp) bp = !1, _p = e, wp = t;else for (gp = r; null !== gp;) t = gp.nextEffect, gp.nextEffect = null, 8 & gp.flags && ((w = gp).sibling = null, w.stateNode = null), gp = t;
  if (0 === (r = e.pendingLanes) && (Ap = null), 1 === r ? e === xp ? Cp++ : (Cp = 0, xp = e) : Cp = 0, n = n.stateNode, Hc && "function" == typeof Hc.onCommitFiberRoot) try {
    Hc.onCommitFiberRoot($c, n, void 0, 64 == (64 & n.current.flags));
  } catch (e) {}
  if (Np(e, cu()), vp) throw vp = !1, e = yp, yp = null, e;
  return 0 != (8 & Xf) || hu(), null;
}
function th() {
  for (; null !== gp;) {
    var e = gp.alternate;
    Bp || null === Ip || (0 != (8 & gp.flags) ? _a(gp, Ip) && (Bp = !0) : 13 === gp.tag && Gf(e, gp) && _a(gp, Ip) && (Bp = !0));
    var t = gp.flags;
    0 != (256 & t) && Nf(e, gp), 0 == (512 & t) || bp || (bp = !0, pu(97, function () {
      return nh(), null;
    })), gp = gp.nextEffect;
  }
}
function nh() {
  if (90 !== wp) {
    var e = 97 < wp ? 97 : wp;
    return wp = 90, fu(e, ih);
  }
  return !1;
}
function rh(e, t) {
  kp.push(t, e), bp || (bp = !0, pu(97, function () {
    return nh(), null;
  }));
}
function oh(e, t) {
  Ep.push(t, e), bp || (bp = !0, pu(97, function () {
    return nh(), null;
  }));
}
function ih() {
  if (null === _p) return !1;
  var e = _p;
  if (_p = null, 0 != (48 & Xf)) throw Error(Po(331));
  var t = Xf;
  Xf |= 32;
  var n = Ep;
  Ep = [];
  for (var r = 0; r < n.length; r += 2) {
    var o = n[r],
      i = n[r + 1],
      a = o.destroy;
    if (o.destroy = void 0, "function" == typeof a) try {
      a();
    } catch (e) {
      if (null === i) throw Error(Po(330));
      sh(i, e);
    }
  }
  for (n = kp, kp = [], r = 0; r < n.length; r += 2) {
    o = n[r], i = n[r + 1];
    try {
      var s = o.create;
      o.destroy = s();
    } catch (e) {
      if (null === i) throw Error(Po(330));
      sh(i, e);
    }
  }
  for (s = e.current.firstEffect; null !== s;) e = s.nextEffect, s.nextEffect = null, 8 & s.flags && (s.sibling = null, s.stateNode = null), s = e;
  return Xf = t, hu(), !0;
}
function ah(e, t, n) {
  Iu(e, t = Rf(0, t = Tf(n, t), 1)), t = Rp(), null !== (e = Dp(e, 1)) && (us(e, 1, t), Np(e, t));
}
function sh(e, t) {
  if (3 === e.tag) ah(e, e, t);else for (var n = e["return"]; null !== n;) {
    if (3 === n.tag) {
      ah(n, e, t);
      break;
    }
    if (1 === n.tag) {
      var r = n.stateNode;
      if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === Ap || !Ap.has(r))) {
        var o = Lf(n, e = Tf(t, e), 1);
        if (Iu(n, o), o = Rp(), null !== (n = Dp(n, 1))) us(n, 1, o), Np(n, o);else if ("function" == typeof r.componentDidCatch && (null === Ap || !Ap.has(r))) try {
          r.componentDidCatch(t, e);
        } catch (e) {}
        break;
      }
    }
    n = n["return"];
  }
}
function lh(e, t, n) {
  var r = e.pingCache;
  null !== r && r["delete"](t), t = Rp(), e.pingedLanes |= e.suspendedLanes & n, ep === e && (np & n) === n && (4 === ip || 3 === ip && (62914560 & np) === np && 500 > cu() - fp ? Vp(e, 0) : up |= n), Np(e, t);
}
function ch(e, t) {
  var n = e.stateNode;
  null !== n && n["delete"](t), 0 === (t = 0) && (0 == (2 & (t = e.mode)) ? t = 1 : 0 == (4 & t) ? t = 99 === uu() ? 1 : 2 : (0 === Pp && (Pp = sp), 0 === (t = ls(62914560 & ~Pp)) && (t = 4194304))), n = Rp(), null !== (e = Dp(e, t)) && (us(e, t, n), Np(e, n));
}
function uh(e, t, n, r) {
  this.tag = e, this.key = n, this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function dh(e, t, n, r) {
  return new uh(e, t, n, r);
}
function fh(e) {
  return !(!(e = e.prototype) || !e.isReactComponent);
}
function ph(e, t) {
  var n = e.alternate;
  return null === n ? ((n = dh(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
    lanes: t.lanes,
    firstContext: t.firstContext
  }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function hh(e, t, n, r, o, i) {
  var a = 2;
  if (r = e, "function" == typeof e) fh(e) && (a = 1);else if ("string" == typeof e) a = 5;else e: switch (e) {
    case Ko:
      return mh(n.children, o, i, t);
    case ii:
      a = 8, o |= 16;
      break;
    case qo:
      a = 8, o |= 1;
      break;
    case Go:
      return (e = dh(12, n, t, 8 | o)).elementType = Go, e.type = Go, e.lanes = i, e;
    case Xo:
      return (e = dh(13, n, t, o)).type = Xo, e.elementType = Xo, e.lanes = i, e;
    case ei:
      return (e = dh(19, n, t, o)).elementType = ei, e.lanes = i, e;
    case ai:
      return gh(n, o, i, t);
    case si:
      return (e = dh(24, n, t, o)).elementType = si, e.lanes = i, e;
    default:
      if ("object" == _typeof(e) && null !== e) switch (e.$$typeof) {
        case Yo:
          a = 10;
          break e;
        case Jo:
          a = 9;
          break e;
        case Zo:
          a = 11;
          break e;
        case ti:
          a = 14;
          break e;
        case ni:
          a = 16, r = null;
          break e;
        case ri:
          a = 22;
          break e;
      }
      throw Error(Po(130, null == e ? e : _typeof(e), ""));
  }
  return (t = dh(a, n, t, o)).elementType = e, t.type = r, t.lanes = i, t;
}
function mh(e, t, n, r) {
  return (e = dh(7, e, r, t)).lanes = n, e;
}
function gh(e, t, n, r) {
  return (e = dh(23, e, r, t)).elementType = ai, e.lanes = n, e;
}
function vh(e, t, n) {
  return (e = dh(6, e, null, t)).lanes = n, e;
}
function yh(e, t, n) {
  return (t = dh(4, null !== e.children ? e.children : [], e.key, t)).lanes = n, t.stateNode = {
    containerInfo: e.containerInfo,
    pendingChildren: null,
    implementation: e.implementation
  }, t;
}
function Ah(e, t, n) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = cs(0), this.expirationTimes = cs(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = cs(0), this.mutableSourceEagerHydrationData = null;
}
function bh(e, t, n, r) {
  var o = t.current,
    i = Rp(),
    a = Lp(o);
  e: if (n) {
    t: {
      if (va(n = n._reactInternals) !== n || 1 !== n.tag) throw Error(Po(170));
      var s = n;
      do {
        switch (s.tag) {
          case 3:
            s = s.stateNode.context;
            break t;
          case 1:
            if (Nc(s.type)) {
              s = s.stateNode.__reactInternalMemoizedMergedChildContext;
              break t;
            }
        }
        s = s["return"];
      } while (null !== s);
      throw Error(Po(171));
    }
    if (1 === n.tag) {
      var l = n.type;
      if (Nc(l)) {
        n = Fc(n, l, s);
        break e;
      }
    }
    n = s;
  } else n = Bc;
  return null === t.context ? t.context = n : t.pendingContext = n, (t = Tu(i, a)).payload = {
    element: e
  }, null !== (r = void 0 === r ? null : r) && (t.callback = r), Iu(o, t), Mp(o, a, i), a;
}
function _h(e) {
  return (e = e.current).child ? (e.child.tag, e.child.stateNode) : null;
}
function wh(e, t) {
  if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
    var n = e.retryLane;
    e.retryLane = 0 !== n && n < t ? n : t;
  }
}
function kh(e, t) {
  wh(e, t), (e = e.alternate) && wh(e, t);
}
function Eh(e, t, n) {
  var r = null != n && null != n.hydrationOptions && n.hydrationOptions.mutableSources || null;
  if (n = new Ah(e, t, null != n && !0 === n.hydrate), t = dh(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0), n.current = t, t.stateNode = n, Ou(t), e[bc] = n.current, Zl(8 === e.nodeType ? e.parentNode : e), r) for (e = 0; e < r.length; e++) {
    var o = (t = r[e])._getVersion;
    o = o(t._source), null == n.mutableSourceEagerHydrationData ? n.mutableSourceEagerHydrationData = [t, o] : n.mutableSourceEagerHydrationData.push(t, o);
  }
  this._internalRoot = n;
}
function Sh(e) {
  return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
}
function Ch(e, t, n, r, o) {
  var i = n._reactRootContainer;
  if (i) {
    var a = i._internalRoot;
    if ("function" == typeof o) {
      var s = o;
      o = function o() {
        var e = _h(a);
        s.call(e);
      };
    }
    bh(t, a, e, o);
  } else {
    if (i = n._reactRootContainer = function (e, t) {
      if (t || (t = !(!(t = e ? 9 === e.nodeType ? e.documentElement : e.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for (var n; n = e.lastChild;) e.removeChild(n);
      return new Eh(e, 0, t ? {
        hydrate: !0
      } : void 0);
    }(n, r), a = i._internalRoot, "function" == typeof o) {
      var l = o;
      o = function o() {
        var e = _h(a);
        l.call(e);
      };
    }
    Qp(function () {
      bh(t, a, e, o);
    });
  }
  return _h(a);
}
function xh(e, t) {
  var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!Sh(t)) throw Error(Po(200));
  return function (e, t, n) {
    var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
      $$typeof: Wo,
      key: null == r ? null : "" + r,
      children: e,
      containerInfo: t,
      implementation: n
    };
  }(e, t, null, n);
}
mp = function mp(e, t, n) {
  var r = t.lanes;
  if (null !== e) {
    if (e.memoizedProps !== t.pendingProps || Lc.current) nf = !0;else {
      if (0 == (n & r)) {
        switch (nf = !1, t.tag) {
          case 3:
            pf(t), pd();
            break;
          case 5:
            td(t);
            break;
          case 1:
            Nc(t.type) && Uc(t);
            break;
          case 4:
            Xu(t, t.stateNode.containerInfo);
            break;
          case 10:
            r = t.memoizedProps.value;
            var o = t.type._context;
            Ic(yu, o._currentValue), o._currentValue = r;
            break;
          case 13:
            if (null !== t.memoizedState) return 0 != (n & t.child.childLanes) ? Af(e, t, n) : (Ic(rd, 1 & rd.current), null !== (t = Cf(e, t, n)) ? t.sibling : null);
            Ic(rd, 1 & rd.current);
            break;
          case 19:
            if (r = 0 != (n & t.childLanes), 0 != (64 & e.flags)) {
              if (r) return Sf(e, t, n);
              t.flags |= 64;
            }
            if (null !== (o = t.memoizedState) && (o.rendering = null, o.tail = null, o.lastEffect = null), Ic(rd, rd.current), r) break;
            return null;
          case 23:
          case 24:
            return t.lanes = 0, lf(e, t, n);
        }
        return Cf(e, t, n);
      }
      nf = 0 != (16384 & e.flags);
    }
  } else nf = !1;
  switch (t.lanes = 0, t.tag) {
    case 2:
      if (r = t.type, null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2), e = t.pendingProps, o = Dc(t, Rc.current), Su(t, n), o = Cd(null, t, r, e, o, n), t.flags |= 1, "object" == _typeof(o) && null !== o && "function" == typeof o.render && void 0 === o.$$typeof) {
        if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, Nc(r)) {
          var i = !0;
          Uc(t);
        } else i = !1;
        t.memoizedState = null !== o.state && void 0 !== o.state ? o.state : null, Ou(t);
        var a = r.getDerivedStateFromProps;
        "function" == typeof a && Du(t, r, a, e), o.updater = Nu, t.stateNode = o, o._reactInternals = t, Uu(t, r, e, n), t = ff(null, t, r, !0, i, n);
      } else t.tag = 0, rf(null, t, o, n), t = t.child;
      return t;
    case 16:
      o = t.elementType;
      e: {
        switch (null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2), e = t.pendingProps, o = (i = o._init)(o._payload), t.type = o, i = t.tag = function (e) {
          if ("function" == typeof e) return fh(e) ? 1 : 0;
          if (null != e) {
            if ((e = e.$$typeof) === Zo) return 11;
            if (e === ti) return 14;
          }
          return 2;
        }(o), e = vu(o, e), i) {
          case 0:
            t = uf(null, t, o, e, n);
            break e;
          case 1:
            t = df(null, t, o, e, n);
            break e;
          case 11:
            t = of(null, t, o, e, n);
            break e;
          case 14:
            t = af(null, t, o, vu(o.type, e), r, n);
            break e;
        }
        throw Error(Po(306, o, ""));
      }
      return t;
    case 0:
      return r = t.type, o = t.pendingProps, uf(e, t, r, o = t.elementType === r ? o : vu(r, o), n);
    case 1:
      return r = t.type, o = t.pendingProps, df(e, t, r, o = t.elementType === r ? o : vu(r, o), n);
    case 3:
      if (pf(t), r = t.updateQueue, null === e || null === r) throw Error(Po(282));
      if (r = t.pendingProps, o = null !== (o = t.memoizedState) ? o.element : null, Pu(e, t), Ru(t, r, null, n), (r = t.memoizedState.element) === o) pd(), t = Cf(e, t, n);else {
        if ((i = (o = t.stateNode).hydrate) && (ad = hc(t.stateNode.containerInfo.firstChild), id = t, i = sd = !0), i) {
          if (null != (e = o.mutableSourceEagerHydrationData)) for (o = 0; o < e.length; o += 2) (i = e[o])._workInProgressVersionPrimary = e[o + 1], hd.push(i);
          for (n = Ku(t, null, r, n), t.child = n; n;) n.flags = -3 & n.flags | 1024, n = n.sibling;
        } else rf(e, t, r, n), pd();
        t = t.child;
      }
      return t;
    case 5:
      return td(t), null === e && ud(t), r = t.type, o = t.pendingProps, i = null !== e ? e.memoizedProps : null, a = o.children, uc(r, o) ? a = null : null !== i && uc(r, i) && (t.flags |= 16), cf(e, t), rf(e, t, a, n), t.child;
    case 6:
      return null === e && ud(t), null;
    case 13:
      return Af(e, t, n);
    case 4:
      return Xu(t, t.stateNode.containerInfo), r = t.pendingProps, null === e ? t.child = Wu(t, null, r, n) : rf(e, t, r, n), t.child;
    case 11:
      return r = t.type, o = t.pendingProps, of(e, t, r, o = t.elementType === r ? o : vu(r, o), n);
    case 7:
      return rf(e, t, t.pendingProps, n), t.child;
    case 8:
    case 12:
      return rf(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        r = t.type._context, o = t.pendingProps, a = t.memoizedProps, i = o.value;
        var s = t.type._context;
        if (Ic(yu, s._currentValue), s._currentValue = i, null !== a) if (s = a.value, 0 === (i = Tl(s, i) ? 0 : 0 | ("function" == typeof r._calculateChangedBits ? r._calculateChangedBits(s, i) : 1073741823))) {
          if (a.children === o.children && !Lc.current) {
            t = Cf(e, t, n);
            break e;
          }
        } else for (null !== (s = t.child) && (s["return"] = t); null !== s;) {
          var l = s.dependencies;
          if (null !== l) {
            a = s.child;
            for (var c = l.firstContext; null !== c;) {
              if (c.context === r && 0 != (c.observedBits & i)) {
                1 === s.tag && ((c = Tu(-1, n & -n)).tag = 2, Iu(s, c)), s.lanes |= n, null !== (c = s.alternate) && (c.lanes |= n), Eu(s["return"], n), l.lanes |= n;
                break;
              }
              c = c.next;
            }
          } else a = 10 === s.tag && s.type === t.type ? null : s.child;
          if (null !== a) a["return"] = s;else for (a = s; null !== a;) {
            if (a === t) {
              a = null;
              break;
            }
            if (null !== (s = a.sibling)) {
              s["return"] = a["return"], a = s;
              break;
            }
            a = a["return"];
          }
          s = a;
        }
        rf(e, t, o.children, n), t = t.child;
      }
      return t;
    case 9:
      return o = t.type, r = (i = t.pendingProps).children, Su(t, n), r = r(o = Cu(o, i.unstable_observedBits)), t.flags |= 1, rf(e, t, r, n), t.child;
    case 14:
      return i = vu(o = t.type, t.pendingProps), af(e, t, o, i = vu(o.type, i), r, n);
    case 15:
      return sf(e, t, t.type, t.pendingProps, r, n);
    case 17:
      return r = t.type, o = t.pendingProps, o = t.elementType === r ? o : vu(r, o), null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2), t.tag = 1, Nc(r) ? (e = !0, Uc(t)) : e = !1, Su(t, n), ju(t, r, o), Uu(t, r, o, n), ff(null, t, r, !0, e, n);
    case 19:
      return Sf(e, t, n);
    case 23:
    case 24:
      return lf(e, t, n);
  }
  throw Error(Po(156, t.tag));
}, Eh.prototype.render = function (e) {
  bh(e, this._internalRoot, null, null);
}, Eh.prototype.unmount = function () {
  var e = this._internalRoot,
    t = e.containerInfo;
  bh(null, e, null, function () {
    t[bc] = null;
  });
}, wa = function wa(e) {
  13 === e.tag && (Mp(e, 4, Rp()), kh(e, 4));
}, ka = function ka(e) {
  13 === e.tag && (Mp(e, 67108864, Rp()), kh(e, 67108864));
}, Ea = function Ea(e) {
  if (13 === e.tag) {
    var t = Rp(),
      n = Lp(e);
    Mp(e, n, t), kh(e, n);
  }
}, Sa = function Sa(e, t) {
  return t();
}, qi = function qi(e, t, n) {
  switch (t) {
    case "input":
      if (Si(e, n), t = n.name, "radio" === n.type && null != t) {
        for (n = e; n.parentNode;) n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var o = Sc(r);
            if (!o) throw Error(Po(90));
            bi(r), Si(r, o);
          }
        }
      }
      break;
    case "textarea":
      Bi(e, n);
      break;
    case "select":
      null != (t = n.value) && Pi(e, !!n.multiple, t, !1);
  }
}, ea = Up, ta = function ta(e, t, n, r, o) {
  var i = Xf;
  Xf |= 4;
  try {
    return fu(98, e.bind(null, t, n, r, o));
  } finally {
    0 === (Xf = i) && (hp(), hu());
  }
}, na = function na() {
  0 == (49 & Xf) && (function () {
    if (null !== Sp) {
      var e = Sp;
      Sp = null, e.forEach(function (e) {
        e.expiredLanes |= 24 & e.pendingLanes, Np(e, cu());
      });
    }
    hu();
  }(), nh());
}, ra = function ra(e, t) {
  var n = Xf;
  Xf |= 2;
  try {
    return e(t);
  } finally {
    0 === (Xf = n) && (hp(), hu());
  }
};
var Oh = {
    Events: [kc, Ec, Sc, Zi, Xi, nh, {
      current: !1
    }]
  },
  Ph = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
  },
  Th = {
    bundleType: Ph.bundleType,
    version: Ph.version,
    rendererPackageName: Ph.rendererPackageName,
    rendererConfig: Ph.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: Ho.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(e) {
      return null === (e = ba(e)) ? null : e.stateNode;
    },
    findFiberByHostInstance: Ph.findFiberByHostInstance || function () {
      return null;
    },
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
  };
if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var Ih = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Ih.isDisabled && Ih.supportsFiber) try {
    $c = Ih.inject(Th), Hc = Ih;
  } catch (Rm) {}
}
ko.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Oh, ko.createPortal = xh, ko.findDOMNode = function (e) {
  if (null == e) return null;
  if (1 === e.nodeType) return e;
  var t = e._reactInternals;
  if (void 0 === t) {
    if ("function" == typeof e.render) throw Error(Po(188));
    throw Error(Po(268, Object.keys(e)));
  }
  return e = null === (e = ba(t)) ? null : e.stateNode;
}, ko.flushSync = function (e, t) {
  var n = Xf;
  if (0 != (48 & n)) return e(t);
  Xf |= 1;
  try {
    if (e) return fu(99, e.bind(null, t));
  } finally {
    Xf = n, hu();
  }
}, ko.hydrate = function (e, t, n) {
  if (!Sh(t)) throw Error(Po(200));
  return Ch(null, e, t, !0, n);
}, ko.render = function (e, t, n) {
  if (!Sh(t)) throw Error(Po(200));
  return Ch(null, e, t, !1, n);
}, ko.unmountComponentAtNode = function (e) {
  if (!Sh(e)) throw Error(Po(40));
  return !!e._reactRootContainer && (Qp(function () {
    Ch(null, null, e, !1, function () {
      e._reactRootContainer = null, e[bc] = null;
    });
  }), !0);
}, ko.unstable_batchedUpdates = Up, ko.unstable_createPortal = function (e, t) {
  return xh(e, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
}, ko.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
  if (!Sh(n)) throw Error(Po(200));
  if (null == e || void 0 === e._reactInternals) throw Error(Po(38));
  return Ch(e, t, n, !1, r);
}, ko.version = "17.0.2", function e() {
  if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
  } catch (e) {
    console.error(e);
  }
}(), wo.exports = ko;
var Bh,
  Rh,
  Lh,
  Mh,
  Dh,
  Nh,
  zh = wo.exports;
function jh(e) {
  return jh = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, jh(e);
}
function Fh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, (o = r.key, i = void 0, i = function (e, t) {
      if ("object" !== jh(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" !== jh(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(o, "string"), "symbol" === jh(i) ? i : String(i)), r);
  }
  var o, i;
}
function Uh(e, t, n) {
  return t && Fh(e.prototype, t), n && Fh(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Qh(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $h(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Gh(e, t);
}
function Hh(e) {
  var t = qh();
  return function () {
    var n,
      r = Yh(e);
    if (t) {
      var o = Yh(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === jh(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Vh(e);
    }(this, n);
  };
}
function Vh(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wh(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return Wh = function Wh(e) {
    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
    var n;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }
    function r() {
      return Kh(e, arguments, Yh(this).constructor);
    }
    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Gh(r, e);
  }, Wh(e);
}
function Kh(e, t, n) {
  return Kh = qh() ? Reflect.construct.bind() : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var o = new (Function.bind.apply(e, r))();
    return n && Gh(o, n.prototype), o;
  }, Kh.apply(null, arguments);
}
function qh() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function Gh(e, t) {
  return Gh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, Gh(e, t);
}
function Yh(e) {
  return Yh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Yh(e);
}
!function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.oauth = "oauth", e.otp = "otp", e.crypto = "crypto", e.passwords = "passwords", e.passkeys = "passkeys";
}(Bh || (Bh = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft", e.Apple = "apple", e.Github = "github", e.GitLab = "gitlab", e.Facebook = "facebook", e.Discord = "discord", e.Salesforce = "salesforce", e.Slack = "slack", e.Amazon = "amazon", e.Bitbucket = "bitbucket", e.LinkedIn = "linkedin", e.Coinbase = "coinbase", e.Twitch = "twitch", e.Twitter = "twitter", e.TikTok = "tiktok", e.Snapchat = "snapchat", e.Figma = "figma", e.Yahoo = "yahoo";
}(Rh || (Rh = {})), function (e) {
  e.Vessel = "Vessel", e.Phantom = "Phantom", e.Metamask = "Metamask", e.Coinbase = "Coinbase", e.Binance = "Binance", e.GenericEthereumWallet = "Other Ethereum Wallet", e.GenericSolanaWallet = "Other Solana Wallet";
}(Lh || (Lh = {})), function (e) {
  e.embedded = "embedded", e.floating = "floating";
}(Mh || (Mh = {})), function (e) {
  e.SMS = "sms", e.WhatsApp = "whatsapp", e.Email = "email";
}(Dh || (Dh = {})), function (e) {
  e.MagicLinkLoginOrCreateEvent = "MAGIC_LINK_LOGIN_OR_CREATE", e.OTPsLoginOrCreateEvent = "OTP_LOGIN_OR_CREATE", e.OTPsAuthenticate = "OTP_AUTHENTICATE", e.CryptoWalletAuthenticateStart = "CRYPTO_WALLET_AUTHENTICATE_START", e.CryptoWalletAuthenticate = "CRYPTO_WALLET_AUTHENTICATE", e.PasswordCreate = "PASSWORD_CREATE", e.PasswordAuthenticate = "PASSWORD_AUTHENTICATE", e.PasswordResetByEmailStart = "PASSWORD_RESET_BY_EMAIL_START", e.PasswordResetByEmail = "PASSWORD_RESET_BY_EMAIL", e.PasskeyRegister = "PASSKEY_REGISTER", e.PasskeyAuthenticate = "PASSKEY_AUTHENTICATE", e.PasskeySkip = "PASSKEY_SKIP", e.PasskeyDone = "PASSKEY_DONE", e.B2BMagicLinkEmailLoginOrSignup = "B2B_MAGIC_LINK_EMAIL_LOGIN_OR_SIGNUP", e.B2BMagicLinkAuthenticate = "B2B_MAGIC_LINK_AUTHENTICATE", e.B2BMagicLinkEmailDiscoverySend = "B2B_MAGIC_LINK_EMAIL_DISCOVERY_SEND", e.B2BMagicLinkDiscoveryAuthenticate = "B2B_MAGIC_LINK_DISCOVERY_AUTHENTICATE", e.B2BSSOStart = "B2B_SSO_START", e.B2BSSOAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthDiscoveryAuthenticate = "B2B_OAUTH_DISCOVERY_AUTHENTICATE", e.B2BDiscoveryOrganizationsCreate = "B2B_DISCOVERY_ORGANIZATIONS_CREATE", e.B2BDiscoveryIntermediateSessionExchange = "B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE", e.B2BPasswordAuthenticate = "B2B_PASSWORD_AUTHENTICATE", e.B2BPasswordResetByEmailStart = "B2B_PASSWORD_RESET_BY_EMAIL_START", e.B2BPasswordResetByEmail = "B2B_PASSWORD_RESET_BY_EMAIL", e.B2BPasswordResetBySession = "B2B_PASSWORD_RESET_BY_SESSION";
}(Nh || (Nh = {}));
var Jh,
  Zh,
  Xh,
  em,
  tm = function (e) {
    $h(n, Wh(Error));
    var t = Hh(n);
    function n(e, r) {
      var o;
      return Qh(this, n), (o = t.call(this, e + "\n" + r)).message = e + "\n" + r, o.name = "SDKAPIUnreachableError", o.details = r, Object.setPrototypeOf(Vh(o), n.prototype), o;
    }
    return Uh(n);
  }(),
  nm = function (e) {
    $h(n, Wh(Error));
    var t = Hh(n);
    function n(e, r) {
      var o;
      return Qh(this, n), (o = t.call(this)).name = "StytchSDKUsageError", o.message = "Invalid call to ".concat(e, "\n") + r, o;
    }
    return Uh(n);
  }(),
  rm = function (e) {
    $h(n, Wh(Error));
    var t = Hh(n);
    function n(e) {
      var r, o;
      Qh(this, n), (r = t.call(this)).name = "StytchSDKSchemaError";
      var i = null === (o = e.body) || void 0 === o ? void 0 : o.map(function (e) {
        return "".concat(e.dataPath, ": ").concat(e.message);
      }).join("\n");
      return r.message = "[400] Request does not match expected schema\n".concat(i), r;
    }
    return Uh(n);
  }(),
  om = function (e) {
    $h(n, Wh(Error));
    var t = Hh(n);
    function n(e) {
      var r;
      Qh(this, n), (r = t.call(this)).name = "StytchSDKAPIError";
      var o = e.status_code,
        i = e.error_type,
        a = e.error_message,
        s = e.error_url,
        l = e.request_id;
      return r.error_type = i, r.error_message = a, r.error_url = s, r.request_id = l, r.status_code = o, r.message = "[".concat(o, "] ").concat(i, "\n") + "".concat(a, "\n") + "See ".concat(s, " for more information.\n") + (l ? "request_id: ".concat(l, "\n") : ""), r;
    }
    return Uh(n);
  }(),
  im = function (e) {
    $h(n, Wh(Error));
    var t = Hh(n);
    function n(e) {
      var r;
      return Qh(this, n), (r = t.call(this)).name = "StytchSDKNativeError", r.error_type = e, r.message = "".concat(e), r;
    }
    return Uh(n);
  }(),
  am = ["unauthorized_credentials", "user_unauthenticated", "invalid_secret_authentication", "session_not_found"];
!function (e) {
  e.BiometricsSensorError = "biometrics_sensor_error", e.DeviceCredentialsNotAllowed = "device_credentials_not_allowed", e.DeviceHardwareError = "device_hardware_error", e.InternalError = "internal_error", e.KeyInvalidated = "key_invalidated", e.KeystoreUnavailable = "keystore_unavailable", e.NoBiometricsEnrolled = "no_biometrics_enrolled", e.NoBiometricsRegistration = "no_biometrics_registration", e.SessionExpired = "session_expired", e.UserCancellation = "user_cancellation", e.UserLockedOut = "user_locked_out", e.BiometricsNotAvailable = "biometrics_not_available";
}(Jh || (Jh = {})), function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.sso = "sso", e.passwords = "passwords", e.oauth = "oauth";
}(Zh || (Zh = {})), function (e) {
  e.Discovery = "Discovery", e.Organization = "Organization", e.PasswordReset = "PasswordReset";
}(Xh || (Xh = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft";
}(em || (em = {}));
var sm = "<div data-prompt_parent_id='g_id_onload' id='google-parent-prompt' style=''></div>";
var lm = function lm(e, t) {
  switch (t.type) {
    case "transition":
      return Object.assign(Object.assign({}, e), {
        screen: t.screen
      });
    case "set_magic_link_email":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          magicLinkState: {
            email: t.email
          }
        })
      });
    case "set_organization":
      return Object.assign(Object.assign({}, e), {
        flowState: {
          type: Xh.Organization,
          organization: t.organization
        }
      });
    case "set_discovery_state":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          discoveryState: {
            email: t.email,
            discoveredOrganizations: t.discoveredOrganizations,
            intermediateSessionToken: t.intermediateSessionToken
          }
        })
      });
    case "set_password_state":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          passwordState: {
            email: t.email
          }
        })
      });
    default:
      throw new Error();
  }
};
var cm;
!function (e) {
  e.Main = "Main", e.EmailConfirmation = "Email Confirmation", e.LoggedIn = "Logged In", e.Discovery = "Discovery", e.ErrorOrganization = "Error Organization Not Found", e.Error = "Error", e.PasswordEmailForm = "Password Email", e.PasswordAuthenticate = "Password Authenticate", e.PasswordResetForm = "Password Reset Form", e.PasswordResetVerifyConfirmation = "Password Reset Verify Confirmation", e.PasswordForgotForm = "Password Forgot Form", e.PasswordSetNewConfirmation = "Password Set New Confirmation";
}(cm || (cm = {}));
var um = {
    screen: cm.Main,
    formState: {
      magicLinkState: {
        email: ""
      },
      discoveryState: {
        email: "",
        intermediateSessionToken: "",
        discoveredOrganizations: []
      },
      passwordState: {
        email: ""
      }
    },
    flowState: {
      type: Xh.Organization,
      organization: null
    }
  },
  dm = {
    products: [Zh.emailMagicLinks],
    authFlowType: Xh.Organization,
    sessionOptions: {
      sessionDurationMinutes: 60
    }
  },
  fm = Mt.createContext({
    client: {},
    config: dm,
    state: [um, function () {
      return null;
    }]
  }),
  pm = function pm(_ref5) {
    var e = _ref5.children,
      t = _ref5.client,
      n = _ref5.config,
      r = _ref5.callbacks,
      o = _ref5.initialState;
    var i = Mt.useReducer(lm, null != o ? o : um);
    return Mt.createElement(fm.Provider, {
      value: {
        client: t,
        state: i,
        config: n,
        callbacks: r
      }
    }, e);
  },
  hm = function hm() {
    return Xe.exports.useContext(fm);
  },
  mm = function mm() {
    return hm().client;
  },
  gm = function gm() {
    return hm().state;
  },
  vm = function vm() {
    return hm().config;
  },
  ym = function ym() {
    var e, t;
    return null !== (t = null === (e = hm().callbacks) || void 0 === e ? void 0 : e.onError) && void 0 !== t ? t : function () {};
  },
  Am = function Am() {
    var e, t;
    return null !== (t = null === (e = hm().callbacks) || void 0 === e ? void 0 : e.onEvent) && void 0 !== t ? t : function () {};
  };
var bm = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  _m = {
    exports: {}
  };
!function (e, t) {
  var n = "__lodash_hash_undefined__",
    r = 9007199254740991,
    o = "[object Arguments]",
    i = "[object AsyncFunction]",
    a = "[object Function]",
    s = "[object GeneratorFunction]",
    l = "[object Null]",
    c = "[object Object]",
    u = "[object Proxy]",
    d = "[object Undefined]",
    f = /^\[object .+?Constructor\]$/,
    p = /^(?:0|[1-9]\d*)$/,
    h = {};
  h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = !0, h[o] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h[a] = h["[object Map]"] = h["[object Number]"] = h[c] = h["[object RegExp]"] = h["[object Set]"] = h["[object String]"] = h["[object WeakMap]"] = !1;
  var m = "object" == _typeof(bm) && bm && bm.Object === Object && bm,
    g = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
    v = m || g || Function("return this")(),
    y = t && !t.nodeType && t,
    A = y && e && !e.nodeType && e,
    b = A && A.exports === y,
    _ = b && m.process,
    w = function () {
      try {
        var e = A && A.require && A.require("util").types;
        return e || _ && _.binding && _.binding("util");
      } catch (e) {}
    }(),
    k = w && w.isTypedArray;
  var E,
    S,
    C,
    x = Array.prototype,
    O = Function.prototype,
    P = Object.prototype,
    T = v["__core-js_shared__"],
    I = O.toString,
    B = P.hasOwnProperty,
    R = (E = /[^.]+$/.exec(T && T.keys && T.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "",
    L = P.toString,
    M = I.call(Object),
    D = RegExp("^" + I.call(B).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
    N = b ? v.Buffer : void 0,
    z = v.Symbol,
    j = v.Uint8Array,
    F = N ? N.allocUnsafe : void 0,
    U = (S = Object.getPrototypeOf, C = Object, function (e) {
      return S(C(e));
    }),
    Q = Object.create,
    $ = P.propertyIsEnumerable,
    H = x.splice,
    V = z ? z.toStringTag : void 0,
    W = function () {
      try {
        var e = ye(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }(),
    K = N ? N.isBuffer : void 0,
    q = Math.max,
    G = Date.now,
    Y = ye(v, "Map"),
    J = ye(Object, "create"),
    Z = function () {
      function e() {}
      return function (t) {
        if (!Te(t)) return {};
        if (Q) return Q(t);
        e.prototype = t;
        var n = new e();
        return e.prototype = void 0, n;
      };
    }();
  function X(e) {
    var t = -1,
      n = null == e ? 0 : e.length;
    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }
  function ee(e) {
    var t = -1,
      n = null == e ? 0 : e.length;
    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }
  function te(e) {
    var t = -1,
      n = null == e ? 0 : e.length;
    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }
  function ne(e) {
    var t = this.__data__ = new ee(e);
    this.size = t.size;
  }
  function re(e, t) {
    var n = Se(e),
      r = !n && Ee(e),
      o = !n && !r && xe(e),
      i = !n && !r && !o && Be(e),
      a = n || r || o || i,
      s = a ? function (e, t) {
        for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
        return r;
      }(e.length, String) : [],
      l = s.length;
    for (var c in e) !t && !B.call(e, c) || a && ("length" == c || o && ("offset" == c || "parent" == c) || i && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || Ae(c, l)) || s.push(c);
    return s;
  }
  function oe(e, t, n) {
    (void 0 !== n && !ke(e[t], n) || void 0 === n && !(t in e)) && se(e, t, n);
  }
  function ie(e, t, n) {
    var r = e[t];
    B.call(e, t) && ke(r, n) && (void 0 !== n || t in e) || se(e, t, n);
  }
  function ae(e, t) {
    for (var n = e.length; n--;) if (ke(e[n][0], t)) return n;
    return -1;
  }
  function se(e, t, n) {
    "__proto__" == t && W ? W(e, t, {
      configurable: !0,
      enumerable: !0,
      value: n,
      writable: !0
    }) : e[t] = n;
  }
  X.prototype.clear = function () {
    this.__data__ = J ? J(null) : {}, this.size = 0;
  }, X.prototype["delete"] = function (e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }, X.prototype.get = function (e) {
    var t = this.__data__;
    if (J) {
      var r = t[e];
      return r === n ? void 0 : r;
    }
    return B.call(t, e) ? t[e] : void 0;
  }, X.prototype.has = function (e) {
    var t = this.__data__;
    return J ? void 0 !== t[e] : B.call(t, e);
  }, X.prototype.set = function (e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = J && void 0 === t ? n : t, this;
  }, ee.prototype.clear = function () {
    this.__data__ = [], this.size = 0;
  }, ee.prototype["delete"] = function (e) {
    var t = this.__data__,
      n = ae(t, e);
    return !(n < 0) && (n == t.length - 1 ? t.pop() : H.call(t, n, 1), --this.size, !0);
  }, ee.prototype.get = function (e) {
    var t = this.__data__,
      n = ae(t, e);
    return n < 0 ? void 0 : t[n][1];
  }, ee.prototype.has = function (e) {
    return ae(this.__data__, e) > -1;
  }, ee.prototype.set = function (e, t) {
    var n = this.__data__,
      r = ae(n, e);
    return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
  }, te.prototype.clear = function () {
    this.size = 0, this.__data__ = {
      hash: new X(),
      map: new (Y || ee)(),
      string: new X()
    };
  }, te.prototype["delete"] = function (e) {
    var t = ve(this, e)["delete"](e);
    return this.size -= t ? 1 : 0, t;
  }, te.prototype.get = function (e) {
    return ve(this, e).get(e);
  }, te.prototype.has = function (e) {
    return ve(this, e).has(e);
  }, te.prototype.set = function (e, t) {
    var n = ve(this, e),
      r = n.size;
    return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
  }, ne.prototype.clear = function () {
    this.__data__ = new ee(), this.size = 0;
  }, ne.prototype["delete"] = function (e) {
    var t = this.__data__,
      n = t["delete"](e);
    return this.size = t.size, n;
  }, ne.prototype.get = function (e) {
    return this.__data__.get(e);
  }, ne.prototype.has = function (e) {
    return this.__data__.has(e);
  }, ne.prototype.set = function (e, t) {
    var n = this.__data__;
    if (n instanceof ee) {
      var r = n.__data__;
      if (!Y || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
      n = this.__data__ = new te(r);
    }
    return n.set(e, t), this.size = n.size, this;
  };
  var le,
    ce = function ce(e, t, n) {
      for (var r = -1, o = Object(e), i = n(e), a = i.length; a--;) {
        var s = i[le ? a : ++r];
        if (!1 === t(o[s], s, o)) break;
      }
      return e;
    };
  function ue(e) {
    return null == e ? void 0 === e ? d : l : V && V in Object(e) ? function (e) {
      var t = B.call(e, V),
        n = e[V];
      try {
        e[V] = void 0;
        var r = !0;
      } catch (e) {}
      var o = L.call(e);
      r && (t ? e[V] = n : delete e[V]);
      return o;
    }(e) : function (e) {
      return L.call(e);
    }(e);
  }
  function de(e) {
    return Ie(e) && ue(e) == o;
  }
  function fe(e) {
    return !(!Te(e) || function (e) {
      return !!R && R in e;
    }(e)) && (Oe(e) ? D : f).test(function (e) {
      if (null != e) {
        try {
          return I.call(e);
        } catch (e) {}
        try {
          return e + "";
        } catch (e) {}
      }
      return "";
    }(e));
  }
  function pe(e) {
    if (!Te(e)) return function (e) {
      var t = [];
      if (null != e) for (var n in Object(e)) t.push(n);
      return t;
    }(e);
    var t = be(e),
      n = [];
    for (var r in e) ("constructor" != r || !t && B.call(e, r)) && n.push(r);
    return n;
  }
  function he(e, t, n, r, o) {
    e !== t && ce(t, function (i, a) {
      if (o || (o = new ne()), Te(i)) !function (e, t, n, r, o, i, a) {
        var s = _e(e, n),
          l = _e(t, n),
          u = a.get(l);
        if (u) return void oe(e, n, u);
        var d = i ? i(s, l, n + "", e, t, a) : void 0,
          f = void 0 === d;
        if (f) {
          var p = Se(l),
            h = !p && xe(l),
            m = !p && !h && Be(l);
          d = l, p || h || m ? Se(s) ? d = s : Ie(b = s) && Ce(b) ? d = function (e, t) {
            var n = -1,
              r = e.length;
            t || (t = Array(r));
            for (; ++n < r;) t[n] = e[n];
            return t;
          }(s) : h ? (f = !1, d = function (e, t) {
            if (t) return e.slice();
            var n = e.length,
              r = F ? F(n) : new e.constructor(n);
            return e.copy(r), r;
          }(l, !0)) : m ? (f = !1, g = l, v = !0 ? (y = g.buffer, A = new y.constructor(y.byteLength), new j(A).set(new j(y)), A) : g.buffer, d = new g.constructor(v, g.byteOffset, g.length)) : d = [] : function (e) {
            if (!Ie(e) || ue(e) != c) return !1;
            var t = U(e);
            if (null === t) return !0;
            var n = B.call(t, "constructor") && t.constructor;
            return "function" == typeof n && n instanceof n && I.call(n) == M;
          }(l) || Ee(l) ? (d = s, Ee(s) ? d = function (e) {
            return function (e, t, n, r) {
              var o = !n;
              n || (n = {});
              var i = -1,
                a = t.length;
              for (; ++i < a;) {
                var s = t[i],
                  l = r ? r(n[s], e[s], s, n, e) : void 0;
                void 0 === l && (l = e[s]), o ? se(n, s, l) : ie(n, s, l);
              }
              return n;
            }(e, Re(e));
          }(s) : Te(s) && !Oe(s) || (d = function (e) {
            return "function" != typeof e.constructor || be(e) ? {} : Z(U(e));
          }(l))) : f = !1;
        }
        var g, v, y, A;
        var b;
        f && (a.set(l, d), o(d, l, r, i, a), a["delete"](l));
        oe(e, n, d);
      }(e, t, a, n, he, r, o);else {
        var s = r ? r(_e(e, a), i, a + "", e, t, o) : void 0;
        void 0 === s && (s = i), oe(e, a, s);
      }
    }, Re);
  }
  function me(e, t) {
    return we(function (e, t, n) {
      return t = q(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var r = arguments, o = -1, i = q(r.length - t, 0), a = Array(i); ++o < i;) a[o] = r[t + o];
        o = -1;
        for (var s = Array(t + 1); ++o < t;) s[o] = r[o];
        return s[t] = n(a), function (e, t, n) {
          switch (n.length) {
            case 0:
              return e.call(t);
            case 1:
              return e.call(t, n[0]);
            case 2:
              return e.call(t, n[0], n[1]);
            case 3:
              return e.call(t, n[0], n[1], n[2]);
          }
          return e.apply(t, n);
        }(e, this, s);
      };
    }(e, t, De), e + "");
  }
  var ge = W ? function (e, t) {
    return W(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: (n = t, function () {
        return n;
      }),
      writable: !0
    });
    var n;
  } : De;
  function ve(e, t) {
    var n,
      r,
      o = e.__data__;
    return ("string" == (r = _typeof(n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? o["string" == typeof t ? "string" : "hash"] : o.map;
  }
  function ye(e, t) {
    var n = function (e, t) {
      return null == e ? void 0 : e[t];
    }(e, t);
    return fe(n) ? n : void 0;
  }
  function Ae(e, t) {
    var n = _typeof(e);
    return !!(t = null == t ? r : t) && ("number" == n || "symbol" != n && p.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }
  function be(e) {
    var t = e && e.constructor;
    return e === ("function" == typeof t && t.prototype || P);
  }
  function _e(e, t) {
    if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
  }
  var we = function (e) {
    var t = 0,
      n = 0;
    return function () {
      var r = G(),
        o = 16 - (r - n);
      if (n = r, o > 0) {
        if (++t >= 800) return arguments[0];
      } else t = 0;
      return e.apply(void 0, arguments);
    };
  }(ge);
  function ke(e, t) {
    return e === t || e != e && t != t;
  }
  var Ee = de(function () {
      return arguments;
    }()) ? de : function (e) {
      return Ie(e) && B.call(e, "callee") && !$.call(e, "callee");
    },
    Se = Array.isArray;
  function Ce(e) {
    return null != e && Pe(e.length) && !Oe(e);
  }
  var xe = K || function () {
    return !1;
  };
  function Oe(e) {
    if (!Te(e)) return !1;
    var t = ue(e);
    return t == a || t == s || t == i || t == u;
  }
  function Pe(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= r;
  }
  function Te(e) {
    var t = _typeof(e);
    return null != e && ("object" == t || "function" == t);
  }
  function Ie(e) {
    return null != e && "object" == _typeof(e);
  }
  var Be = k ? function (e) {
    return function (t) {
      return e(t);
    };
  }(k) : function (e) {
    return Ie(e) && Pe(e.length) && !!h[ue(e)];
  };
  function Re(e) {
    return Ce(e) ? re(e, !0) : pe(e);
  }
  var Le,
    Me = (Le = function Le(e, t, n) {
      he(e, t, n);
    }, me(function (e, t) {
      var n = -1,
        r = t.length,
        o = r > 1 ? t[r - 1] : void 0,
        i = r > 2 ? t[2] : void 0;
      for (o = Le.length > 3 && "function" == typeof o ? (r--, o) : void 0, i && function (e, t, n) {
        if (!Te(n)) return !1;
        var r = _typeof(t);
        return !!("number" == r ? Ce(n) && Ae(t, n.length) : "string" == r && (t in n)) && ke(n[t], e);
      }(t[0], t[1], i) && (o = r < 3 ? void 0 : o, r = 1), e = Object(e); ++n < r;) {
        var a = t[n];
        a && Le(e, a, n, o);
      }
      return e;
    }));
  function De(e) {
    return e;
  }
  e.exports = Me;
}(_m, _m.exports);
var wm,
  km = _m.exports;
!function (e) {
  e.Main = "Main", e.PasskeyRegistrationStart = "Register New Passkey", e.PasskeyRegistrationSuccess = "Passkey Registration Success", e.PasskeyConfirmation = "Passkey Confirmation", e.PasswordCreateOrLogin = "Password", e.PasswordResetForm = "Password Reset Form", e.PasswordForgot = "Password Forgot", e.PasswordBreached = "Password Breached", e.PasswordSetNew = "Password Set New", e.PasswordDedupe = "Password Dedupe", e.PasswordConfirmation = "Password Confirmation", e.EmailConfirmation = "Email Confirmation", e.OTPAuthenticate = "OTP Authenticate", e.OTPConfirmation = "OTP Confirmation", e.CryptoConnect = "Crypto Connect", e.CryptoSignMessage = "Crypto Sign Message", e.CryptoOtherScreen = "Crypto Other Screen", e.CryptoSetupWallet = "Crypto Setup Wallet", e.CryptoError = "Crypto Error", e.CryptoConfirmation = "Crypto Confirmation";
}(wm || (wm = {}));
var Em = {
    screen: wm.Main,
    formState: {
      magicLinkState: {
        email: ""
      },
      otpState: {
        type: Dh.Email,
        methodId: "",
        otpDestination: ""
      },
      cryptoState: {
        walletAddress: "",
        walletOption: Lh.Metamask,
        walletChallenge: ""
      },
      passwordState: {
        email: "",
        type: "new"
      },
      resetPasswordState: {
        token: ""
      },
      errorMessage: ""
    }
  },
  Sm = {
    products: [Bh.emailMagicLinks],
    emailMagicLinksOptions: {
      loginRedirectURL: "",
      loginExpirationMinutes: 30,
      signupRedirectURL: "",
      signupExpirationMinutes: 30,
      createUserAsPending: !1
    }
  },
  Cm = {
    container: {
      backgroundColor: "#FFFFFF",
      borderColor: "#ADBCC5",
      borderRadius: "8px",
      width: "400px"
    },
    colors: {
      primary: "#19303D",
      secondary: "#5C727D",
      success: "#0C5A56",
      error: "#8B1214"
    },
    buttons: {
      primary: {
        backgroundColor: "#19303D",
        textColor: "#FFFFFF",
        borderColor: "#19303D",
        borderRadius: "4px"
      },
      secondary: {
        backgroundColor: "#FFFFFF",
        textColor: "#19303D",
        borderColor: "#19303D",
        borderRadius: "4px"
      }
    },
    fontFamily: "Arial, Helvetica, sans-serif",
    hideHeaderText: !1,
    logo: {
      logoImageUrl: ""
    }
  };
Mt.createContext({
  client: {},
  config: Sm,
  state: [Em, function () {
    return null;
  }]
});
var xm,
  Om,
  Pm,
  Tm = {
    data: ""
  },
  Im = function Im(e) {
    return "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), {
      innerHTML: " ",
      id: "_goober"
    })).firstChild : e || Tm;
  },
  Bm = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,
  Rm = /\/\*[^]*?\*\/|  +/g,
  Lm = /\n+/g,
  Mm = function Mm(e, t) {
    var n = "",
      r = "",
      o = "";
    var _loop = function _loop(_i2) {
      var a = e[_i2];
      "@" == _i2[0] ? "i" == _i2[1] ? n = _i2 + " " + a + ";" : r += "f" == _i2[1] ? Mm(a, _i2) : _i2 + "{" + Mm(a, "k" == _i2[1] ? "" : t) + "}" : "object" == _typeof(a) ? r += Mm(a, t ? t.replace(/([^,])+/g, function (e) {
        return _i2.replace(/(^:.*)|([^,])+/g, function (t) {
          return /&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t;
        });
      }) : _i2) : null != a && (_i2 = /^--/.test(_i2) ? _i2 : _i2.replace(/[A-Z]/g, "-$&").toLowerCase(), o += Mm.p ? Mm.p(_i2, a) : _i2 + ":" + a + ";");
    };
    for (var _i2 in e) {
      _loop(_i2);
    }
    return n + (t && o ? t + "{" + o + "}" : o) + r;
  },
  Dm = {},
  Nm = function Nm(e) {
    if ("object" == _typeof(e)) {
      var t = "";
      for (var _n3 in e) t += _n3 + Nm(e[_n3]);
      return t;
    }
    return e;
  },
  zm = function zm(e, t, n, r, o) {
    var i = Nm(e),
      a = Dm[i] || (Dm[i] = function (e) {
        var t = 0,
          n = 11;
        for (; t < e.length;) n = 101 * n + e.charCodeAt(t++) >>> 0;
        return "go" + n;
      }(i));
    if (!Dm[a]) {
      var _t4 = i !== e ? e : function (e) {
        var t,
          n,
          r = [{}];
        for (; t = Bm.exec(e.replace(Rm, ""));) t[4] ? r.shift() : t[3] ? (n = t[3].replace(Lm, " ").trim(), r.unshift(r[0][n] = r[0][n] || {})) : r[0][t[1]] = t[2].replace(Lm, " ").trim();
        return r[0];
      }(e);
      Dm[a] = Mm(o ? _defineProperty({}, "@keyframes " + a, _t4) : _t4, n ? "" : "." + a);
    }
    var s = n && Dm.g ? Dm.g : null;
    return n && (Dm.g = Dm[a]), function (e, t, n, r) {
      r ? t.data = t.data.replace(r, e) : -1 === t.data.indexOf(e) && (t.data = n ? e + t.data : t.data + e);
    }(Dm[a], t, r, s), a;
  },
  jm = function jm(e, t, n) {
    return e.reduce(function (e, r, o) {
      var i = t[o];
      if (i && i.call) {
        var _e4 = i(n),
          _t5 = _e4 && _e4.props && _e4.props.className || /^go/.test(_e4) && _e4;
        i = _t5 ? "." + _t5 : _e4 && "object" == _typeof(_e4) ? _e4.props ? "" : Mm(_e4, "") : !1 === _e4 ? "" : _e4;
      }
      return e + r + (null == i ? "" : i);
    }, "");
  };
function Fm(e) {
  var t = this || {},
    n = e.call ? e(t.p) : e;
  return zm(n.unshift ? n.raw ? jm(n, [].slice.call(arguments, 1), t.p) : n.reduce(function (e, n) {
    return Object.assign(e, n && n.call ? n(t.p) : n);
  }, {}) : n, Im(t.target), t.g, t.o, t.k);
}
Fm.bind({
  g: 1
});
var Um = Fm.bind({
  k: 1
});
function Qm(e, t) {
  var n = this || {};
  return function () {
    var r = arguments;
    function o(i, a) {
      var s = Object.assign({}, i),
        l = s.className || o.className;
      n.p = Object.assign({
        theme: Om && Om()
      }, s), n.o = / *go\d+/.test(l), s.className = Fm.apply(n, r) + (l ? " " + l : ""), t && (s.ref = a);
      var c = e;
      return e[0] && (c = s.as || e, delete s.as), Pm && c[0] && Pm(s), xm(c, s);
    }
    return t ? t(o) : o;
  };
}
function $m() {
  return $m = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $m.apply(this, arguments);
}
function Hm(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}
var Vm,
  Wm = function Wm(e, t) {
    return function (e) {
      return "function" == typeof e;
    }(e) ? e(t) : e;
  },
  Km = function () {
    var e = 0;
    return function () {
      return (++e).toString();
    };
  }(),
  qm = function () {
    var e = void 0;
    return function () {
      if (void 0 === e && "undefined" != typeof window) {
        var t = matchMedia("(prefers-reduced-motion: reduce)");
        e = !t || t.matches;
      }
      return e;
    };
  }();
!function (e) {
  e[e.ADD_TOAST = 0] = "ADD_TOAST", e[e.UPDATE_TOAST = 1] = "UPDATE_TOAST", e[e.UPSERT_TOAST = 2] = "UPSERT_TOAST", e[e.DISMISS_TOAST = 3] = "DISMISS_TOAST", e[e.REMOVE_TOAST = 4] = "REMOVE_TOAST", e[e.START_PAUSE = 5] = "START_PAUSE", e[e.END_PAUSE = 6] = "END_PAUSE";
}(Vm || (Vm = {}));
var Gm = new Map(),
  Ym = function Ym(e) {
    if (!Gm.has(e)) {
      var t = setTimeout(function () {
        Gm["delete"](e), eg({
          type: Vm.REMOVE_TOAST,
          toastId: e
        });
      }, 1e3);
      Gm.set(e, t);
    }
  },
  Jm = function e(t, n) {
    switch (n.type) {
      case Vm.ADD_TOAST:
        return $m({}, t, {
          toasts: [n.toast].concat(t.toasts).slice(0, 20)
        });
      case Vm.UPDATE_TOAST:
        return n.toast.id && function (e) {
          var t = Gm.get(e);
          t && clearTimeout(t);
        }(n.toast.id), $m({}, t, {
          toasts: t.toasts.map(function (e) {
            return e.id === n.toast.id ? $m({}, e, n.toast) : e;
          })
        });
      case Vm.UPSERT_TOAST:
        var r = n.toast;
        return t.toasts.find(function (e) {
          return e.id === r.id;
        }) ? e(t, {
          type: Vm.UPDATE_TOAST,
          toast: r
        }) : e(t, {
          type: Vm.ADD_TOAST,
          toast: r
        });
      case Vm.DISMISS_TOAST:
        var o = n.toastId;
        return o ? Ym(o) : t.toasts.forEach(function (e) {
          Ym(e.id);
        }), $m({}, t, {
          toasts: t.toasts.map(function (e) {
            return e.id === o || void 0 === o ? $m({}, e, {
              visible: !1
            }) : e;
          })
        });
      case Vm.REMOVE_TOAST:
        return void 0 === n.toastId ? $m({}, t, {
          toasts: []
        }) : $m({}, t, {
          toasts: t.toasts.filter(function (e) {
            return e.id !== n.toastId;
          })
        });
      case Vm.START_PAUSE:
        return $m({}, t, {
          pausedAt: n.time
        });
      case Vm.END_PAUSE:
        var i = n.time - (t.pausedAt || 0);
        return $m({}, t, {
          pausedAt: void 0,
          toasts: t.toasts.map(function (e) {
            return $m({}, e, {
              pauseDuration: e.pauseDuration + i
            });
          })
        });
    }
  },
  Zm = [],
  Xm = {
    toasts: [],
    pausedAt: void 0
  },
  eg = function eg(e) {
    Xm = Jm(Xm, e), Zm.forEach(function (e) {
      e(Xm);
    });
  },
  tg = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
  },
  ng = function ng(e) {
    return function (t, n) {
      var r = function (e, t, n) {
        return void 0 === t && (t = "blank"), $m({
          createdAt: Date.now(),
          visible: !0,
          type: t,
          ariaProps: {
            role: "status",
            "aria-live": "polite"
          },
          message: e,
          pauseDuration: 0
        }, n, {
          id: (null == n ? void 0 : n.id) || Km()
        });
      }(t, e, n);
      return eg({
        type: Vm.UPSERT_TOAST,
        toast: r
      }), r.id;
    };
  },
  rg = function rg(e, t) {
    return ng("blank")(e, t);
  };
rg.error = ng("error"), rg.success = ng("success"), rg.loading = ng("loading"), rg.custom = ng("custom"), rg.dismiss = function (e) {
  eg({
    type: Vm.DISMISS_TOAST,
    toastId: e
  });
}, rg.remove = function (e) {
  return eg({
    type: Vm.REMOVE_TOAST,
    toastId: e
  });
}, rg.promise = function (e, t, n) {
  var r = rg.loading(t.loading, $m({}, n, null == n ? void 0 : n.loading));
  return e.then(function (e) {
    return rg.success(Wm(t.success, e), $m({
      id: r
    }, n, null == n ? void 0 : n.success)), e;
  })["catch"](function (e) {
    rg.error(Wm(t.error, e), $m({
      id: r
    }, n, null == n ? void 0 : n.error));
  }), e;
};
var og = function og(e) {
  var t = function (e) {
      void 0 === e && (e = {});
      var t = Xe.exports.useState(Xm),
        n = t[0],
        r = t[1];
      Xe.exports.useEffect(function () {
        return Zm.push(r), function () {
          var e = Zm.indexOf(r);
          e > -1 && Zm.splice(e, 1);
        };
      }, [n]);
      var o = n.toasts.map(function (t) {
        var n, r, o;
        return $m({}, e, e[t.type], t, {
          duration: t.duration || (null == (n = e[t.type]) ? void 0 : n.duration) || (null == (r = e) ? void 0 : r.duration) || tg[t.type],
          style: $m({}, e.style, null == (o = e[t.type]) ? void 0 : o.style, t.style)
        });
      });
      return $m({}, n, {
        toasts: o
      });
    }(e),
    n = t.toasts,
    r = t.pausedAt;
  Xe.exports.useEffect(function () {
    if (!r) {
      var e = Date.now(),
        t = n.map(function (t) {
          if (t.duration !== 1 / 0) {
            var n = (t.duration || 0) + t.pauseDuration - (e - t.createdAt);
            if (!(n < 0)) return setTimeout(function () {
              return rg.dismiss(t.id);
            }, n);
            t.visible && rg.dismiss(t.id);
          }
        });
      return function () {
        t.forEach(function (e) {
          return e && clearTimeout(e);
        });
      };
    }
  }, [n, r]);
  var o = Xe.exports.useMemo(function () {
    return {
      startPause: function startPause() {
        eg({
          type: Vm.START_PAUSE,
          time: Date.now()
        });
      },
      endPause: function endPause() {
        r && eg({
          type: Vm.END_PAUSE,
          time: Date.now()
        });
      },
      updateHeight: function updateHeight(e, t) {
        return eg({
          type: Vm.UPDATE_TOAST,
          toast: {
            id: e,
            height: t
          }
        });
      },
      calculateOffset: function calculateOffset(e, t) {
        var r,
          o = t || {},
          i = o.reverseOrder,
          a = void 0 !== i && i,
          s = o.gutter,
          l = void 0 === s ? 8 : s,
          c = o.defaultPosition,
          u = n.filter(function (t) {
            return (t.position || c) === (e.position || c) && t.height;
          }),
          d = u.findIndex(function (t) {
            return t.id === e.id;
          }),
          f = u.filter(function (e, t) {
            return t < d && e.visible;
          }).length,
          p = (r = u.filter(function (e) {
            return e.visible;
          })).slice.apply(r, a ? [f + 1] : [0, f]).reduce(function (e, t) {
            return e + (t.height || 0) + l;
          }, 0);
        return p;
      }
    };
  }, [n, r]);
  return {
    toasts: n,
    handlers: o
  };
};
function ig() {
  var e = Hm(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ", ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"]);
  return ig = function ig() {
    return e;
  }, e;
}
function ag() {
  var e = Hm(["\nfrom {\n  transform: scale(0) rotate(90deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n\topacity: 1;\n}"]);
  return ag = function ag() {
    return e;
  }, e;
}
function sg() {
  var e = Hm(["\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);
  return sg = function sg() {
    return e;
  }, e;
}
function lg() {
  var e = Hm(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"]);
  return lg = function lg() {
    return e;
  }, e;
}
var cg = Um(lg()),
  ug = Um(sg()),
  dg = Um(ag()),
  fg = Qm("div")(ig(), function (e) {
    return e.primary || "#ff4b4b";
  }, cg, ug, function (e) {
    return e.secondary || "#fff";
  }, dg);
function pg() {
  var e = Hm(["\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ", ";\n  border-right-color: ", ";\n  animation: ", " 1s linear infinite;\n"]);
  return pg = function pg() {
    return e;
  }, e;
}
function hg() {
  var e = Hm(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]);
  return hg = function hg() {
    return e;
  }, e;
}
var mg = Um(hg()),
  gg = Qm("div")(pg(), function (e) {
    return e.secondary || "#e0e0e0";
  }, function (e) {
    return e.primary || "#616161";
  }, mg);
function vg() {
  var e = Hm(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ", " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ", ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"]);
  return vg = function vg() {
    return e;
  }, e;
}
function yg() {
  var e = Hm(["\n0% {\n\theight: 0;\n\twidth: 0;\n\topacity: 0;\n}\n40% {\n  height: 0;\n\twidth: 6px;\n\topacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"]);
  return yg = function yg() {
    return e;
  }, e;
}
function Ag() {
  var e = Hm(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n\topacity: 1;\n}"]);
  return Ag = function Ag() {
    return e;
  }, e;
}
var bg = Um(Ag()),
  _g = Um(yg()),
  wg = Qm("div")(vg(), function (e) {
    return e.primary || "#61d345";
  }, bg, _g, function (e) {
    return e.secondary || "#fff";
  });
function kg() {
  var e = Hm(["\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ", " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"]);
  return kg = function kg() {
    return e;
  }, e;
}
function Eg() {
  var e = Hm(["\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);
  return Eg = function Eg() {
    return e;
  }, e;
}
function Sg() {
  var e = Hm(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"]);
  return Sg = function Sg() {
    return e;
  }, e;
}
function Cg() {
  var e = Hm(["\n  position: absolute;\n"]);
  return Cg = function Cg() {
    return e;
  }, e;
}
var xg = Qm("div")(Cg()),
  Og = Qm("div")(Sg()),
  Pg = Um(Eg()),
  Tg = Qm("div")(kg(), Pg),
  Ig = function Ig(e) {
    var t = e.toast,
      n = t.icon,
      r = t.type,
      o = t.iconTheme;
    return void 0 !== n ? "string" == typeof n ? Xe.exports.createElement(Tg, null, n) : n : "blank" === r ? null : Xe.exports.createElement(Og, null, Xe.exports.createElement(gg, Object.assign({}, o)), "loading" !== r && Xe.exports.createElement(xg, null, "error" === r ? Xe.exports.createElement(fg, Object.assign({}, o)) : Xe.exports.createElement(wg, Object.assign({}, o))));
  };
function Bg() {
  var e = Hm(["\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"]);
  return Bg = function Bg() {
    return e;
  }, e;
}
function Rg() {
  var e = Hm(["\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"]);
  return Rg = function Rg() {
    return e;
  }, e;
}
var Lg = function Lg(e) {
    return "\n0% {transform: translate3d(0," + -200 * e + "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n";
  },
  Mg = function Mg(e) {
    return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0," + -150 * e + "%,-1px) scale(.6); opacity:0;}\n";
  },
  Dg = Qm("div", Xe.exports.forwardRef)(Rg()),
  Ng = Qm("div")(Bg()),
  zg = Xe.exports.memo(function (e) {
    var t = e.toast,
      n = e.position,
      r = e.style,
      o = e.children,
      i = null != t && t.height ? function (e, t) {
        var n = e.includes("top") ? 1 : -1,
          r = qm() ? ["0%{opacity:0;} 100%{opacity:1;}", "0%{opacity:1;} 100%{opacity:0;}"] : [Lg(n), Mg(n)],
          o = r[1];
        return {
          animation: t ? Um(r[0]) + " 0.35s cubic-bezier(.21,1.02,.73,1) forwards" : Um(o) + " 0.4s forwards cubic-bezier(.06,.71,.55,1)"
        };
      }(t.position || n || "top-center", t.visible) : {
        opacity: 0
      },
      a = Xe.exports.createElement(Ig, {
        toast: t
      }),
      s = Xe.exports.createElement(Ng, Object.assign({}, t.ariaProps), Wm(t.message, t));
    return Xe.exports.createElement(Dg, {
      className: t.className,
      style: $m({}, i, r, t.style)
    }, "function" == typeof o ? o({
      icon: a,
      message: s
    }) : Xe.exports.createElement(Xe.exports.Fragment, null, a, s));
  });
function jg() {
  var e = Hm(["\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"]);
  return jg = function jg() {
    return e;
  }, e;
}
!function (e, t, n, r) {
  Mm.p = t, xm = e, Om = n, Pm = r;
}(Xe.exports.createElement);
var Fg = Fm(jg()),
  Ug = function Ug(e) {
    var t = e.reverseOrder,
      n = e.position,
      r = void 0 === n ? "top-center" : n,
      o = e.toastOptions,
      i = e.gutter,
      a = e.children,
      s = e.containerStyle,
      l = e.containerClassName,
      c = og(o),
      u = c.toasts,
      d = c.handlers;
    return Xe.exports.createElement("div", {
      style: $m({
        position: "fixed",
        zIndex: 9999,
        top: 16,
        left: 16,
        right: 16,
        bottom: 16,
        pointerEvents: "none"
      }, s),
      className: l,
      onMouseEnter: d.startPause,
      onMouseLeave: d.endPause
    }, u.map(function (e) {
      var n,
        o = e.position || r,
        s = function (e, t) {
          var n = e.includes("top"),
            r = n ? {
              top: 0
            } : {
              bottom: 0
            },
            o = e.includes("center") ? {
              justifyContent: "center"
            } : e.includes("right") ? {
              justifyContent: "flex-end"
            } : {};
          return $m({
            left: 0,
            right: 0,
            display: "flex",
            position: "absolute",
            transition: qm() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
            transform: "translateY(" + t * (n ? 1 : -1) + "px)"
          }, r, o);
        }(o, d.calculateOffset(e, {
          reverseOrder: t,
          gutter: i,
          defaultPosition: r
        })),
        l = e.height ? void 0 : (n = function n(t) {
          d.updateHeight(e.id, t.height);
        }, function (e) {
          e && setTimeout(function () {
            var t = e.getBoundingClientRect();
            n(t);
          });
        });
      return Xe.exports.createElement("div", {
        ref: l,
        className: e.visible ? Fg : "",
        key: e.id,
        style: s
      }, "custom" === e.type ? Wm(e.message, e) : a ? a(e) : Xe.exports.createElement(zg, {
        toast: e,
        position: o
      }));
    }));
  };
var Qg = function Qg() {
    return Xe.exports.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Xe.exports.createElement("path", {
      d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z",
      fill: "#0F4447"
    }));
  },
  $g = function $g() {
    return Xe.exports.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Xe.exports.createElement("path", {
      d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z",
      fill: "#590607"
    }));
  },
  Hg = {
    display: "flex",
    gap: "8px",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px"
  },
  Vg = Object.assign(Object.assign({}, Hg), {
    background: "#ECFFF5",
    boxShadow: "0px 5px 10px rgba(15, 68, 71, 0.18)",
    color: "#0F4447"
  }),
  Wg = Object.assign(Object.assign({}, Hg), {
    background: "#FFEEEC",
    boxShadow: "0px 5px 10px rgba(89, 6, 7, 0.2)",
    color: "#590607"
  }),
  Kg = function Kg() {
    return Mt.createElement(Ug, {
      containerStyle: {
        position: "sticky",
        marginTop: "4px",
        marginBottom: "24px"
      },
      toastOptions: {
        success: {
          style: Vg,
          icon: Mt.createElement(Qg, null)
        },
        error: {
          style: Wg,
          icon: Mt.createElement($g, null)
        }
      }
    });
  },
  qg = function qg(e) {
    return null != e ? e : void 0;
  },
  Gg = function Gg(e) {
    return e ? "".concat(e, "px") : void 0;
  },
  Yg = _o.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: ", ";\n\n  flex-direction: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n  align-self: ", ";\n  flex-flow: ", ";\n  flex-wrap: ", ";\n\n  width: ", ";\n  height: ", ";\n  max-width: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  min-height: ", ";\n  padding: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  gap: ", ";\n"])), function (_ref7) {
    var e = _ref7.inline;
    return e ? "inline-flex" : "flex";
  }, function (_ref8) {
    var e = _ref8.direction;
    return qg(e);
  }, function (_ref9) {
    var e = _ref9.justifyContent,
      t = _ref9.center;
    return t ? "center" : qg(e);
  }, function (_ref10) {
    var e = _ref10.alignItems,
      t = _ref10.center;
    return t ? "center" : qg(e);
  }, function (_ref11) {
    var e = _ref11.grow;
    return qg(e);
  }, function (_ref12) {
    var e = _ref12.shrink;
    return qg(e);
  }, function (_ref13) {
    var e = _ref13.order;
    return qg(e);
  }, function (_ref14) {
    var e = _ref14.alignSelf;
    return qg(e);
  }, function (_ref15) {
    var e = _ref15.flow;
    return qg(e);
  }, function (_ref16) {
    var e = _ref16.wrap;
    return qg(e);
  }, function (_ref17) {
    var e = _ref17.width;
    return "string" == typeof e ? e : Gg(e);
  }, function (_ref18) {
    var e = _ref18.height;
    return "string" == typeof e ? e : Gg(e);
  }, function (_ref19) {
    var e = _ref19.maxWidth;
    return "string" == typeof e ? e : Gg(e);
  }, function (_ref20) {
    var e = _ref20.maxHeight;
    return "string" == typeof e ? e : Gg(e);
  }, function (_ref21) {
    var e = _ref21.minWidth;
    return "string" == typeof e ? e : Gg(e);
  }, function (_ref22) {
    var e = _ref22.minHeight;
    return "string" == typeof e ? e : Gg(e);
  }, function (_ref23) {
    var e = _ref23.padding;
    return Gg(e);
  }, function (_ref24) {
    var e = _ref24.margin;
    return Gg(e);
  }, function (_ref25) {
    var e = _ref25.marginTop;
    return Gg(e);
  }, function (_ref26) {
    var e = _ref26.marginRight;
    return Gg(e);
  }, function (_ref27) {
    var e = _ref27.marginBottom;
    return Gg(e);
  }, function (_ref28) {
    var e = _ref28.marginLeft;
    return Gg(e);
  }, function (_ref29) {
    var e = _ref29.paddingTop;
    return Gg(e);
  }, function (_ref30) {
    var e = _ref30.paddingRight;
    return Gg(e);
  }, function (_ref31) {
    var e = _ref31.paddingBottom;
    return Gg(e);
  }, function (_ref32) {
    var e = _ref32.paddingLeft;
    return Gg(e);
  }, function (_ref33) {
    var e = _ref33.gap;
    return Gg(e);
  }),
  Jg = _o.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: ", ";\n  ", ";\n"])), function (e) {
    return e.color && e.theme.colors[e.color];
  }, function (e) {
    return e.align;
  }, function (e) {
    return e.size && e.theme.typography[e.size];
  });
Jg.defaultProps = {
  size: "body",
  color: "primary",
  align: "left"
};
var Zg = function Zg() {
    return Mt.createElement("svg", {
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Mt.createElement("g", {
      opacity: "0.1"
    }, Mt.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M99.9999 0C155.229 0 200 44.7715 200 99.9999C200 155.229 155.229 200 99.9999 200C44.7715 200 0 155.229 0 99.9999C0 44.7715 44.7715 0 99.9999 0Z",
      fill: "url(#paint0_linear_4408_12810)"
    })), Mt.createElement("g", {
      opacity: "0.3"
    }, Mt.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M99.9993 17.5723C145.523 17.5723 182.427 54.4762 182.427 99.9993C182.427 145.523 145.523 182.427 99.9993 182.427C54.4762 182.427 17.5723 145.523 17.5723 99.9993C17.5723 54.4762 54.4762 17.5723 99.9993 17.5723Z",
      fill: "url(#paint1_linear_4408_12810)"
    })), Mt.createElement("g", {
      opacity: "0.7"
    }, Mt.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M99.9987 32.2305C137.487 32.2305 167.877 62.6203 167.877 100.108C167.877 137.596 137.487 167.986 99.9987 167.986C62.5109 167.986 32.1211 137.596 32.1211 100.108C32.1211 62.6203 62.5109 32.2305 99.9987 32.2305Z",
      fill: "url(#paint2_linear_4408_12810)"
    })), Mt.createElement("path", {
      d: "M100 45.8334C70.1 45.8334 45.8333 70.1 45.8333 100C45.8333 129.9 70.1 154.167 100 154.167C129.9 154.167 154.167 129.9 154.167 100C154.167 70.1 129.9 45.8334 100 45.8334ZM105.417 127.083H94.5833V116.25H105.417V127.083ZM105.417 105.417H94.5833V72.9167H105.417V105.417Z",
      fill: "#8B1214"
    }), Mt.createElement("defs", null, Mt.createElement("linearGradient", {
      id: "paint0_linear_4408_12810",
      x1: "-87.1375",
      y1: "160.384",
      x2: "169.669",
      y2: "338.297",
      gradientUnits: "userSpaceOnUse"
    }, Mt.createElement("stop", {
      stopColor: "white"
    }), Mt.createElement("stop", {
      offset: "1",
      stopColor: "#8B1214"
    })), Mt.createElement("linearGradient", {
      id: "paint1_linear_4408_12810",
      x1: "-87.138",
      y1: "160.384",
      x2: "169.668",
      y2: "338.297",
      gradientUnits: "userSpaceOnUse"
    }, Mt.createElement("stop", {
      stopColor: "#F7F0F0"
    }), Mt.createElement("stop", {
      offset: "1",
      stopColor: "#8B1214"
    })), Mt.createElement("linearGradient", {
      id: "paint2_linear_4408_12810",
      x1: "-87.1386",
      y1: "160.493",
      x2: "169.668",
      y2: "338.405",
      gradientUnits: "userSpaceOnUse"
    }, Mt.createElement("stop", {
      stopColor: "#8B1214",
      stopOpacity: "0.01"
    }), Mt.createElement("stop", {
      offset: "1",
      stopColor: "#E4C7C7"
    }))));
  },
  Xg = _o(Jg)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: center;\n"]))),
  ev = function ev(_ref34) {
    var e = _ref34.errorMessage;
    return Mt.createElement(Yg, {
      direction: "column",
      gap: 24,
      alignItems: "center"
    }, Mt.createElement(Xg, {
      size: "header"
    }, "Looks like there was an error!"), Mt.createElement(Zg, null), Mt.createElement(Jg, null, e));
  };
var tv = {
    exports: {}
  },
  nv = {},
  rv = Xe.exports;
var ov = "function" == typeof Object.is ? Object.is : function (e, t) {
    return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
  },
  iv = rv.useState,
  av = rv.useEffect,
  sv = rv.useLayoutEffect,
  lv = rv.useDebugValue;
function cv(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !ov(e, n);
  } catch (e) {
    return !0;
  }
}
var uv = "undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement ? function (e, t) {
  return t();
} : function (e, t) {
  var n = t(),
    r = iv({
      inst: {
        value: n,
        getSnapshot: t
      }
    }),
    o = r[0].inst,
    i = r[1];
  return sv(function () {
    o.value = n, o.getSnapshot = t, cv(o) && i({
      inst: o
    });
  }, [e, n, t]), av(function () {
    return cv(o) && i({
      inst: o
    }), e(function () {
      cv(o) && i({
        inst: o
      });
    });
  }, [e]), lv(n), n;
};
nv.useSyncExternalStore = void 0 !== rv.useSyncExternalStore ? rv.useSyncExternalStore : uv, tv.exports = nv;
var dv = new WeakMap(),
  fv = {},
  pv = {},
  hv = function hv() {},
  mv = hv(),
  gv = Object,
  vv = function vv(e) {
    return e === mv;
  },
  yv = function yv(e) {
    return "function" == typeof e;
  },
  Av = function Av(e, t) {
    return Object.assign(Object.assign({}, e), t);
  },
  bv = "undefined",
  _v = (typeof window === "undefined" ? "undefined" : _typeof(window)) != bv,
  wv = (typeof document === "undefined" ? "undefined" : _typeof(document)) != bv,
  kv = function kv(e, t) {
    var n = dv.get(e);
    return [function () {
      return e.get(t) || fv;
    }, function (r) {
      if (!vv(t)) {
        var _o2 = e.get(t);
        t in pv || (pv[t] = _o2), n[5](t, Av(_o2, r), _o2 || fv);
      }
    }, n[6], function () {
      return !vv(t) && t in pv ? pv[t] : e.get(t) || fv;
    }];
  },
  Ev = new WeakMap();
var Sv = 0;
var Cv = function Cv(e) {
  var t = _typeof(e),
    n = e && e.constructor,
    r = n == Date;
  var o, i;
  if (gv(e) !== e || r || n == RegExp) o = r ? e.toJSON() : "symbol" == t ? e.toString() : "string" == t ? JSON.stringify(e) : "" + e;else {
    if (o = Ev.get(e), o) return o;
    if (o = ++Sv + "~", Ev.set(e, o), n == Array) {
      for (o = "@", i = 0; i < e.length; i++) o += Cv(e[i]) + ",";
      Ev.set(e, o);
    }
    if (n == gv) {
      o = "#";
      var _t6 = gv.keys(e).sort();
      for (; !vv(i = _t6.pop());) vv(e[i]) || (o += i + ":" + Cv(e[i]) + ",");
      Ev.set(e, o);
    }
  }
  return o;
};
var xv = !0;
var _ref35 = _v && window.addEventListener ? [window.addEventListener.bind(window), window.removeEventListener.bind(window)] : [hv, hv],
  _ref36 = _slicedToArray(_ref35, 2),
  Ov = _ref36[0],
  Pv = _ref36[1],
  Tv = {
    isOnline: function isOnline() {
      return xv;
    },
    isVisible: function isVisible() {
      var e = wv && document.visibilityState;
      return vv(e) || "hidden" !== e;
    }
  },
  Iv = {
    initFocus: function initFocus(e) {
      return wv && document.addEventListener("visibilitychange", e), Ov("focus", e), function () {
        wv && document.removeEventListener("visibilitychange", e), Pv("focus", e);
      };
    },
    initReconnect: function initReconnect(e) {
      var t = function t() {
          xv = !0, e();
        },
        n = function n() {
          xv = !1;
        };
      return Ov("online", t), Ov("offline", n), function () {
        Pv("online", t), Pv("offline", n);
      };
    }
  },
  Bv = !Mt.useId,
  Rv = !_v || "Deno" in window,
  Lv = function Lv(e) {
    return _v && _typeof(window.requestAnimationFrame) != bv ? window.requestAnimationFrame(e) : setTimeout(e, 1);
  },
  Mv = Rv ? Xe.exports.useEffect : Xe.exports.useLayoutEffect,
  Dv = "undefined" != typeof navigator && navigator.connection,
  Nv = !Rv && Dv && (["slow-2g", "2g"].includes(Dv.effectiveType) || Dv.saveData),
  zv = function zv(e) {
    if (yv(e)) try {
      e = e();
    } catch (t) {
      e = "";
    }
    var t = e;
    return [e = "string" == typeof e ? e : (Array.isArray(e) ? e.length : e) ? Cv(e) : "", t];
  };
var jv = 0;
var Fv = function Fv() {
  return ++jv;
};
var Uv = 0,
  Qv = 1,
  $v = 2,
  Hv = 3;
function Vv() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
    var t, n, r, o, i, a, s, l, c, u, _e5, _r2, _o3, _n4, _o4, d;
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          d = function _d2(n) {
            return Ee(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
              var _zv, _zv2, o, _kv, _kv2, i, d, _dv$get, _dv$get2, f, p, h, m, g, v, y, A, b, _, w, k, E, S;
              return _regeneratorRuntime().wrap(function _callee18$(_context18) {
                while (1) switch (_context18.prev = _context18.next) {
                  case 0:
                    _zv = zv(n), _zv2 = _slicedToArray(_zv, 1), o = _zv2[0];
                    if (o) {
                      _context18.next = 3;
                      break;
                    }
                    return _context18.abrupt("return");
                  case 3:
                    _kv = kv(t, o), _kv2 = _slicedToArray(_kv, 2), i = _kv2[0], d = _kv2[1], _dv$get = dv.get(t), _dv$get2 = _slicedToArray(_dv$get, 3), f = _dv$get2[0], p = _dv$get2[1], h = _dv$get2[2], m = f[o], g = function g() {
                      return c && (delete h[o], m && m[0]) ? m[0](2).then(function () {
                        return i().data;
                      }) : i().data;
                    };
                    if (!(e.length < 3)) {
                      _context18.next = 6;
                      break;
                    }
                    return _context18.abrupt("return", g());
                  case 6:
                    y = r;
                    A = Fv();
                    p[o] = [A, 0];
                    b = !vv(l), _ = i(), w = _.data, k = _._c, E = vv(k) ? w : k;
                    if (b && (l = yv(l) ? l(E) : l, d({
                      data: l,
                      _c: E
                    })), yv(y)) try {
                      y = y(E);
                    } catch (e) {
                      v = e;
                    }
                    if (!(y && yv(y.then))) {
                      _context18.next = 20;
                      break;
                    }
                    _context18.next = 14;
                    return y["catch"](function (e) {
                      v = e;
                    });
                  case 14:
                    y = _context18.sent;
                    if (!(A !== p[o][0])) {
                      _context18.next = 19;
                      break;
                    }
                    if (!v) {
                      _context18.next = 18;
                      break;
                    }
                    throw v;
                  case 18:
                    return _context18.abrupt("return", y);
                  case 19:
                    v && b && function (e) {
                      return "function" == typeof s ? s(e) : !1 !== s;
                    }(v) && (a = !0, y = E, d({
                      data: y,
                      _c: mv
                    }));
                  case 20:
                    a && (v || (yv(a) && (y = a(y, E)), d({
                      data: y,
                      _c: mv
                    }))), p[o][1] = Fv();
                    _context18.next = 23;
                    return g();
                  case 23:
                    S = _context18.sent;
                    if (!(d({
                      _c: mv
                    }), !v)) {
                      _context18.next = 26;
                      break;
                    }
                    return _context18.abrupt("return", a ? S : y);
                  case 26:
                    if (!u) {
                      _context18.next = 28;
                      break;
                    }
                    throw v;
                  case 28:
                  case "end":
                    return _context18.stop();
                }
              }, _callee18);
            }));
          };
          t = e[0], n = e[1], r = e[2], o = e[3], i = Av({
            populateCache: !0,
            throwOnError: !0
          }, "boolean" == typeof o ? {
            revalidate: o
          } : o || {});
          a = i.populateCache;
          s = i.rollbackOnError;
          l = i.optimisticData;
          c = !1 !== i.revalidate, u = i.throwOnError;
          if (!yv(n)) {
            _context19.next = 10;
            break;
          }
          _e5 = n, _r2 = [], _o3 = t.keys();
          for (_n4 = _o3.next(); !_n4.done; _n4 = _o3.next()) {
            _o4 = _n4.value;
            !/^\$(inf|sub)\$/.test(_o4) && _e5(t.get(_o4)._k) && _r2.push(_o4);
          }
          return _context19.abrupt("return", Promise.all(_r2.map(d)));
        case 10:
          return _context19.abrupt("return", d(n));
        case 11:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
}
var Wv = function Wv(e, t) {
    for (var _n5 in e) e[_n5][0] && e[_n5][0](t);
  },
  _ref6 = function (e, t) {
    if (!dv.has(e)) {
      var _n6 = Av(Iv, t),
        _r3 = {},
        _o5 = Vv.bind(mv, e);
      var _i3 = hv;
      var _a2 = {},
        _s2 = function _s2(e, t) {
          var n = _a2[e] || [];
          return _a2[e] = n, n.push(t), function () {
            return n.splice(n.indexOf(t), 1);
          };
        },
        _l2 = function _l2(t, n, r) {
          e.set(t, n);
          var o = _a2[t];
          if (o) {
            var _iterator2 = _createForOfIteratorHelper(o),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _e6 = _step2.value;
                _e6(n, r);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        },
        _c2 = function _c2() {
          if (!dv.has(e) && (dv.set(e, [_r3, {}, {}, {}, _o5, _l2, _s2]), !Rv)) {
            var _t7 = _n6.initFocus(setTimeout.bind(mv, Wv.bind(mv, _r3, 0))),
              _o6 = _n6.initReconnect(setTimeout.bind(mv, Wv.bind(mv, _r3, 1)));
            _i3 = function _i3() {
              _t7 && _t7(), _o6 && _o6(), dv["delete"](e);
            };
          }
        };
      return _c2(), [e, _o5, _c2, _i3];
    }
    return [e, dv.get(e)[4]];
  }(new Map()),
  _ref37 = _slicedToArray(_ref6, 2),
  Kv = _ref37[0],
  qv = _ref37[1],
  Gv = Av({
    onLoadingSlow: hv,
    onSuccess: hv,
    onError: hv,
    onErrorRetry: function onErrorRetry(e, t, n, r, o) {
      var i = n.errorRetryCount,
        a = o.retryCount,
        s = ~~((Math.random() + .5) * (1 << (a < 8 ? a : 8))) * n.errorRetryInterval;
      !vv(i) && a > i || setTimeout(r, s, o);
    },
    onDiscarded: hv,
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    errorRetryInterval: Nv ? 1e4 : 5e3,
    focusThrottleInterval: 5e3,
    dedupingInterval: 2e3,
    loadingTimeout: Nv ? 5e3 : 3e3,
    compare: function compare(e, t) {
      return Cv(e) == Cv(t);
    },
    isPaused: function isPaused() {
      return !1;
    },
    cache: Kv,
    mutate: qv,
    fallback: {}
  }, Tv),
  Yv = Xe.exports.createContext({}),
  Jv = _v && window.__SWR_DEVTOOLS_USE__,
  Zv = Jv ? window.__SWR_DEVTOOLS_USE__ : [],
  Xv = function Xv(e) {
    return yv(e[1]) ? [e[0], e[1], e[2] || {}] : [e[0], null, (null === e[1] ? e[2] : e[1]) || {}];
  },
  ey = function ey() {
    return Av(Gv, Xe.exports.useContext(Yv));
  },
  ty = Zv.concat(function (e) {
    return function (t, n, r) {
      return e(t, n && function () {
        var r = zv(t)[0],
          _dv$get3 = dv.get(Kv),
          _dv$get4 = _slicedToArray(_dv$get3, 4),
          o = _dv$get4[3],
          i = o[r];
        return i ? (delete o[r], i) : n.apply(void 0, arguments);
      }, r);
    };
  });
Jv && (window.__SWR_DEVTOOLS_REACT__ = Mt);
var ny = {
  dedupe: !0
};
var ry,
  oy = (ry = function ry(e, t, n) {
    var r = n.cache,
      o = n.compare,
      i = n.suspense,
      a = n.fallbackData,
      s = n.revalidateOnMount,
      l = n.revalidateIfStale,
      c = n.refreshInterval,
      u = n.refreshWhenHidden,
      d = n.refreshWhenOffline,
      f = n.keepPreviousData,
      _dv$get5 = dv.get(r),
      _dv$get6 = _slicedToArray(_dv$get5, 3),
      p = _dv$get6[0],
      h = _dv$get6[1],
      m = _dv$get6[2],
      _zv3 = zv(e),
      _zv4 = _slicedToArray(_zv3, 2),
      g = _zv4[0],
      v = _zv4[1],
      y = Xe.exports.useRef(!1),
      A = Xe.exports.useRef(!1),
      b = Xe.exports.useRef(g),
      _ = Xe.exports.useRef(t),
      w = Xe.exports.useRef(n),
      k = function k() {
        return w.current;
      },
      E = function E() {
        return k().isVisible() && k().isOnline();
      },
      _kv3 = kv(r, g),
      _kv4 = _slicedToArray(_kv3, 4),
      S = _kv4[0],
      C = _kv4[1],
      x = _kv4[2],
      O = _kv4[3],
      P = Xe.exports.useRef({}).current,
      T = vv(a) ? n.fallback[g] : a,
      I = function I(e, t) {
        var n = !0;
        for (var _r4 in P) {
          var _i4 = _r4;
          "data" === _i4 ? o(t[_i4], e[_i4]) || vv(e[_i4]) && o(t[_i4], F) || (n = !1) : t[_i4] !== e[_i4] && (n = !1);
        }
        return n;
      },
      B = Xe.exports.useMemo(function () {
        var e = !!g && !!t && (vv(s) ? !k().isPaused() && !i && (!!vv(l) || l) : s),
          n = function n(t) {
            var n = Av(t);
            return delete n._k, e ? Object.assign({
              isValidating: !0,
              isLoading: !0
            }, n) : n;
          },
          r = S(),
          o = O(),
          a = n(r),
          c = r === o ? a : n(o);
        var u = a;
        return [function () {
          var e = n(S());
          return I(e, u) ? u : u = e;
        }, function () {
          return c;
        }];
      }, [r, g]),
      R = tv.exports.useSyncExternalStore(Xe.exports.useCallback(function (e) {
        return x(g, function (t, n) {
          I(n, t) || e();
        });
      }, [r, g]), B[0], B[1]),
      L = !y.current,
      M = p[g] && p[g].length > 0,
      D = R.data,
      N = vv(D) ? T : D,
      z = R.error,
      j = Xe.exports.useRef(N),
      F = f ? vv(D) ? j.current : D : N,
      U = !(M && !vv(z)) && (L && !vv(s) ? s : !k().isPaused() && (i ? !vv(N) && l : vv(N) || l)),
      Q = !!(g && t && L && U),
      $ = vv(R.isValidating) ? Q : R.isValidating,
      H = vv(R.isLoading) ? Q : R.isLoading,
      V = Xe.exports.useCallback(function (e) {
        return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
          var t, r, i, a, s, l, c, u, d, f, w, _m$g, _e7, _s3, _t8, _n7;
          return _regeneratorRuntime().wrap(function _callee20$(_context20) {
            while (1) switch (_context20.prev = _context20.next) {
              case 0:
                t = _.current;
                if (!(!g || !t || A.current || k().isPaused())) {
                  _context20.next = 3;
                  break;
                }
                return _context20.abrupt("return", !1);
              case 3:
                a = !0;
                s = e || {}, l = !m[g] || !s.dedupe, c = function c() {
                  return Bv ? !A.current && g === b.current && y.current : g === b.current;
                }, u = {
                  isValidating: !1,
                  isLoading: !1
                }, d = function d() {
                  C(u);
                }, f = function f() {
                  var e = m[g];
                  e && e[1] === i && delete m[g];
                }, w = {
                  isValidating: !0
                };
                vv(S().data) && (w.isLoading = !0);
                _context20.prev = 6;
                l && (C(w), n.loadingTimeout && vv(S().data) && setTimeout(function () {
                  a && c() && k().onLoadingSlow(g, n);
                }, n.loadingTimeout), m[g] = [t(v), Fv()]);
                _m$g = _slicedToArray(m[g], 2), r = _m$g[0], i = _m$g[1];
                _context20.next = 11;
                return r;
              case 11:
                r = _context20.sent;
                l && setTimeout(f, n.dedupingInterval);
                if (!(!m[g] || m[g][1] !== i)) {
                  _context20.next = 15;
                  break;
                }
                return _context20.abrupt("return", (l && c() && k().onDiscarded(g), !1));
              case 15:
                u.error = mv;
                _e7 = h[g];
                if (!(!vv(_e7) && (i <= _e7[0] || i <= _e7[1] || 0 === _e7[1]))) {
                  _context20.next = 19;
                  break;
                }
                return _context20.abrupt("return", (d(), l && c() && k().onDiscarded(g), !1));
              case 19:
                _s3 = S().data;
                u.data = o(_s3, r) ? _s3 : r, l && c() && k().onSuccess(r, g, n);
                _context20.next = 28;
                break;
              case 23:
                _context20.prev = 23;
                _context20.t0 = _context20["catch"](6);
                f();
                _t8 = k(), _n7 = _t8.shouldRetryOnError;
                _t8.isPaused() || (u.error = _context20.t0, l && c() && (_t8.onError(_context20.t0, g, _t8), (!0 === _n7 || yv(_n7) && _n7(_context20.t0)) && E() && _t8.onErrorRetry(_context20.t0, g, _t8, function (e) {
                  var t = p[g];
                  t && t[0] && t[0](Hv, e);
                }, {
                  retryCount: (s.retryCount || 0) + 1,
                  dedupe: !0
                })));
              case 28:
                return _context20.abrupt("return", (a = !1, d(), !0));
              case 29:
              case "end":
                return _context20.stop();
            }
          }, _callee20, null, [[6, 23]]);
        }));
      }, [g, r]),
      W = Xe.exports.useCallback(function () {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }
        return Vv.apply(void 0, [r, b.current].concat(e));
      }, []);
    if (Mv(function () {
      _.current = t, w.current = n, vv(D) || (j.current = D);
    }), Mv(function () {
      if (!g) return;
      var e = V.bind(mv, ny);
      var t = 0;
      var n = function (e, t, n) {
        var r = t[e] || (t[e] = []);
        return r.push(n), function () {
          var e = r.indexOf(n);
          e >= 0 && (r[e] = r[r.length - 1], r.pop());
        };
      }(g, p, function (n) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (n == Uv) {
          var _n8 = Date.now();
          k().revalidateOnFocus && _n8 > t && E() && (t = _n8 + k().focusThrottleInterval, e());
        } else if (n == Qv) k().revalidateOnReconnect && E() && e();else {
          if (n == $v) return V();
          if (n == Hv) return V(r);
        }
      });
      return A.current = !1, b.current = g, y.current = !0, C({
        _k: v
      }), U && (vv(N) || Rv ? e() : Lv(e)), function () {
        A.current = !0, n();
      };
    }, [g]), Mv(function () {
      var e;
      function t() {
        var t = yv(c) ? c(N) : c;
        t && -1 !== e && (e = setTimeout(n, t));
      }
      function n() {
        S().error || !u && !k().isVisible() || !d && !k().isOnline() ? t() : V(ny).then(t);
      }
      return t(), function () {
        e && (clearTimeout(e), e = -1);
      };
    }, [c, u, d, g]), Xe.exports.useDebugValue(F), i && vv(N) && g) {
      if (!Bv && Rv) throw new Error("Fallback data is required when using suspense in SSR.");
      throw _.current = t, w.current = n, A.current = !1, vv(z) ? V(ny) : z;
    }
    return {
      mutate: W,
      get data() {
        return P.data = !0, F;
      },
      get error() {
        return P.error = !0, z;
      },
      get isValidating() {
        return P.isValidating = !0, $;
      },
      get isLoading() {
        return P.isLoading = !0, H;
      }
    };
  }, function () {
    for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      e[_key3] = arguments[_key3];
    }
    var t = ey(),
      _Xv = Xv(e),
      _Xv2 = _slicedToArray(_Xv, 3),
      n = _Xv2[0],
      r = _Xv2[1],
      o = _Xv2[2],
      i = function (e, t) {
        var n = Av(e, t);
        if (t) {
          var _r5 = e.use,
            _o7 = e.fallback,
            _i5 = t.use,
            _a3 = t.fallback;
          _r5 && _i5 && (n.use = _r5.concat(_i5)), _o7 && _a3 && (n.fallback = Av(_o7, _a3));
        }
        return n;
      }(t, o);
    var a = ry;
    var s = i.use,
      l = (s || []).concat(ty);
    for (var _e8 = l.length; _e8--;) a = l[_e8](a);
    return a(n, r || i.fetcher || null, i);
  });
var iy = function (e, t) {
  return function () {
    for (var _len4 = arguments.length, n = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      n[_key4] = arguments[_key4];
    }
    var _Xv3 = Xv(n),
      _Xv4 = _slicedToArray(_Xv3, 3),
      r = _Xv4[0],
      o = _Xv4[1],
      i = _Xv4[2],
      a = (i.use || []).concat(t);
    return e(r, o, Object.assign(Object.assign({}, i), {
      use: a
    }));
  };
}(oy, function () {
  return function (e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _ey = ey(),
      r = _ey.mutate,
      o = Xe.exports.useRef(e),
      i = Xe.exports.useRef(t),
      a = Xe.exports.useRef(n),
      s = Xe.exports.useRef(0),
      _ref38 = function (e) {
        var t = Xe.exports.useState({})[1],
          n = Xe.exports.useRef(!1),
          r = Xe.exports.useRef(e),
          o = Xe.exports.useRef({
            data: !1,
            error: !1,
            isValidating: !1
          }),
          i = Xe.exports.useCallback(function (e) {
            var i = !1;
            var a = r.current;
            for (var _t9 in e) {
              var _n9 = _t9;
              a[_n9] !== e[_n9] && (a[_n9] = e[_n9], o.current[_n9] && (i = !0));
            }
            i && !n.current && (Bv ? t({}) : Mt.startTransition(function () {
              return t({});
            }));
          }, []);
        return Mv(function () {
          return n.current = !1, function () {
            n.current = !0;
          };
        }), [r, o.current, i];
      }({
        data: mv,
        error: mv,
        isMutating: !1
      }),
      _ref39 = _slicedToArray(_ref38, 3),
      l = _ref39[0],
      c = _ref39[1],
      u = _ref39[2],
      d = l.current,
      f = Xe.exports.useCallback(function (e, t) {
        return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
          var _zv5, _zv6, n, l, c, d, _t10;
          return _regeneratorRuntime().wrap(function _callee21$(_context21) {
            while (1) switch (_context21.prev = _context21.next) {
              case 0:
                _zv5 = zv(o.current), _zv6 = _slicedToArray(_zv5, 2), n = _zv6[0], l = _zv6[1];
                if (i.current) {
                  _context21.next = 3;
                  break;
                }
                throw new Error("Can’t trigger the mutation: missing fetcher.");
              case 3:
                if (n) {
                  _context21.next = 5;
                  break;
                }
                throw new Error("Can’t trigger the mutation: missing key.");
              case 5:
                c = Av(Av({
                  populateCache: !1,
                  throwOnError: !0
                }, a.current), t), d = Fv();
                s.current = d, u({
                  isMutating: !0
                });
                _context21.prev = 7;
                _context21.next = 10;
                return r(n, i.current(l, {
                  arg: e
                }), Av(c, {
                  throwOnError: !0
                }));
              case 10:
                _t10 = _context21.sent;
                return _context21.abrupt("return", (s.current <= d && (u({
                  data: _t10,
                  isMutating: !1,
                  error: void 0
                }), null == c.onSuccess || c.onSuccess(_t10, n, c)), _t10));
              case 14:
                _context21.prev = 14;
                _context21.t0 = _context21["catch"](7);
                if (!(s.current <= d && (u({
                  error: _context21.t0,
                  isMutating: !1
                }), null == c.onError || c.onError(_context21.t0, n, c), c.throwOnError))) {
                  _context21.next = 18;
                  break;
                }
                throw _context21.t0;
              case 18:
              case "end":
                return _context21.stop();
            }
          }, _callee21, null, [[7, 14]]);
        }));
      }, []),
      p = Xe.exports.useCallback(function () {
        s.current = Fv(), u({
          data: mv,
          error: mv,
          isMutating: !1
        });
      }, []);
    return Mv(function () {
      o.current = e, i.current = t, a.current = n;
    }), {
      trigger: f,
      reset: p,
      get data() {
        return c.data = !0, d.data;
      },
      get error() {
        return c.error = !0, d.error;
      },
      get isMutating() {
        return c.isMutating = !0, d.isMutating;
      }
    };
  };
});
var ay = {
    "stytch.magicLinks.authenticate": Nh.B2BMagicLinkAuthenticate,
    "stytch.sso.authenticate": Nh.B2BSSOAuthenticate,
    "stytch.magicLinks.discovery.authenticate": Nh.B2BMagicLinkDiscoveryAuthenticate,
    "stytch.discovery.organization.create": Nh.B2BDiscoveryOrganizationsCreate,
    "stytch.discovery.intermediateSessions.exchange": Nh.B2BDiscoveryIntermediateSessionExchange,
    "stytch.magicLinks.email.loginOrSignup": Nh.B2BMagicLinkEmailLoginOrSignup,
    "stytch.magicLinks.discovery.send": Nh.B2BMagicLinkEmailDiscoverySend,
    "stytch.oauth.authenticate": Nh.B2BOAuthAuthenticate,
    "stytch.oauth.discovery.authenticate": Nh.B2BOAuthDiscoveryAuthenticate
  },
  sy = function sy(e, t, n) {
    var r = Am(),
      o = ym();
    return iy(e, t, Object.assign(Object.assign({}, n), {
      onSuccess: function onSuccess(e, t, o) {
        ay[t] && r({
          type: ay[t],
          data: e
        }), (null == n ? void 0 : n.onSuccess) && n.onSuccess(e, t, o);
      },
      onError: function onError(e, t, r) {
        o(e), (null == n ? void 0 : n.onError) && n.onError(e, t, r);
      }
    }));
  },
  ly = function ly() {
    var e = mm(),
      _Xe$exports$useState = Xe.exports.useState(Je(e).bootstrap.getSync()),
      _Xe$exports$useState2 = _slicedToArray(_Xe$exports$useState, 2),
      t = _Xe$exports$useState2[0],
      n = _Xe$exports$useState2[1];
    return Xe.exports.useEffect(function () {
      Je(e).bootstrap.getAsync().then(function (e) {
        n(e);
      });
    }, [e]), t;
  },
  cy = function cy(e, t) {
    e.member_session ? t({
      type: "transition",
      screen: cm.LoggedIn
    }) : t({
      type: "transition",
      screen: cm.Error
    });
  },
  uy = function uy() {
    var _gm = gm(),
      _gm2 = _slicedToArray(_gm, 2),
      e = _gm2[0],
      t = _gm2[1],
      n = vm(),
      r = mm(),
      o = Am(),
      i = ym(),
      _Xe$exports$useState3 = Xe.exports.useState(e.formState.passwordState.email),
      _Xe$exports$useState4 = _slicedToArray(_Xe$exports$useState3, 2),
      a = _Xe$exports$useState4[0],
      s = _Xe$exports$useState4[1],
      _Xe$exports$useState5 = Xe.exports.useState(""),
      _Xe$exports$useState6 = _slicedToArray(_Xe$exports$useState5, 2),
      l = _Xe$exports$useState6[0],
      c = _Xe$exports$useState6[1],
      _Xe$exports$useState7 = Xe.exports.useState(""),
      _Xe$exports$useState8 = _slicedToArray(_Xe$exports$useState7, 2),
      u = _Xe$exports$useState8[0],
      d = _Xe$exports$useState8[1],
      _Xe$exports$useState9 = Xe.exports.useState(!1),
      _Xe$exports$useState10 = _slicedToArray(_Xe$exports$useState9, 2),
      f = _Xe$exports$useState10[0],
      p = _Xe$exports$useState10[1],
      h = e.flowState.organization;
    return {
      stytch: r,
      onError: i,
      email: a,
      setEmail: s,
      password: l,
      setPassword: c,
      organization: h,
      errorMessage: u,
      setErrorMessage: d,
      isSubmitting: f,
      setIsSubmitting: p,
      submitPassword: function submitPassword(e) {
        var s, c;
        d(""), p(!0), r.passwords.authenticate({
          email_address: a,
          organization_id: e,
          password: l,
          session_duration_minutes: null !== (c = null === (s = n.sessionOptions) || void 0 === s ? void 0 : s.sessionDurationMinutes) && void 0 !== c ? c : 30
        }).then(function (e) {
          p(!1), o({
            type: Nh.B2BPasswordAuthenticate,
            data: e
          }), cy(e, t);
        })["catch"](function (e) {
          p(!1), i(e), d("Invalid email or password. Please try again or use the link below to get help.");
        });
      },
      handleNonMemberReset: function handleNonMemberReset() {
        var e, o, s, l;
        if (!h) return;
        if (!function (e, t) {
          var n = t.split("@").pop();
          return "NOT_ALLOWED" == e.email_jit_provisioning || "RESTRICTED" == e.email_jit_provisioning && n && e.email_allowed_domains.includes(n);
        }(h, a)) return p(!1), void d(a + " does not have access to " + h.organization_name + ". If you think this is a mistake, contact your admin.");
        Je(r).dataLayer.setItem("reset-email-value", a), r.magicLinks.email.loginOrSignup({
          email_address: a,
          organization_id: h.organization_id,
          login_redirect_url: null === (e = n.passwordOptions) || void 0 === e ? void 0 : e.resetPasswordRedirectURL,
          signup_redirect_url: null === (o = n.passwordOptions) || void 0 === o ? void 0 : o.resetPasswordRedirectURL,
          login_template_id: null === (s = n.emailMagicLinksOptions) || void 0 === s ? void 0 : s.loginTemplateId,
          signup_template_id: null === (l = n.emailMagicLinksOptions) || void 0 === l ? void 0 : l.signupTemplateId
        }).then(function () {
          p(!1), t({
            type: "set_password_state",
            email: a
          }), t({
            type: "transition",
            screen: cm.PasswordResetVerifyConfirmation
          });
        })["catch"](function (e) {
          i(e), d("We were unable to verify your email. Please contact your admin."), p(!1);
        });
      }
    };
  },
  dy = function dy(e) {
    if (null === e) return null;
    var t = window.location.href.replace(window.location.search, "").trim(),
      n = e.replace("{{slug}}", "(.+)"),
      r = new RegExp(n),
      o = t.match(r);
    return o && o[1] ? o[1] : null;
  },
  fy = _o.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  all: unset;\n  width: 100%;\n  height: 45px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 18px;\n  text-transform: none;\n  font-family: ", ";\n  box-shadow: none;\n  text-align: center;\n\n  ", "\n\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n"])), function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    switch (e.variant) {
      case "primary":
        return "\n          border: ".concat(e.theme.buttons.primary.border, ";\n          border-radius: ").concat(e.theme.buttons.primary.borderRadius, ";\n          color: ").concat(e.theme.buttons.primary.textColor, ";\n          background-color: ").concat(e.theme.buttons.primary.backgroundColor, ";\n        ");
      case "outlined":
        return "\n          border: ".concat(e.theme.buttons.secondary.border, ";\n          border-radius: ").concat(e.theme.buttons.secondary.borderRadius, ";\n          color: ").concat(e.theme.buttons.secondary.textColor, ";\n          background-color: ").concat(e.theme.buttons.secondary.backgroundColor, ";\n        ");
      case "text":
        return "\n          color: ".concat(e.theme.colors.primary, ";\n          background-color: transparent;\n          font-weight: 600;\n        ");
    }
  }, function (e) {
    return e.theme.colors.disabled;
  }, function (e) {
    return e.theme.colors.disabledText;
  });
fy.defaultProps = {
  variant: "primary"
};
var py = Ao(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]))),
  hy = Ao(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"]))),
  my = _o.circle(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  stroke-dasharray: 80px, 200px;\n  stroke-dashoffset: 0;\n  animation: ", " 1.4s ease-in-out infinite;\n  stroke: ", ";\n  fill: none;\n"])), hy, function (e) {
    return e.theme.colors.primary;
  }),
  gy = _o.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  animation: ", " 1.4s ease-in-out infinite;\n"])), function (e) {
    return e.size;
  }, function (e) {
    return e.size;
  }, py),
  vy = _o.svg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: block;\n"]))),
  yy = function yy(_ref40) {
    var e = _ref40.size,
      t = _ref40.thickness;
    return Mt.createElement(gy, {
      size: e
    }, Mt.createElement(vy, {
      viewBox: "".concat(e / 2, " ").concat(e / 2, " ").concat(e, " ").concat(e)
    }, Mt.createElement(my, {
      cx: e,
      cy: e,
      r: (e - t) / 2,
      fill: "none",
      strokeWidth: t
    })));
  },
  Ay = function Ay(e) {
    var t = e.isSubmitting || e.disabled;
    return Mt.createElement(fy, {
      id: "submit",
      type: "submit",
      disabled: t
    }, e.isSubmitting ? Mt.createElement(Yg, {
      justifyContent: "center"
    }, Mt.createElement(yy, {
      size: 18,
      thickness: 1,
      "data-testid": "loading-icon"
    })) : e.text);
  },
  by = _o.input(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  height: 45px;\n  padding: 0 8px;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n  & input::placeholder {\n    color: ", ";\n  }\n\n  &:disabled {\n    border: 1px solid ", ";\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (e) {
    return e.theme.colors.primary;
  }, function (e) {
    return e.theme.colors.primary;
  }, function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    return e.theme.colors.disabledText;
  }, function (e) {
    return e.theme.colors.disabledText;
  }, function (e) {
    return e.theme.colors.disabledText;
  }, function (e) {
    return e.theme.colors.disabled;
  }),
  _y = function _y(_ref41) {
    var e = _ref41.email,
      t = _ref41.setEmail,
      _ref41$disableInput = _ref41.disableInput,
      n = _ref41$disableInput === void 0 ? !1 : _ref41$disableInput,
      _ref41$hasPasskeys = _ref41.hasPasskeys,
      r = _ref41$hasPasskeys === void 0 ? !1 : _ref41$hasPasskeys;
    return Mt.createElement(by, Object.assign({
      placeholder: "example@email.com",
      name: "email",
      type: "email",
      autoComplete: r ? "email webauthn" : "email",
      disabled: n,
      id: "email-input",
      value: e,
      onChange: function onChange(e) {
        return t(e.target.value);
      },
      required: !0
    }, r ? {
      "data-1p-ignore": !0
    } : {}));
  },
  wy = /https:\/\/stytch\.com\/[#a-zA-Z0-9/-]+/g,
  ky = function ky(_ref42) {
    var e = _ref42.errorMessage;
    var t = Xe.exports.useMemo(function () {
      return function (e) {
        var t = e.split(wy),
          n = Array.from(e.matchAll(wy)).map(function (e) {
            return e[0];
          }),
          r = [];
        for (; t.length || n.length;) if (t.length && r.push(t.shift()), n.length) {
          var _e9 = n.shift();
          r.push(Mt.createElement("a", {
            key: _e9 + "__" + String(n.length),
            href: _e9,
            target: "_blank",
            rel: "noreferrer"
          }, _e9));
        }
        return r;
      }(e);
    }, [e]);
    return Mt.createElement(Jg, {
      size: "helper",
      color: "error"
    }, t);
  },
  Ey = ["email_jit_provisioning_not_allowed", "invalid_email_for_jit_provisioning"],
  Sy = function Sy(e, _ref43) {
    var t = _ref43.email,
      n = _ref43.org;
    return Ey.includes(e.error_type) ? "".concat(t, " does not have access to ").concat(n, ". If you think this is a mistake, contact your admin") : e.error_message;
  },
  Cy = function Cy() {
    var _gm3 = gm(),
      _gm4 = _slicedToArray(_gm3, 2),
      e = _gm4[0],
      t = _gm4[1],
      n = mm(),
      r = vm(),
      _Xe$exports$useState11 = Xe.exports.useState(""),
      _Xe$exports$useState12 = _slicedToArray(_Xe$exports$useState11, 2),
      o = _Xe$exports$useState12[0],
      i = _Xe$exports$useState12[1],
      _sy = sy("stytch.magicLinks.email.loginOrSignup", function (e, _ref44) {
        var t = _ref44.arg.organization_id;
        var i, a, s, l;
        return n.magicLinks.email.loginOrSignup({
          email_address: o,
          organization_id: t,
          login_redirect_url: null === (i = r.emailMagicLinksOptions) || void 0 === i ? void 0 : i.loginRedirectURL,
          signup_redirect_url: null === (a = r.emailMagicLinksOptions) || void 0 === a ? void 0 : a.signupRedirectURL,
          login_template_id: null === (s = r.emailMagicLinksOptions) || void 0 === s ? void 0 : s.loginTemplateId,
          signup_template_id: null === (l = r.emailMagicLinksOptions) || void 0 === l ? void 0 : l.signupTemplateId
        });
      }, {
        onSuccess: function onSuccess() {
          t({
            type: "set_magic_link_email",
            email: o
          }), t({
            type: "transition",
            screen: cm.EmailConfirmation
          });
        }
      }),
      a = _sy.trigger,
      s = _sy.error,
      l = _sy.isMutating,
      c = e.flowState.organization;
    if (!c) return Mt.createElement(Mt.Fragment, null);
    return Mt.createElement("form", {
      onSubmit: function onSubmit(e) {
        return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
          return _regeneratorRuntime().wrap(function _callee22$(_context22) {
            while (1) switch (_context22.prev = _context22.next) {
              case 0:
                e.preventDefault(), a({
                  organization_id: c.organization_id
                });
              case 1:
              case "end":
                return _context22.stop();
            }
          }, _callee22);
        }));
      }
    }, Mt.createElement(Yg, {
      direction: "column",
      gap: 8
    }, Mt.createElement(Yg, {
      direction: "column",
      minHeight: 52
    }, Mt.createElement(_y, {
      email: o,
      setEmail: i
    }), s && Mt.createElement(ky, {
      errorMessage: Sy(s, {
        email: o,
        org: c.organization_name
      })
    })), Mt.createElement(Ay, {
      isSubmitting: l,
      text: "Continue with email"
    })));
  },
  xy = function xy() {
    var _gm5 = gm(),
      _gm6 = _slicedToArray(_gm5, 2),
      e = _gm6[1],
      t = mm(),
      n = vm(),
      _Xe$exports$useState13 = Xe.exports.useState(""),
      _Xe$exports$useState14 = _slicedToArray(_Xe$exports$useState13, 2),
      r = _Xe$exports$useState14[0],
      o = _Xe$exports$useState14[1],
      _sy2 = sy("stytch.magicLinks.discovery.send", function () {
        var e, o;
        return t.magicLinks.email.discovery.send({
          email_address: r,
          discovery_redirect_url: null === (e = n.emailMagicLinksOptions) || void 0 === e ? void 0 : e.discoveryRedirectURL,
          login_template_id: null === (o = n.emailMagicLinksOptions) || void 0 === o ? void 0 : o.loginTemplateId
        });
      }, {
        onSuccess: function onSuccess() {
          e({
            type: "set_magic_link_email",
            email: r
          }), e({
            type: "transition",
            screen: cm.EmailConfirmation
          });
        }
      }),
      i = _sy2.trigger,
      a = _sy2.error,
      s = _sy2.isMutating;
    return Mt.createElement("form", {
      onSubmit: function onSubmit(e) {
        return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
          return _regeneratorRuntime().wrap(function _callee23$(_context23) {
            while (1) switch (_context23.prev = _context23.next) {
              case 0:
                e.preventDefault(), i();
              case 1:
              case "end":
                return _context23.stop();
            }
          }, _callee23);
        }));
      }
    }, Mt.createElement(Yg, {
      direction: "column",
      gap: 8
    }, Mt.createElement(Yg, {
      direction: "column",
      minHeight: 52
    }, Mt.createElement(_y, {
      email: r,
      setEmail: o
    }), a && Mt.createElement(ky, {
      errorMessage: a.error_message
    })), Mt.createElement(Ay, {
      isSubmitting: s,
      text: "Continue with email"
    })));
  },
  Oy = function Oy(_ref45) {
    var e = _ref45.display_name,
      t = _ref45.connection_id;
    var n = mm(),
      r = vm();
    return Xe.exports.createElement(fy, {
      id: "sso-".concat(e),
      type: "submit",
      onClick: function onClick() {
        var e, o;
        return n.sso.start({
          connection_id: t,
          signup_redirect_url: null === (e = r.ssoOptions) || void 0 === e ? void 0 : e.signupRedirectURL,
          login_redirect_url: null === (o = r.ssoOptions) || void 0 === o ? void 0 : o.loginRedirectURL
        });
      },
      variant: "outlined"
    }, Xe.exports.createElement(Yg, {
      justifyContent: "center",
      alignItems: "center",
      gap: 4
    }, Xe.exports.createElement("span", {
      style: {
        verticalAlign: "middle"
      }
    }, "Continue with ".concat(e))));
  },
  Py = function Py() {
    var _gm7 = gm(),
      _gm8 = _slicedToArray(_gm7, 1),
      e = _gm8[0];
    return e.flowState.organization ? Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 8,
      className: "oauth-buttons"
    }, e.flowState.organization.sso_active_connections.map(function (e) {
      return Xe.exports.createElement(Oy, {
        key: "oauth-".concat(e.display_name),
        display_name: e.display_name,
        connection_id: e.connection_id
      });
    })) : Xe.exports.createElement(Xe.exports.Fragment, null);
  },
  Ty = _o(Yg)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (e) {
    return e.theme.colors.secondary;
  }),
  Iy = _o.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  border-bottom: 1px solid ", ";\n  flex-grow: 1;\n"])), function (e) {
    return "left" === e.$placement && "margin-right: 6px;";
  }, function (e) {
    return "right" === e.$placement && "margin-left: 6px;";
  }, function (e) {
    return e.theme.colors.secondary;
  }),
  By = _o(Jg)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (e) {
    return e.theme.colors.secondary;
  }),
  Ry = function Ry() {
    return Mt.createElement(Ty, {
      alignItems: "center"
    }, Mt.createElement(Iy, {
      $placement: "left"
    }), Mt.createElement(By, null, "or"), Mt.createElement(Iy, {
      $placement: "right"
    }));
  },
  Ly = function Ly(_ref46) {
    var _ref46$enabled = _ref46.enabled,
      e = _ref46$enabled === void 0 ? !1 : _ref46$enabled;
    return Mt.createElement("svg", {
      width: "20",
      height: "14",
      viewBox: "0 0 20 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Mt.createElement("path", {
      d: "M9.99992 2.41667C13.1583 2.41667 15.9749 4.19167 17.3499 7C15.9749 9.80833 13.1583 11.5833 9.99992 11.5833C6.84158 11.5833 4.02492 9.80833 2.64992 7C4.02492 4.19167 6.84158 2.41667 9.99992 2.41667ZM9.99992 0.75C5.83325 0.75 2.27492 3.34167 0.833252 7C2.27492 10.6583 5.83325 13.25 9.99992 13.25C14.1666 13.25 17.7249 10.6583 19.1666 7C17.7249 3.34167 14.1666 0.75 9.99992 0.75ZM9.99992 4.91667C11.1499 4.91667 12.0833 5.85 12.0833 7C12.0833 8.15 11.1499 9.08333 9.99992 9.08333C8.84992 9.08333 7.91658 8.15 7.91658 7C7.91658 5.85 8.84992 4.91667 9.99992 4.91667ZM9.99992 3.25C7.93325 3.25 6.24992 4.93333 6.24992 7C6.24992 9.06667 7.93325 10.75 9.99992 10.75C12.0666 10.75 13.7499 9.06667 13.7499 7C13.7499 4.93333 12.0666 3.25 9.99992 3.25Z",
      fill: e ? "#19303D" : "#5C727D"
    }));
  },
  My = function My() {
    return Mt.createElement("svg", {
      width: "20",
      height: "16",
      viewBox: "0 0 20 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Mt.createElement("path", {
      d: "M10.0002 2.97921C13.1585 2.97921 15.9752 4.75421 17.3502 7.56254C16.8585 8.57921 16.1668 9.45421 15.3418 10.1625L16.5168 11.3375C17.6752 10.3125 18.5918 9.02921 19.1668 7.56254C17.7252 3.90421 14.1668 1.31254 10.0002 1.31254C8.94183 1.31254 7.92516 1.47921 6.96683 1.78754L8.34183 3.16254C8.8835 3.05421 9.4335 2.97921 10.0002 2.97921ZM9.1085 3.92921L10.8335 5.65421C11.3085 5.86254 11.6918 6.24587 11.9002 6.72087L13.6252 8.44587C13.6918 8.16254 13.7418 7.86254 13.7418 7.55421C13.7502 5.48754 12.0668 3.81254 10.0002 3.81254C9.69183 3.81254 9.40016 3.85421 9.1085 3.92921ZM1.67516 1.20421L3.9085 3.43754C2.55016 4.50421 1.47516 5.92087 0.833496 7.56254C2.27516 11.2209 5.8335 13.8125 10.0002 13.8125C11.2668 13.8125 12.4835 13.5709 13.6002 13.1292L16.4502 15.9792L17.6252 14.8042L2.85016 0.020874L1.67516 1.20421ZM7.92516 7.45421L10.1002 9.62921C10.0668 9.63754 10.0335 9.64587 10.0002 9.64587C8.85016 9.64587 7.91683 8.71254 7.91683 7.56254C7.91683 7.52087 7.92516 7.49587 7.92516 7.45421ZM5.09183 4.62087L6.55016 6.07921C6.3585 6.53754 6.25016 7.03754 6.25016 7.56254C6.25016 9.62921 7.9335 11.3125 10.0002 11.3125C10.5252 11.3125 11.0252 11.2042 11.4752 11.0125L12.2918 11.8292C11.5585 12.0292 10.7918 12.1459 10.0002 12.1459C6.84183 12.1459 4.02516 10.3709 2.65016 7.56254C3.2335 6.37087 4.0835 5.38754 5.09183 4.62087Z",
      fill: "#19303D"
    }));
  },
  Dy = _o.input(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  border: 0;\n  padding: 0;\n  width: 100%;\n\n  background-color: transparent;\n  height: 45px;\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n\n  & input::placeholder: {\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])), function (e) {
    return e.theme.colors.primary;
  }, function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    return e.theme.colors.disabledText;
  }, function (e) {
    return e.theme.colors.disabledText;
  }, function (e) {
    return e.theme.colors.disabled;
  }),
  Ny = _o(Yg)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  height: 45px;\n  padding-left: 8px;\n  padding-right: 8px;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n  width: calc(100% - 18px);\n  & input::placeholder: {\n    color: ", ";\n  }\n"])), function (e) {
    return e.theme.colors.primary;
  }, function (e) {
    return e.theme.colors.primary;
  }, function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    return e.theme.colors.disabledText;
  }),
  zy = _o.button(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n"]))),
  jy = function jy(_ref47) {
    var e = _ref47.onClick,
      t = _ref47.enabled,
      n = _ref47.visible;
    return Mt.createElement(zy, {
      onClick: e,
      type: "button"
    }, n ? Mt.createElement(My, null) : Mt.createElement(Ly, {
      enabled: t
    }));
  },
  Fy = function Fy(_ref48) {
    var e = _ref48.password,
      t = _ref48.setPassword,
      n = _ref48.type;
    var _Xe$exports$useState15 = Xe.exports.useState(!1),
      _Xe$exports$useState16 = _slicedToArray(_Xe$exports$useState15, 2),
      r = _Xe$exports$useState16[0],
      o = _Xe$exports$useState16[1];
    return Mt.createElement(Ny, {
      gap: 2,
      alignItems: "center"
    }, Mt.createElement(Dy, {
      name: "password",
      "aria-label": "Password",
      id: "".concat(n, "-password"),
      autoComplete: "".concat(n, "-password"),
      type: r ? "text" : "password",
      value: e,
      onChange: function onChange(e) {
        return t(e.target.value);
      },
      required: !0
    }), Mt.createElement(jy, {
      onClick: function onClick() {
        return o(function (e) {
          return !e;
        });
      },
      enabled: !!e,
      visible: r
    }));
  },
  Uy = _o.button(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n"]))),
  Qy = function Qy(_ref49) {
    var e = _ref49.color;
    return Mt.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Mt.createElement("path", {
      d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z",
      fill: e
    }));
  },
  $y = function $y(_ref50) {
    var e = _ref50.onClick;
    var t = bo();
    return Mt.createElement(Uy, {
      onClick: e
    }, Mt.createElement(Qy, {
      color: t.colors.primary
    }));
  },
  Hy = _o(Jg)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-weight: bold !important;\n  cursor: pointer;\n"]))),
  Vy = function Vy() {
    var _gm9 = gm(),
      _gm10 = _slicedToArray(_gm9, 2),
      e = _gm10[1],
      t = vm().passwordOptions,
      _uy = uy(),
      n = _uy.email,
      r = _uy.setEmail,
      o = _uy.password,
      i = _uy.setPassword,
      a = _uy.organization,
      s = _uy.errorMessage,
      l = _uy.setErrorMessage,
      c = _uy.isSubmitting,
      u = _uy.submitPassword;
    if (!t) return Mt.createElement(Mt.Fragment, null);
    if (!a) return Mt.createElement(Mt.Fragment, null);
    return Mt.createElement(Yg, {
      direction: "column",
      gap: 28
    }, Mt.createElement($y, {
      onClick: function onClick() {
        return e({
          type: "transition",
          screen: cm.Main
        });
      }
    }), Mt.createElement(Jg, {
      size: "header"
    }, "Log in with email and password"), Mt.createElement("form", {
      onSubmit: function onSubmit(e) {
        return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
          return _regeneratorRuntime().wrap(function _callee24$(_context24) {
            while (1) switch (_context24.prev = _context24.next) {
              case 0:
                e.preventDefault(), a && (n.match(Ne) ? u(a.organization_id) : l("Invalid email address"));
              case 1:
              case "end":
                return _context24.stop();
            }
          }, _callee24);
        }));
      }
    }, Mt.createElement(Yg, {
      direction: "column",
      gap: 8
    }, Mt.createElement(Yg, {
      direction: "column",
      gap: 2
    }, Mt.createElement(Jg, {
      size: "helper",
      color: "secondary"
    }, "Email"), Mt.createElement(_y, {
      email: n,
      setEmail: r
    })), Mt.createElement(Yg, {
      direction: "column",
      gap: 2
    }, Mt.createElement(Jg, {
      size: "helper",
      color: "secondary"
    }, "Password"), Mt.createElement(Fy, {
      password: o,
      setPassword: i,
      type: "current"
    }), Mt.createElement(ky, {
      errorMessage: s
    })), Mt.createElement(Ay, {
      isSubmitting: c,
      text: "Continue"
    }), Mt.createElement(Yg, {
      onClick: function onClick() {
        e({
          type: "set_password_state",
          email: n
        }), e({
          type: "transition",
          screen: cm.PasswordForgotForm
        });
      },
      direction: "row"
    }, Mt.createElement(Jg, {
      color: "secondary"
    }, "Having trouble signing in?"), " ", Mt.createElement(Hy, {
      color: "secondary"
    }, "Get help")))));
  },
  Wy = function Wy() {
    var _gm11 = gm(),
      _gm12 = _slicedToArray(_gm11, 2),
      e = _gm12[1],
      t = vm().passwordOptions,
      _Xe$exports$useState17 = Xe.exports.useState(!0),
      _Xe$exports$useState18 = _slicedToArray(_Xe$exports$useState17, 2),
      n = _Xe$exports$useState18[0],
      r = _Xe$exports$useState18[1],
      _uy2 = uy(),
      o = _uy2.stytch,
      i = _uy2.email,
      a = _uy2.setEmail,
      s = _uy2.password,
      l = _uy2.setPassword,
      c = _uy2.organization,
      u = _uy2.errorMessage,
      d = _uy2.setErrorMessage,
      f = _uy2.isSubmitting,
      p = _uy2.setIsSubmitting,
      h = _uy2.submitPassword,
      m = _uy2.handleNonMemberReset;
    if (!t) return Mt.createElement(Mt.Fragment, null);
    if (!c) return Mt.createElement(Mt.Fragment, null);
    return Mt.createElement(Yg, {
      direction: "column",
      gap: 36
    }, Mt.createElement("form", {
      onSubmit: function onSubmit(t) {
        return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
          var a;
          return _regeneratorRuntime().wrap(function _callee25$(_context25) {
            while (1) switch (_context25.prev = _context25.next) {
              case 0:
                t.preventDefault();
                a = c.organization_id;
                n ? i.match(Ne) ? (d(""), p(!0), Je(o).searchManager.searchMember(i, c.organization_id).then(function (_ref51) {
                  var t = _ref51.member;
                  if (null == t ? void 0 : t.member_password_id) return r(!1), p(!1), void e({
                    type: "set_password_state",
                    email: i
                  });
                  m();
                })["catch"](function (e) {
                  p(!1), d(e.message);
                })) : d("Invalid email address") : h(a);
              case 3:
              case "end":
                return _context25.stop();
            }
          }, _callee25);
        }));
      }
    }, Mt.createElement(Yg, {
      direction: "column",
      gap: 8
    }, Mt.createElement(Yg, {
      direction: "column",
      gap: 2
    }, Mt.createElement(Jg, {
      size: "helper",
      color: "secondary"
    }, "Email"), Mt.createElement(_y, {
      email: i,
      setEmail: a
    })), !n && Mt.createElement(Yg, {
      direction: "column",
      gap: 2
    }, Mt.createElement(Jg, {
      size: "helper",
      color: "secondary"
    }, "Password"), Mt.createElement(Fy, {
      password: s,
      setPassword: l,
      type: "current"
    })), Mt.createElement(ky, {
      errorMessage: u
    }), Mt.createElement(Ay, {
      isSubmitting: f,
      text: "Continue"
    }), !n && Mt.createElement(Yg, {
      onClick: function onClick() {
        e({
          type: "set_password_state",
          email: i
        }), e({
          type: "transition",
          screen: cm.PasswordForgotForm
        });
      },
      direction: "row"
    }, Mt.createElement(Jg, {
      color: "secondary"
    }, "Having trouble signing in?"), " ", Mt.createElement(Hy, {
      color: "secondary"
    }, "Get help")))));
  },
  Ky = function Ky(e) {
    var t = mm(),
      _gm13 = gm(),
      _gm14 = _slicedToArray(_gm13, 1),
      n = _gm14[0];
    return Mt.createElement(fy, {
      id: "oauth-".concat(e.providerType),
      type: "submit",
      onClick: function onClick() {
        return n.flowState.organization ? t.oauth[e.providerType].start({
          login_redirect_url: e.loginRedirectUrl,
          signup_redirect_url: e.signupRedirectUrl,
          custom_scopes: e.customScopes,
          organization_id: n.flowState.organization.organization_id
        }) : t.oauth[e.providerType].discovery.start({
          discovery_redirect_url: e.discoveryRedirectUrl,
          custom_scopes: e.customScopes
        });
      },
      variant: "outlined"
    }, Mt.createElement(Yg, {
      justifyContent: "center",
      alignItems: "center",
      gap: 4
    }, e.icon, Mt.createElement("span", {
      style: {
        verticalAlign: "middle"
      }
    }, "Continue with ", e.providerTypeTitle)));
  };
var qy = function qy(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    wrapped: !0
  };
  return function () {
    var r = function (e) {
      var _Xe$exports$useState19 = Xe.exports.useState(e),
        _Xe$exports$useState20 = _slicedToArray(_Xe$exports$useState19, 2),
        t = _Xe$exports$useState20[0],
        n = _Xe$exports$useState20[1];
      return Xe.exports.useEffect(function () {
        var t = Math.floor(1e6 * Math.random());
        n("".concat(e, "-").concat(t));
      }, [e]), t;
    }(e);
    return n.wrapped ? Mt.createElement(Yg, {
      height: 24,
      width: 24
    }, Mt.createElement(t, {
      patternId: r
    })) : Mt.createElement(t, {
      patternId: r
    });
  };
};
var Gy = qy("google", function () {
  return Mt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%"
  }, Mt.createElement("path", {
    fill: "#FFC107",
    d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
  }), Mt.createElement("path", {
    fill: "#FF3D00",
    d: "M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
  }), Mt.createElement("path", {
    fill: "#4CAF50",
    d: "M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
  }), Mt.createElement("path", {
    fill: "#1976D2",
    d: "M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
  }));
});
var Yy = qy("microsoft", function (_ref52) {
  var e = _ref52.patternId;
  return Mt.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Mt.createElement("rect", {
    width: "22",
    height: "22",
    fill: "url(#".concat(e, ")")
  }), Mt.createElement("defs", null, Mt.createElement("pattern", {
    id: e,
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, Mt.createElement("use", {
    href: "#microsoftImage",
    transform: "scale(0.000976562)"
  })), Mt.createElement("image", {
    id: "microsoftImage",
    width: "1024",
    height: "1024",
    xlinkHref: "data:image/png;base64,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"
  })));
});
var Jy = function Jy() {
    var e, t;
    var n = vm(),
      _gm15 = gm(),
      _gm16 = _slicedToArray(_gm15, 1),
      r = _gm16[0];
    if (!n.oauthOptions) return Xe.exports.createElement(Xe.exports.Fragment, null);
    var _n$oauthOptions = n.oauthOptions,
      o = _n$oauthOptions.providers,
      i = _n$oauthOptions.loginRedirectURL,
      a = _n$oauthOptions.signupRedirectURL,
      s = _n$oauthOptions.discoveryRedirectURL,
      l = _n$oauthOptions.customScopes;
    var c = [];
    r.flowState.organization && "RESTRICTED" === r.flowState.organization.auth_methods && (c = null !== (t = null === (e = r.flowState.organization) || void 0 === e ? void 0 : e.allowed_auth_methods) && void 0 !== t ? t : []);
    var u = o.map(function (e) {
      var _ref53 = function (e) {
          switch (e) {
            case em.Google:
              return {
                providerTypeTitle: "Google",
                allowedAuthMethod: "google_oauth",
                icon: Xe.exports.createElement(Gy, null)
              };
            case em.Microsoft:
              return {
                providerTypeTitle: "Microsoft",
                allowedAuthMethod: "microsoft_oauth",
                icon: Xe.exports.createElement(Yy, null)
              };
            default:
              return {
                providerTypeTitle: "",
                allowedAuthMethod: "",
                icon: Xe.exports.createElement(Xe.exports.Fragment, null)
              };
          }
        }(e),
        t = _ref53.icon,
        n = _ref53.providerTypeTitle,
        o = _ref53.allowedAuthMethod;
      return !r.flowState.organization || "ALL_ALLOWED" === r.flowState.organization.auth_methods || c.includes(o) ? Xe.exports.createElement(Ky, {
        key: "oauth-".concat(e),
        providerType: e,
        icon: t,
        providerTypeTitle: n,
        loginRedirectUrl: i,
        signupRedirectUrl: a,
        discoveryRedirectUrl: s,
        customScopes: l
      }) : (console.error("Provider ".concat(e, " is not an `allowed_auth_method` for this organization. Please update your organization settings.")), null);
    });
    return Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 8,
      className: "oauth-buttons"
    }, u);
  },
  Zy = _o(Jg)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  font-weight: bold !important;\n  cursor: pointer;\n"]))),
  Xy = function Xy() {
    var _gm17 = gm(),
      _gm18 = _slicedToArray(_gm17, 2),
      e = _gm18[1];
    return Mt.createElement(Yg, {
      justifyContent: "center"
    }, Mt.createElement(Zy, {
      onClick: function onClick() {
        e({
          type: "transition",
          screen: cm.PasswordAuthenticate
        });
      }
    }, "Use a password instead"));
  };
var eA;
!function (e) {
  e.MagicLinkEmailForm = "MagicLinkEmailForm", e.MagicLinkEmailDiscoveryForm = "MagicLinkEmailDiscoveryForm", e.OAuthButtons = "OAuthButtons", e.SSOButtons = "SSOButtons", e.PasswordsEmailForm = "PasswordsEmailForm", e.PasswordEMLCombined = "PasswordEMLCombined", e.Divider = "Divider";
}(eA || (eA = {}));
var tA = _o(Yg)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  > * + * {\n    margin-top: 24px;\n  }\n"]))),
  nA = _o.img(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  max-height: 50px;\n  max-width: 100px;\n"]))),
  rA = _o(Jg)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  text-align: center;\n"]))),
  oA = function oA(_ref54) {
    var e = _ref54.orgLogo,
      t = _ref54.appLogo;
    return "" !== e && "" !== t ? Mt.createElement(Mt.Fragment, null) : Mt.createElement(Yg, {
      justifyContent: "center",
      gap: 4
    }, Mt.createElement(nA, {
      src: e
    }), Mt.createElement(nA, {
      src: t
    }));
  },
  iA = function iA(_ref55) {
    var e = _ref55.components;
    var t = e.map(function (e) {
      switch (e) {
        case eA.MagicLinkEmailForm:
          return Mt.createElement(Cy, {
            key: e
          });
        case eA.MagicLinkEmailDiscoveryForm:
          return Mt.createElement(xy, {
            key: e
          });
        case eA.OAuthButtons:
          return Mt.createElement(Jy, {
            key: e
          });
        case eA.SSOButtons:
          return Mt.createElement(Py, {
            key: e
          });
        case eA.PasswordsEmailForm:
          return Mt.createElement(Wy, {
            key: e
          });
        case eA.PasswordEMLCombined:
          return Mt.createElement(Yg, {
            key: "eml_password",
            direction: "column",
            gap: 12
          }, Mt.createElement(Cy, {
            key: "magic_link"
          }), Mt.createElement(Xy, {
            key: "password"
          }));
        case eA.Divider:
          return Mt.createElement(Ry, {
            key: "divider"
          });
      }
    });
    return Mt.createElement(Mt.Fragment, null, t);
  },
  aA = function aA() {
    var e, t, n, r, o, i, a;
    var _bo = bo(),
      s = _bo.logo,
      l = vm(),
      _gm19 = gm(),
      _gm20 = _slicedToArray(_gm19, 1),
      c = _gm20[0],
      u = [];
    var d = l.products;
    if ("RESTRICTED" === (null === (e = c.flowState.organization) || void 0 === e ? void 0 : e.auth_methods)) {
      (null !== (n = null === (t = c.flowState.organization) || void 0 === t ? void 0 : t.allowed_auth_methods) && void 0 !== n ? n : []).forEach(function (e) {
        "sso" === e && u.push(Zh.sso), "magic_link" === e && u.push(Zh.emailMagicLinks), "password" === e && u.push(Zh.passwords), "google_oauth" !== e && "microsoft_oauth" !== e || u.push(Zh.oauth);
      }), d = d.filter(function (e) {
        return u.includes(e);
      });
    }
    var f = function (e, t) {
      var n = e.includes(Zh.emailMagicLinks) && e.includes(Zh.passwords),
        r = e.map(function (e) {
          switch (e) {
            case Zh.emailMagicLinks:
              return n ? null : t === Xh.Organization ? eA.MagicLinkEmailForm : eA.MagicLinkEmailDiscoveryForm;
            case Zh.oauth:
              return eA.OAuthButtons;
            case Zh.sso:
              return t === Xh.Organization ? eA.SSOButtons : null;
            case Zh.passwords:
              return n ? null : eA.PasswordsEmailForm;
          }
        }).filter(function (e) {
          return null !== e;
        });
      if (n) {
        var _n10 = e.indexOf(Zh.passwords),
          _o8 = e.indexOf(Zh.emailMagicLinks),
          _i6 = Math.min(_n10, _o8),
          _a4 = t === Xh.Organization ? eA.PasswordEMLCombined : eA.MagicLinkEmailDiscoveryForm;
        r.splice(_i6, 0, _a4);
      }
      var o = r.includes(eA.OAuthButtons) || r.includes(eA.SSOButtons),
        i = e.includes(Zh.emailMagicLinks) || e.includes(Zh.passwords),
        a = o && i;
      return r.length > 1 && a && r.splice(r.length - 1, 0, eA.Divider), r;
    }(d, c.flowState.type);
    var p;
    switch (c.flowState.type) {
      case Xh.Discovery:
        p = "Sign up or log in";
        break;
      case Xh.PasswordReset:
        p = "";
        break;
      default:
        p = "Continue to ".concat(null !== (o = null === (r = c.flowState.organization) || void 0 === r ? void 0 : r.organization_name) && void 0 !== o ? o : "...");
    }
    return Mt.createElement(tA, {
      direction: "column"
    }, Mt.createElement(oA, {
      appLogo: s.logoImageUrl,
      orgLogo: null !== (a = null === (i = c.flowState.organization) || void 0 === i ? void 0 : i.organization_logo_url) && void 0 !== a ? a : ""
    }), p ? Mt.createElement(Yg, {
      justifyContent: "center"
    }, Mt.createElement(rA, {
      size: "header"
    }, p)) : Mt.createElement(Mt.Fragment, null), Mt.createElement(iA, {
      components: f
    }));
  };
var sA = qy("gmail", function () {
  return Mt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%"
  }, Mt.createElement("path", {
    fill: "#4caf50",
    d: "M45,16.2l-5,2.75l-5,4.75L35,40h7c1.657,0,3-1.343,3-3V16.2z"
  }), Mt.createElement("path", {
    fill: "#1e88e5",
    d: "M3,16.2l3.614,1.71L13,23.7V40H6c-1.657,0-3-1.343-3-3V16.2z"
  }), Mt.createElement("polygon", {
    fill: "#e53935",
    points: "35,11.2 24,19.45 13,11.2 12,17 13,23.7 24,31.95 35,23.7 36,17"
  }), Mt.createElement("path", {
    fill: "#c62828",
    d: "M3,12.298V16.2l10,7.5V11.2L9.876,8.859C9.132,8.301,8.228,8,7.298,8h0C4.924,8,3,9.924,3,12.298z"
  }), Mt.createElement("path", {
    fill: "#fbc02d",
    d: "M45,12.298V16.2l-10,7.5V11.2l3.124-2.341C38.868,8.301,39.772,8,40.702,8h0 C43.076,8,45,9.924,45,12.298z"
  }));
});
var lA = qy("outlook", function () {
  return Mt.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0 0 103.17322 104.31332",
    xmlSpace: "preserve"
  }, Mt.createElement("defs", {
    id: "defs43"
  }), Mt.createElement("path", {
    d: "m 64.566509,22.116383 v 20.404273 l 7.130526,4.489881 c 0.188058,0.05485 0.595516,0.05877 0.783574,0 L 103.16929,26.320259 c 0,-2.44867 -2.28412,-4.203876 -3.573094,-4.203876 H 64.566509 z",
    id: "path3",
    "inkscape:connector-curvature": "0",
    style: {
      fill: "#0072c6"
    }
  }), Mt.createElement("path", {
    d: "m 64.566509,50.13308 6.507584,4.470291 c 0.916782,0.673874 2.021622,0 2.021622,0 -1.100922,0.673874 30.077495,-20.035993 30.077495,-20.035993 v 37.501863 c 0,4.082422 -2.61322,5.794531 -5.551621,5.794531 H 64.562591 V 50.13308 z",
    id: "path5",
    "inkscape:connector-curvature": "0",
    style: {
      fill: "#0072c6"
    }
  }), Mt.createElement("g", {
    id: "g23",
    transform: "matrix(3.9178712,0,0,3.9178712,-13.481403,-41.384473)"
  }, Mt.createElement("path", {
    d: "m 11.321,20.958 c -0.566,0 -1.017,0.266 -1.35,0.797 -0.333,0.531 -0.5,1.234 -0.5,2.109 0,0.888 0.167,1.59 0.5,2.106 0.333,0.517 0.77,0.774 1.31,0.774 0.557,0 0.999,-0.251 1.325,-0.753 0.326,-0.502 0.49,-1.199 0.49,-2.09 0,-0.929 -0.158,-1.652 -0.475,-2.169 -0.317,-0.516 -0.75,-0.774 -1.3,-0.774 z",
    id: "path25",
    "inkscape:connector-curvature": "0",
    style: {
      fill: "#0072c6"
    }
  }), Mt.createElement("path", {
    d: "m 3.441,13.563 v 20.375 l 15.5,3.25 V 10.563 l -15.5,3 z m 10.372,13.632 c -0.655,0.862 -1.509,1.294 -2.563,1.294 -1.027,0 -1.863,-0.418 -2.51,-1.253 C 8.094,26.4 7.77,25.312 7.77,23.97 c 0,-1.417 0.328,-2.563 0.985,-3.438 0.657,-0.875 1.527,-1.313 2.61,-1.313 1.023,0 1.851,0.418 2.482,1.256 0.632,0.838 0.948,1.942 0.948,3.313 10e-4,1.409 -0.327,2.545 -0.982,3.407 z",
    id: "path27",
    "inkscape:connector-curvature": "0",
    style: {
      fill: "#0072c6"
    }
  })));
});
var cA = qy("yahoo", function (_ref56) {
  var e = _ref56.patternId;
  return Mt.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Mt.createElement("rect", {
    width: "22",
    height: "22",
    fill: "url(#".concat(e, ")")
  }), Mt.createElement("defs", null, Mt.createElement("pattern", {
    id: e,
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, Mt.createElement("use", {
    href: "#yahooImage",
    transform: "scale(0.000976562)"
  })), Mt.createElement("image", {
    id: "yahooImage",
    width: "1024",
    height: "1024",
    xlinkHref: "data:image/jpeg;base64,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"
  })));
});
var uA = _o.a(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n    text-decoration-color: ", ";\n  }\n"])), function (e) {
    return e.theme.colors.primary;
  }),
  dA = function dA(_ref57) {
    var e = _ref57.label,
      t = _ref57.href,
      n = _ref57.Icon;
    return Mt.createElement(Yg, {
      gap: 4
    }, n, Mt.createElement(uA, {
      href: t,
      target: "_blank",
      rel: "noopener noreferrer"
    }, Mt.createElement(Jg, null, "Open in ", e)));
  },
  fA = function fA(_ref58) {
    var e = _ref58.emailDomain,
      t = _ref58.reset,
      n = _ref58.email;
    var _ref59 = function (e) {
        return e ? {
          GMAIL: "https://mail.google.com/mail/u/0/#search/".concat(encodeURIComponent("from:@".concat(e, " in:anywhere"))),
          OUTLOOK: "https://outlook.office.com/mail/0/inbox",
          YAHOO: "https://mail.yahoo.com/d/search/keyword=".concat(e)
        } : {
          GMAIL: "https://mail.google.com/mail/u/0/#search/in%3Aanywhere",
          OUTLOOK: "https://outlook.office.com/mail/0/inbox",
          YAHOO: "https://mail.yahoo.com/d/search/referrer=unread"
        };
      }(e),
      r = _ref59.GMAIL,
      o = _ref59.YAHOO,
      i = _ref59.OUTLOOK;
    return Mt.createElement(Yg, {
      direction: "column",
      gap: 24
    }, Mt.createElement(Jg, {
      size: "header"
    }, "Check your email"), Mt.createElement(Yg, {
      direction: "column",
      gap: 12
    }, Mt.createElement(Jg, null, "An email was sent to ", Mt.createElement("b", null, n), "."), Mt.createElement(Yg, {
      direction: "column",
      gap: 8
    }, Mt.createElement(dA, {
      href: r,
      label: "Gmail",
      Icon: Mt.createElement(sA, null)
    }), Mt.createElement(dA, {
      href: o,
      label: "Yahoo",
      Icon: Mt.createElement(cA, null)
    }), Mt.createElement(dA, {
      href: i,
      label: "Outlook",
      Icon: Mt.createElement(lA, null)
    }))), Mt.createElement(fy, {
      onClick: t
    }, "Try again"));
  },
  pA = function pA() {
    var _gm21 = gm(),
      _gm22 = _slicedToArray(_gm21, 2),
      e = _gm22[0],
      t = _gm22[1],
      n = function () {
        var e, t;
        var n = mm(),
          r = vm(),
          _Xe$exports$useState21 = Xe.exports.useState(function () {
            var _Je$bootstrap$getSync = Je(n).bootstrap.getSync(),
              e = _Je$bootstrap$getSync.emailDomains;
            return e;
          }),
          _Xe$exports$useState22 = _slicedToArray(_Xe$exports$useState21, 2),
          o = _Xe$exports$useState22[0],
          i = _Xe$exports$useState22[1];
        return Xe.exports.useEffect(function () {
          Je(n).bootstrap.getAsync().then(function (_ref60) {
            var e = _ref60.emailDomains;
            i(e);
          });
        }, [n]), (null === (e = r.emailMagicLinksOptions) || void 0 === e ? void 0 : e.domainHint) ? null === (t = r.emailMagicLinksOptions) || void 0 === t ? void 0 : t.domainHint : 1 === o.length ? o[0] : null;
      }();
    return Mt.createElement(fA, {
      emailDomain: n,
      reset: function reset() {
        t({
          type: "set_magic_link_email",
          email: ""
        }), t({
          type: "transition",
          screen: cm.Main
        });
      },
      email: e.formState.magicLinkState.email
    });
  },
  hA = function hA() {
    return Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 36,
      alignItems: "center"
    }, Xe.exports.createElement(Jg, {
      size: "header"
    }, "Logging in..."), Xe.exports.createElement(yy, {
      size: 100,
      thickness: 8
    }));
  },
  mA = function mA() {
    return Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 36,
      alignItems: "center"
    }, Xe.exports.createElement(yy, {
      size: 100,
      thickness: 8
    }));
  },
  gA = _o(Yg)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  border: ", ";\n  border-radius: ", ";\n  > div + div {\n    border-top: ", ";\n  }\n"])), function (_ref61) {
    var e = _ref61.theme;
    return e.container.border;
  }, function (_ref62) {
    var e = _ref62.theme;
    return e.container.borderRadius;
  }, function (_ref63) {
    var e = _ref63.theme;
    return e.container.border;
  }),
  vA = _o(Yg)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]))),
  yA = _o.img(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  height: 40px;\n  width: 40px;\n  border-radius: 4px;\n"]))),
  AA = _o(Yg)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  height: 40px;\n  width: 40px;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 4px;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 25px;\n"])), function (_ref64) {
    var e = _ref64.theme;
    return e.buttons.primary.backgroundColor;
  }, function (_ref65) {
    var e = _ref65.theme;
    return e.buttons.primary.textColor;
  }),
  bA = function bA() {
    return Xe.exports.createElement("svg", {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Xe.exports.createElement("path", {
      d: "M7 0.333313L5.825 1.50831L10.475 6.16665H0.333334V7.83331H10.475L5.825 12.4916L7 13.6666L13.6667 6.99998L7 0.333313Z",
      fill: "#19303D"
    }));
  },
  _A = function _A(_ref66) {
    var e = _ref66.name,
      t = _ref66.logo;
    return "" !== t ? Xe.exports.createElement(yA, {
      src: t
    }) : Xe.exports.createElement(AA, {
      alignItems: "center",
      justifyContent: "center"
    }, e[0]);
  },
  wA = function wA(_ref67) {
    var e = _ref67.type;
    return "eligible_to_join_by_email_domain" === e || "pending_member" === e ? Xe.exports.createElement(Jg, null, "Join") : "invited_member" === e ? Xe.exports.createElement(Jg, null, "Accept Invite") : Xe.exports.createElement(Xe.exports.Fragment, null);
  },
  kA = function kA() {
    var _gm23 = gm(),
      _gm24 = _slicedToArray(_gm23, 2),
      e = _gm24[0],
      t = _gm24[1],
      n = mm(),
      r = vm(),
      _ly = ly(),
      o = _ly.createOrganizationEnabled,
      i = function i() {
        return t({
          type: "transition",
          screen: cm.Main
        });
      },
      _sy3 = sy("stytch.discovery.organization.create", function () {
        return n.discovery.organizations.create({
          session_duration_minutes: r.sessionOptions.sessionDurationMinutes
        });
      }, {
        onSuccess: function onSuccess(e) {
          cy(e, t);
        },
        onError: function onError() {
          t({
            type: "transition",
            screen: cm.Error
          });
        }
      }),
      a = _sy3.trigger,
      s = _sy3.isMutating;
    return s ? Xe.exports.createElement(mA, null) : o ? Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 24
    }, Xe.exports.createElement($y, {
      onClick: i
    }), Xe.exports.createElement(Jg, {
      size: "header"
    }, "Create an organization to get started"), Xe.exports.createElement(fy, {
      onClick: function onClick() {
        return a();
      }
    }, "Create an organization"), Xe.exports.createElement(Jg, null, e.formState.discoveryState.email, " does not have an account. Think this is a mistake? Try a different email address, or contact your admin.")) : Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 24
    }, Xe.exports.createElement($y, {
      onClick: i
    }), Xe.exports.createElement(Jg, {
      size: "header"
    }, e.formState.discoveryState.email, " does not belong to any organizations."), Xe.exports.createElement(Jg, null, "Make sure your email address is correct. Otherwise, you might need to be invited by your admin."), Xe.exports.createElement(fy, {
      variant: "outlined",
      onClick: i
    }, "Try a different email address"));
  },
  EA = function EA() {
    var _gm25 = gm(),
      _gm26 = _slicedToArray(_gm25, 2),
      e = _gm26[0],
      t = _gm26[1],
      n = mm(),
      r = vm(),
      _ly2 = ly(),
      o = _ly2.createOrganizationEnabled,
      i = Xe.exports.useCallback(function (e) {
        n.sso.start({
          connection_id: e
        });
      }, [n]),
      _sy4 = sy("stytch.discovery.intermediateSessions.exchange", function (e, _ref68) {
        var t = _ref68.arg.organizationId;
        return n.discovery.intermediateSessions.exchange({
          organization_id: t,
          session_duration_minutes: r.sessionOptions.sessionDurationMinutes
        });
      }, {
        onSuccess: function onSuccess(e) {
          cy(e, t);
        }
      }),
      a = _sy4.trigger,
      s = _sy4.isMutating,
      _sy5 = sy("stytch.discovery.organization.create", function () {
        return n.discovery.organizations.create({
          session_duration_minutes: r.sessionOptions.sessionDurationMinutes
        });
      }, {
        onSuccess: function onSuccess(e) {
          cy(e, t);
        },
        onError: function onError() {
          t({
            type: "transition",
            screen: cm.Error
          });
        }
      }),
      l = _sy5.trigger,
      c = _sy5.isMutating;
    return s ? Xe.exports.createElement(hA, null) : c ? Xe.exports.createElement(mA, null) : 0 === e.formState.discoveryState.discoveredOrganizations.length ? Xe.exports.createElement(kA, null) : Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 24
    }, Xe.exports.createElement($y, {
      onClick: function onClick() {
        return t({
          type: "transition",
          screen: cm.Main
        });
      }
    }), Xe.exports.createElement(Jg, {
      size: "header"
    }, "Select an organization to continue"), Xe.exports.createElement(gA, {
      direction: "column"
    }, e.formState.discoveryState.discoveredOrganizations.map(function (_ref69) {
      var e = _ref69.organization,
        t = _ref69.membership;
      return Xe.exports.createElement(vA, {
        padding: 8,
        justifyContent: "space-between",
        key: e.organization_id,
        alignItems: "center",
        onClick: function onClick() {
          return function (e) {
            null != e.allowed_auth_methods && 1 == e.allowed_auth_methods.length && e.allowed_auth_methods.includes("sso") && null != e.sso_default_connection_id ? i(e.sso_default_connection_id) : a({
              organizationId: e.organization_id
            });
          }(e);
        }
      }, Xe.exports.createElement(Yg, {
        gap: 4,
        alignItems: "center"
      }, Xe.exports.createElement(_A, {
        name: e.organization_name,
        logo: e.organization_logo_url
      }), Xe.exports.createElement(Jg, null, e.organization_name)), Xe.exports.createElement(Yg, {
        gap: 4,
        alignItems: "center"
      }, Xe.exports.createElement(wA, {
        type: t.type
      }), Xe.exports.createElement(bA, null)));
    })), o && Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 8
    }, Xe.exports.createElement(Ry, null), Xe.exports.createElement(fy, {
      variant: "outlined",
      onClick: function onClick() {
        return l();
      }
    }, "Create an organization")));
  },
  SA = function SA() {
    return Xe.exports.createElement("svg", {
      width: "201",
      height: "200",
      viewBox: "0 0 201 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Xe.exports.createElement("g", {
      opacity: "0.1"
    }, Xe.exports.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.5 0C155.729 0 200.5 44.7715 200.5 99.9999C200.5 155.229 155.729 200 100.5 200C45.2715 200 0.5 155.229 0.5 99.9999C0.5 44.7715 45.2715 0 100.5 0Z",
      fill: "url(#paint0_linear_1356_5135)"
    })), Xe.exports.createElement("g", {
      opacity: "0.3"
    }, Xe.exports.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.5 17.5728C146.023 17.5728 182.927 54.4767 182.927 99.9998C182.927 145.523 146.023 182.427 100.5 182.427C54.9768 182.427 18.0729 145.523 18.0729 99.9998C18.0729 54.4767 54.9768 17.5728 100.5 17.5728Z",
      fill: "url(#paint1_linear_1356_5135)"
    })), Xe.exports.createElement("g", {
      opacity: "0.7"
    }, Xe.exports.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.5 32.231C137.988 32.231 168.378 62.6208 168.378 100.109C168.378 137.597 137.988 167.987 100.5 167.987C63.012 167.987 32.6222 137.597 32.6222 100.109C32.6222 62.6208 63.012 32.231 100.5 32.231Z",
      fill: "url(#paint2_linear_1356_5135)"
    })), Xe.exports.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.605 48.7734C128.955 48.7734 151.937 71.7553 151.937 100.105C151.937 128.455 128.955 151.437 100.605 151.437C72.255 151.437 49.2731 128.455 49.2731 100.105C49.2731 71.7553 72.255 48.7734 100.605 48.7734Z",
      fill: "#00AC26",
      fillOpacity: "0.12"
    }), Xe.exports.createElement("mask", {
      id: "mask0_1356_5135",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "49",
      y: "48",
      width: "103",
      height: "104"
    }, Xe.exports.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.605 48.7734C128.955 48.7734 151.937 71.7553 151.937 100.105C151.937 128.455 128.955 151.437 100.605 151.437C72.255 151.437 49.2731 128.455 49.2731 100.105C49.2731 71.7553 72.255 48.7734 100.605 48.7734Z",
      fill: "white"
    })), Xe.exports.createElement("g", {
      mask: "url(#mask0_1356_5135)"
    }), Xe.exports.createElement("path", {
      d: "M88 117.5L70.5 100L64.6667 105.833L88 129.167L138 79.1666L132.167 73.3333L88 117.5Z",
      fill: "white"
    }), Xe.exports.createElement("defs", null, Xe.exports.createElement("linearGradient", {
      id: "paint0_linear_1356_5135",
      x1: "-86.6375",
      y1: "160.384",
      x2: "170.169",
      y2: "338.297",
      gradientUnits: "userSpaceOnUse"
    }, Xe.exports.createElement("stop", {
      stopColor: "white"
    }), Xe.exports.createElement("stop", {
      offset: "1",
      stopColor: "#09F33D"
    })), Xe.exports.createElement("linearGradient", {
      id: "paint1_linear_1356_5135",
      x1: "-86.6374",
      y1: "160.384",
      x2: "170.169",
      y2: "338.297",
      gradientUnits: "userSpaceOnUse"
    }, Xe.exports.createElement("stop", {
      stopColor: "#00AC26",
      stopOpacity: "0.4"
    }), Xe.exports.createElement("stop", {
      offset: "1",
      stopColor: "#BDFFBC",
      stopOpacity: "0.58"
    })), Xe.exports.createElement("linearGradient", {
      id: "paint2_linear_1356_5135",
      x1: "-86.6375",
      y1: "160.493",
      x2: "170.169",
      y2: "338.406",
      gradientUnits: "userSpaceOnUse"
    }, Xe.exports.createElement("stop", {
      stopColor: "#F8FFF5"
    }), Xe.exports.createElement("stop", {
      offset: "1",
      stopColor: "#00AC26",
      stopOpacity: "0.26"
    }))));
  },
  CA = function CA() {
    return Xe.exports.createElement(Yg, {
      direction: "column",
      gap: 24,
      alignItems: "center"
    }, Xe.exports.createElement(Jg, {
      size: "header"
    }, "Success!"), Xe.exports.createElement(Jg, null, "You have successfully logged in."), Xe.exports.createElement(SA, null));
  },
  xA = _o.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  height: 4px;\n  width: 25%;\n  background-color: ", ";\n"])), function (e) {
    return e.$bgColor;
  }),
  OA = function OA(_ref70) {
    var e = _ref70.score;
    var t = [];
    switch (e) {
      case 0:
      case 1:
        t = ["#8B1214", "#ADBCC5", "#ADBCC5", "#ADBCC5"];
        break;
      case 2:
        t = ["#8B1214", "#8B1214", "#ADBCC5", "#ADBCC5"];
        break;
      case 3:
        t = ["#0C5A56", "#0C5A56", "#0C5A56", "#ADBCC5"];
        break;
      case 4:
        t = ["#0C5A56", "#0C5A56", "#0C5A56", "#0C5A56"];
        break;
      default:
        t = ["#ADBCC5", "#ADBCC5", "#ADBCC5", "#ADBCC5"];
    }
    return Mt.createElement(Yg, {
      gap: 2
    }, t.map(function (e, t) {
      return Mt.createElement(xA, {
        key: "".concat(e, "-").concat(t),
        $bgColor: e
      });
    }));
  },
  PA = function PA() {
    return Xe.exports.createElement(Yg, {
      height: 16,
      width: 16
    }, Xe.exports.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Xe.exports.createElement("path", {
      d: "M5.86332 10.5833L3.08332 7.80333L2.13666 8.74333L5.86332 12.47L13.8633 4.47L12.9233 3.53L5.86332 10.5833Z",
      fill: "#0C5A56"
    })));
  },
  TA = function TA() {
    return Xe.exports.createElement(Yg, {
      height: 16,
      width: 16
    }, Xe.exports.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Xe.exports.createElement("path", {
      d: "M12.6667 4.27334L11.7267 3.33334L8.00001 7.06001L4.27334 3.33334L3.33334 4.27334L7.06001 8.00001L3.33334 11.7267L4.27334 12.6667L8.00001 8.94001L11.7267 12.6667L12.6667 11.7267L8.94001 8.00001L12.6667 4.27334Z",
      fill: "#8B1214"
    })));
  },
  IA = function IA(e) {
    var t, n;
    var r = ly(),
      o = null === (t = r.passwordConfig) || void 0 === t ? void 0 : t.ludsComplexity,
      i = null === (n = r.passwordConfig) || void 0 === n ? void 0 : n.ludsMinimumCount;
    return "none" === e.passwordPolicy ? null : "zxcvbn" === e.passwordPolicy ? Mt.createElement(Mt.Fragment, null, Mt.createElement(OA, {
      score: e.passwordScore
    }), Mt.createElement(ky, {
      errorMessage: "" !== e.errorMessage ? e.errorMessage : e.passwordFeedback
    })) : Mt.createElement(Yg, {
      direction: "column",
      gap: 4
    }, Mt.createElement(Yg, {
      gap: 4
    }, 0 === e.missingCharacters ? Mt.createElement(PA, null) : Mt.createElement(TA, null), Mt.createElement(Jg, {
      size: "helper",
      color: 0 === e.missingCharacters ? "success" : "error"
    }, "Must be at least ", i, " characters long")), Mt.createElement(Yg, {
      gap: 4
    }, 0 === e.missingComplexity ? Mt.createElement(PA, null) : Mt.createElement(TA, null), Mt.createElement(Jg, {
      size: "helper",
      color: 0 === e.missingComplexity ? "success" : "error"
    }, "Must contain ", o, " of the following: uppercase letter, lowercase letter, number, symbol")), e.isPasswordBreached && Mt.createElement(Yg, {
      gap: 4
    }, Mt.createElement(TA, null), Mt.createElement(Jg, {
      size: "helper",
      color: "error"
    }, "This password may have been used on a different site that experienced a security issue. Please choose another password.")));
  },
  BA = _o.form(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  RA = function RA() {
    var e = mm(),
      t = vm(),
      _gm27 = gm(),
      _gm28 = _slicedToArray(_gm27, 2),
      n = _gm28[1],
      r = Am(),
      o = ym(),
      _Xe$exports$useState23 = Xe.exports.useState(""),
      _Xe$exports$useState24 = _slicedToArray(_Xe$exports$useState23, 2),
      i = _Xe$exports$useState24[0],
      a = _Xe$exports$useState24[1],
      _Xe$exports$useState25 = Xe.exports.useState(""),
      _Xe$exports$useState26 = _slicedToArray(_Xe$exports$useState25, 2),
      s = _Xe$exports$useState26[0],
      l = _Xe$exports$useState26[1],
      c = Je(e).dataLayer.getItem("reset-email-value"),
      _Xe$exports$useState27 = Xe.exports.useState(""),
      _Xe$exports$useState28 = _slicedToArray(_Xe$exports$useState27, 2),
      u = _Xe$exports$useState28[0],
      d = _Xe$exports$useState28[1],
      _Xe$exports$useState29 = Xe.exports.useState(""),
      _Xe$exports$useState30 = _slicedToArray(_Xe$exports$useState29, 2),
      f = _Xe$exports$useState30[0],
      p = _Xe$exports$useState30[1],
      _Xe$exports$useState31 = Xe.exports.useState(0),
      _Xe$exports$useState32 = _slicedToArray(_Xe$exports$useState31, 2),
      h = _Xe$exports$useState32[0],
      m = _Xe$exports$useState32[1],
      _Xe$exports$useState33 = Xe.exports.useState(""),
      _Xe$exports$useState34 = _slicedToArray(_Xe$exports$useState33, 2),
      g = _Xe$exports$useState34[0],
      v = _Xe$exports$useState34[1],
      _Xe$exports$useState35 = Xe.exports.useState(!0),
      _Xe$exports$useState36 = _slicedToArray(_Xe$exports$useState35, 2),
      y = _Xe$exports$useState36[0],
      A = _Xe$exports$useState36[1],
      _Xe$exports$useState37 = Xe.exports.useState(!1),
      _Xe$exports$useState38 = _slicedToArray(_Xe$exports$useState37, 2),
      b = _Xe$exports$useState38[0],
      _ = _Xe$exports$useState38[1],
      _Xe$exports$useState39 = Xe.exports.useState("none"),
      _Xe$exports$useState40 = _slicedToArray(_Xe$exports$useState39, 2),
      w = _Xe$exports$useState40[0],
      k = _Xe$exports$useState40[1],
      _Xe$exports$useState41 = Xe.exports.useState(0),
      _Xe$exports$useState42 = _slicedToArray(_Xe$exports$useState41, 2),
      E = _Xe$exports$useState42[0],
      S = _Xe$exports$useState42[1],
      _Xe$exports$useState43 = Xe.exports.useState(0),
      _Xe$exports$useState44 = _slicedToArray(_Xe$exports$useState43, 2),
      C = _Xe$exports$useState44[0],
      x = _Xe$exports$useState44[1],
      _Xe$exports$useState45 = Xe.exports.useState(!1),
      _Xe$exports$useState46 = _slicedToArray(_Xe$exports$useState45, 2),
      O = _Xe$exports$useState46[0],
      P = _Xe$exports$useState46[1],
      T = Xe.exports.useMemo(function () {
        return function (e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
          var n;
          return function () {
            for (var _len5 = arguments.length, r = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              r[_key5] = arguments[_key5];
            }
            clearTimeout(n), n = setTimeout(function () {
              return e.apply(void 0, r);
            }, t);
          };
        }(function (t) {
          return e.passwords.strengthCheck({
            password: t
          }).then(function (_ref71) {
            var e = _ref71.score,
              t = _ref71.valid_password,
              n = _ref71.zxcvbn_feedback,
              r = _ref71.luds_feedback,
              o = _ref71.strength_policy,
              i = _ref71.breached_password;
            k(o), A(!t), "zxcvbn" === o ? (m(e), v(n.warning)) : "luds" === o && (S(r.missing_characters), x(r.missing_complexity), P(i));
          });
        });
      }, []);
    Xe.exports.useEffect(function () {
      var e, t;
      var n = new URLSearchParams(window.location.search),
        r = null !== (e = n.get("token")) && void 0 !== e ? e : "",
        o = null !== (t = n.get("stytch_token_type")) && void 0 !== t ? t : "";
      l(r), a(o);
    }, []), Xe.exports.useEffect(function () {
      var r, a;
      "multi_tenant_magic_links" !== i || e.magicLinks.authenticate({
        magic_links_token: s,
        session_duration_minutes: null !== (a = null === (r = t.sessionOptions) || void 0 === r ? void 0 : r.sessionDurationMinutes) && void 0 !== a ? a : 30
      }).then(function (e) {
        e.member_session || n({
          type: "transition",
          screen: cm.Error
        });
      })["catch"](function (e) {
        p("We were unable to verify your email. Please contact your admin for help."), o(e);
      });
    }, [i]);
    return Mt.createElement(Yg, {
      direction: "column",
      gap: 36,
      className: "resetPasswordContainer"
    }, Mt.createElement(Jg, {
      size: "header"
    }, "Set a new password"), Mt.createElement(BA, {
      onSubmit: function onSubmit(a) {
        var l, c;
        a.preventDefault(), p(""), _(!0), "multi_tenant_passwords" == i ? e.passwords.resetByEmail({
          password_reset_token: s,
          password: u,
          session_duration_minutes: null !== (c = null === (l = t.sessionOptions) || void 0 === l ? void 0 : l.sessionDurationMinutes) && void 0 !== c ? c : 30
        }).then(function (e) {
          _(!1), r({
            type: Nh.B2BPasswordResetByEmail,
            data: e
          }), cy(e, n);
        })["catch"](function (e) {
          o(e), p(e.message), _(!1);
        }) : "multi_tenant_magic_links" == i && e.passwords.resetBySession({
          password: u
        }).then(function (e) {
          _(!1), r({
            type: Nh.B2BPasswordResetBySession,
            data: e
          }), cy(e, n);
        })["catch"](function (e) {
          o(e), p(e.message), _(!1);
        });
      }
    }, Mt.createElement(Yg, {
      direction: "column",
      gap: 8
    }, c ? Mt.createElement(Yg, {
      direction: "column",
      gap: 2
    }, Mt.createElement(Jg, {
      size: "helper",
      color: "secondary"
    }, "Email"), Mt.createElement(by, {
      disabled: !0,
      name: "email",
      id: "email-input",
      value: c
    })) : Mt.createElement(Mt.Fragment, null), Mt.createElement(Yg, {
      direction: "column",
      gap: 2
    }, Mt.createElement(Jg, {
      size: "helper",
      color: "secondary"
    }, "Password"), Mt.createElement(Fy, {
      password: u,
      setPassword: function setPassword(e) {
        d(e), T(e);
      },
      type: "new"
    }), Mt.createElement(IA, {
      passwordPolicy: w,
      passwordScore: h,
      errorMessage: f,
      passwordFeedback: g,
      missingCharacters: E,
      missingComplexity: C,
      isPasswordBreached: O
    })), Mt.createElement(Ay, {
      isSubmitting: b,
      text: "Continue",
      disabled: y
    }))));
  },
  LA = _o.a(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n    text-decoration-color: ", ";\n  }\n"])), function (e) {
    return e.theme.colors.primary;
  }),
  MA = function MA(_ref72) {
    var e = _ref72.label,
      t = _ref72.href,
      n = _ref72.Icon;
    return Mt.createElement(Yg, {
      gap: 4
    }, n, Mt.createElement(LA, {
      href: t,
      target: "_blank",
      rel: "noopener noreferrer"
    }, Mt.createElement(Jg, null, "Open in ", e)));
  },
  DA = function DA(_ref73) {
    var e = _ref73.emailDomain,
      t = _ref73.reset,
      n = _ref73.email;
    var _ref74 = function (e) {
        return e ? {
          GMAIL: "https://mail.google.com/mail/u/0/#search/".concat(encodeURIComponent("from:@".concat(e, " in:anywhere"))),
          OUTLOOK: "https://outlook.office.com/mail/0/inbox"
        } : {
          GMAIL: "https://mail.google.com/mail/u/0/#search/in%3Aanywhere",
          OUTLOOK: "https://outlook.office.com/mail/0/inbox"
        };
      }(e),
      r = _ref74.GMAIL,
      o = _ref74.OUTLOOK,
      _gm29 = gm(),
      _gm30 = _slicedToArray(_gm29, 2),
      i = _gm30[1];
    return Mt.createElement(Yg, {
      direction: "column",
      gap: 24
    }, Mt.createElement($y, {
      onClick: function onClick() {
        return i({
          type: "transition",
          screen: cm.Main
        });
      }
    }), Mt.createElement(Jg, {
      size: "header"
    }, "Verify your email first."), Mt.createElement(Yg, {
      direction: "column",
      gap: 12
    }, Mt.createElement(Jg, null, "A login link was sent to you at ", Mt.createElement("b", null, n), "."), Mt.createElement(Yg, {
      direction: "column",
      gap: 8
    }, Mt.createElement(MA, {
      href: r,
      label: "Gmail",
      Icon: Mt.createElement(sA, null)
    }), Mt.createElement(MA, {
      href: o,
      label: "Outlook",
      Icon: Mt.createElement(lA, null)
    }))), Mt.createElement(Yg, {
      direction: "row"
    }, Mt.createElement(Jg, {
      color: "secondary"
    }, "Didn't get it?"), " ", Mt.createElement(Hy, {
      color: "secondary",
      onClick: t
    }, "Resend email")));
  },
  NA = function NA() {
    var _gm31 = gm(),
      _gm32 = _slicedToArray(_gm31, 2),
      e = _gm32[0],
      t = _gm32[1],
      n = function () {
        var e, t;
        var n = mm(),
          r = vm(),
          _Xe$exports$useState47 = Xe.exports.useState(function () {
            var _Je$bootstrap$getSync2 = Je(n).bootstrap.getSync(),
              e = _Je$bootstrap$getSync2.emailDomains;
            return e;
          }),
          _Xe$exports$useState48 = _slicedToArray(_Xe$exports$useState47, 2),
          o = _Xe$exports$useState48[0],
          i = _Xe$exports$useState48[1];
        return Xe.exports.useEffect(function () {
          Je(n).bootstrap.getAsync().then(function (_ref75) {
            var e = _ref75.emailDomains;
            i(e);
          });
        }, [n]), (null === (e = r.emailMagicLinksOptions) || void 0 === e ? void 0 : e.domainHint) ? null === (t = r.emailMagicLinksOptions) || void 0 === t ? void 0 : t.domainHint : 1 === o.length ? o[0] : null;
      }();
    return Mt.createElement(DA, {
      emailDomain: n,
      reset: function reset() {
        t({
          type: "set_magic_link_email",
          email: ""
        }), t({
          type: "transition",
          screen: cm.Main
        });
      },
      email: e.formState.passwordState.email
    });
  },
  zA = function zA() {
    var _gm33 = gm(),
      _gm34 = _slicedToArray(_gm33, 2),
      e = _gm34[1],
      t = vm(),
      n = Am(),
      r = t.passwordOptions,
      _uy3 = uy(),
      o = _uy3.stytch,
      i = _uy3.email,
      a = _uy3.setEmail,
      s = _uy3.organization,
      l = _uy3.errorMessage,
      c = _uy3.setErrorMessage,
      u = _uy3.isSubmitting,
      d = _uy3.setIsSubmitting,
      f = _uy3.handleNonMemberReset;
    if (!r) return Mt.createElement(Mt.Fragment, null);
    if (!s) return Mt.createElement(Mt.Fragment, null);
    return Mt.createElement("form", {
      onSubmit: function onSubmit(r) {
        return Ee(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
          return _regeneratorRuntime().wrap(function _callee26$(_context26) {
            while (1) switch (_context26.prev = _context26.next) {
              case 0:
                r.preventDefault(), i.match(Ne) ? (c(""), d(!0), Je(o).searchManager.searchMember(i, s.organization_id).then(function (_ref76) {
                  var r = _ref76.member;
                  var a, l, u, p;
                  (null == r ? void 0 : r.member_password_id) ? o.passwords.resetByEmailStart({
                    email_address: i,
                    organization_id: s.organization_id,
                    login_redirect_url: null === (a = t.emailMagicLinksOptions) || void 0 === a ? void 0 : a.loginRedirectURL,
                    reset_password_redirect_url: null === (l = t.passwordOptions) || void 0 === l ? void 0 : l.resetPasswordRedirectURL,
                    reset_password_expiration_minutes: null === (u = t.passwordOptions) || void 0 === u ? void 0 : u.resetPasswordExpirationMinutes,
                    reset_password_template_id: null === (p = t.passwordOptions) || void 0 === p ? void 0 : p.resetPasswordTemplateId
                  }).then(function (t) {
                    d(!1), n({
                      type: Nh.B2BPasswordResetByEmailStart,
                      data: t
                    }), e({
                      type: "set_password_state",
                      email: i
                    }), e({
                      type: "transition",
                      screen: cm.PasswordSetNewConfirmation
                    });
                  })["catch"](function (e) {
                    d(!1), c(e.message);
                  }) : f();
                })["catch"](function (e) {
                  d(!1), c(e.message);
                })) : c("Invalid email address");
              case 1:
              case "end":
                return _context26.stop();
            }
          }, _callee26);
        }));
      }
    }, Mt.createElement(Yg, {
      direction: "column",
      gap: 24
    }, Mt.createElement($y, {
      onClick: function onClick() {
        return e({
          type: "transition",
          screen: cm.Main
        });
      }
    }), Mt.createElement(Jg, {
      size: "header"
    }, "Check your email for help signing in!"), Mt.createElement(Jg, null, "We'll email you a login link to sign in to your account directly or reset your password if you have one."), Mt.createElement(Yg, {
      direction: "column",
      gap: 4
    }, Mt.createElement(Jg, {
      size: "helper",
      color: "secondary"
    }, "Email"), Mt.createElement(_y, {
      email: i,
      setEmail: a
    }), Mt.createElement(ky, {
      errorMessage: l
    }), Mt.createElement(Ay, {
      isSubmitting: u,
      text: "Continue"
    }))));
  },
  jA = function jA() {
    var _gm35 = gm(),
      _gm36 = _slicedToArray(_gm35, 2),
      e = _gm36[1],
      t = Am(),
      n = vm(),
      _uy4 = uy(),
      r = _uy4.stytch,
      o = _uy4.onError,
      i = _uy4.email,
      a = _uy4.organization,
      s = _uy4.setIsSubmitting;
    if (!a) return Mt.createElement(Mt.Fragment, null);
    return Mt.createElement(Yg, {
      direction: "column",
      gap: 24
    }, Mt.createElement($y, {
      onClick: function onClick() {
        return e({
          type: "transition",
          screen: cm.Main
        });
      }
    }), Mt.createElement(Jg, {
      size: "header"
    }, "Check your email!"), Mt.createElement(Jg, null, "A login link was sent to you at ", Mt.createElement("b", null, i), "."), Mt.createElement(Jg, null, "Didn't get it?", " ", Mt.createElement("button", {
      onClick: function onClick() {
        var e, l, c, u;
        r.passwords.resetByEmailStart({
          email_address: i,
          organization_id: a.organization_id,
          login_redirect_url: null === (e = n.emailMagicLinksOptions) || void 0 === e ? void 0 : e.loginTemplateId,
          reset_password_redirect_url: null === (l = n.passwordOptions) || void 0 === l ? void 0 : l.resetPasswordRedirectURL,
          reset_password_expiration_minutes: null === (c = n.passwordOptions) || void 0 === c ? void 0 : c.resetPasswordExpirationMinutes,
          reset_password_template_id: null === (u = n.passwordOptions) || void 0 === u ? void 0 : u.resetPasswordTemplateId
        }).then(function (e) {
          rg.success("Email resent"), s(!1), t({
            type: Nh.B2BPasswordResetByEmailStart,
            data: e
          });
        })["catch"](function (e) {
          o(e);
        });
      },
      style: {
        all: "unset"
      }
    }, Mt.createElement("b", {
      style: {
        cursor: "pointer"
      }
    }, "Resend email"))));
  },
  FA = _o.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  width: ", ";\n  font-family: ", ";\n  padding: 24px 32px;\n  box-sizing: border-box;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n"])), function (_ref77) {
    var e = _ref77.theme;
    return e.container.width;
  }, function (_ref78) {
    var e = _ref78.theme;
    return e.typography.fontFamily;
  }, function (_ref79) {
    var e = _ref79.theme;
    return e.container.backgroundColor;
  }, function (_ref80) {
    var e = _ref80.theme;
    return e.container.border;
  }, function (_ref81) {
    var e = _ref81.theme;
    return e.container.borderRadius;
  }),
  UA = _o.img(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  width: 150px;\n"]))),
  QA = function QA() {
    var _a5;
    var _gm37 = gm(),
      _gm38 = _slicedToArray(_gm37, 2),
      e = _gm38[0],
      t = _gm38[1],
      n = mm(),
      r = vm(),
      _bo2 = bo(),
      o = _bo2.displayWatermark,
      i = e.screen,
      a = (_a5 = {}, _defineProperty(_a5, cm.Main, Mt.createElement(aA, null)), _defineProperty(_a5, cm.EmailConfirmation, Mt.createElement(pA, null)), _defineProperty(_a5, cm.LoggedIn, Mt.createElement(CA, null)), _defineProperty(_a5, cm.Discovery, Mt.createElement(EA, null)), _defineProperty(_a5, cm.ErrorOrganization, Mt.createElement(ev, {
        errorMessage: "The organization you are looking for could not be found. If you think this is a mistake, contact your admin."
      })), _defineProperty(_a5, cm.Error, Mt.createElement(ev, {
        errorMessage: "Something went wrong. Try again later or contact your admin for help."
      })), _defineProperty(_a5, cm.PasswordEmailForm, Mt.createElement(Wy, null)), _defineProperty(_a5, cm.PasswordAuthenticate, Mt.createElement(Vy, null)), _defineProperty(_a5, cm.PasswordResetForm, Mt.createElement(RA, null)), _defineProperty(_a5, cm.PasswordResetVerifyConfirmation, Mt.createElement(NA, null)), _defineProperty(_a5, cm.PasswordForgotForm, Mt.createElement(zA, null)), _defineProperty(_a5, cm.PasswordSetNewConfirmation, Mt.createElement(jA, null)), _a5),
      s = function s(e) {
        window.history.replaceState(null, window.document.title, window.location.pathname), cy(e, t);
      },
      l = function l(e) {
        window.history.replaceState(null, window.document.title, window.location.pathname), t({
          type: "set_discovery_state",
          email: e.email_address,
          discoveredOrganizations: e.discovered_organizations,
          intermediateSessionToken: e.intermediate_session_token
        }), t({
          type: "transition",
          screen: cm.Discovery
        });
      },
      c = function c() {
        window.history.replaceState(null, window.document.title, window.location.pathname), t({
          type: "transition",
          screen: cm.Error
        });
      },
      _sy6 = sy("stytch.magicLinks.authenticate", function (e, _ref83) {
        var t = _ref83.arg.token;
        return n.magicLinks.authenticate({
          magic_links_token: t,
          session_duration_minutes: r.sessionOptions.sessionDurationMinutes
        });
      }, {
        onSuccess: s,
        onError: c
      }),
      u = _sy6.trigger,
      d = _sy6.isMutating,
      _sy7 = sy("stytch.oauth.authenticate", function (e, _ref84) {
        var t = _ref84.arg.token;
        return n.oauth.authenticate({
          oauth_token: t,
          session_duration_minutes: r.sessionOptions.sessionDurationMinutes
        });
      }, {
        onSuccess: s,
        onError: c
      }),
      f = _sy7.trigger,
      p = _sy7.isMutating,
      _sy8 = sy("stytch.oauth.discovery.authenticate", function (e, _ref85) {
        var t = _ref85.arg.token;
        return n.oauth.discovery.authenticate({
          discovery_oauth_token: t
        });
      }, {
        onSuccess: l,
        onError: c
      }),
      h = _sy8.trigger,
      m = _sy8.isMutating,
      _sy9 = sy("stytch.sso.authenticate", function (e, _ref86) {
        var t = _ref86.arg.token;
        return n.sso.authenticate({
          sso_token: t,
          session_duration_minutes: r.sessionOptions.sessionDurationMinutes
        });
      }, {
        onSuccess: s,
        onError: c
      }),
      g = _sy9.trigger,
      v = _sy9.isMutating,
      _sy10 = sy("stytch.magicLinks.discovery.authenticate", function (e, _ref87) {
        var t = _ref87.arg.token;
        return n.magicLinks.discovery.authenticate({
          discovery_magic_links_token: t
        });
      }, {
        onSuccess: l,
        onError: c
      }),
      y = _sy10.trigger,
      A = _sy10.isMutating,
      _ref82 = function () {
        var _gm39 = gm(),
          _gm40 = _slicedToArray(_gm39, 2),
          e = _gm40[0],
          t = _gm40[1],
          _Xe$exports$useState49 = Xe.exports.useState(null),
          _Xe$exports$useState50 = _slicedToArray(_Xe$exports$useState49, 2),
          n = _Xe$exports$useState50[0],
          r = _Xe$exports$useState50[1],
          o = mm(),
          i = dy(n),
          _sy11 = sy("stytch.searchOrganization", function (e, _ref88) {
            var t = _ref88.arg.slug;
            return Je(o).searchManager.searchOrganization(t);
          }, {
            onSuccess: function onSuccess(_ref89) {
              var e = _ref89.organization;
              t(null === e ? {
                type: "transition",
                screen: cm.ErrorOrganization
              } : {
                type: "set_organization",
                organization: Object.assign({}, e)
              });
            }
          }),
          a = _sy11.trigger,
          s = _sy11.isMutating;
        return Xe.exports.useEffect(function () {
          Je(o).bootstrap.getAsync().then(function (_ref90) {
            var e = _ref90.slugPattern;
            r(e);
          });
        }, [o]), Xe.exports.useEffect(function () {
          null !== i && null === e.flowState.organization && e.screen === cm.Main && e.flowState.type == Xh.Organization && a({
            slug: i
          });
        }, [i, e.flowState, e.screen]), {
          isSearching: s
        };
      }(),
      b = _ref82.isSearching;
    return Xe.exports.useEffect(function () {
      var t = new URL(window.location.href),
        n = t.searchParams.get("stytch_token_type"),
        r = t.searchParams.get("token");
      e.flowState.type != Xh.PasswordReset && r && n && ("discovery" === n ? y({
        token: r
      }) : "discovery_oauth" === n ? h({
        token: r
      }) : "oauth" === n ? f({
        token: r
      }) : "sso" === n ? g({
        token: r
      }) : "multi_tenant_magic_links" === n && u({
        token: r
      }));
    }, []), d || v || A || m || p ? Mt.createElement(FA, null, Mt.createElement(hA, null)) : b ? Mt.createElement(FA, null, Mt.createElement(mA, null)) : Mt.createElement(FA, null, a[i], Mt.createElement(Kg, null), o && Mt.createElement(Yg, {
      justifyContent: "center",
      marginTop: 24
    }, Mt.createElement("a", {
      href: "https://stytch.com/",
      target: "_blank",
      rel: "noreferrer"
    }, Mt.createElement(UA, {
      alt: "Powered by Stytch",
      src: "https://public-assets.stytch.com/et_powered_by_stytch_logo.png"
    }))));
  },
  $A = "stytch-b2b-ui",
  HA = (VA = function VA(_ref91) {
    var e = _ref91.client,
      t = _ref91.styles,
      n = _ref91.callbacks,
      r = _ref91.config;
    var _Xe$exports$useState51 = Xe.exports.useState(function () {
        var _Je$bootstrap$getSync3 = Je(e).bootstrap.getSync(),
          t = _Je$bootstrap$getSync3.displayWatermark;
        return t;
      }),
      _Xe$exports$useState52 = _slicedToArray(_Xe$exports$useState51, 2),
      o = _Xe$exports$useState52[0],
      i = _Xe$exports$useState52[1];
    Xe.exports.useEffect(function () {
      Je(e).networkClient.logEvent({
        name: "render_b2b_login_screen",
        details: {
          options: r
        }
      }), Je(e).bootstrap.getAsync().then(function (_ref92) {
        var e = _ref92.displayWatermark;
        i(e);
      });
    }, [e]);
    var a = Object.assign(Object.assign({}, um), {
        screen: r.authFlowType === Xh.PasswordReset ? cm.PasswordResetForm : cm.Main,
        flowState: Object.assign(Object.assign({}, um.flowState), {
          type: r.authFlowType
        })
      }),
      s = function (_ref93) {
        var e = _ref93.styles,
          t = _ref93.displayWatermark;
        return Xe.exports.useMemo(function () {
          return function (e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            return {
              typography: {
                fontFamily: e.fontFamily,
                header: {
                  fontFamily: e.fontFamily,
                  fontSize: 24,
                  fontWeight: 600,
                  lineHeight: "30px"
                },
                body: {
                  fontFamily: e.fontFamily,
                  fontSize: 16,
                  fontWeight: "normal",
                  lineHeight: "21px"
                },
                helper: {
                  fontFamily: e.fontFamily,
                  fontSize: 14,
                  fontWeight: "400",
                  lineHeight: "20px",
                  whiteSpace: "pre-wrap"
                }
              },
              colors: {
                primary: e.colors.primary,
                secondary: e.colors.secondary,
                success: e.colors.success,
                error: e.colors.error,
                disabled: "#F3F5F6",
                disabledText: "#8296A1"
              },
              container: {
                width: e.container.width,
                border: "1px solid ".concat(e.container.borderColor),
                borderRadius: e.container.borderRadius,
                backgroundColor: e.container.backgroundColor
              },
              buttons: {
                primary: {
                  backgroundColor: e.buttons.primary.backgroundColor,
                  textColor: e.buttons.primary.textColor,
                  border: "1px solid ".concat(e.buttons.primary.borderColor),
                  borderRadius: e.buttons.primary.borderRadius
                },
                secondary: {
                  backgroundColor: e.buttons.secondary.backgroundColor,
                  textColor: e.buttons.secondary.textColor,
                  border: "1px solid ".concat(e.buttons.secondary.borderColor),
                  borderRadius: e.buttons.secondary.borderRadius
                }
              },
              displayHeader: !e.hideHeaderText,
              displayWatermark: t,
              logo: {
                logoImageUrl: e.logo.logoImageUrl
              }
            };
          }(km({}, Cm, e), t);
        }, [e, t]);
      }({
        styles: t,
        displayWatermark: o
      });
    return Mt.createElement(pm, {
      client: e,
      callbacks: n,
      config: r,
      initialState: a
    }, Mt.createElement(mo, {
      theme: s
    }, Mt.createElement(QA, null)));
  }, WA = $A, "undefined" == typeof window ? function () {
    return null;
  } : function (e) {
    if (e.config.enableShadowDOM) {
      var _t11 = function (e, t) {
        var n = customElements.get(t);
        if (n) return n;
        var r = /*#__PURE__*/function (_HTMLElement) {
          _inherits(r, _HTMLElement);
          var _super4 = _createSuper(r);
          function r(e) {
            var _this9;
            _classCallCheck(this, r);
            _this9 = _super4.call(this), _this9.props = e, _this9.rootRef = _this9.attachShadow({
              mode: "open"
            });
            return _this9;
          }
          _createClass(r, [{
            key: "connectedCallback",
            value: function connectedCallback() {
              this.styleSlot = document.createElement("section"), this.rootRef.appendChild(this.styleSlot), this.mountPoint = document.createElement("span"), this.styleSlot.appendChild(this.mountPoint), this.render(this.props);
            }
          }, {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
              this.mountPoint && zh.unmountComponentAtNode(this.mountPoint);
            }
          }, {
            key: "renderOneTap",
            value: function renderOneTap(e) {
              var t, n, _r6;
              var o = null === (_r6 = null === (n = null === (t = null == e ? void 0 : e.config) || void 0 === t ? void 0 : t.oauthOptions) || void 0 === n ? void 0 : n.providers) || void 0 === _r6 ? void 0 : _r6.find(function (e) {
                  return e.type === Rh.Google && e.one_tap;
                }),
                i = this.innerHTML.includes(sm);
              o ? i || (this.innerHTML = sm) : this.innerHTML = "";
            }
          }, {
            key: "render",
            value: function render(t) {
              if (!this.mountPoint) throw Error("Cannot render - no mount point defined");
              if (!this.styleSlot) throw Error("Cannot render - no style slot defined");
              this.renderOneTap(t), zh.render(Mt.createElement(Kr, {
                target: this.styleSlot
              }, Mt.createElement(e, Object.assign({}, t))), this.mountPoint);
            }
          }]);
          return r;
        }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
        return customElements.define(t, r), r;
      }(VA, WA);
      return new _t11(e);
    }
    {
      var _t12 = function (e, t) {
        var n = customElements.get(t);
        if (n) return n;
        var r = /*#__PURE__*/function (_HTMLElement2) {
          _inherits(r, _HTMLElement2);
          var _super5 = _createSuper(r);
          function r(e) {
            var _this10;
            _classCallCheck(this, r);
            _this10 = _super5.call(this), _this10.props = e, _this10.rootRef = document.createElement("div"), _this10.append(_this10.rootRef);
            return _this10;
          }
          _createClass(r, [{
            key: "connectedCallback",
            value: function connectedCallback() {
              this.styleSlot = document.createElement("section"), this.rootRef.appendChild(this.styleSlot), this.mountPoint = document.createElement("span"), this.styleSlot.appendChild(this.mountPoint), this.render(this.props);
            }
          }, {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
              this.mountPoint && zh.unmountComponentAtNode(this.mountPoint);
            }
          }, {
            key: "render",
            value: function render(t) {
              if (!this.mountPoint) throw Error("Cannot render - no mount point defined");
              if (!this.styleSlot) throw Error("Cannot render - no style slot defined");
              zh.render(Mt.createElement(Kr, {
                target: this.styleSlot
              }, Mt.createElement(e, Object.assign({}, t))), this.mountPoint);
            }
          }]);
          return r;
        }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
        return customElements.define(t, r), r;
      }(VA, WA);
      return new _t12(e);
    }
  });
var VA, WA;
var KA = /*#__PURE__*/function (_Ze) {
  _inherits(KA, _Ze);
  var _super6 = _createSuper(KA);
  function KA() {
    var _this11;
    _classCallCheck(this, KA);
    for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      e[_key6] = arguments[_key6];
    }
    !function (e) {
      var t = "StytchUIClient" === e ? "import { createStytchUIClient } from '@stytch/nextjs/ui';\n    \nconst stytch = createStytchUIClient('public-token-...');\n" : "import { createStytchHeadlessClient } from '@stytch/nextjs/ui';\n    \nconst stytch = createStytchHeadlessClient('public-token-...');\n";
      if ("undefined" == typeof window) throw new Error("The ".concat(e, " is not compatible with server-side environments.\nIf using nextjs, use the create").concat(e, " method instead.\n```\n").concat(t, "\n```\n"));
    }("StytchUIClient"), _this11 = _super6.call.apply(_super6, [this].concat(e));
    return _this11;
  }
  _createClass(KA, [{
    key: "mount",
    value: function mount(_ref94) {
      var e = _ref94.elementId,
        t = _ref94.styles,
        n = _ref94.callbacks,
        r = _ref94.config;
      var o;
      var i = document.querySelector(e);
      if (!i) {
        throw new Error("The selector you specified (".concat(e, ") applies to no DOM elements that are currently on the page. Make sure the element exists on the page before calling mountLogin()."));
      }
      if ((null === (o = i.firstChild) || void 0 === o ? void 0 : o.nodeName.toLowerCase()) === $A.toLowerCase()) {
        return void i.firstChild.render({
          client: this,
          config: r,
          callbacks: n,
          styles: t
        });
      }
      var a = HA({
        client: this,
        config: r,
        callbacks: n,
        styles: t
      });
      i.appendChild(a);
    }
  }]);
  return KA;
}(Ze);
export { Xh as AuthFlowType, em as B2BOAuthProviders, Zh as B2BProducts, Jh as BiometricsErrors, Rh as OAuthProviders, Dh as OTPMethods, Mh as OneTapPositions, Bh as Products, tm as SDKAPIUnreachableError, KA as StytchB2BUIClient, Nh as StytchEventType, om as StytchSDKAPIError, im as StytchSDKNativeError, rm as StytchSDKSchemaError, nm as StytchSDKUsageError, am as UNRECOVERABLE_ERROR_TYPES, Lh as Wallets };
